//#region \0rolldown/runtime.js
var e = Object.defineProperty, t = (e, t, n) => () => {
	if (n) throw n[0];
	try {
		return e && (t = e(e = 0)), t;
	} catch (e) {
		throw n = [e], e;
	}
}, n = (t, n) => {
	let r = {};
	for (var i in t) e(r, i, {
		get: t[i],
		enumerable: !0
	});
	return n || e(r, Symbol.toStringTag, { value: "Module" }), r;
}, r = "1.3.26";
function i(e, t, n) {
	return Math.max(e, Math.min(t, n));
}
function a(e, t, n) {
	return (1 - n) * e + n * t;
}
function o(e, t, n, r) {
	return a(e, t, 1 - Math.exp(-n * r));
}
function s(e, t) {
	return (e % t + t) % t;
}
var c = class {
	isRunning = !1;
	value = 0;
	from = 0;
	to = 0;
	currentTime = 0;
	lerp;
	duration;
	easing;
	onUpdate;
	advance(e) {
		if (!this.isRunning) return;
		let t = !1;
		if (this.duration && this.easing) {
			this.currentTime += e;
			let n = i(0, this.currentTime / this.duration, 1);
			t = n >= 1;
			let r = t ? 1 : this.easing(n);
			this.value = this.from + (this.to - this.from) * r;
		} else this.lerp ? (this.value = o(this.value, this.to, this.lerp * 60, e), Math.round(this.value) === Math.round(this.to) && (this.value = this.to, t = !0)) : (this.value = this.to, t = !0);
		t && this.stop(), this.onUpdate?.(this.value, t);
	}
	stop() {
		this.isRunning = !1;
	}
	fromTo(e, t, { lerp: n, duration: r, easing: i, onStart: a, onUpdate: o }) {
		this.from = this.value = e, this.to = t, this.lerp = n, this.duration = r, this.easing = i, this.currentTime = 0, this.isRunning = !0, a?.(), this.onUpdate = o;
	}
};
function l(e, t) {
	let n;
	return function(...r) {
		clearTimeout(n), n = setTimeout(() => {
			n = void 0, e.apply(this, r);
		}, t);
	};
}
var u = class {
	width = 0;
	height = 0;
	scrollHeight = 0;
	scrollWidth = 0;
	debouncedResize;
	wrapperResizeObserver;
	contentResizeObserver;
	constructor(e, t, { autoResize: n = !0, debounce: r = 250 } = {}) {
		this.wrapper = e, this.content = t, n && (this.debouncedResize = l(this.resize, r), this.wrapper instanceof Window ? window.addEventListener("resize", this.debouncedResize) : (this.wrapperResizeObserver = new ResizeObserver(this.debouncedResize), this.wrapperResizeObserver.observe(this.wrapper)), this.contentResizeObserver = new ResizeObserver(this.debouncedResize), this.contentResizeObserver.observe(this.content)), this.resize();
	}
	destroy() {
		this.wrapperResizeObserver?.disconnect(), this.contentResizeObserver?.disconnect(), this.wrapper === window && this.debouncedResize && window.removeEventListener("resize", this.debouncedResize);
	}
	resize = () => {
		this.onWrapperResize(), this.onContentResize();
	};
	onWrapperResize = () => {
		this.wrapper instanceof Window ? (this.width = window.innerWidth, this.height = window.innerHeight) : (this.width = this.wrapper.clientWidth, this.height = this.wrapper.clientHeight);
	};
	onContentResize = () => {
		this.wrapper instanceof Window ? (this.scrollHeight = this.content.scrollHeight, this.scrollWidth = this.content.scrollWidth) : (this.scrollHeight = this.wrapper.scrollHeight, this.scrollWidth = this.wrapper.scrollWidth);
	};
	get limit() {
		return {
			x: this.scrollWidth - this.width,
			y: this.scrollHeight - this.height
		};
	}
}, d = class {
	events = {};
	emit(e, ...t) {
		let n = this.events[e] || [];
		for (let e = 0, r = n.length; e < r; e++) n[e]?.(...t);
	}
	on(e, t) {
		return this.events[e] ? this.events[e].push(t) : this.events[e] = [t], () => {
			this.events[e] = this.events[e]?.filter((e) => t !== e);
		};
	}
	off(e, t) {
		this.events[e] = this.events[e]?.filter((e) => t !== e);
	}
	destroy() {
		this.events = {};
	}
}, f = 100 / 6, p = { passive: !1 };
function m(e, t) {
	return e === 1 ? f : e === 2 ? t : 1;
}
var h = class {
	touchStart = {
		x: 0,
		y: 0
	};
	lastDelta = {
		x: 0,
		y: 0
	};
	window = {
		width: 0,
		height: 0
	};
	emitter = new d();
	constructor(e, t = {
		wheelMultiplier: 1,
		touchMultiplier: 1
	}) {
		this.element = e, this.options = t, window.addEventListener("resize", this.onWindowResize), this.onWindowResize(), this.element.addEventListener("wheel", this.onWheel, p), this.element.addEventListener("touchstart", this.onTouchStart, p), this.element.addEventListener("touchmove", this.onTouchMove, p), this.element.addEventListener("touchend", this.onTouchEnd, p);
	}
	on(e, t) {
		return this.emitter.on(e, t);
	}
	destroy() {
		this.emitter.destroy(), window.removeEventListener("resize", this.onWindowResize), this.element.removeEventListener("wheel", this.onWheel, p), this.element.removeEventListener("touchstart", this.onTouchStart, p), this.element.removeEventListener("touchmove", this.onTouchMove, p), this.element.removeEventListener("touchend", this.onTouchEnd, p);
	}
	onTouchStart = (e) => {
		let { clientX: t, clientY: n } = e.targetTouches ? e.targetTouches[0] : e;
		this.touchStart.x = t, this.touchStart.y = n, this.lastDelta = {
			x: 0,
			y: 0
		}, this.emitter.emit("scroll", {
			deltaX: 0,
			deltaY: 0,
			event: e
		});
	};
	onTouchMove = (e) => {
		let { clientX: t, clientY: n } = e.targetTouches ? e.targetTouches[0] : e, r = -(t - this.touchStart.x) * this.options.touchMultiplier, i = -(n - this.touchStart.y) * this.options.touchMultiplier;
		this.touchStart.x = t, this.touchStart.y = n, this.lastDelta = {
			x: r,
			y: i
		}, this.emitter.emit("scroll", {
			deltaX: r,
			deltaY: i,
			event: e
		});
	};
	onTouchEnd = (e) => {
		this.emitter.emit("scroll", {
			deltaX: this.lastDelta.x,
			deltaY: this.lastDelta.y,
			event: e
		});
	};
	onWheel = (e) => {
		let { deltaX: t, deltaY: n, deltaMode: r } = e, i = m(r, this.window.width), a = m(r, this.window.height);
		t *= i, n *= a, t *= this.options.wheelMultiplier, n *= this.options.wheelMultiplier, this.emitter.emit("scroll", {
			deltaX: t,
			deltaY: n,
			event: e
		});
	};
	onWindowResize = () => {
		this.window = {
			width: window.innerWidth,
			height: window.innerHeight
		};
	};
}, g = (e) => Math.min(1, 1.001 - 2 ** (-10 * e)), _ = class {
	_isScrolling = !1;
	_isStopped = !1;
	_isLocked = !1;
	_preventNextNativeScrollEvent = !1;
	_resetVelocityTimeout = null;
	_rafId = null;
	_isDraggingSelection = !1;
	reducedMotionMediaQuery = window.matchMedia("(prefers-reduced-motion: reduce)");
	isTouching;
	isIos;
	time = 0;
	userData = {};
	lastVelocity = 0;
	velocity = 0;
	direction = 0;
	options;
	targetScroll;
	animatedScroll;
	animate = new c();
	emitter = new d();
	dimensions;
	virtualScroll;
	constructor({ wrapper: e = window, content: t = document.documentElement, eventsTarget: n = e, smoothWheel: i = !0, syncTouch: a = !1, syncTouchLerp: o = .075, touchInertiaExponent: s = 1.7, duration: c, easing: l, lerp: d = .1, infinite: f = !1, orientation: p = "vertical", gestureOrientation: m = p === "horizontal" ? "both" : "vertical", touchMultiplier: _ = 1, wheelMultiplier: v = 1, autoResize: y = !0, prevent: b, virtualScroll: x, overscroll: S = !0, autoRaf: C = !1, anchors: w = !1, autoToggle: T = !1, allowNestedScroll: E = !1, __experimental__naiveDimensions: D = !1, naiveDimensions: O = D, stopInertiaOnNavigate: ee = !1, respectReducedMotion: k = !0 } = {}) {
		window.lenisVersion = r, window.lenis || (window.lenis = {}), window.lenis.version = r, p === "horizontal" && (window.lenis.horizontal = !0), a === !0 && (window.lenis.touch = !0), this.isIos = /(iPad|iPhone|iPod)/g.test(navigator.userAgent), (!e || e === document.documentElement) && (e = window), typeof c == "number" && typeof l != "function" ? l = g : typeof l == "function" && typeof c != "number" && (c = 1), this.options = {
			wrapper: e,
			content: t,
			eventsTarget: n,
			smoothWheel: i,
			syncTouch: a,
			syncTouchLerp: o,
			touchInertiaExponent: s,
			duration: c,
			easing: l,
			lerp: d,
			infinite: f,
			gestureOrientation: m,
			orientation: p,
			touchMultiplier: _,
			wheelMultiplier: v,
			autoResize: y,
			prevent: b,
			virtualScroll: x,
			overscroll: S,
			autoRaf: C,
			anchors: w,
			autoToggle: T,
			allowNestedScroll: E,
			naiveDimensions: O,
			stopInertiaOnNavigate: ee,
			respectReducedMotion: k
		}, this.dimensions = new u(e, t, { autoResize: y }), this.updateClassName(), this.targetScroll = this.animatedScroll = this.actualScroll, this.options.wrapper.addEventListener("scroll", this.onNativeScroll), this.options.wrapper.addEventListener("scrollend", this.onScrollEnd, { capture: !0 }), (this.options.anchors || this.options.stopInertiaOnNavigate) && this.options.wrapper.addEventListener("click", this.onClick), this.options.wrapper.addEventListener("pointerdown", this.onPointerDown), this.virtualScroll = new h(n, {
			touchMultiplier: _,
			wheelMultiplier: v
		}), this.virtualScroll.on("scroll", this.onVirtualScroll), this.options.autoToggle && (this.checkOverflow(), this.rootElement.addEventListener("transitionend", this.onTransitionEnd)), this.options.autoRaf && (this._rafId = requestAnimationFrame(this.raf));
	}
	destroy() {
		this.emitter.destroy(), this.options.wrapper.removeEventListener("scroll", this.onNativeScroll), this.options.wrapper.removeEventListener("scrollend", this.onScrollEnd, { capture: !0 }), this.options.wrapper.removeEventListener("pointerdown", this.onPointerDown), (this.options.anchors || this.options.stopInertiaOnNavigate) && this.options.wrapper.removeEventListener("click", this.onClick), this.virtualScroll.destroy(), this.dimensions.destroy(), this.cleanUpClassName(), this._rafId && cancelAnimationFrame(this._rafId);
	}
	on(e, t) {
		return this.emitter.on(e, t);
	}
	off(e, t) {
		return this.emitter.off(e, t);
	}
	onScrollEnd = (e) => {
		e instanceof CustomEvent || (this.isScrolling === "smooth" || this.isScrolling === !1) && e.stopPropagation();
	};
	dispatchScrollendEvent = () => {
		this.options.wrapper.dispatchEvent(new CustomEvent("scrollend", {
			bubbles: this.options.wrapper === window,
			detail: { lenisScrollEnd: !0 }
		}));
	};
	get overflow() {
		let e = this.isHorizontal ? "overflow-x" : "overflow-y";
		return getComputedStyle(this.rootElement)[e];
	}
	checkOverflow() {
		["hidden", "clip"].includes(this.overflow) ? this.internalStop() : this.internalStart();
	}
	onTransitionEnd = (e) => {
		e.propertyName?.includes("overflow") && e.target === this.rootElement && this.checkOverflow();
	};
	setScroll(e) {
		this.isHorizontal ? this.options.wrapper.scrollTo({
			left: e,
			behavior: "instant"
		}) : this.options.wrapper.scrollTo({
			top: e,
			behavior: "instant"
		});
	}
	onClick = (e) => {
		let t = e.composedPath().filter((e) => e instanceof HTMLAnchorElement && e.href).map((e) => new URL(e.href)), n = new URL(window.location.href);
		if (this.options.anchors) {
			let e = t.find((e) => n.host === e.host && n.pathname === e.pathname && e.hash);
			if (e) {
				let t = typeof this.options.anchors == "object" && this.options.anchors ? this.options.anchors : void 0, n = decodeURIComponent(e.hash);
				this.scrollTo(n, t);
				return;
			}
		}
		this.options.stopInertiaOnNavigate && t.some((e) => n.host === e.host && n.pathname !== e.pathname) && this.reset();
	};
	onPointerDown = (e) => {
		e.button === 1 && this.reset();
	};
	isTouchOnSelectionHandle(e) {
		let t = window.getSelection();
		if (!t || t.isCollapsed || t.rangeCount === 0) return !1;
		let n = e.targetTouches[0] ?? e.changedTouches[0];
		if (!n) return !1;
		let r = t.getRangeAt(0).getClientRects();
		if (r.length === 0) return !1;
		let i = r[0], a = r[r.length - 1], o = Math.hypot(n.clientX - i.left, n.clientY - i.top) <= 40, s = Math.hypot(n.clientX - a.right, n.clientY - a.bottom) <= 40;
		return o || s;
	}
	onVirtualScroll = (e) => {
		if (typeof this.options.virtualScroll == "function" && this.options.virtualScroll(e) === !1) return;
		let { deltaX: t, deltaY: n, event: r } = e;
		if (this.emitter.emit("virtual-scroll", {
			deltaX: t,
			deltaY: n,
			event: r
		}), r.ctrlKey || r.lenisStopPropagation) return;
		let i = r.type.includes("touch"), a = r.type.includes("wheel");
		if (i && this.isIos && (r.type === "touchstart" && (this._isDraggingSelection = this.isTouchOnSelectionHandle(r)), this._isDraggingSelection)) {
			r.type === "touchend" && (this._isDraggingSelection = !1);
			return;
		}
		this.isTouching = r.type === "touchstart" || r.type === "touchmove";
		let o = t === 0 && n === 0;
		if (this.options.syncTouch && i && r.type === "touchstart" && o && !this.isStopped && !this.isLocked) {
			this.reset();
			return;
		}
		let s = this.options.gestureOrientation === "vertical" && n === 0 || this.options.gestureOrientation === "horizontal" && t === 0;
		if (o || s) return;
		let c = r.composedPath();
		c = c.slice(0, c.indexOf(this.rootElement));
		let l = this.options.prevent, u = Math.abs(t) >= Math.abs(n) ? "horizontal" : "vertical";
		if (c.find((e) => e instanceof HTMLElement && (typeof l == "function" && l?.(e) || e.hasAttribute?.("data-lenis-prevent") || u === "vertical" && e.hasAttribute?.("data-lenis-prevent-vertical") || u === "horizontal" && e.hasAttribute?.("data-lenis-prevent-horizontal") || i && e.hasAttribute?.("data-lenis-prevent-touch") || a && e.hasAttribute?.("data-lenis-prevent-wheel") || this.options.allowNestedScroll && this.hasNestedScroll(e, {
			deltaX: t,
			deltaY: n
		})))) return;
		if (this.isStopped || this.isLocked) {
			r.cancelable && r.preventDefault();
			return;
		}
		if (!(this.options.syncTouch && i || this.options.smoothWheel && a)) {
			this.isScrolling = "native", this.animate.stop(), r.lenisStopPropagation = !0;
			return;
		}
		let d = n;
		this.options.gestureOrientation === "both" ? d = Math.abs(n) > Math.abs(t) ? n : t : this.options.gestureOrientation === "horizontal" && (d = t), (!this.options.overscroll || this.options.infinite || this.options.wrapper !== window && this.limit > 0 && (this.animatedScroll > 0 && this.animatedScroll < this.limit || this.animatedScroll === 0 && n > 0 || this.animatedScroll === this.limit && n < 0)) && (r.lenisStopPropagation = !0), r.cancelable && r.preventDefault();
		let f = i && this.options.syncTouch, p = i && r.type === "touchend";
		p && (d = Math.sign(d) * Math.abs(this.velocity) ** this.options.touchInertiaExponent), this.scrollTo(this.targetScroll + d, {
			programmatic: !1,
			...f ? { lerp: p ? this.options.syncTouchLerp : 1 } : {
				lerp: this.options.lerp,
				duration: this.options.duration,
				easing: this.options.easing
			}
		});
	};
	resize() {
		this.dimensions.resize(), this.animatedScroll = this.targetScroll = this.actualScroll, this.emit();
	}
	emit() {
		this.emitter.emit("scroll", this);
	}
	onNativeScroll = () => {
		if (this._resetVelocityTimeout !== null && (clearTimeout(this._resetVelocityTimeout), this._resetVelocityTimeout = null), this._preventNextNativeScrollEvent) this._preventNextNativeScrollEvent = !1;
		else if (this.isScrolling === !1 || this.isScrolling === "native") {
			let e = this.animatedScroll;
			this.animatedScroll = this.targetScroll = this.actualScroll, this.lastVelocity = this.velocity, this.velocity = this.animatedScroll - e, this.direction = Math.sign(this.animatedScroll - e), this.isStopped || (this.isScrolling = "native"), this.emit(), this.velocity !== 0 && (this._resetVelocityTimeout = setTimeout(() => {
				this.lastVelocity = this.velocity, this.velocity = 0, this.isScrolling = !1, this.emit();
			}, 400));
		}
	};
	reset() {
		this.isLocked = !1, this.isScrolling = !1, this.animatedScroll = this.targetScroll = this.actualScroll, this.lastVelocity = this.velocity = 0, this.animate.stop();
	}
	start() {
		this.isStopped && (this.options.autoToggle ? this.rootElement.style.removeProperty("overflow") : this.internalStart());
	}
	internalStart() {
		this.isStopped && (this.reset(), this.isStopped = !1, this.emit());
	}
	stop() {
		this.isStopped || (this.options.autoToggle ? this.rootElement.style.setProperty("overflow", "clip") : this.internalStop());
	}
	internalStop() {
		this.isStopped || (this.reset(), this.isStopped = !0, this.emit());
	}
	raf = (e) => {
		let t = e - (this.time || e);
		this.time = e, this.animate.advance(t * .001), this.options.autoRaf && (this._rafId = requestAnimationFrame(this.raf));
	};
	scrollTo(e, { offset: t = 0, immediate: n = !1, lock: r = !1, programmatic: a = !0, lerp: o = a ? this.options.lerp : void 0, duration: s = a ? this.options.duration : void 0, easing: c = a ? this.options.easing : void 0, onStart: l, onComplete: u, force: d = !1, userData: f } = {}) {
		if (this.prefersReducedMotion && (a ? n = !0 : (o = 1, s = void 0, c = void 0)), (this.isStopped || this.isLocked) && !d) return;
		let p = e, m = t;
		if (typeof p == "string" && [
			"top",
			"left",
			"start",
			"#"
		].includes(p)) p = 0;
		else if (typeof p == "string" && [
			"bottom",
			"right",
			"end"
		].includes(p)) p = this.limit;
		else {
			let e = null;
			if (typeof p == "string" ? (e = p.startsWith("#") ? document.getElementById(p.slice(1)) : document.querySelector(p), e || (p === "#top" ? p = 0 : console.warn("Lenis: Target not found", p))) : p instanceof HTMLElement && p?.nodeType && (e = p), e) {
				if (this.options.wrapper !== window) {
					let e = this.rootElement.getBoundingClientRect();
					m -= this.isHorizontal ? e.left : e.top;
				}
				let t = e.getBoundingClientRect(), n = getComputedStyle(e), r = this.isHorizontal ? Number.parseFloat(n.scrollMarginLeft) : Number.parseFloat(n.scrollMarginTop), i = getComputedStyle(this.rootElement), a = this.isHorizontal ? Number.parseFloat(i.scrollPaddingLeft) : Number.parseFloat(i.scrollPaddingTop);
				p = (this.isHorizontal ? t.left : t.top) + this.animatedScroll - (Number.isNaN(r) ? 0 : r) - (Number.isNaN(a) ? 0 : a);
			}
		}
		if (typeof p == "number") {
			if (p += m, this.options.infinite) {
				if (a) {
					this.targetScroll = this.animatedScroll = this.scroll;
					let e = p - this.animatedScroll;
					e > this.limit / 2 ? p -= this.limit : e < -this.limit / 2 && (p += this.limit);
				}
			} else p = i(0, p, this.limit);
			p === this.targetScroll ? (l?.(this), u?.(this)) : (this.userData = f ?? {}, n ? (this.animatedScroll = this.targetScroll = p, this.setScroll(this.scroll), this.reset(), this.preventNextNativeScrollEvent(), this.emit(), u?.(this), this.userData = {}, requestAnimationFrame(() => {
				this.dispatchScrollendEvent();
			})) : (a || (this.targetScroll = p), typeof s == "number" && typeof c != "function" ? c = g : typeof c == "function" && typeof s != "number" && (s = 1), this.animate.fromTo(this.animatedScroll, p, {
				duration: s,
				easing: c,
				lerp: o,
				onStart: () => {
					r && (this.isLocked = !0), this.isScrolling = "smooth", l?.(this);
				},
				onUpdate: (e, t) => {
					this.isScrolling = "smooth", this.lastVelocity = this.velocity, this.velocity = e - this.animatedScroll, this.direction = Math.sign(this.velocity), this.animatedScroll = e, this.setScroll(this.scroll), a && (this.targetScroll = e), t || this.emit(), t && (this.reset(), this.emit(), u?.(this), this.userData = {}, requestAnimationFrame(() => {
						this.dispatchScrollendEvent();
					}), this.preventNextNativeScrollEvent());
				}
			})));
		}
	}
	preventNextNativeScrollEvent() {
		this._preventNextNativeScrollEvent = !0, requestAnimationFrame(() => {
			this._preventNextNativeScrollEvent = !1;
		});
	}
	hasNestedScroll(e, { deltaX: t, deltaY: n }) {
		let r = Date.now();
		e._lenis ||= {};
		let i = e._lenis, a, o, s, c, l, u, d, f, p, m;
		if (r - (i.time ?? 0) > 2e3) {
			i.time = Date.now();
			let t = window.getComputedStyle(e);
			if (i.computedStyle = t, a = [
				"auto",
				"overlay",
				"scroll"
			].includes(t.overflowX), o = [
				"auto",
				"overlay",
				"scroll"
			].includes(t.overflowY), l = ["auto"].includes(t.overscrollBehaviorX), u = ["auto"].includes(t.overscrollBehaviorY), i.hasOverflowX = a, i.hasOverflowY = o, !(a || o)) return !1;
			d = e.scrollWidth, f = e.scrollHeight, p = e.clientWidth, m = e.clientHeight, s = d > p, c = f > m, i.isScrollableX = s, i.isScrollableY = c, i.scrollWidth = d, i.scrollHeight = f, i.clientWidth = p, i.clientHeight = m, i.hasOverscrollBehaviorX = l, i.hasOverscrollBehaviorY = u;
		} else s = i.isScrollableX, c = i.isScrollableY, a = i.hasOverflowX, o = i.hasOverflowY, d = i.scrollWidth, f = i.scrollHeight, p = i.clientWidth, m = i.clientHeight, l = i.hasOverscrollBehaviorX, u = i.hasOverscrollBehaviorY;
		if (!(a && s || o && c)) return !1;
		let h = Math.abs(t) >= Math.abs(n) ? "horizontal" : "vertical", g, _, v, y, b, x;
		if (h === "horizontal") g = Math.round(e.scrollLeft), _ = d - p, v = t, y = a, b = s, x = l;
		else if (h === "vertical") g = Math.round(e.scrollTop), _ = f - m, v = n, y = o, b = c, x = u;
		else return !1;
		return !x && (g >= _ || g <= 0) || (v > 0 ? g < _ : g > 0) && y && b;
	}
	get rootElement() {
		return this.options.wrapper === window ? document.documentElement : this.options.wrapper;
	}
	get limit() {
		return this.options.naiveDimensions ? this.isHorizontal ? this.rootElement.scrollWidth - this.rootElement.clientWidth : this.rootElement.scrollHeight - this.rootElement.clientHeight : this.dimensions.limit[this.isHorizontal ? "x" : "y"];
	}
	get isHorizontal() {
		return this.options.orientation === "horizontal";
	}
	get actualScroll() {
		let e = this.options.wrapper;
		return this.isHorizontal ? e.scrollX ?? e.scrollLeft : e.scrollY ?? e.scrollTop;
	}
	get scroll() {
		return this.options.infinite ? s(this.animatedScroll, this.limit) : this.animatedScroll;
	}
	get progress() {
		return this.limit === 0 ? 1 : this.scroll / this.limit;
	}
	get isScrolling() {
		return this._isScrolling;
	}
	set isScrolling(e) {
		this._isScrolling !== e && (this._isScrolling = e, this.updateClassName());
	}
	get isStopped() {
		return this._isStopped;
	}
	set isStopped(e) {
		this._isStopped !== e && (this._isStopped = e, this.updateClassName());
	}
	get isLocked() {
		return this._isLocked;
	}
	set isLocked(e) {
		this._isLocked !== e && (this._isLocked = e, this.updateClassName());
	}
	get isSmooth() {
		return this.isScrolling === "smooth";
	}
	get prefersReducedMotion() {
		return this.options.respectReducedMotion && this.reducedMotionMediaQuery.matches;
	}
	get className() {
		let e = "lenis";
		return this.options.autoToggle && (e += " lenis-autoToggle"), this.isStopped && (e += " lenis-stopped"), this.isLocked && (e += " lenis-locked"), this.isScrolling && (e += " lenis-scrolling"), this.isScrolling === "smooth" && (e += " lenis-smooth"), e;
	}
	updateClassName() {
		this.cleanUpClassName(), this.className.split(" ").forEach((e) => {
			this.rootElement.classList.add(e);
		});
	}
	cleanUpClassName() {
		for (let e of Array.from(this.rootElement.classList)) (e === "lenis" || e.startsWith("lenis-")) && this.rootElement.classList.remove(e);
	}
}, v = (e, t, n) => n > t ? t : n < e ? e : n, y = {};
//#endregion
//#region node_modules/motion-utils/dist/es/memo.mjs
/*#__NO_SIDE_EFFECTS__*/
function b(e) {
	let t;
	return () => (t === void 0 && (t = e()), t);
}
//#endregion
//#region node_modules/motion-utils/dist/es/noop.mjs
var x = /* @__NO_SIDE_EFFECTS__ */ (e) => e, S = /* @__NO_SIDE_EFFECTS__ */ (e) => e * 1e3, C = /* @__NO_SIDE_EFFECTS__ */ (e) => e / 1e3, w = (e, t, n) => (((1 - 3 * n + 3 * t) * e + (3 * n - 6 * t)) * e + 3 * t) * e, T = 1e-7, E = 12;
function D(e, t, n, r, i) {
	let a, o, s = 0;
	do
		o = t + (n - t) / 2, a = w(o, r, i) - e, a > 0 ? n = o : t = o;
	while (Math.abs(a) > T && ++s < E);
	return o;
}
/*#__NO_SIDE_EFFECTS__*/
function O(e, t, n, r) {
	if (e === t && n === r) return x;
	let i = (t) => D(t, 0, 1, e, n);
	return (e) => e === 0 || e === 1 ? e : w(i(e), t, r);
}
//#endregion
//#region node_modules/motion-utils/dist/es/easing/modifiers/mirror.mjs
var ee = /* @__NO_SIDE_EFFECTS__ */ (e) => (t) => t <= .5 ? e(2 * t) / 2 : (2 - e(2 * (1 - t))) / 2, k = /* @__NO_SIDE_EFFECTS__ */ (e) => (t) => 1 - e(1 - t), te = /*@__PURE__*/ O(.33, 1.53, .69, .99), ne = /*@__PURE__*/ k(te), re = /*@__PURE__*/ ee(ne), j = (e) => e >= 1 ? 1 : (e *= 2) < 1 ? .5 * ne(e) : .5 * (2 - 2 ** (-10 * (e - 1))), M = (e) => 1 - Math.sin(Math.acos(e)), ie = /* @__PURE__ */ k(M), ae = /* @__PURE__ */ ee(M), oe = /*@__PURE__*/ O(.42, 0, 1, 1), se = /*@__PURE__*/ O(0, 0, .58, 1), ce = /*@__PURE__*/ O(.42, 0, .58, 1), N = /* @__NO_SIDE_EFFECTS__ */ (e) => Array.isArray(e) && typeof e[0] == "number", le = {
	linear: x,
	easeIn: oe,
	easeInOut: ce,
	easeOut: se,
	circIn: M,
	circInOut: ae,
	circOut: ie,
	backIn: ne,
	backInOut: re,
	backOut: te,
	anticipate: j
}, P = (e) => typeof e == "string", ue = (e) => {
	if (/* @__PURE__ */ N(e)) {
		e.length;
		let [t, n, r, i] = e;
		return /* @__PURE__ */ O(t, n, r, i);
	}
	return P(e) ? (le[e], `${e}`, le[e]) : e;
}, de = {
	delta: 0,
	timestamp: 0,
	isProcessing: !1
}, fe;
function pe() {
	fe = void 0;
}
var me = {
	now: () => (fe === void 0 && me.set(de.isProcessing || y.useManualTiming ? de.timestamp : performance.now()), fe),
	set: (e) => {
		fe = e, queueMicrotask(pe);
	}
}, F = (e, t, n = 10) => {
	let r = "", i = Math.max(Math.round(t / n), 2);
	for (let t = 0; t < i; t++) r += Math.round(e(t / (i - 1)) * 1e4) / 1e4 + ", ";
	return `linear(${r.substring(0, r.length - 2)})`;
}, I = 2e4;
function L(e, t = 50, n = I, r) {
	let i = 0, a = e.next(i);
	for (r?.push(a.value); !a.done && i < n;) i += t, a = e.next(i), r?.push(a.value);
	return i >= n ? Infinity : i;
}
//#endregion
//#region node_modules/motion-dom/dist/es/animation/generators/utils/create-generator-easing.mjs
function he(e, t = 100, n) {
	let r = n({
		...e,
		keyframes: [0, t]
	}), i = Math.min(L(r), I);
	return {
		type: "keyframes",
		ease: (e) => r.next(i * e).value / t,
		duration: /* @__PURE__ */ C(i)
	};
}
//#endregion
//#region node_modules/motion-dom/dist/es/animation/generators/spring.mjs
var R = {
	stiffness: 100,
	damping: 10,
	mass: 1,
	duration: 800,
	bounce: .3,
	visualDuration: .3,
	restSpeed: {
		granular: .01,
		default: 2
	},
	restDelta: {
		granular: .005,
		default: .5
	},
	minDuration: .01,
	maxDuration: 10,
	minDamping: .05
}, ge = (e) => e < 0 ? 1 / Math.max(1 + e, R.minDamping) : Math.max(1 - e, R.minDamping);
function z(e, t) {
	if (!(e > 1)) return 1;
	let n = Math.sqrt(e * e - 1), r = e - n, i = e + n, a = 2 * n * Math.exp(-t) * (1 + t);
	return ve((e) => i * Math.exp(-r * e) - r * Math.exp(-i * e) - a, (e) => Math.exp(-i * e) - Math.exp(-r * e), t) / t;
}
function B(e, t) {
	return e * Math.sqrt(1 - t * t);
}
var _e = 12;
function ve(e, t, n) {
	let r = n;
	for (let n = 1; n < _e; n++) r -= e(r) / t(r);
	return r;
}
var ye = .001;
function be({ duration: e = R.duration, bounce: t = R.bounce }) {
	let n, r;
	R.maxDuration;
	let i = ge(t);
	e = v(R.minDuration, R.maxDuration, /* @__PURE__ */ C(e)), i < 1 ? (n = (t) => {
		let n = t * i, r = n * e, a = B(t, i), o = Math.exp(-r);
		return ye - n / a * o;
	}, r = (t) => {
		let r = t * i * e, a = i * i * t * t * e, o = Math.exp(-r), s = B(t * t, i);
		return (-n(t) + ye > 0 ? -1 : 1) * -a * o / s;
	}) : (n = (t) => -.001 + Math.exp(-t * e) * (t * e + 1), r = (t) => Math.exp(-t * e) * (-t * (e * e)));
	let a = 5 / e, o = ve(n, r, a), s = o * z(i, o * e), c = s * s;
	return {
		stiffness: c,
		damping: i * 2 * Math.sqrt(c),
		duration: /* @__PURE__ */ S(e)
	};
}
var V = (e, t) => (t ? e >= 0 : e > 0) && e < Infinity;
function xe(e, t) {
	if (V(e, t)) return e;
}
function Se(e) {
	let t = xe(e.stiffness), n = xe(e.damping, !0), r = xe(e.mass), i = {
		...e,
		stiffness: t ?? R.stiffness,
		damping: n ?? R.damping,
		mass: r ?? R.mass,
		isResolvedFromDuration: !1,
		isTimeDefined: (t ?? n ?? r) === void 0 && (e.duration !== void 0 || e.bounce !== void 0)
	};
	if (i.isTimeDefined) {
		if (e.visualDuration) {
			let t = ge(e.bounce || 0), n = 2 * Math.PI / (e.visualDuration * 1.2) * z(t, 2 * Math.PI / 1.2);
			i.stiffness = n * n, i.damping = 2 * t * Math.sqrt(i.stiffness);
		} else Object.assign(i, be(i)), i.isResolvedFromDuration = !0;
		(!V(i.stiffness) || !V(i.damping, !0)) && (i.stiffness = R.stiffness, i.damping = R.damping);
	}
	return i;
}
function Ce(e = R.visualDuration, t = R.bounce) {
	let n = typeof e == "object" ? e : {
		visualDuration: e,
		keyframes: [0, 1],
		bounce: t
	}, r = n.keyframes[0], i = n.keyframes[n.keyframes.length - 1], a = {
		done: !1,
		value: r
	}, { stiffness: o, damping: s, mass: c, duration: l, isResolvedFromDuration: u, isTimeDefined: d } = Se({ ...n }), f = (e) => d ? 0 : -/* @__PURE__ */ C(e), p = s / (2 * Math.sqrt(o * c)), m = /* @__PURE__ */ C(Math.sqrt(o / c)), h = p * m, g = {
		target: i,
		delta: i - r,
		velocity: f(n.velocity || 0) || 0,
		restSpeed: 0,
		restDelta: 0
	}, _ = () => {
		let e = Math.abs(g.delta) < 5;
		g.restSpeed = n.restSpeed || (e ? R.restSpeed.granular : R.restSpeed.default), g.restDelta = n.restDelta || (e ? R.restDelta.granular : R.restDelta.default);
	};
	_();
	let v, y, b;
	if (p < 1) {
		let e = B(m, p), t = {
			A: 0,
			sinC: 0,
			cosC: 0,
			t: -1,
			env: 0,
			sin: 0,
			cos: 0
		};
		b = () => {
			t.A = (g.velocity + h * g.delta) / e, t.sinC = h * t.A + g.delta * e, t.cosC = h * g.delta - t.A * e;
		};
		let n = (n) => {
			n !== t.t && (t.t = n, t.env = Math.exp(-h * n), t.sin = Math.sin(e * n), t.cos = Math.cos(e * n));
		};
		v = (e) => (n(e), g.target - t.env * (t.A * t.sin + g.delta * t.cos)), y = (e) => (n(e), t.env * (t.sinC * t.sin + t.cosC * t.cos));
	} else if (p === 1) {
		v = (e) => g.target - Math.exp(-m * e) * (g.delta + (g.velocity + m * g.delta) * e);
		let e = { C: 0 };
		b = () => {
			e.C = g.velocity + m * g.delta;
		}, y = (t) => Math.exp(-m * t) * (m * e.C * t - g.velocity);
	} else {
		let e = m * Math.sqrt(p * p - 1), t = h - e, n = h + e, r = d ? Infinity : 300 / e, i = (e, t) => Math.exp(t > r ? -e * r - h * (t - r) : -e * t), a = {
			S: 0,
			F: 0
		};
		b = () => {
			let t = (g.velocity + h * g.delta) / e;
			a.S = (g.delta + t) / 2, a.F = (g.delta - t) / 2;
		}, v = (e) => g.target - a.S * i(t, e) - a.F * i(n, e), y = (e) => t * a.S * i(t, e) + n * a.F * i(n, e);
	}
	b();
	let x = u && l || null, w = {
		calculatedDuration: x,
		retarget: (e, t) => {
			g.target = e[e.length - 1], g.delta = g.target - e[0], g.velocity = f(t), n.restSpeed && n.restDelta || _(), w.calculatedDuration = x, a.done = !1, b();
		},
		velocity: (e) => /* @__PURE__ */ S(y(e)),
		next: (e) => {
			let t = v(e);
			if (u) a.done = e >= l;
			else {
				let n = /* @__PURE__ */ S(y(e));
				a.done = Math.abs(n) <= g.restSpeed && Math.abs(g.target - t) <= g.restDelta;
			}
			return a.value = a.done ? g.target : t, a;
		},
		toString: () => {
			let e = Math.min(L(w), I), t = F((t) => w.next(e * t).value, e, 30);
			return e + "ms " + t;
		},
		toTransition: () => {}
	};
	return w;
}
Ce.applyToOptions = (e) => {
	let t = he(e, 100, Ce);
	return e.ease = t.ease, e.duration = /* @__PURE__ */ S(t.duration), e.type = "keyframes", e;
};
//#endregion
//#region node_modules/motion-dom/dist/es/animation/keyframes/get-final.mjs
var we = (e) => e !== null;
function Te(e, { repeat: t, repeatType: n = "loop" }, r, i = 1) {
	let a = e.filter(we), o = i < 0 || t && n !== "loop" && t % 2 == 1 ? 0 : a.length - 1;
	return !o || r === void 0 ? a[o] : r;
}
//#endregion
//#region node_modules/motion-dom/dist/es/animation/utils/notify-inspector.mjs
function Ee(e, t) {
	return {
		kind: e,
		animation: t,
		timestamp: me.now(),
		frameTimestamp: de.timestamp,
		frameIsProcessing: de.isProcessing
	};
}
function De(e, t, n) {
	let r = globalThis.__MOTION_INSPECT__;
	if (r) try {
		r({
			...Ee("animation-start", e),
			options: n ? {
				...t,
				...n
			} : t
		});
	} catch {}
}
//#endregion
//#region node_modules/motion-dom/dist/es/animation/utils/WithPromise.mjs
var Oe = class {
	constructor() {
		this.isResolved = !1;
	}
	get finished() {
		return this._finished ||= this.isResolved ? Promise.resolve() : new Promise((e) => {
			this._resolve = e;
		}), this._finished;
	}
	updateFinished() {
		this._finished = this._resolve = void 0, this.isResolved = !1;
	}
	notifyFinished() {
		this.isResolved = !0, this._resolve?.();
	}
	then(e, t) {
		return this.finished.then(e, t);
	}
};
//#endregion
//#region node_modules/motion-dom/dist/es/animation/keyframes/utils/fill-wildcards.mjs
function ke(e) {
	for (let t = 1; t < e.length; t++) e[t] ?? (e[t] = e[t - 1]);
}
//#endregion
//#region node_modules/motion-dom/dist/es/render/dom/is-css-var.mjs
var Ae = (e) => e.startsWith("--");
//#endregion
//#region node_modules/motion-dom/dist/es/render/dom/style-set.mjs
function je(e, t, n) {
	Ae(t) ? e.style.setProperty(t, n) : e.style[t] = n;
}
//#endregion
//#region node_modules/motion-dom/dist/es/utils/supports/flags.mjs
var Me = {};
//#endregion
//#region node_modules/motion-dom/dist/es/utils/supports/memo.mjs
function Ne(e, t) {
	let n = /* @__PURE__ */ b(e);
	return () => Me[t] ?? n();
}
//#endregion
//#region node_modules/motion-dom/dist/es/utils/supports/scroll-timeline.mjs
var Pe = /* @__PURE__ */ Ne(() => window.ScrollTimeline !== void 0, "scrollTimeline"), Fe = /*@__PURE__*/ Ne(() => {
	try {
		document.createElement("div").animate({ opacity: 0 }, { easing: "linear(0, 1)" });
	} catch {
		return !1;
	}
	return !0;
}, "linearEasing"), Ie = ([e, t, n, r]) => `cubic-bezier(${e}, ${t}, ${n}, ${r})`, Le = {
	linear: "linear",
	ease: "ease",
	easeIn: "ease-in",
	easeOut: "ease-out",
	easeInOut: "ease-in-out",
	circIn: /*@__PURE__*/ Ie([
		0,
		.65,
		.55,
		1
	]),
	circOut: /*@__PURE__*/ Ie([
		.55,
		0,
		1,
		.45
	]),
	backIn: /*@__PURE__*/ Ie([
		.31,
		.01,
		.66,
		-.59
	]),
	backOut: /*@__PURE__*/ Ie([
		.33,
		1.53,
		.69,
		.99
	])
};
//#endregion
//#region node_modules/motion-dom/dist/es/animation/waapi/easing/map-easing.mjs
function Re(e, t) {
	if (e) return typeof e == "function" ? Fe() ? F(e, t) : "ease-out" : /* @__PURE__ */ N(e) ? Ie(e) : Array.isArray(e) ? e.map((e) => Re(e, t) || Le.easeOut) : Le[e];
}
//#endregion
//#region node_modules/motion-dom/dist/es/animation/waapi/start-waapi-animation.mjs
function ze(e, t, n, { delay: r = 0, duration: i = 300, repeat: a = 0, repeatType: o = "loop", ease: s = "easeOut", times: c } = {}, l = void 0) {
	let u = { [t]: n };
	c && (u.offset = c);
	let d = Re(s, i);
	Array.isArray(d) && (u.easing = d);
	let f = {
		delay: r,
		duration: i,
		easing: Array.isArray(d) ? "linear" : d,
		fill: "both",
		iterations: a + 1,
		direction: o === "reverse" ? "alternate" : "normal"
	};
	return l && (f.pseudoElement = l), e.animate(u, f);
}
//#endregion
//#region node_modules/motion-dom/dist/es/animation/generators/utils/is-generator.mjs
function Be(e) {
	return typeof e == "function" && "applyToOptions" in e;
}
//#endregion
//#region node_modules/motion-dom/dist/es/animation/waapi/utils/apply-generator.mjs
function Ve({ type: e, ...t }) {
	return Be(e) && Fe() ? e.applyToOptions(t) : (t.duration ??= 300, t.ease ??= "easeOut", t);
}
//#endregion
//#region node_modules/motion-dom/dist/es/animation/NativeAnimation.mjs
var He = class extends Oe {
	constructor(e) {
		if (super(), this.finishedTime = null, this.isStopped = !1, this.manualStartTime = null, !e) return;
		let { element: t, name: n, keyframes: r, pseudoElement: i, allowFlatten: a = !1, finalKeyframe: o, onComplete: s } = e;
		this.isPseudoElement = !!i, this.allowFlatten = a, this.options = e, e.type;
		let c = Ve(e);
		this.animation = ze(t, n, r, c, i), c.autoplay === !1 && this.animation.pause(), this.animation.onfinish = () => {
			if (this.finishedTime = this.time, !i) {
				let e = Te(r, this.options, o, this.speed);
				this.updateMotionValue && this.updateMotionValue(e), je(t, n, e), this.animation.cancel();
			}
			s?.(), this.notifyFinished();
		}, De(this, e, c);
	}
	play() {
		this.isStopped || (this.manualStartTime = null, this.animation.play(), this.state === "finished" && this.updateFinished());
	}
	pause() {
		this.animation.pause();
	}
	complete() {
		this.animation.finish?.();
	}
	cancel() {
		try {
			this.animation.cancel();
		} catch {}
	}
	stop() {
		if (this.isStopped) return;
		this.isStopped = !0;
		let { state: e } = this;
		e !== "idle" && e !== "finished" && (this.updateMotionValue ? this.updateMotionValue() : this.commitStyles(), this.isPseudoElement || this.cancel());
	}
	commitStyles() {
		let e = this.options?.element;
		!this.isPseudoElement && e?.isConnected && this.animation.commitStyles?.();
	}
	get duration() {
		let e = this.animation.effect?.getComputedTiming?.().duration || 0;
		return /* @__PURE__ */ C(Number(e));
	}
	get iterationDuration() {
		let { delay: e = 0 } = this.options || {};
		return this.duration + /* @__PURE__ */ C(e);
	}
	get time() {
		return /* @__PURE__ */ C(Number(this.animation.currentTime) || 0);
	}
	set time(e) {
		let t = this.finishedTime !== null;
		this.manualStartTime = null, this.finishedTime = null, this.animation.currentTime = /* @__PURE__ */ S(e), t && this.animation.pause();
	}
	get speed() {
		return this.animation.playbackRate;
	}
	set speed(e) {
		e < 0 && (this.finishedTime = null), this.animation.playbackRate = e;
	}
	get state() {
		return this.finishedTime === null ? this.animation.playState : "finished";
	}
	get startTime() {
		return this.manualStartTime ?? Number(this.animation.startTime);
	}
	set startTime(e) {
		this.manualStartTime = this.animation.startTime = e;
	}
	attachTimeline({ timeline: e, onAttach: t, observe: n }) {
		return this.allowFlatten && this.animation.effect?.updateTiming({ easing: "linear" }), this.animation.onfinish = null, e && Pe() ? (this.animation.timeline = e, t?.(this.animation), x) : n(this);
	}
}, Ue = class {
	constructor(e) {
		this.stop = () => this.runAll("stop"), this.animations = e.filter(Boolean);
	}
	get finished() {
		return Promise.all(this.animations.map((e) => e.finished));
	}
	getAll(e) {
		return this.animations[0][e];
	}
	setAll(e, t) {
		for (let n = 0; n < this.animations.length; n++) this.animations[n][e] = t;
	}
	attachTimeline(e) {
		let t = this.animations.map((t) => t.attachTimeline(e));
		return () => {
			t.forEach((e, t) => {
				e && e(), this.animations[t].stop();
			});
		};
	}
	get time() {
		return this.getAll("time");
	}
	set time(e) {
		this.setAll("time", e);
	}
	get speed() {
		return this.getAll("speed");
	}
	set speed(e) {
		this.setAll("speed", e);
	}
	get state() {
		return this.getAll("state");
	}
	get startTime() {
		return this.getAll("startTime");
	}
	get duration() {
		return We(this.animations, "duration");
	}
	get iterationDuration() {
		return We(this.animations, "iterationDuration");
	}
	runAll(e) {
		this.animations.forEach((t) => t[e]());
	}
	play() {
		this.runAll("play");
	}
	pause() {
		this.runAll("pause");
	}
	cancel() {
		this.runAll("cancel");
	}
	complete() {
		this.runAll("complete");
	}
};
function We(e, t) {
	let n = 0;
	for (let r = 0; r < e.length; r++) {
		let i = e[r][t];
		i !== null && i > n && (n = i);
	}
	return n;
}
//#endregion
//#region node_modules/motion-dom/dist/es/animation/GroupAnimationWithThen.mjs
var Ge = class extends Ue {
	then(e, t) {
		return this.finished.finally(e).then(() => {});
	}
}, Ke = /* @__PURE__ */ new WeakMap(), qe = (e, t = "") => `${e}:${t}`;
function Je(e) {
	let t = Ke.get(e);
	return t || (t = /* @__PURE__ */ new Map(), Ke.set(e, t)), t;
}
//#endregion
//#region node_modules/motion-dom/dist/es/animation/utils/resolve-transition.mjs
function Ye(e, t) {
	if (e?.inherit && t) {
		let { inherit: n, ...r } = e;
		return {
			...t,
			...r
		};
	}
	return e;
}
//#endregion
//#region node_modules/motion-dom/dist/es/animation/utils/get-value-transition.mjs
function Xe(e, t) {
	let n = e?.[t] ?? e?.default ?? e;
	return n === e ? n : Ye(n, e);
}
//#endregion
//#region node_modules/motion-dom/dist/es/animation/waapi/utils/px-values.mjs
var Ze = /* @__PURE__ */ new Set(/* @__PURE__ */ "borderWidth.borderTopWidth.borderRightWidth.borderBottomWidth.borderLeftWidth.borderRadius.borderTopLeftRadius.borderTopRightRadius.borderBottomRightRadius.borderBottomLeftRadius.width.maxWidth.height.maxHeight.top.right.bottom.left.inset.insetBlock.insetBlockStart.insetBlockEnd.insetInline.insetInlineStart.insetInlineEnd.padding.paddingTop.paddingRight.paddingBottom.paddingLeft.paddingBlock.paddingBlockStart.paddingBlockEnd.paddingInline.paddingInlineStart.paddingInlineEnd.margin.marginTop.marginRight.marginBottom.marginLeft.marginBlock.marginBlockStart.marginBlockEnd.marginInline.marginInlineStart.marginInlineEnd.fontSize.backgroundPositionX.backgroundPositionY".split("."));
//#endregion
//#region node_modules/motion-dom/dist/es/animation/keyframes/utils/apply-px-defaults.mjs
function Qe(e, t) {
	for (let n = 0; n < e.length; n++) typeof e[n] == "number" && Ze.has(t) && (e[n] = e[n] + "px");
}
//#endregion
//#region node_modules/motion-dom/dist/es/utils/resolve-elements.mjs
function $e(e, t, n) {
	if (e == null) return [];
	if (e instanceof EventTarget) return [e];
	if (typeof e == "string") {
		let r = document;
		t && (r = t.current);
		let i = n?.[e] ?? r.querySelectorAll(e);
		return i ? Array.from(i) : [];
	}
	return Array.from(e).filter((e) => e != null);
}
//#endregion
//#region node_modules/motion-dom/dist/es/render/dom/style-computed.mjs
function et(e, t) {
	let n = window.getComputedStyle(e);
	return Ae(t) ? n.getPropertyValue(t) : n[t];
}
//#endregion
//#region node_modules/motion-dom/dist/es/utils/stagger.mjs
function tt(e, t) {
	if (e === "first") return 0;
	{
		let n = t - 1;
		return e === "last" ? n : n / 2;
	}
}
function nt(e = .1, { startDelay: t = 0, from: n = 0, ease: r } = {}) {
	return (i, a) => {
		let o = typeof n == "number" ? n : tt(n, a), s = e * Math.abs(o - i);
		if (r) {
			let t = a * e;
			s = ue(r)(s / t) * t;
		}
		return t + s;
	};
}
//#endregion
//#region node_modules/framer-motion/dist/es/animation/animators/waapi/animate-elements.mjs
function rt(e, t, n, r) {
	if (e == null) return [];
	let i = $e(e, r), a = i.length, o = [];
	for (let e = 0; e < a; e++) {
		let r = i[e], s = { ...n };
		typeof s.delay == "function" && (s.delay = s.delay(e, a));
		for (let e in t) {
			let n = t[e];
			Array.isArray(n) || (n = [n]);
			let i = { ...Xe(s, e) };
			i.duration &&= /* @__PURE__ */ S(i.duration), i.delay &&= /* @__PURE__ */ S(i.delay);
			let a = Je(r), c = qe(e, i.pseudoElement || ""), l = a.get(c);
			l && l.stop(), o.push({
				map: a,
				key: c,
				unresolvedKeyframes: n,
				options: {
					...i,
					element: r,
					name: e,
					allowFlatten: !s.type && !s.ease
				}
			});
		}
	}
	for (let e = 0; e < o.length; e++) {
		let { unresolvedKeyframes: t, options: n } = o[e], { element: r, name: i, pseudoElement: a } = n;
		!a && t[0] === null && (t[0] = et(r, i)), ke(t), Qe(t, i), !a && t.length < 2 && t.unshift(et(r, i)), n.keyframes = t;
	}
	let s = [];
	for (let e = 0; e < o.length; e++) {
		let { map: t, key: n, options: r } = o[e], i = new He(r);
		t.set(n, i), i.finished.finally(() => t.delete(n)), s.push(i);
	}
	return s;
}
var it = /*@__PURE__*/ ((e) => {
	function t(t, n, r) {
		return new Ge(rt(t, n, r, e));
	}
	return t;
})(), at = {
	type: Ce,
	visualDuration: .38,
	bounce: .18
}, ot = class extends HTMLElement {
	connectedCallback() {
		this.A = window.A, this.reduced = this.A?.reduced ?? matchMedia("(prefers-reduced-motion: reduce)").matches, this.fine = this.A?.fine ?? matchMedia("(hover: hover) and (pointer: fine)").matches, this.header = this.closest(".site-header") || this, this.bar = this.querySelector(".nav-bar"), this.ac = new AbortController();
		let e = this.ac.signal;
		this.initScroll(e), this.initLogo(e), this.initPill(e), this.initMega(e), this.initMobile(e);
	}
	disconnectedCallback() {
		this.ac?.abort();
	}
	initScroll(e) {
		let t = this.header, n = scrollY, r = 0, i = !1, a = (e) => {
			e !== i && (i = e, t.classList.toggle("is-hidden", e), document.documentElement.classList.toggle("is-header-hidden", e), e || s());
		};
		document.documentElement.classList.remove("is-header-hidden");
		let o = [], s = () => {
			if (i) return;
			(!o.length || document.readyState === "loading") && (o = [...document.querySelectorAll("[data-header-dark]")]);
			let e = this.bar.getBoundingClientRect(), n = e.top + e.height / 2;
			t.classList.toggle("is-on-dark", o.some((e) => {
				let t = e.getBoundingClientRect();
				return t.top < n && t.bottom > n;
			}));
		}, c = innerHeight, l = () => {
			let e = document.documentElement.scrollHeight - innerHeight, i = Math.min(Math.max(scrollY, 0), Math.max(0, e)), o = i - n;
			if (n = i, t.classList.toggle("is-scrolled", i > 40), s(), innerHeight !== c) c = innerHeight, r = 0;
			else if (o) {
				if (Math.sign(o) !== Math.sign(r) && (r = 0), r += o, i < 160 || this.megaOpen || t.contains(document.activeElement)) return a(!1);
				r > 64 ? a(!0) : r < -48 && a(!1);
			}
		};
		addEventListener("scroll", l, {
			passive: !0,
			signal: e
		}), addEventListener("resize", s, {
			passive: !0,
			signal: e
		}), document.readyState === "loading" && document.addEventListener("DOMContentLoaded", s, {
			once: !0,
			signal: e
		}), l();
	}
	shine(e, t = 0) {
		let n = e?.querySelector(".logo-sheen");
		!n || this.reduced || n.running || (n.running = n.animate([{ transform: "translateX(0)" }, { transform: "translateX(720px)" }], {
			duration: 1150,
			delay: t,
			easing: "cubic-bezier(.45, 0, .2, 1)"
		}), n.running.finished.catch(() => {}).finally(() => {
			n.running = null;
		}));
	}
	initLogo(e) {
		let t = this.querySelector(".brand"), n = t?.querySelector(".logo-fx");
		if (!n) return;
		t.addEventListener("pointerenter", () => this.shine(n), { signal: e });
		let r = document.documentElement, i = () => this.shine(n, 400);
		if (r.classList.contains("is-loaded")) i();
		else {
			let t = new MutationObserver(() => {
				r.classList.contains("is-loaded") && (t.disconnect(), i());
			});
			t.observe(r, {
				attributes: !0,
				attributeFilter: ["class"]
			}), e.addEventListener("abort", () => t.disconnect());
		}
	}
	initPill(e) {
		let t = this.querySelector(".nav-pill"), n = this.querySelector(".nav-links");
		if (!t || !n) return;
		this.bar.classList.add("has-pill");
		let r = [...n.querySelectorAll(":scope > li > a, :scope > li > button")], i = r.find((e) => e.matches("[aria-current=\"page\"], [data-current]")), a = !1, o = null, s = null, c = () => this.megaOpen ? this.toggle : s || i, l = (e, n = !1) => {
			if (o = e, !e || !e.offsetWidth) {
				a && (a = !1, it(t, { opacity: 0 }, { duration: .2 }));
				return;
			}
			let r = {
				transform: `translateX(${e.offsetLeft}px)`,
				width: `${e.offsetWidth}px`
			};
			!a || n || this.reduced ? (it(t, r, { duration: 0 }), it(t, { opacity: 1 }, { duration: n || this.reduced ? 0 : .2 })) : it(t, r, at), a = !0;
		};
		this.pillHome = (e = !1) => l(c(), e), r.forEach((t) => {
			t.addEventListener("pointerenter", () => {
				s = t, l(t);
			}, { signal: e }), t.addEventListener("pointerleave", () => {
				s === t && (s = null);
			}, { signal: e }), t.addEventListener("focus", () => {
				t.matches(":focus-visible") && l(t);
			}, { signal: e });
		}), n.addEventListener("pointerleave", () => this.pillHome(), { signal: e }), n.addEventListener("focusout", (e) => {
			n.contains(e.relatedTarget) || this.pillHome();
		}, { signal: e });
		let u = new ResizeObserver(() => l(o, !0));
		[
			this.bar,
			...this.bar.children,
			...r
		].filter((e) => e !== t).forEach((e) => u.observe(e)), e.addEventListener("abort", () => u.disconnect()), this.pillHome(!0);
	}
	initMega(e) {
		let t = this.toggle = this.querySelector("[data-mega-toggle]"), n = this.querySelector("#mega"), r = document.querySelector("[data-mega-scrim]");
		if (!t || !n) return;
		let i = t.closest("li"), a = [...n.querySelectorAll("[data-mega-cat]")], o = new Map([...n.querySelectorAll("[data-mega-panel]")].map((e) => [e.dataset.megaPanel, e])), s = n.querySelector(".mega__panels"), c = a.find((e) => e.getAttribute("aria-current") === "page")?.dataset.megaCat || "all", l = "all", u, d, f = 0, p = !1, m = (e, t = !0) => {
			let n = o.get(l), r = o.get(e);
			if (!r || e === l || (l = e, a.forEach((t) => t.classList.toggle("is-active", t.dataset.megaCat === e)), n.hidden = !0, r.hidden = !1, !t || this.reduced)) return;
			let i = r.querySelectorAll(".mega__head, .mega__prod");
			it(i, {
				opacity: [0, 1],
				transform: ["translateY(10px)", "none"]
			}, {
				...at,
				delay: nt(.035)
			}).then(() => i.forEach((e) => {
				e.style.transform = "", e.style.opacity = "";
			}));
		}, h = (e = "click") => {
			clearTimeout(d), !this.megaOpen && (p || (p = !0, n.querySelectorAll("img[loading=\"lazy\"]").forEach((e) => e.loading = "eager")), m(c, !1), this.megaOpen = !0, f = e === "hover" ? performance.now() : 0, n.classList.add("is-open"), this.header.classList.add("is-mega-open"), r?.classList.add("is-on"), t.setAttribute("aria-expanded", "true"), this.pillHome?.());
		}, g = () => {
			clearTimeout(u), this.megaOpen && (this.megaOpen = !1, n.classList.remove("is-open"), this.header.classList.remove("is-mega-open"), r?.classList.remove("is-on"), t.setAttribute("aria-expanded", "false"), this.pillHome?.());
		};
		t.addEventListener("click", () => {
			this.megaOpen ? performance.now() - f > 450 && g() : h();
		}, { signal: e }), this.fine && (i.addEventListener("pointerenter", () => {
			clearTimeout(d), this.megaOpen || (u = setTimeout(() => h("hover"), 90));
		}, { signal: e }), i.addEventListener("pointerleave", () => {
			clearTimeout(u), d = setTimeout(g, 220);
		}, { signal: e })), r?.addEventListener("click", g, { signal: e }), t.addEventListener("keydown", (e) => {
			e.key === "ArrowDown" && (e.preventDefault(), h(), a.find((e) => e.classList.contains("is-active"))?.focus());
		}, { signal: e }), n.addEventListener("keydown", (e) => {
			let t = a.indexOf(document.activeElement);
			t > -1 && (e.key === "ArrowDown" || e.key === "ArrowUp") ? (e.preventDefault(), a[(t + (e.key === "ArrowDown" ? 1 : -1) + a.length) % a.length].focus()) : t > -1 && e.key === "ArrowRight" ? (e.preventDefault(), o.get(l)?.querySelector(".mega__prod")?.focus()) : e.key === "ArrowLeft" && e.target.closest(".mega__panels") && (e.preventDefault(), a.find((e) => e.dataset.megaCat === l)?.focus());
		}, { signal: e }), document.addEventListener("keydown", (e) => {
			e.key === "Escape" && this.megaOpen && (g(), t.focus());
		}, { signal: e }), i.addEventListener("focusout", (e) => {
			e.relatedTarget && !i.contains(e.relatedTarget) && g();
		}, { signal: e });
		let _ = [];
		n.addEventListener("pointermove", (e) => {
			_.push([e.clientX, e.clientY]), _.length > 4 && _.shift();
		}, { signal: e });
		let v = () => {
			if (_.length < 2) return !1;
			let [e, t] = _[0], [n, r] = _[_.length - 1], i = s.getBoundingClientRect();
			if (n >= i.left || n <= e) return !1;
			let a = (e, t, n, r) => (r - t) / (n - e);
			return a(n, r, i.left, i.top - 20) < a(e, t, i.left, i.top - 20) && a(n, r, i.left, i.bottom + 20) > a(e, t, i.left, i.bottom + 20);
		}, y;
		a.forEach((t) => {
			t.addEventListener("pointerenter", () => {
				clearTimeout(y), v() ? y = setTimeout(() => {
					t.matches(":hover") && m(t.dataset.megaCat);
				}, 150) : m(t.dataset.megaCat);
			}, { signal: e }), t.addEventListener("focus", () => m(t.dataset.megaCat), { signal: e });
		});
	}
	initMobile(e) {
		let t = document.getElementById("mnav"), n = this.querySelector("[data-mnav-open]"), r = t?.querySelector("[data-mnav-close]");
		if (!t || !n || !r) return;
		let i = !1, a = [], o = (e) => {
			if (e) {
				let e = (n) => [...n.children].flatMap((n) => n === t ? [] : n.contains(t) ? e(n) : [n]);
				a = e(document.body).filter((e) => !e.inert && !e.matches("script, #search, [data-toasts]")), a.forEach((e) => e.inert = !0);
			} else a.forEach((e) => e.inert = !1), a = [];
		}, s = () => {
			if (i) return;
			i = !0, t.classList.add("is-open"), n.setAttribute("aria-expanded", "true"), this.A?.lock(), o(!0);
			let e = t.querySelector(".mnav__cat[aria-current]"), a = e?.parentElement;
			a && (a.scrollLeft += e.getBoundingClientRect().left - a.getBoundingClientRect().left - parseFloat(getComputedStyle(a).paddingLeft)), history.pushState({ mnav: !0 }, ""), setTimeout(() => r.focus(), 300), this.shine(t.querySelector(".logo-fx"), 450);
		}, c = (e = !1) => {
			if (i) {
				if (i = !1, t.classList.remove("is-open"), n.setAttribute("aria-expanded", "false"), this.A?.unlock(), o(!1), !e && history.state?.mnav) {
					let e = history.scrollRestoration;
					history.scrollRestoration = "manual", addEventListener("popstate", () => {
						history.scrollRestoration = e;
					}, { once: !0 }), history.back();
				}
				n.focus({ preventScroll: !0 });
			}
		};
		n.addEventListener("click", s, { signal: e }), r.addEventListener("click", () => c(), { signal: e }), t.addEventListener("keydown", (e) => {
			e.key === "Escape" && c();
		}, { signal: e }), addEventListener("popstate", () => c(!0), { signal: e }), t.addEventListener("click", (e) => {
			let t = e.target.closest("a[href]");
			if (!t || t.target === "_blank" || this.A?.lenis) return;
			let n = new URL(t.href, location.href);
			if (n.pathname !== location.pathname || n.search !== location.search || n.hash.length < 2) return;
			e.preventDefault();
			let r = () => {
				let e = document.querySelector(n.hash), t = e && this.A?.fitTop?.(e);
				t == null ? location.hash = n.hash : (scrollTo({
					top: t,
					behavior: this.A?.reduced ? "instant" : "smooth"
				}), history.replaceState(null, "", n.hash));
			};
			history.state?.mnav ? addEventListener("popstate", () => setTimeout(r), { once: !0 }) : setTimeout(r), c();
		}, { signal: e });
		let l = matchMedia("(min-width: 1080px)");
		l.addEventListener("change", () => {
			l.matches && c();
		}, { signal: e });
	}
};
customElements.define("aura-header", ot);
//#endregion
//#region src/announce/aura-announce.js
var st = 5e3, ct = class extends HTMLElement {
	connectedCallback() {
		if (this.track = this.querySelector(".announce__track"), this.msgs = [...this.querySelectorAll(".announce__msg")], !this.track || this.msgs.length < 2) return;
		this.reduced = window.A?.reduced ?? matchMedia("(prefers-reduced-motion: reduce)").matches, this.i = Math.max(0, this.msgs.findIndex((e) => e.classList.contains("is-active"))), this.holds = /* @__PURE__ */ new Set(), this.ac = new AbortController();
		let e = this.ac.signal;
		this.addEventListener("click", (e) => {
			let t = e.target.closest("[data-announce-step]");
			t && this.step(Number(t.dataset.announceStep), !0);
		}, { signal: e });
		let t = (e, t) => {
			t ? this.holds.add(e) : this.holds.delete(e), this.schedule();
		};
		this.addEventListener("pointerenter", (e) => e.pointerType === "mouse" && t("hover", !0), { signal: e }), this.addEventListener("pointerleave", () => t("hover", !1), { signal: e }), this.addEventListener("focusin", () => t("focus", !0), { signal: e }), this.addEventListener("focusout", (e) => {
			this.contains(e.relatedTarget) || t("focus", !1);
		}, { signal: e }), document.addEventListener("visibilitychange", () => t("hidden", document.hidden), { signal: e });
		let n = null, r = !1;
		this.track.addEventListener("pointerdown", (e) => {
			e.pointerType !== "mouse" && (n = e.clientX, r = !1, t("touch", !0));
		}, { signal: e }), this.track.addEventListener("pointerup", (e) => {
			if (n === null) return;
			let i = e.clientX - n;
			n = null, Math.abs(i) > 30 && (r = !0, this.step(i < 0 ? 1 : -1, !0)), setTimeout(() => t("touch", !1), 1500);
		}, { signal: e }), this.track.addEventListener("pointercancel", () => {
			n = null, t("touch", !1);
		}, { signal: e }), this.track.addEventListener("click", (e) => {
			r &&= (e.preventDefault(), !1);
		}, { signal: e }), this.schedule();
	}
	disconnectedCallback() {
		this.ac?.abort(), clearTimeout(this.t);
	}
	schedule() {
		clearTimeout(this.t), !(this.reduced || this.holds.size) && (this.t = setTimeout(() => this.step(1, !1), st));
	}
	step(e, t) {
		let n = this.msgs.length, r = this.msgs[this.i];
		this.i = (this.i + e + n) % n;
		let i = this.msgs[this.i];
		this.track.dataset.dir = e < 0 ? "prev" : "next", this.track.setAttribute("aria-live", t ? "polite" : "off");
		let a = r.contains(document.activeElement);
		r.classList.remove("is-active"), r.classList.add("is-leaving"), r.inert = !0, i.style.transition = "none", i.classList.remove("is-leaving"), i.offsetWidth, i.style.transition = "", i.classList.add("is-active"), i.inert = !1, a && i.focus({ preventScroll: !0 }), clearTimeout(r.leaveT), r.leaveT = setTimeout(() => r.classList.remove("is-leaving"), 800), this.schedule();
	}
};
//#endregion
//#region src/header/instant-nav.js
if (customElements.define("aura-announce", ct), HTMLScriptElement.supports?.("speculationrules")) {
	let e = ["/cart*", "/checkout*"], t = matchMedia("(hover: none)").matches, n = { and: [{ href_matches: "/*" }, { not: { selector_matches: "[target=\"_blank\"], [data-no-prerender]" } }] }, r = t ? { prefetch: [{
		where: n,
		eagerness: "moderate"
	}] } : {
		prerender: [{
			where: { and: [...n.and, { not: { href_matches: e } }] },
			eagerness: "moderate"
		}],
		prefetch: [{
			where: { href_matches: e },
			eagerness: "moderate"
		}]
	}, i = document.createElement("script");
	i.type = "speculationrules", i.textContent = JSON.stringify(r), document.head.append(i);
}
//#endregion
//#region src/tabs/aura-tabs.js
var lt = {
	type: Ce,
	visualDuration: .3,
	bounce: .12
}, ut = {
	type: Ce,
	visualDuration: .4,
	bounce: 0
}, dt = class extends HTMLElement {
	connectedCallback() {
		if (this.list = this.querySelector("[role=\"tablist\"]"), !this.list) return;
		this.reduced = window.A?.reduced ?? matchMedia("(prefers-reduced-motion: reduce)").matches, this.ac = new AbortController();
		let e = this.ac.signal;
		this.puck = document.createElement("span"), this.puck.className = "tab-puck", this.puck.setAttribute("aria-hidden", "true"), this.at = null;
		let t = new ResizeObserver(() => {
			this.place(!0), this.edges();
		}), n = () => {
			this.puck.isConnected || this.list.prepend(this.puck), t.disconnect(), [
				this,
				this.list,
				...this.tabs()
			].forEach((e) => t.observe(e)), this.place(!0);
		}, r = new MutationObserver((e) => {
			e.some((e) => e.type === "childList" && [...e.addedNodes, ...e.removedNodes].some((e) => e !== this.puck)) ? n() : this.place();
		});
		r.observe(this.list, {
			childList: !0,
			subtree: !0,
			attributes: !0,
			attributeFilter: ["aria-selected"]
		}), this.addEventListener("scroll", () => this.edges(), {
			passive: !0,
			signal: e
		}), e.addEventListener("abort", () => {
			r.disconnect(), t.disconnect();
		}), n();
	}
	disconnectedCallback() {
		this.ac?.abort();
	}
	tabs() {
		return [...this.list.querySelectorAll("[role=\"tab\"]")];
	}
	place(e = !1) {
		let t = this.tabs(), n = t.find((e) => e.getAttribute("aria-selected") === "true");
		if (t.forEach((e) => e.tabIndex = e === (n || t[0]) ? 0 : -1), !n || !n.offsetWidth) {
			this.classList.remove("has-puck"), this.at = null;
			return;
		}
		let r = n.offsetLeft, i = this.list.offsetWidth - r - n.offsetWidth;
		if (this.at && r === this.at.left && i === this.at.right) return;
		let a = {
			left: `${r}px`,
			right: `${i}px`
		};
		e || this.reduced || !this.at ? it(this.puck, a, { duration: 0 }) : it(this.puck, a, r > this.at.left ? {
			right: lt,
			left: ut
		} : {
			left: lt,
			right: ut
		}), this.at = {
			left: r,
			right: i
		}, this.classList.add("has-puck");
	}
	edges() {
		let e = this.scrollWidth - this.clientWidth;
		this.classList.toggle("is-clip-start", this.scrollLeft > 1), this.classList.toggle("is-clip-end", this.scrollLeft < e - 1);
	}
};
customElements.define("aura-tabs", dt);
//#endregion
//#region src/pdp/aura-chapters.js
var ft = {
	type: Ce,
	visualDuration: .3,
	bounce: .12
}, pt = {
	type: Ce,
	visualDuration: .4,
	bounce: 0
}, mt = (e) => e < .5 ? 4 * e ** 3 : 1 - (-2 * e + 2) ** 3 / 2, ht = "cubic-bezier(.16, 1, .3, 1)", gt = {
	duration: 1.4,
	easing: (e) => (1 - Math.cos(Math.PI * e)) / 2
}, _t = "[data-reveal], [data-split], .img-reveal", vt = ".drawer, .modal, .search, .mnav", yt = 180, bt = {
	notch: 300,
	push: 900
}, xt = 400, St = [
	"ArrowDown",
	"ArrowUp",
	"PageDown",
	"PageUp",
	" ",
	"Home",
	"End"
], Ct = 240, wt = 24, H = document.documentElement, Tt = (e) => new Promise((t) => setTimeout(t, e)), Et = () => new Promise((e) => requestAnimationFrame(e)), U = (e) => {
	let t = 0;
	for (; e; e = e.offsetParent) t += e.offsetTop;
	return t;
}, Dt = class extends HTMLElement {
	connectedCallback() {
		this.A = window.A, this.reduced = this.A?.reduced ?? matchMedia("(prefers-reduced-motion: reduce)").matches, this.wide = matchMedia("(min-width: 1000px) and (hover: hover) and (pointer: fine)"), this.nav = this.querySelector(".subnav"), this.bar = this.querySelector(".subnav__inner"), this.list = this.querySelector(".subnav__links"), this.buy = this.querySelector(".subnav__buy"), this.close = this.querySelector("[data-chapters-close]"), this.links = [...this.list.querySelectorAll("a[href^=\"#\"]")], this.secs = this.links.map((e) => document.querySelector(e.getAttribute("href"))), this.product = this.parentElement.previousElementSibling, this.next = this.secs.at(-1).nextElementSibling, [this.product, ...this.secs].forEach((e) => e.dataset.chapter = ""), this.puck = document.createElement("span"), this.puck.className = "subnav__puck", this.puck.setAttribute("aria-hidden", "true"), this.list.prepend(this.puck), this.on = !1, this.busy = !1, this.at = -1, this.cur = -1, this.gesture = 0, this.turned = -1, this.lastWheel = 0, this.input = -Infinity, this.speed = 0, this.spyAt = -Infinity, this.spyY = 0, this.tail = 0, this.wheelDir = 0, this.recent = [], this.peak = 0, this.low = 0, this.flickAt = -Infinity, this.notched = !1, this.queued = null, this.aim = null, this.armed = null, this.side = "above", this.folding = [], this.ac = new AbortController();
		let e = this.ac.signal;
		this.addEventListener("click", (e) => {
			e.target.closest("[data-chapters-close]") && this.exit("stay");
		}, { signal: e }), document.addEventListener("click", (e) => this.onLink(e), {
			capture: !0,
			signal: e
		}), document.addEventListener("click", (e) => {
			this.on && e.target.closest("[data-pick]") && this.exit("top");
		}, {
			capture: !0,
			signal: e
		}), addEventListener("scroll", () => this.spy(), {
			passive: !0,
			signal: e
		}), addEventListener("wheel", (e) => this.onWheel(e), {
			passive: !1,
			signal: e
		}), addEventListener("keydown", (e) => this.onKey(e), { signal: e }), addEventListener("resize", () => this.onResize(), { signal: e });
		let t = new ResizeObserver(() => {
			this.busy || this.place(!0);
		});
		[this.list, ...this.links].forEach((e) => t.observe(e)), e.addEventListener("abort", () => t.disconnect()), this.mark(0, !0);
	}
	disconnectedCallback() {
		this.ac?.abort();
	}
	select(e) {
		this.at = e, this.links.forEach((t, n) => {
			t.classList.toggle("is-active", n === e), t.toggleAttribute("aria-current", n === e);
		});
	}
	mark(e, t = !1) {
		e !== this.at && (this.select(e), this.place(t), this.on || this.A?.centerInRail(this.links[e]));
	}
	place(e = !1) {
		let t = this.links[this.at];
		if (!t?.offsetWidth) return;
		let n = t.offsetTop, r = t.offsetLeft, i = {
			top: `${n}px`,
			left: `${r}px`,
			width: `${t.offsetWidth}px`,
			height: `${t.offsetHeight}px`
		}, a = this.spot;
		this.spot = {
			top: n,
			left: r
		}, e || this.reduced || !a ? it(this.puck, i, { duration: 0 }) : n === a.top ? it(this.puck, i, {
			left: r > a.left ? pt : ft,
			width: ft,
			top: { duration: 0 },
			height: { duration: 0 }
		}) : it(this.puck, i, {
			top: n > a.top ? pt : ft,
			height: ft,
			left: { duration: 0 },
			width: { duration: 0 }
		}), this.classList.add("has-puck");
	}
	spied() {
		let e = innerHeight * .35, t = 0;
		return this.secs.forEach((n, r) => {
			n.getBoundingClientRect().top < e && (t = r);
		}), t;
	}
	spy() {
		let e = performance.now(), t = e - this.spyAt;
		this.speed = t > 0 && t < 100 ? (scrollY - this.spyY) / t : 0, this.spyAt = e, this.spyY = scrollY, !(this.on || this.busy) && (this.mark(this.spied()), this.auto());
	}
	edge() {
		let e = this.secs[0];
		return U(e) + parseFloat(getComputedStyle(e).paddingTop);
	}
	end() {
		let e = this.secs.at(-1);
		return this.tail = parseFloat(getComputedStyle(e).paddingBottom), U(e) + e.offsetHeight - this.tail;
	}
	zone() {
		let e = this.target();
		return this.edge() - e > innerHeight ? "above" : this.end() - e <= 1 ? "below" : "in";
	}
	auto() {
		if (this.busy || !this.wide.matches || document.querySelector(".rail.is-drag")) return;
		let e = this.zone();
		e === "in" ? (this.armed === null && (this.armed = !1), !(!this.armed || performance.now() - this.input > xt) && (this.armed = !1, this.enter(this.side === "below" ? this.secs.length - 1 : 0, this.side))) : (this.armed = !0, this.side = e);
	}
	onLink(e) {
		let t = e.target.closest("a[href^=\"#\"]"), n = t ? this.secs.findIndex((e) => `#${e.id}` === t.getAttribute("href")) : -1;
		if (n < 0) return;
		let r = this.links.includes(t);
		(this.on || this.wide.matches || r) && (e.preventDefault(), e.stopPropagation(), this.on ? this.go(n) : this.wide.matches ? this.enter(n, this.zone() === "above" ? "above" : "in") : this.jump(n));
	}
	jump(e) {
		let t = this.secs[e], n = U(t), r = n < scrollY, i = n - this.nav.offsetHeight - (r ? 88 : 12) - 16;
		this.A?.lenis ? this.A.lenis.scrollTo(i) : scrollTo({
			top: i,
			behavior: this.reduced ? "instant" : "smooth"
		}), history.replaceState(null, "", `#${t.id}`);
	}
	onWheel(e) {
		if (e.ctrlKey || e.target.closest?.(vt)) return;
		let t = e.deltaY * (e.deltaMode === 1 ? 32 : e.deltaMode === 2 ? innerHeight : 1), n = Math.sign(t), r = Math.abs(t), i = e.timeStamp - this.lastWheel, a = e.deltaMode === 1 || r >= 50 && Number.isInteger(e.deltaY) && e.wheelDeltaY && e.wheelDeltaY % 120 == 0 && Math.abs(e.wheelDeltaY) !== 3 * r, o = i <= yt && n === this.wheelDir, s = (this.recent = o ? [...this.recent.filter(([t]) => e.timeStamp - t < 100), [e.timeStamp, r]] : [[e.timeStamp, r]]).reduce((e, [, t]) => e + t, 0) * 16.7 / 100, c = o && !this.busy && this.low <= this.peak * .4 && s >= Math.max(8, this.low * 2.5) && e.timeStamp - this.flickAt > 300, l = !o || a || c;
		l ? (this.gesture++, this.flickAt = e.timeStamp, this.peak = this.low = s) : s > this.peak ? this.peak = this.low = s : this.low = Math.min(this.low, s), Object.assign(this, {
			lastWheel: e.timeStamp,
			wheelDir: n,
			notched: a,
			input: performance.now()
		}), this.on && (e.preventDefault(), n && (this.busy ? l && (this.queued = {
			dir: n,
			at: performance.now(),
			keep: a ? bt.notch : bt.push,
			gesture: this.gesture
		}) : this.move(n, r, this.gesture)));
	}
	flush() {
		let e = this.queued;
		this.queued = null, e && this.on && !this.busy && performance.now() - e.at < e.keep && this.move(e.dir, 100, e.gesture);
	}
	onKey(e) {
		if (St.includes(e.key) && (this.input = performance.now()), !this.on || e.defaultPrevented || e.altKey || e.ctrlKey || e.metaKey || e.target.closest?.(vt)) return;
		if (e.key === "Escape") {
			e.preventDefault(), this.exit("stay");
			return;
		}
		if (/^(input|textarea|select)$/i.test(e.target.tagName)) return;
		let t = e.key === " " && !e.target.closest("button, a, summary, [role=\"button\"]"), n = e.key === "ArrowDown" || e.key === "PageDown" || t && !e.shiftKey ? 1 : e.key === "ArrowUp" || e.key === "PageUp" || t && e.shiftKey ? -1 : 0;
		e.key === "Home" || e.key === "End" ? (e.preventDefault(), this.go(e.key === "Home" ? 0 : this.secs.length - 1)) : n && (e.preventDefault(), this.busy || this.move(n, e.key.startsWith("Arrow") ? 140 : innerHeight * .85, ++this.gesture));
	}
	move(e, t, n) {
		let r = this.secs[this.cur], i = U(r), a = this.aim ?? this.target(), o = e > 0 ? i + r.offsetHeight - innerHeight - a : a - i;
		if (o > 1) {
			this.aim = a + e * Math.min(t, o), this.scroll(this.aim, { lerp: .12 }), this.turned = n;
			return;
		}
		if (n === this.turned) return;
		this.turned = n;
		let s = this.cur + e;
		s < 0 ? this.exit("product") : s >= this.secs.length ? this.exit("after") : this.go(s);
	}
	onResize() {
		this.on && !this.busy && (this.wide.matches ? (this.aim = null, this.scroll(U(this.secs[this.cur]), { immediate: !0 })) : this.exit("stay"));
	}
	target() {
		return this.A?.lenis ? this.A.lenis.targetScroll : scrollY;
	}
	scroll(e, { immediate: t = !1, lerp: n, duration: r = .95, easing: i = mt } = {}) {
		return new Promise((a) => {
			let o = this.A?.lenis, s = t || this.reduced;
			o ? (o.scrollTo(e, {
				force: !0,
				immediate: s,
				...n ? { lerp: n } : {
					duration: r,
					easing: i
				},
				onComplete: () => a()
			}), s && a()) : (scrollTo({
				top: e,
				behavior: s || n ? "instant" : "smooth"
			}), setTimeout(a, s || n ? 0 : 700));
		});
	}
	onward(e, t) {
		let n = t ? Math.min(2.5, Math.max(0, e * 950 / t)) : 0;
		return (e) => n * (e ** 3 - 2 * e ** 2 + e) + 3 * e ** 2 - 2 * e ** 3;
	}
	reveal(e, t) {
		e.querySelectorAll(_t).forEach((e) => e.classList.toggle("is-in", t));
	}
	async show(e, t = !1, n = !1, r) {
		let i = this.secs[this.cur], a = this.secs[e], o = n ? -1 : Math.sign(e - this.cur);
		this.cur = e, this.aim = null, i?.classList.remove("is-current"), a.classList.add("is-current"), this.reveal(a, !0), this.mark(e), history.replaceState(null, "", `#${a.id}`);
		let s = U(a), c = o < 0 ? Math.max(s, s + a.offsetHeight - innerHeight) : s;
		await this.scroll(c, {
			immediate: t,
			easing: r
		}), i && i !== this.secs[this.cur] && this.reveal(i, !1);
	}
	async go(e) {
		if (!this.on || this.busy || e === this.cur) return;
		this.busy = !0;
		let t = performance.now() - this.spyAt < 100 ? this.speed : 0, n = this.secs[e], r = e < this.cur ? U(n) + Math.max(0, n.offsetHeight - innerHeight) : U(n);
		await this.show(e, !1, !1, Math.abs(t) > .05 ? this.onward(t, r - scrollY) : void 0), this.busy = !1, this.flush();
	}
	drift(e) {
		H.classList.add("is-chapters-snap"), H.style.setProperty("--chapter-drift", `${e}px`), H.offsetWidth, H.classList.remove("is-chapters-snap");
	}
	enter(e, t = "in") {
		return this.safely(() => this.opening(e, t));
	}
	async opening(e, t) {
		if (this.on || this.busy) return;
		let n = t === "below", r = performance.now() - this.spyAt < 100 ? this.speed : 0;
		if (this.on = this.busy = !0, this.turned = this.gesture, this.A?.lock(), this.select(e), t === "above" || t === "below") {
			let t = n ? this.next : null, i = t?.getBoundingClientRect().top;
			H.classList.add("is-chapters-on", "is-chapters"), t && await this.scroll(scrollY + t.getBoundingClientRect().top - i, { immediate: !0 }), this.secs.forEach((e) => this.reveal(e, !1)), this.cur = -1;
			let a = this.secs[e], o = n ? U(a) + Math.max(0, a.offsetHeight - innerHeight) : U(a), s = this.show(e, !1, n, this.onward(r, o - scrollY));
			await Promise.all([Et().then(() => this.unfold()), s]), this.busy = !1, this.flush();
			return;
		}
		H.style.setProperty("--chapter-drift", `${n ? wt : -24}px`), H.classList.add("is-chapters-on", "is-chapters-out");
		let i = this.unfold();
		await Tt(this.reduced ? 0 : Ct), this.secs.forEach((e) => this.reveal(e, !1)), this.drift(n ? -24 : wt), H.classList.add("is-chapters"), H.classList.remove("is-chapters-out"), this.cur = -1, await this.show(e, !0, n), await i, this.busy = !1, this.flush();
	}
	exit(e = "stay") {
		return this.safely(() => this.closing(e));
	}
	async closing(e) {
		if (!this.on || this.busy) return;
		if (this.busy = !0, e === "product") return this.onto(this.product, 0, gt, "above");
		if (e === "after" && this.next) return this.onto(this.next, Math.max(this.middle(this.next), U(this.next) - this.tail), {}, "below");
		let t = this.secs[this.cur], n = e === "top" ? wt : -24;
		H.style.setProperty("--chapter-drift", `${n}px`), H.classList.add("is-chapters-out");
		let r = this.fold();
		await Tt(this.reduced ? 0 : Ct), H.classList.remove("is-chapters"), t.classList.remove("is-current"), this.secs.forEach((e) => this.reveal(e, !0));
		let i = parseFloat(getComputedStyle(t).scrollMarginTop) || 0, a = e === "top" ? 0 : U(e === "after" ? this.secs.at(-1) : t) - i;
		await this.scroll(Math.max(0, a), { immediate: !0 }), this.drift(-n), H.classList.remove("is-chapters-out"), this.on = !1, this.armed = e !== "stay", this.side = e === "after" ? "below" : "above", this.select(this.spied()), await r, await this.settle();
	}
	middle(e) {
		let t = e.firstElementChild ?? e;
		return U(t) - Math.max(40, (innerHeight - t.offsetHeight) / 2);
	}
	async onto(e, t, n, r) {
		this.secs[this.cur].classList.remove("is-current"), e.classList.add("is-current"), this.cur = -1, history.replaceState(null, "", location.pathname + location.search), r === "above" && H.classList.add("is-chapters-home"), await Promise.all([this.scroll(Math.max(0, t), n), this.fold()]);
		let i = e.getBoundingClientRect().top;
		H.classList.remove("is-chapters", "is-chapters-home"), e.classList.remove("is-current"), this.secs.forEach((e) => this.reveal(e, !0));
		let a = e.getBoundingClientRect().top - i;
		Math.abs(a) > .5 && await this.scroll(scrollY + a, { immediate: !0 }), this.on = !1, this.armed = !0, this.side = r, this.select(this.spied()), await this.settle();
	}
	async safely(e) {
		try {
			await e();
		} catch (e) {
			this.folding.forEach((e) => e.cancel()), this.folding = [], this.classList.remove("is-rail"), H.classList.remove("is-chapters-on", "is-chapters", "is-chapters-out", "is-chapters-home"), [
				this.product,
				this.next,
				...this.secs
			].forEach((e) => e?.classList.remove("is-current")), this.secs.forEach((e) => this.reveal(e, !0)), this.on = this.busy = !1, this.cur = -1, this.armed = !1, this.A?.unlock(), console.error(e);
		}
	}
	async settle() {
		for (H.classList.remove("is-chapters-on"), this.queued = null; !this.notched && performance.now() - this.lastWheel < yt;) await Tt(50);
		this.A?.unlock(), this.busy = !1;
	}
	unfold() {
		if (this.folding.forEach((e) => e.cancel()), this.classList.add("is-rail"), this.spot = null, this.place(!0), this.reduced) return Promise.resolve();
		let e = [
			this.close,
			...this.links,
			...this.buy.children
		];
		return this.folding = [
			this.bar.animate([{
				clipPath: "inset(50% 0 round 30px)",
				opacity: 0
			}, {
				clipPath: "inset(0 0 round 30px)",
				opacity: 1
			}], {
				duration: 760,
				easing: ht
			}),
			...e.map((e, t) => e.animate([{
				opacity: 0,
				transform: "translateY(14px)"
			}, {
				opacity: 1,
				transform: "none"
			}], {
				duration: 560,
				delay: 140 + t * 45,
				easing: ht,
				fill: "backwards"
			})),
			this.puck.animate([{
				opacity: 0,
				scale: .8
			}, {
				opacity: 1,
				scale: 1
			}], {
				duration: 560,
				delay: 140 + (this.at + 1) * 45 + 120,
				easing: ht,
				fill: "backwards"
			})
		], Promise.all(this.folding.map((e) => e.finished)).then(() => this.folding.forEach((e) => e.cancel()), () => {});
	}
	async fold() {
		if (this.folding.forEach((e) => e.cancel()), !this.reduced) {
			let e = [
				this.close,
				...this.links,
				...this.buy.children,
				this.puck
			];
			this.folding = [...e.map((e) => e.animate([{ opacity: 1 }, { opacity: 0 }], {
				duration: 180,
				easing: "ease-out",
				fill: "forwards"
			})), this.bar.animate([{
				clipPath: "inset(0 0 round 30px)",
				opacity: 1
			}, {
				clipPath: "inset(50% 0 round 30px)",
				opacity: 0
			}], {
				duration: 420,
				delay: 60,
				easing: "cubic-bezier(.5, 0, .75, 0)",
				fill: "forwards"
			})], await Promise.all(this.folding.map((e) => e.finished)).catch(() => {});
		}
		this.classList.remove("is-rail"), this.folding.forEach((e) => e.cancel()), this.folding = [];
	}
};
customElements.define("aura-chapters", Dt);
//#endregion
//#region src/pdp/aura-overview.js
var Ot = (e) => e ? (e.complete && e.naturalWidth ? Promise.resolve() : new Promise((t) => {
	e.addEventListener("load", t, { once: !0 }), e.addEventListener("error", t, { once: !0 });
})).then(() => e.decode?.()).catch(() => {}) : Promise.resolve(), kt = .36, At = 1.25, jt = class extends HTMLElement {
	connectedCallback() {
		if (this.stage = this.querySelector("[data-ov-stage]"), this.frame = this.querySelector("[data-ov-frame]"), this.shots = [...this.querySelectorAll(".ov__shot")], this.tabs = [...this.querySelectorAll("[data-ov-view]")], this.bar = this.querySelector(".ov__bar"), this.mode = this.dataset.mode, this.mode === "finish") {
			this.querySelectorAll("img[loading=\"lazy\"]").forEach((e) => {
				e.loading = "eager";
			});
			let e = new IntersectionObserver(([t]) => {
				t.isIntersecting && (e.disconnect(), this.shots.forEach((e) => Ot(e.querySelector("img")).then(() => {
					e.decoded = !0;
				})));
			}, { rootMargin: "100% 0px" });
			e.observe(this);
		}
		this.box = this.shots[0].dataset.box?.split(" ").map(Number), this.view = 0, this.ac = new AbortController();
		let e = this.ac.signal;
		this.tabs.forEach((t, n) => t.addEventListener("click", () => this.show(n, !0), { signal: e })), this.mode === "finish" && (this.tones = [...this.querySelectorAll("[data-ov-tone]")], this.materials = [...this.querySelectorAll("[data-ov-material]")], this.tones.forEach((t) => t.addEventListener("click", () => this.pick(t.dataset.ovTone, this.shots[this.view].dataset.material), { signal: e })), this.materials.forEach((t) => t.addEventListener("click", () => this.pick(this.shots[this.view].dataset.tone, t.dataset.ovMaterial), { signal: e })), new ResizeObserver(() => this.style.setProperty("--bar-h", `${this.bar.offsetHeight}px`)).observe(this.bar)), this.frame.addEventListener("click", () => {
			if (this.mode !== "finish") {
				this.show(1 - this.view, !0);
				return;
			}
			let e = this.tones.map((e) => e.dataset.ovTone), t = this.shots[this.view].dataset;
			this.pick(e[(e.indexOf(t.tone) + 1) % e.length], t.material);
		}, { signal: e }), this.frame.addEventListener("pointerenter", (e) => {
			e.pointerType === "mouse" && (this.leaning = !0, this.place());
		}, { signal: e }), this.frame.addEventListener("pointerleave", () => {
			this.leaning = !1, this.place();
		}, { signal: e }), new ResizeObserver(() => this.measure()).observe(this), new MutationObserver(() => {
			!this.stage.classList.contains("is-in") && this.view && this.show(0, !1, !0);
		}).observe(this.stage, {
			attributes: !0,
			attributeFilter: ["class"]
		}), this.video = this.querySelector("video"), this.video && (this.seen = !1, new IntersectionObserver(([e]) => {
			this.seen = e.isIntersecting, this.play();
		}).observe(this), document.addEventListener("visibilitychange", () => this.play(), { signal: e })), this.measure(!0);
	}
	disconnectedCallback() {
		this.ac?.abort();
	}
	showFinish(e) {
		let t = this.shots.findIndex((t) => t.dataset.finish === e);
		t > -1 && t !== this.view && this.show(t);
	}
	pick(e, t) {
		let n = this.shots.findIndex((n) => n.dataset.tone === e && n.dataset.material === t);
		n < 0 && (n = this.shots.findIndex((t) => t.dataset.tone === e)), n > -1 && this.show(n, !0);
	}
	show(e, t = !1, n = !1) {
		if (e === this.view) return;
		let r = this.view;
		if (this.view = e, this.dataset.dir = e > r ? "in" : "out", this.mode === "finish") {
			let t = this.shots[r].dataset, n = this.shots[e].dataset, i = (e, t, n) => e.findIndex((e) => e.dataset[t] === n);
			this.sameRoom = t.tone === n.tone, this.dataset.dir = (this.sameRoom ? i(this.materials, "ovMaterial", n.material) > i(this.materials, "ovMaterial", t.material) : i(this.tones, "ovTone", n.tone) > i(this.tones, "ovTone", t.tone)) ? "in" : "out", this.tones.forEach((e) => e.setAttribute("aria-selected", e.dataset.ovTone === n.tone)), this.materials.forEach((e) => e.setAttribute("aria-selected", e.dataset.ovMaterial === n.material));
		} else this.tabs.forEach((t, n) => {
			t.setAttribute("aria-selected", n === e), t.tabIndex = n === e ? 0 : -1;
		});
		this.classList.toggle("is-close", this.mode !== "finish" && e === 1), n && this.snap(), this.place(), this.play(), t && this.mode === "finish" && this.dispatchEvent(new CustomEvent("ov:finish", { detail: this.shots[e].dataset.finish }));
	}
	snap() {
		this.classList.add("is-snap"), requestAnimationFrame(() => requestAnimationFrame(() => this.classList.remove("is-snap")));
	}
	play() {
		let e = this.video;
		e && (this.view === this.shots.indexOf(e.closest(".ov__shot")) && this.seen && !document.hidden && !window.A?.reduced ? (e.preload = "auto", e.play().catch(() => {})) : e.pause());
	}
	fit(e) {
		let { W: t, H: n, wide: r } = this, i = Math.min(t, n * e), a = i / e;
		return {
			x: 0,
			y: r ? (n - a) / 2 : 0,
			w: i,
			h: a
		};
	}
	measure(e = !1) {
		let t = this.stage.clientWidth;
		if (!t) return;
		this.wide = matchMedia("(min-width: 1000px)").matches, this.W = t;
		let n = this.shots.map((e) => +e.dataset.ar), r = this.mode === "zoom" ? [n[0], .8] : n;
		this.wide ? (this.stage.style.height = this.frame.style.height = "", this.H = this.stage.clientHeight) : (this.H = Infinity, this.H = Math.max(...r.map((e) => this.fit(e).h)), this.frame.style.height = `${this.H}px`), this.boxes = r.map((e) => this.fit(e)), this.shots.forEach((e, t) => {
			let r = this.fit(n[t]);
			Object.assign(e.style, {
				left: `${r.x}px`,
				top: `${r.y}px`,
				width: `${r.w}px`,
				height: `${r.h}px`
			}), e.box = r;
		}), e && this.snap(), this.place();
	}
	crossfade() {
		let e = this.shots[this.view], t = this.shots.filter((t) => t !== e);
		this.shown = this.view;
		let n = (e) => {
			e.fade?.cancel(), e.glide?.cancel(), e.fade = e.glide = null;
		}, r = () => {
			this.shots[this.view] === e && (t.forEach((e) => {
				n(e), e.classList.remove("is-on");
			}), n(e), e.classList.add("is-on"), this.base = e);
		};
		if (!this.base || this.classList.contains("is-snap") || window.A?.reduced) {
			e.style.zIndex = this.z = (this.z || 2) + 1, r();
			return;
		}
		let i = (e) => +getComputedStyle(e).opacity;
		if (e === this.base) {
			let e = t.filter((e) => e.classList.contains("is-on"));
			e.forEach((e) => {
				e.glide?.pause();
				let t = i(e);
				e.fade?.cancel(), e.fade = e.animate([{ opacity: t }, { opacity: 0 }], {
					duration: 250 + 400 * t,
					easing: "cubic-bezier(.4, 0, .2, 1)",
					fill: "both"
				});
			}), Promise.all(e.map((e) => e.fade.finished)).then(r, () => {});
			return;
		}
		let a = e.classList.contains("is-on");
		if (!a && !e.decoded) {
			let t = this.view;
			Ot(e.querySelector("img")).then(() => {
				e.decoded = !0, this.view === t && this.shown === t && this.crossfade();
			});
			return;
		}
		t.forEach((e) => {
			e.fade?.pause(), e.glide?.pause();
		});
		let o = a ? i(e) : 0, s = a ? getComputedStyle(e).transform : this.sameRoom ? "none" : `translateX(${this.dataset.dir === "out" ? -2 : 2}%) scale(1.015)`;
		n(e), e.style.zIndex = this.z = (this.z || 2) + 1, e.classList.add("is-on"), e.glide = e.animate([{ transform: s === "none" ? "translateX(0) scale(1)" : s }, { transform: "translateX(0) scale(1)" }], {
			duration: 1100,
			easing: "cubic-bezier(.22, .7, .25, 1)",
			fill: "both"
		}), e.fade = e.animate([{ opacity: o }, { opacity: 1 }], {
			duration: 250 + 450 * (1 - o),
			easing: "cubic-bezier(.4, 0, .2, 1)",
			fill: "both"
		}), Promise.all([e.fade.finished, e.glide.finished]).then(r, () => {});
	}
	centre() {
		let e = this.shots[0].box, [t, n, r, i] = this.box || [
			50,
			50,
			0,
			0
		];
		return [e.w * (t + r / 2) / 100, e.h * (n + i / 2) / 100];
	}
	moveIn(e) {
		let t = this.shots[0], n = t.box, r = t.querySelector("img"), [i, a] = this.centre(), o = this.box[2], s = Math.max(1.6, At * (r?.naturalWidth || 960) / n.w), c = Math.max(e.w / n.w, e.h / n.h), l = Math.max(c, Math.min(s, kt * e.w / (n.w * o / 100)));
		return `translate(${Math.min(e.x - n.x, Math.max(e.x + e.w - n.x - l * n.w, e.x + e.w / 2 - n.x - l * i))}px, ${Math.min(e.y - n.y, Math.max(e.y + e.h - n.y - l * n.h, e.y + e.h / 2 - n.y - l * a))}px) scale(${l})`;
	}
	lean(e = 1.03) {
		let [t, n] = this.centre();
		return `translate(${t * (1 - e)}px, ${n * (1 - e)}px) scale(${e})`;
	}
	place() {
		if (!this.boxes) return;
		let e = this.boxes[this.view], t = this.wide ? 44 : 32;
		if (this.frame.style.clipPath = `inset(${e.y}px ${this.W - e.x - e.w}px ${this.H - e.y - e.h}px ${e.x}px round ${t}px)`, Object.assign(this.bar.style, {
			top: `${e.y + e.h}px`,
			width: `${e.w}px`
		}), this.wide || (this.stage.style.height = `${e.h}px`), this.mode === "finish") {
			this.view !== this.shown && this.crossfade();
			return;
		}
		let n = this.view === 1, [r, i] = this.shots;
		r.style.transform = n ? this.moveIn(this.boxes[1]) : this.leaning ? this.lean() : "translate(0px, 0px) scale(1)", r.classList.toggle("is-on", !n || this.mode === "zoom"), i?.classList.toggle("is-on", n);
	}
};
customElements.define("aura-overview", jt);
//#endregion
//#region src/app/app-tour.js
var Mt = window.A?.reduced ?? matchMedia("(prefers-reduced-motion: reduce)").matches;
document.querySelectorAll("[data-app-tour]").forEach((e) => {
	let t = e.querySelector("[role=\"tablist\"]"), n = [...t.querySelectorAll("[role=\"tab\"]")], r = e.querySelector("[role=\"tabpanel\"]"), i = [...r.querySelectorAll(".app-screen")], a = n.findIndex((e) => e.getAttribute("aria-selected") === "true"), o = !1, s = !1, c = !1;
	i.forEach((e, t) => {
		let r = e.querySelector("video");
		if (!r) return;
		let i = () => n[t].style.setProperty("--tour-dur", `${r.duration}s`);
		r.readyState ? i() : r.addEventListener("loadedmetadata", i, { once: !0 });
	});
	let l = (e) => i.forEach((t, n) => {
		t.classList.toggle("is-shown", n === e), t.setAttribute("aria-hidden", n !== e);
		let r = t.querySelector("video");
		r && (n === e ? Mt || (r.currentTime = 0, r.play().catch(() => {})) : r.pause());
	}), u = (e, n) => t.scrollTo({
		top: e.offsetTop - (t.clientHeight - e.offsetHeight) / 2,
		left: e.offsetLeft - (t.clientWidth - e.offsetWidth) / 2,
		behavior: n && !Mt ? "smooth" : "auto"
	}), d = (e) => {
		e !== a && (n.forEach((t, n) => {
			t.setAttribute("aria-selected", n === e), t.tabIndex = n === e ? 0 : -1;
		}), r.setAttribute("aria-labelledby", n[e].id), a = e, l(e), setTimeout(() => u(n[e], !0)));
	}, f = () => e.classList.toggle("is-running", o && !s), p = () => {
		s = c || !!t.querySelector(":focus-visible"), t.classList.toggle("is-held", s), f();
	};
	n.forEach((e, t) => {
		e.tabIndex = t === a ? 0 : -1, e.addEventListener("click", () => d(t));
	}), t.addEventListener("keydown", (e) => {
		let t = {
			ArrowDown: 1,
			ArrowUp: -1
		}[e.key];
		if (!t) return;
		e.preventDefault();
		let r = (a + t + n.length) % n.length;
		n[r].focus(), d(r);
	}), u(n[a], !1), !Mt && (e.classList.add("is-auto"), t.addEventListener("animationend", (e) => {
		e.target.closest("[role=\"tab\"]") === n[a] && d((a + 1) % n.length);
	}), t.addEventListener("pointerenter", (e) => {
		c = e.pointerType === "mouse", p();
	}), t.addEventListener("pointerleave", () => {
		c = !1, p();
	}), ["focusin", "focusout"].forEach((e) => t.addEventListener(e, () => setTimeout(p))), new IntersectionObserver(([e]) => {
		o = e.isIntersecting, o && r.classList.add("is-on"), f();
	}, { threshold: .35 }).observe(t));
});
//#endregion
//#region node_modules/minisearch/dist/es/index.js
var Nt = "ENTRIES", Pt = "KEYS", Ft = "VALUES", W = "", It = class {
	constructor(e, t) {
		let n = e._tree, r = Array.from(n.keys());
		this.set = e, this._type = t, this._path = r.length > 0 ? [{
			node: n,
			keys: r
		}] : [];
	}
	next() {
		let e = this.dive();
		return this.backtrack(), e;
	}
	dive() {
		if (this._path.length === 0) return {
			done: !0,
			value: void 0
		};
		let { node: e, keys: t } = Lt(this._path);
		if (Lt(t) === W) return {
			done: !1,
			value: this.result()
		};
		let n = e.get(Lt(t));
		return this._path.push({
			node: n,
			keys: Array.from(n.keys())
		}), this.dive();
	}
	backtrack() {
		if (this._path.length === 0) return;
		let e = Lt(this._path).keys;
		e.pop(), !(e.length > 0) && (this._path.pop(), this.backtrack());
	}
	key() {
		return this.set._prefix + this._path.map(({ keys: e }) => Lt(e)).filter((e) => e !== W).join("");
	}
	value() {
		return Lt(this._path).node.get(W);
	}
	result() {
		switch (this._type) {
			case Ft: return this.value();
			case Pt: return this.key();
			default: return [this.key(), this.value()];
		}
	}
	[Symbol.iterator]() {
		return this;
	}
}, Lt = (e) => e[e.length - 1], Rt = (e, t, n) => {
	let r = /* @__PURE__ */ new Map();
	if (t === void 0) return r;
	let i = t.length + 1, a = i + n, o = new Uint8Array(a * i).fill(n + 1);
	for (let e = 0; e < i; ++e) o[e] = e;
	for (let e = 1; e < a; ++e) o[e * i] = e;
	return zt(e, t, n, r, o, 1, i, ""), r;
}, zt = (e, t, n, r, i, a, o, s) => {
	let c = a * o;
	key: for (let l of e.keys()) if (l === W) {
		let t = i[c - 1];
		t <= n && r.set(s, [e.get(l), t]);
	} else {
		let c = a;
		for (let e = 0; e < l.length; ++e, ++c) {
			let r = l[e], a = o * c, s = a - o, u = i[a], d = Math.max(0, c - n - 1), f = Math.min(o - 1, c + n);
			for (let e = d; e < f; ++e) {
				let n = r !== t[e], o = i[s + e] + +n, c = i[s + e + 1] + 1, l = i[a + e] + 1, d = i[a + e + 1] = Math.min(o, c, l);
				d < u && (u = d);
			}
			if (u > n) continue key;
		}
		zt(e.get(l), t, n, r, i, c, o, s + l);
	}
}, Bt = class e {
	constructor(e = /* @__PURE__ */ new Map(), t = "") {
		this._size = void 0, this._tree = e, this._prefix = t;
	}
	atPrefix(t) {
		if (!t.startsWith(this._prefix)) throw Error("Mismatched prefix");
		let [n, r] = Vt(this._tree, t.slice(this._prefix.length));
		if (n === void 0) {
			let [n, i] = qt(r);
			for (let r of n.keys()) if (r !== W && r.startsWith(i)) {
				let a = /* @__PURE__ */ new Map();
				return a.set(r.slice(i.length), n.get(r)), new e(a, t);
			}
		}
		return new e(n, t);
	}
	clear() {
		this._size = void 0, this._tree.clear();
	}
	delete(e) {
		return this._size = void 0, Wt(this._tree, e);
	}
	entries() {
		return new It(this, Nt);
	}
	forEach(e) {
		for (let [t, n] of this) e(t, n, this);
	}
	fuzzyGet(e, t) {
		return Rt(this._tree, e, t);
	}
	get(e) {
		let t = Ht(this._tree, e);
		return t === void 0 ? void 0 : t.get(W);
	}
	has(e) {
		let t = Ht(this._tree, e);
		return t !== void 0 && t.has(W);
	}
	keys() {
		return new It(this, Pt);
	}
	set(e, t) {
		if (typeof e != "string") throw Error("key must be a string");
		return this._size = void 0, Ut(this._tree, e).set(W, t), this;
	}
	get size() {
		if (this._size) return this._size;
		this._size = 0;
		let e = this.entries();
		for (; !e.next().done;) this._size += 1;
		return this._size;
	}
	update(e, t) {
		if (typeof e != "string") throw Error("key must be a string");
		this._size = void 0;
		let n = Ut(this._tree, e);
		return n.set(W, t(n.get(W))), this;
	}
	fetch(e, t) {
		if (typeof e != "string") throw Error("key must be a string");
		this._size = void 0;
		let n = Ut(this._tree, e), r = n.get(W);
		return r === void 0 && n.set(W, r = t()), r;
	}
	values() {
		return new It(this, Ft);
	}
	[Symbol.iterator]() {
		return this.entries();
	}
	static from(t) {
		let n = new e();
		for (let [e, r] of t) n.set(e, r);
		return n;
	}
	static fromObject(t) {
		return e.from(Object.entries(t));
	}
}, Vt = (e, t, n = []) => {
	if (t.length === 0 || e == null) return [e, n];
	for (let r of e.keys()) if (r !== W && t.startsWith(r)) return n.push([e, r]), Vt(e.get(r), t.slice(r.length), n);
	return n.push([e, t]), Vt(void 0, "", n);
}, Ht = (e, t) => {
	if (t.length === 0 || e == null) return e;
	for (let n of e.keys()) if (n !== W && t.startsWith(n)) return Ht(e.get(n), t.slice(n.length));
}, Ut = (e, t) => {
	let n = t.length;
	outer: for (let r = 0; e && r < n;) {
		for (let i of e.keys()) if (i !== W && t[r] === i[0]) {
			let a = Math.min(n - r, i.length), o = 1;
			for (; o < a && t[r + o] === i[o];) ++o;
			let s = e.get(i);
			if (o === i.length) e = s;
			else {
				let n = /* @__PURE__ */ new Map();
				n.set(i.slice(o), s), e.set(t.slice(r, r + o), n), e.delete(i), e = n;
			}
			r += o;
			continue outer;
		}
		let i = /* @__PURE__ */ new Map();
		return e.set(t.slice(r), i), i;
	}
	return e;
}, Wt = (e, t) => {
	let [n, r] = Vt(e, t);
	if (n !== void 0) {
		if (n.delete(W), n.size === 0) Gt(r);
		else if (n.size === 1) {
			let [e, t] = n.entries().next().value;
			Kt(r, e, t);
		}
	}
}, Gt = (e) => {
	if (e.length === 0) return;
	let [t, n] = qt(e);
	if (t.delete(n), t.size === 0) Gt(e.slice(0, -1));
	else if (t.size === 1) {
		let [n, r] = t.entries().next().value;
		n !== W && Kt(e.slice(0, -1), n, r);
	}
}, Kt = (e, t, n) => {
	if (e.length === 0) return;
	let [r, i] = qt(e);
	r.set(i + t, n), r.delete(i);
}, qt = (e) => e[e.length - 1], Jt = "or", Yt = "and", Xt = "and_not", Zt = class e {
	constructor(e) {
		if (e?.fields == null) throw Error("MiniSearch: option \"fields\" must be provided");
		let t = e.autoVacuum == null || e.autoVacuum === !0 ? ln : e.autoVacuum;
		this._options = {
			...rn,
			...e,
			autoVacuum: t,
			searchOptions: {
				...an,
				...e.searchOptions || {}
			},
			autoSuggestOptions: {
				...on,
				...e.autoSuggestOptions || {}
			}
		}, this._index = new Bt(), this._documentCount = 0, this._documentIds = /* @__PURE__ */ new Map(), this._idToShortId = /* @__PURE__ */ new Map(), this._fieldIds = {}, this._fieldLength = /* @__PURE__ */ new Map(), this._avgFieldLength = [], this._nextId = 0, this._storedFields = /* @__PURE__ */ new Map(), this._dirtCount = 0, this._currentVacuum = null, this._enqueuedVacuum = null, this._enqueuedVacuumConditions = cn, this.addFields(this._options.fields);
	}
	add(e) {
		let { extractField: t, stringifyField: n, tokenize: r, processTerm: i, fields: a, idField: o } = this._options, s = t(e, o);
		if (s == null) throw Error(`MiniSearch: document does not have ID field "${o}"`);
		if (this._idToShortId.has(s)) throw Error(`MiniSearch: duplicate ID ${s}`);
		let c = this.addDocumentId(s);
		this.saveStoredFields(c, e);
		for (let o of a) {
			let a = t(e, o);
			if (a == null) continue;
			let s = r(n(a, o), o), l = this._fieldIds[o], u = new Set(s).size;
			this.addFieldLength(c, l, this._documentCount - 1, u);
			for (let e of s) {
				let t = i(e, o);
				if (Array.isArray(t)) for (let e of t) this.addTerm(l, c, e);
				else t && this.addTerm(l, c, t);
			}
		}
	}
	addAll(e) {
		for (let t of e) this.add(t);
	}
	addAllAsync(e, t = {}) {
		let { chunkSize: n = 10 } = t, r = {
			chunk: [],
			promise: Promise.resolve()
		}, { chunk: i, promise: a } = e.reduce(({ chunk: e, promise: t }, r, i) => (e.push(r), (i + 1) % n === 0 ? {
			chunk: [],
			promise: t.then(() => new Promise((e) => setTimeout(e, 0))).then(() => this.addAll(e))
		} : {
			chunk: e,
			promise: t
		}), r);
		return a.then(() => this.addAll(i));
	}
	remove(e) {
		let { tokenize: t, processTerm: n, extractField: r, stringifyField: i, fields: a, idField: o } = this._options, s = r(e, o);
		if (s == null) throw Error(`MiniSearch: document does not have ID field "${o}"`);
		let c = this._idToShortId.get(s);
		if (c == null) throw Error(`MiniSearch: cannot remove document with ID ${s}: it is not in the index`);
		for (let o of a) {
			let a = r(e, o);
			if (a == null) continue;
			let s = t(i(a, o), o), l = this._fieldIds[o], u = new Set(s).size;
			this.removeFieldLength(c, l, this._documentCount, u);
			for (let e of s) {
				let t = n(e, o);
				if (Array.isArray(t)) for (let e of t) this.removeTerm(l, c, e);
				else t && this.removeTerm(l, c, t);
			}
		}
		this._storedFields.delete(c), this._documentIds.delete(c), this._idToShortId.delete(s), this._fieldLength.delete(c), --this._documentCount;
	}
	removeAll(e) {
		if (e) for (let t of e) this.remove(t);
		else if (arguments.length > 0) throw Error("Expected documents to be present. Omit the argument to remove all documents.");
		else this._index = new Bt(), this._documentCount = 0, this._documentIds = /* @__PURE__ */ new Map(), this._idToShortId = /* @__PURE__ */ new Map(), this._fieldLength = /* @__PURE__ */ new Map(), this._avgFieldLength = [], this._storedFields = /* @__PURE__ */ new Map(), this._nextId = 0;
	}
	discard(e) {
		let t = this._idToShortId.get(e);
		if (t == null) throw Error(`MiniSearch: cannot discard document with ID ${e}: it is not in the index`);
		this._idToShortId.delete(e), this._documentIds.delete(t), this._storedFields.delete(t), (this._fieldLength.get(t) || []).forEach((e, n) => {
			this.removeFieldLength(t, n, this._documentCount, e);
		}), this._fieldLength.delete(t), --this._documentCount, this._dirtCount += 1, this.maybeAutoVacuum();
	}
	maybeAutoVacuum() {
		if (this._options.autoVacuum === !1) return;
		let { minDirtFactor: e, minDirtCount: t, batchSize: n, batchWait: r } = this._options.autoVacuum;
		this.conditionalVacuum({
			batchSize: n,
			batchWait: r
		}, {
			minDirtCount: t,
			minDirtFactor: e
		});
	}
	discardAll(e) {
		let t = this._options.autoVacuum;
		try {
			this._options.autoVacuum = !1;
			for (let t of e) this.discard(t);
		} finally {
			this._options.autoVacuum = t;
		}
		this.maybeAutoVacuum();
	}
	replace(e) {
		let { idField: t, extractField: n } = this._options, r = n(e, t);
		this.discard(r), this.add(e);
	}
	vacuum(e = {}) {
		return this.conditionalVacuum(e);
	}
	conditionalVacuum(e, t) {
		return this._currentVacuum ? (this._enqueuedVacuumConditions = this._enqueuedVacuumConditions && t, this._enqueuedVacuum ??= this._currentVacuum.then(() => {
			let t = this._enqueuedVacuumConditions;
			return this._enqueuedVacuumConditions = cn, this.performVacuuming(e, t);
		}), this._enqueuedVacuum) : this.vacuumConditionsMet(t) === !1 ? Promise.resolve() : (this._currentVacuum = this.performVacuuming(e), this._currentVacuum);
	}
	async performVacuuming(e, t) {
		let n = this._dirtCount;
		if (this.vacuumConditionsMet(t)) {
			let t = e.batchSize || sn.batchSize, r = e.batchWait || sn.batchWait, i = 1;
			for (let [e, n] of this._index) {
				for (let [e, t] of n) for (let [r] of t) this._documentIds.has(r) || (t.size <= 1 ? n.delete(e) : t.delete(r));
				this._index.get(e).size === 0 && this._index.delete(e), i % t === 0 && await new Promise((e) => setTimeout(e, r)), i += 1;
			}
			this._dirtCount -= n;
		}
		await null, this._currentVacuum = this._enqueuedVacuum, this._enqueuedVacuum = null;
	}
	vacuumConditionsMet(e) {
		if (e == null) return !0;
		let { minDirtCount: t, minDirtFactor: n } = e;
		return t ||= ln.minDirtCount, n ||= ln.minDirtFactor, this.dirtCount >= t && this.dirtFactor >= n;
	}
	get isVacuuming() {
		return this._currentVacuum != null;
	}
	get dirtCount() {
		return this._dirtCount;
	}
	get dirtFactor() {
		return this._dirtCount / (1 + this._documentCount + this._dirtCount);
	}
	has(e) {
		return this._idToShortId.has(e);
	}
	getStoredFields(e) {
		let t = this._idToShortId.get(e);
		if (t != null) return this._storedFields.get(t);
	}
	search(t, n = {}) {
		let { searchOptions: r } = this._options, i = {
			...r,
			...n
		}, a = this.executeQuery(t, n), o = [];
		for (let [e, { score: t, terms: n, match: r }] of a) {
			let a = n.length || 1, s = {
				id: this._documentIds.get(e),
				score: t * a,
				terms: Object.keys(r),
				queryTerms: n,
				match: r
			};
			Object.assign(s, this._storedFields.get(e)), (i.filter == null || i.filter(s)) && o.push(s);
		}
		return t === e.wildcard && i.boostDocument == null || o.sort(fn), o;
	}
	autoSuggest(e, t = {}) {
		t = {
			...this._options.autoSuggestOptions,
			...t
		};
		let n = /* @__PURE__ */ new Map();
		for (let { score: r, terms: i } of this.search(e, t)) {
			let e = i.join(" "), t = n.get(e);
			t == null ? n.set(e, {
				score: r,
				terms: i,
				count: 1
			}) : (t.score += r, t.count += 1);
		}
		let r = [];
		for (let [e, { score: t, terms: i, count: a }] of n) r.push({
			suggestion: e,
			terms: i,
			score: t / a
		});
		return r.sort(fn), r;
	}
	get documentCount() {
		return this._documentCount;
	}
	get termCount() {
		return this._index.size;
	}
	static loadJSON(e, t) {
		if (t == null) throw Error("MiniSearch: loadJSON should be given the same options used when serializing the index");
		return this.loadJS(JSON.parse(e), t);
	}
	static async loadJSONAsync(e, t) {
		if (t == null) throw Error("MiniSearch: loadJSON should be given the same options used when serializing the index");
		return this.loadJSAsync(JSON.parse(e), t);
	}
	static getDefault(e) {
		if (rn.hasOwnProperty(e)) return Qt(rn, e);
		throw Error(`MiniSearch: unknown option "${e}"`);
	}
	static loadJS(e, t) {
		let { index: n, documentIds: r, fieldLength: i, storedFields: a, serializationVersion: o } = e, s = this.instantiateMiniSearch(e, t);
		s._documentIds = mn(r), s._fieldLength = mn(i), s._storedFields = mn(a);
		for (let [e, t] of s._documentIds) s._idToShortId.set(t, e);
		for (let [e, t] of n) {
			let n = /* @__PURE__ */ new Map();
			for (let e of Object.keys(t)) {
				let r = t[e];
				o === 1 && (r = r.ds), n.set(parseInt(e, 10), mn(r));
			}
			s._index.set(e, n);
		}
		return s;
	}
	static async loadJSAsync(e, t) {
		let { index: n, documentIds: r, fieldLength: i, storedFields: a, serializationVersion: o } = e, s = this.instantiateMiniSearch(e, t);
		s._documentIds = await hn(r), s._fieldLength = await hn(i), s._storedFields = await hn(a);
		for (let [e, t] of s._documentIds) s._idToShortId.set(t, e);
		let c = 0;
		for (let [e, t] of n) {
			let n = /* @__PURE__ */ new Map();
			for (let e of Object.keys(t)) {
				let r = t[e];
				o === 1 && (r = r.ds), n.set(parseInt(e, 10), await hn(r));
			}
			++c % 1e3 == 0 && await gn(0), s._index.set(e, n);
		}
		return s;
	}
	static instantiateMiniSearch(t, n) {
		let { documentCount: r, nextId: i, fieldIds: a, averageFieldLength: o, dirtCount: s, serializationVersion: c } = t;
		if (c !== 1 && c !== 2) throw Error("MiniSearch: cannot deserialize an index created with an incompatible version");
		let l = new e(n);
		return l._documentCount = r, l._nextId = i, l._idToShortId = /* @__PURE__ */ new Map(), l._fieldIds = a, l._avgFieldLength = o, l._dirtCount = s || 0, l._index = new Bt(), l;
	}
	executeQuery(t, n = {}) {
		if (t === e.wildcard) return this.executeWildcardQuery(n);
		if (typeof t != "string") {
			let e = {
				...n,
				...t,
				queries: void 0
			}, r = t.queries.map((t) => this.executeQuery(t, e));
			return this.combineResults(r, e.combineWith);
		}
		let { tokenize: r, processTerm: i, searchOptions: a } = this._options, o = {
			tokenize: r,
			processTerm: i,
			...a,
			...n
		}, { tokenize: s, processTerm: c } = o, l = s(t).flatMap((e) => c(e)).filter((e) => !!e).map(nn(o)).map((e) => this.executeQuerySpec(e, o));
		return this.combineResults(l, o.combineWith);
	}
	executeQuerySpec(e, t) {
		let n = {
			...this._options.searchOptions,
			...t
		}, r = (n.fields || this._options.fields).reduce((e, t) => ({
			...e,
			[t]: Qt(n.boost, t) || 1
		}), {}), { boostDocument: i, weights: a, maxFuzzy: o, bm25: s } = n, { fuzzy: c, prefix: l } = {
			...an.weights,
			...a
		}, u = this._index.get(e.term), d = this.termResults(e.term, e.term, 1, e.termBoost, u, r, i, s), f, p;
		if (e.prefix && (f = this._index.atPrefix(e.term)), e.fuzzy) {
			let t = e.fuzzy === !0 ? .2 : e.fuzzy, n = t < 1 ? Math.min(o, Math.round(e.term.length * t)) : t;
			n && (p = this._index.fuzzyGet(e.term, n));
		}
		if (f) for (let [t, n] of f) {
			let a = t.length - e.term.length;
			if (!a) continue;
			p?.delete(t);
			let o = l * t.length / (t.length + .3 * a);
			this.termResults(e.term, t, o, e.termBoost, n, r, i, s, d);
		}
		if (p) for (let t of p.keys()) {
			let [n, a] = p.get(t);
			if (!a) continue;
			let o = c * t.length / (t.length + a);
			this.termResults(e.term, t, o, e.termBoost, n, r, i, s, d);
		}
		return d;
	}
	executeWildcardQuery(e) {
		let t = /* @__PURE__ */ new Map(), n = {
			...this._options.searchOptions,
			...e
		};
		for (let [e, r] of this._documentIds) {
			let i = n.boostDocument ? n.boostDocument(r, "", this._storedFields.get(e)) : 1;
			t.set(e, {
				score: i,
				terms: [],
				match: {}
			});
		}
		return t;
	}
	combineResults(e, t = Jt) {
		if (e.length === 0) return /* @__PURE__ */ new Map();
		let n = $t[t.toLowerCase()];
		if (!n) throw Error(`Invalid combination operator: ${t}`);
		return e.reduce(n) || /* @__PURE__ */ new Map();
	}
	toJSON() {
		let e = [];
		for (let [t, n] of this._index) {
			let r = {};
			for (let [e, t] of n) r[e] = Object.fromEntries(t);
			e.push([t, r]);
		}
		return {
			documentCount: this._documentCount,
			nextId: this._nextId,
			documentIds: Object.fromEntries(this._documentIds),
			fieldIds: this._fieldIds,
			fieldLength: Object.fromEntries(this._fieldLength),
			averageFieldLength: this._avgFieldLength,
			storedFields: Object.fromEntries(this._storedFields),
			dirtCount: this._dirtCount,
			index: e,
			serializationVersion: 2
		};
	}
	termResults(e, t, n, r, i, a, o, s, c = /* @__PURE__ */ new Map()) {
		if (i == null) return c;
		for (let l of Object.keys(a)) {
			let u = a[l], d = this._fieldIds[l], f = i.get(d);
			if (f == null) continue;
			let p = f.size, m = this._avgFieldLength[d];
			for (let i of f.keys()) {
				if (!this._documentIds.has(i)) {
					this.removeTerm(d, i, t), --p;
					continue;
				}
				let a = o ? o(this._documentIds.get(i), t, this._storedFields.get(i)) : 1;
				if (!a) continue;
				let h = f.get(i), g = this._fieldLength.get(i)[d], _ = tn(h, p, this._documentCount, g, m, s), v = n * r * u * a * _, y = c.get(i);
				if (y) {
					y.score += v, un(y.terms, e);
					let n = Qt(y.match, t);
					n ? n.push(l) : y.match[t] = [l];
				} else c.set(i, {
					score: v,
					terms: [e],
					match: { [t]: [l] }
				});
			}
		}
		return c;
	}
	addTerm(e, t, n) {
		let r = this._index.fetch(n, pn), i = r.get(e);
		if (i == null) i = /* @__PURE__ */ new Map(), i.set(t, 1), r.set(e, i);
		else {
			let e = i.get(t);
			i.set(t, (e || 0) + 1);
		}
	}
	removeTerm(e, t, n) {
		if (!this._index.has(n)) {
			this.warnDocumentChanged(t, e, n);
			return;
		}
		let r = this._index.fetch(n, pn), i = r.get(e);
		i == null || i.get(t) == null ? this.warnDocumentChanged(t, e, n) : i.get(t) <= 1 ? i.size <= 1 ? r.delete(e) : i.delete(t) : i.set(t, i.get(t) - 1), this._index.get(n).size === 0 && this._index.delete(n);
	}
	warnDocumentChanged(e, t, n) {
		for (let r of Object.keys(this._fieldIds)) if (this._fieldIds[r] === t) {
			this._options.logger("warn", `MiniSearch: document with ID ${this._documentIds.get(e)} has changed before removal: term "${n}" was not present in field "${r}". Removing a document after it has changed can corrupt the index!`, "version_conflict");
			return;
		}
	}
	addDocumentId(e) {
		let t = this._nextId;
		return this._idToShortId.set(e, t), this._documentIds.set(t, e), this._documentCount += 1, this._nextId += 1, t;
	}
	addFields(e) {
		for (let t = 0; t < e.length; t++) this._fieldIds[e[t]] = t;
	}
	addFieldLength(e, t, n, r) {
		let i = this._fieldLength.get(e);
		i ?? this._fieldLength.set(e, i = []), i[t] = r;
		let a = (this._avgFieldLength[t] || 0) * n + r;
		this._avgFieldLength[t] = a / (n + 1);
	}
	removeFieldLength(e, t, n, r) {
		if (n === 1) {
			this._avgFieldLength[t] = 0;
			return;
		}
		let i = this._avgFieldLength[t] * n - r;
		this._avgFieldLength[t] = i / (n - 1);
	}
	saveStoredFields(e, t) {
		let { storeFields: n, extractField: r } = this._options;
		if (n == null || n.length === 0) return;
		let i = this._storedFields.get(e);
		i ?? this._storedFields.set(e, i = {});
		for (let e of n) {
			let n = r(t, e);
			n !== void 0 && (i[e] = n);
		}
	}
};
Zt.wildcard = Symbol("*");
var Qt = (e, t) => Object.prototype.hasOwnProperty.call(e, t) ? e[t] : void 0, $t = {
	[Jt]: (e, t) => {
		for (let n of t.keys()) {
			let r = e.get(n);
			if (r == null) e.set(n, t.get(n));
			else {
				let { score: e, terms: i, match: a } = t.get(n);
				r.score += e, r.match = Object.assign(r.match, a), dn(r.terms, i);
			}
		}
		return e;
	},
	[Yt]: (e, t) => {
		let n = /* @__PURE__ */ new Map();
		for (let r of t.keys()) {
			let i = e.get(r);
			if (i == null) continue;
			let { score: a, terms: o, match: s } = t.get(r);
			dn(i.terms, o), n.set(r, {
				score: i.score + a,
				terms: i.terms,
				match: Object.assign(i.match, s)
			});
		}
		return n;
	},
	[Xt]: (e, t) => {
		for (let n of t.keys()) e.delete(n);
		return e;
	}
}, en = {
	k: 1.2,
	b: .7,
	d: .5
}, tn = (e, t, n, r, i, a) => {
	let { k: o, b: s, d: c } = a;
	return Math.log(1 + (n - t + .5) / (t + .5)) * (c + e * (o + 1) / (e + o * (1 - s + s * r / i)));
}, nn = (e) => (t, n, r) => ({
	term: t,
	fuzzy: typeof e.fuzzy == "function" ? e.fuzzy(t, n, r) : e.fuzzy || !1,
	prefix: typeof e.prefix == "function" ? e.prefix(t, n, r) : e.prefix === !0,
	termBoost: typeof e.boostTerm == "function" ? e.boostTerm(t, n, r) : 1
}), rn = {
	idField: "id",
	extractField: (e, t) => e[t],
	stringifyField: (e, t) => e.toString(),
	tokenize: (e) => e.split(_n),
	processTerm: (e) => e.toLowerCase(),
	fields: void 0,
	searchOptions: void 0,
	storeFields: [],
	logger: (e, t) => {
		typeof (console == null ? void 0 : console[e]) == "function" && console[e](t);
	},
	autoVacuum: !0
}, an = {
	combineWith: Jt,
	prefix: !1,
	fuzzy: !1,
	maxFuzzy: 6,
	boost: {},
	weights: {
		fuzzy: .45,
		prefix: .375
	},
	bm25: en
}, on = {
	combineWith: Yt,
	prefix: (e, t, n) => t === n.length - 1
}, sn = {
	batchSize: 1e3,
	batchWait: 10
}, cn = {
	minDirtFactor: .1,
	minDirtCount: 20
}, ln = {
	...sn,
	...cn
}, un = (e, t) => {
	e.includes(t) || e.push(t);
}, dn = (e, t) => {
	for (let n of t) e.includes(n) || e.push(n);
}, fn = ({ score: e }, { score: t }) => t - e, pn = () => /* @__PURE__ */ new Map(), mn = (e) => {
	let t = /* @__PURE__ */ new Map();
	for (let n of Object.keys(e)) t.set(parseInt(n, 10), e[n]);
	return t;
}, hn = async (e) => {
	let t = /* @__PURE__ */ new Map(), n = 0;
	for (let r of Object.keys(e)) t.set(parseInt(r, 10), e[r]), ++n % 1e3 == 0 && await gn(0);
	return t;
}, gn = (e) => new Promise((t) => setTimeout(t, e)), _n = /[\n\r\p{Z}\p{P}]+/u, vn = new Set("a an the and or but for to of in on at by from my me i im is it its do does did can could you your we our us with without how what which who whats where when why there this that these those need want get got any are be have has will would should some show find looking look buy price prices cost costs".split(" ")), yn = {
	cctv: ["camera"],
	cam: ["camera"],
	webcam: ["camera"],
	surveillance: ["camera"],
	door: ["lock"],
	light: ["floodlight"],
	flood: ["floodlight"],
	spotlight: ["floodlight"],
	lamp: ["floodlight"],
	keyless: ["lock"],
	key: ["lock"],
	keypad: ["lock"],
	deadbolt: ["lock"],
	burglar: ["alarm"],
	intruder: ["alarm"],
	siren: ["alarm"],
	sensor: ["alarm"],
	switch: ["panel"],
	gang: ["switch"],
	rocker: ["switch"],
	hub: ["panel"],
	touchscreen: ["panel"],
	remote: ["panel"],
	plug: ["socket"],
	outlet: ["socket"],
	usb: ["socket"],
	charger: ["socket"],
	zigbee: ["socket", "panel"],
	curtain: ["blinds"],
	shade: ["blinds"],
	shutter: ["blinds"],
	window: ["blinds"],
	subscription: ["fee", "monthly"],
	contract: ["fee", "monthly"],
	install: ["installation"],
	installer: ["installation"],
	fit: ["installation"],
	fitting: ["installation"],
	fitted: ["installation"],
	electrician: ["installation"],
	garden: ["outdoor"],
	driveway: ["outdoor", "floodlight"],
	yard: ["outdoor"],
	outside: ["outdoor"],
	external: ["outdoor"],
	inside: ["indoor"],
	baby: ["indoor"],
	pet: ["indoor"],
	nanny: ["indoor"],
	dark: ["night"],
	nite: ["night"],
	alexa: ["alexa"],
	google: ["google"],
	sun: ["solar"],
	wireless: ["battery", "wire"],
	cordless: ["battery"],
	refund: ["return"],
	money: ["refund"],
	guarantee: ["warranty"]
}, bn = (e) => String(e).toLowerCase().normalize("NFKD").replace(/[\u0300-\u036f]/g, "").replace(/wi-?fi/g, "wifi").replace(/lite\b/g, "light"), xn = (e) => bn(e).split(/[^\p{L}\p{N}]+/u).filter(Boolean), Sn = (e) => e.length > 3 && e.endsWith("s") && !e.endsWith("ss") ? e.slice(0, -1) : e, Cn = [
	[
		"Pro installation",
		"pro-installation.html",
		"Licensed installers across Dublin, Cork & Galway",
		"tools",
		"installation installer fitting fitted setup book booking electrician"
	],
	[
		"Get a free quote",
		"contact.html#quote",
		"Get device advice and compare DIY or fitted prices",
		"sparkle",
		"quote estimate consultation survey design price"
	],
	[
		"Smart blinds",
		"smart-blinds.html",
		"Motorised blinds with app & voice control",
		"blinds",
		"blinds curtains shades motorised window"
	],
	[
		"Blackout blinds",
		"blackout-blinds.html",
		"Guard 2 total blackout blinds, made to your window",
		"blinds",
		"blackout blind guard dark sleep night shift curtains window"
	],
	[
		"Showroom, Co. Wicklow",
		"showroom.html",
		"See working devices at Loghouse.ie, Glen of the Downs",
		"pin",
		"showroom visit demo store address wicklow bray opening hours"
	],
	[
		"Upgrade programme",
		"upgrade.html",
		"10% off installation when you upgrade",
		"refresh",
		"upgrade replace old existing trade switch"
	],
	[
		"FAQ & Support",
		"faq.html",
		"Answers on products, installation & troubleshooting",
		"chat",
		"help support question problem troubleshoot"
	],
	[
		"Contact us",
		"contact.html",
		"Phone, WhatsApp, email",
		"phone",
		"contact call phone email whatsapp number reach talk"
	],
	[
		"Returns & refunds",
		"policy.html?p=refund",
		"14-day returns on DIY orders",
		"return",
		"return returns refund exchange money back"
	]
], wn = null, Tn = null;
function En() {
	let e = window.AURA, t = window.AURA_ARTICLES || [], n = (e) => e.replace(/^./, (e) => e.toUpperCase());
	Tn = /* @__PURE__ */ new Map();
	let r = (e) => Tn.set(e.id, e);
	e.products.forEach((t) => r({
		id: "p:" + t.handle,
		kind: "product",
		ref: t,
		title: t.name,
		type: t.type,
		cats: t.collections.map((t) => e.collections.find((e) => e.handle === t)?.title || t).join(" "),
		tagline: t.tagline,
		keywords: [
			...t.highlights.map((e) => e[1]),
			...(t.features || []).map((e) => e[0]),
			t.idealFor || ""
		].join(" "),
		body: [t.intro, ...(t.features || []).map((e) => e[1])].join(" ")
	})), e.collections.filter((e) => e.handle !== "all").forEach((t) => r({
		id: "c:" + t.handle,
		kind: "collection",
		ref: t,
		title: n(t.title),
		keywords: t.blurb,
		n: e.inCollection(t.handle).length
	})), Cn.filter(([, t]) => e.shown(t)).forEach(([t, n, i, a, o], s) => r({
		id: "g:" + s,
		kind: "page",
		title: t,
		href: e.route(n),
		desc: i,
		ico: a,
		keywords: o,
		body: i
	})), e.faqs.forEach((e) => e.items.forEach(([t, n], i) => r({
		id: `f:${e.cat}:${i}`,
		kind: "faq",
		title: t,
		cats: e.cat,
		body: n,
		answer: n
	}))), e.features.journal && t.forEach((e) => r({
		id: "a:" + e.slug,
		kind: "article",
		ref: e,
		title: e.title,
		cats: e.tag,
		body: e.excerpt
	})), wn = new Zt({
		fields: [
			"title",
			"type",
			"cats",
			"tagline",
			"keywords",
			"body"
		],
		storeFields: [],
		tokenize: xn,
		processTerm: (e) => vn.has(e) ? null : Sn(e),
		searchOptions: {
			boost: {
				title: 5,
				type: 3,
				cats: 2,
				tagline: 1.5,
				keywords: 1.2,
				body: .5
			},
			prefix: (e) => e.length > 1,
			fuzzy: (e) => e.length >= 6 ? 2 : +(e.length >= 3)
		}
	}), wn.addAll([...Tn.values()]);
}
var Dn = "€?\\s*(\\d+(?:[.,]\\d+)?)\\s*(?:€|eur|euro|euros)?", On = {
	range: RegExp(`(?:between\\s+)?${Dn}\\s*(?:-|–|to|and)\\s*${Dn}`, "i"),
	max: RegExp(`(?:under|below|less than|cheaper than|max(?:imum)?|up to|upto|no more than|<)\\s*${Dn}`, "i"),
	min: RegExp(`(?:over|above|more than|at least|min(?:imum)?|>)\\s*${Dn}`, "i"),
	cheap: /\b(cheap(?:est|er)?|budget|affordable|lowest price|inexpensive|low cost)\b/i
};
function kn(e) {
	let t = " " + String(e || "") + " ", n = null, r = null, i = !1, a = (e) => Number(String(e).replace(",", ".")), o;
	return (o = t.match(On.range)) && /[€]|eur|-|–|to|between/i.test(o[0]) && a(o[2]) > a(o[1]) && (n = a(o[1]), r = a(o[2]), t = t.replace(o[0], " ")), (o = t.match(On.max)) && (r = a(o[1]), t = t.replace(o[0], " ")), (o = t.match(On.min)) && (n = a(o[1]), t = t.replace(o[0], " ")), (o = t.match(On.cheap)) && (i = !0, t = t.replace(o[0], " ")), {
		words: xn(t).filter((e) => !vn.has(e)),
		min: n,
		max: r,
		cheap: i,
		question: /\?\s*$|^\s*(how|what|do|does|can|is|are|will|where|why|when|which|should)\b/i.test(e || "")
	};
}
var An = (e, t) => (t.min == null || e.from >= t.min) && (t.max == null || e.from <= t.max), jn = (e) => ({
	combineWith: "AND",
	queries: e.map((e) => ({
		combineWith: "OR",
		queries: [e, ...yn[Sn(e)] || yn[e] || []]
	}))
}), Mn = (e, t) => {
	let n = Array.from({ length: t.length + 1 }, (e, t) => t);
	for (let r = 1; r <= e.length; r++) {
		let i = n[0];
		n[0] = r;
		for (let a = 1; a <= t.length; a++) {
			let o = n[a];
			n[a] = Math.min(n[a] + 1, n[a - 1] + 1, i + (e[r - 1] === t[a - 1] ? 0 : 1)), i = o;
		}
	}
	return n[t.length];
};
function Nn(e, t) {
	let n = [];
	return t.forEach((e) => {
		let t = /* @__PURE__ */ new Set();
		if (wn.search(e, {
			prefix: !1,
			fuzzy: e.length >= 5 ? 2 : 1
		}).slice(0, 8).forEach((e) => e.terms.forEach((e) => t.add(e))), t.has(Sn(e)) || !t.size) return;
		let r = [...t].sort((t, n) => Mn(e, t) - Mn(e, n))[0];
		Mn(e, r) <= 2 && n.push([e, r]);
	}), n.length ? n.reduce((e, [t, n]) => e.replace(RegExp(`(^|[^\\p{L}\\p{N}])${In(t)}(?=$|[^\\p{L}\\p{N}])`, "iu"), `$1${n}`), String(e).trim()) : null;
}
function Pn(e) {
	wn || En();
	let t = kn(e), n = {
		q: t,
		products: [],
		collections: [],
		faqs: [],
		pages: [],
		articles: [],
		loose: !1,
		suggestion: null,
		terms: [],
		order: []
	}, r = t.min != null || t.max != null || t.cheap, i = window.AURA;
	if (!t.words.length) return r && (n.products = i.products.filter((e) => An(e, t)).sort((e, t) => e.from - t.from)), n.order = ["products"], n;
	let a = wn.search(jn(t.words));
	!a.length && t.words.length > 1 && (a = wn.search(t.words.join(" "), { combineWith: "OR" }), n.loose = a.length > 0), (!a.length || n.loose) && (n.suggestion = Nn(e, t.words));
	let o = new Set(t.words), s = {};
	a.forEach((e) => {
		e.terms.forEach((e) => o.add(e));
		let r = Tn.get(e.id), i = r.kind === "product" ? "products" : r.kind === "collection" ? "collections" : r.kind === "faq" ? "faqs" : r.kind === "page" ? "pages" : "articles";
		(i !== "products" || An(r.ref, t)) && (n[i].push({
			...r,
			score: e.score
		}), s[i] = Math.max(s[i] || 0, e.score));
	}), n.terms = [...o];
	for (let e of [
		"products",
		"faqs",
		"pages",
		"articles"
	]) n[e] = n[e].filter((t) => t.score >= s[e] * .12);
	t.cheap && n.products.sort((e, t) => e.ref.from - t.ref.from), n.products = n.products.map((e) => e.ref);
	let c = {
		products: 1.25,
		collections: .6,
		faqs: t.question ? 1.6 : .8,
		pages: .9,
		articles: .5
	};
	return n.order = Object.keys(c).filter((e) => n[e].length).sort((e, t) => s[t] * c[t] - s[e] * c[e]), n;
}
var Fn = (e) => Pn(e).products, In = (e) => e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
function Ln(e, t, n) {
	let r = n(e), i = t.filter((e) => e.length > 1).sort((e, t) => t.length - e.length).map((e) => In(e).replace(/^wifi/, "wi-?fi"));
	return i.length ? r.replace(RegExp(`(^|[^\\p{L}\\p{N}])(${i.join("|")})`, "giu"), "$1<mark>$2</mark>") : r;
}
//#endregion
//#region src/search/aura-search.js
var Rn = (e) => window.AURA.route(e), zn = "aura-recent-searches", Bn = () => {
	try {
		return JSON.parse(localStorage.getItem(zn)) || [];
	} catch {
		return [];
	}
}, Vn = (e) => {
	try {
		localStorage.setItem(zn, JSON.stringify(e));
	} catch {}
}, Hn = [
	"Floodlight camera",
	"Solar camera",
	"Cameras under €150",
	"Cheapest smart lock",
	"Do I need Wi-Fi?",
	"Installation"
], Un = class extends HTMLElement {
	connectedCallback() {
		if (this.A = window.A, this.input = this.querySelector("[data-search-input]"), this.out = this.querySelector("[data-search-results]"), this.status = this.querySelector("[data-search-status]"), !this.input || !this.out) return;
		this.ac = new AbortController();
		let e = this.ac.signal;
		this.active = -1, this.input.addEventListener("input", () => this.render(), { signal: e }), this.input.addEventListener("keydown", (e) => this.onKey(e), { signal: e }), this.out.addEventListener("pointermove", (e) => {
			let t = e.target.closest("[data-hit]");
			t && this.setActive(this.hits().indexOf(t), !1);
		}, { signal: e }), document.addEventListener("click", (e) => {
			if (e.target.closest("[data-search-open]")) {
				e.preventDefault(), this.open();
				return;
			}
			if (!this.isOpen) return;
			e.target.closest("[data-search-close]") && this.close();
			let t = e.target.closest("[data-suggest]");
			t && (this.input.value = t.dataset.suggest, this.render(), this.input.focus()), e.target.closest("[data-recent-clear]") && (Vn([]), this.render(), this.input.focus()), e.target.closest("[data-hit]") && this.remember();
		}, { signal: e }), document.addEventListener("keydown", (e) => {
			let t = /input|textarea|select/i.test(document.activeElement?.tagName) || document.activeElement?.isContentEditable;
			(e.key === "/" && !t || e.key.toLowerCase() === "k" && (e.metaKey || e.ctrlKey)) && (e.preventDefault(), this.open());
		}, { signal: e });
	}
	disconnectedCallback() {
		this.ac?.abort();
	}
	get isOpen() {
		return this.classList.contains("is-open");
	}
	open() {
		this.isOpen || (this.last = document.activeElement, this.classList.add("is-open"), this.setAttribute("aria-hidden", "false"), this.A?.lock(), this.render(), this.input.select(), setTimeout(() => this.input.focus(), 80));
	}
	close() {
		this.isOpen && (this.classList.remove("is-open"), this.setAttribute("aria-hidden", "true"), this.A?.unlock(), this.last?.focus?.());
	}
	remember(e = this.input.value.trim()) {
		e.length < 2 || Vn([e, ...Bn().filter((t) => t.toLowerCase() !== e.toLowerCase())].slice(0, 5));
	}
	hits() {
		return [...this.out.querySelectorAll("[data-hit]")];
	}
	setActive(e, t = !0) {
		let n = this.hits();
		this.active = n.length ? (e + n.length) % n.length : -1, n.forEach((e, t) => {
			e.classList.toggle("is-active", t === this.active), e.setAttribute("aria-selected", t === this.active);
		});
		let r = n[this.active];
		r ? (this.input.setAttribute("aria-activedescendant", r.id), t && r.scrollIntoView({ block: "nearest" })) : this.input.removeAttribute("aria-activedescendant");
	}
	onKey(e) {
		let t = this.hits();
		if (e.key === "ArrowDown" || e.key === "ArrowUp") e.preventDefault(), this.setActive(this.active < 0 && e.key === "ArrowUp" ? -1 : this.active + (e.key === "ArrowDown" ? 1 : -1));
		else if (e.key === "Enter") {
			e.preventDefault();
			let n = this.input.value.trim();
			if (t[this.active]) {
				t[this.active].click();
				return;
			}
			if (!n) return;
			this.remember(n), this.result?.products.length ? location.href = Rn("shop.html?q=" + encodeURIComponent(n)) : t.find((e) => e.tagName === "A")?.click();
		} else e.key === "Escape" && (e.preventDefault(), e.stopPropagation(), this.input.value ? (this.input.value = "", this.render()) : this.close());
	}
	render() {
		let { esc: e, icon: t } = this.A, n = this.input.value, r = 0, i = () => `sr-${r++}`, a, o = 0;
		if (n.trim()) {
			let r = this.result = Pn(n), s = (t) => Ln(t, r.terms, e), c = [];
			r.q.min != null && r.q.max != null ? c.push(`€${r.q.min}–€${r.q.max}`) : r.q.max == null ? r.q.min != null && c.push(`over €${r.q.min}`) : c.push(`under €${r.q.max}`), r.q.cheap && c.push("cheapest first");
			let l = {
				products: () => `<div class="search__group" role="group" aria-label="Products"><h3>Products</h3>${r.products.slice(0, r.q.question ? 3 : 6).map((e) => this.productHit(e, r.terms, i())).join("")}</div>`,
				collections: () => `<div class="search__group" role="group" aria-label="Collections"><h3>Collections</h3><div class="search__suggest">${r.collections.slice(0, 4).map((e) => `<a class="chip chip--sm" id="${i()}" role="option" data-hit href="${Rn(`shop.html?c=${e.ref.handle}`)}"><span>${s(e.title)}</span><span class="n">${e.n}</span></a>`).join("")}</div></div>`,
				faqs: () => `<div class="search__group" role="group" aria-label="Answers"><h3>Answers</h3>${r.faqs.slice(0, 3).map((n) => `<a class="search__hit search__hit--answer" id="${i()}" role="option" data-hit href="${Rn(`faq.html?q=${encodeURIComponent(n.title)}`)}"><span class="media">${t("chat")}</span><span><b>${s(n.title)}</b><span class="search__answer">${e(n.answer)}</span></span>${t("arrow")}</a>`).join("")}</div>`,
				pages: () => `<div class="search__group" role="group" aria-label="Pages"><h3>Pages</h3>${r.pages.slice(0, 3).map((n) => `<a class="search__hit" id="${i()}" role="option" data-hit href="${n.href}"><span class="media">${t(n.ico)}</span><span><b>${s(n.title)}</b><span>${e(n.desc)}</span></span>${t("arrow")}</a>`).join("")}</div>`,
				articles: () => `<div class="search__group" role="group" aria-label="Journal"><h3>Journal</h3>${r.articles.slice(0, 3).map((n) => `<a class="search__hit" id="${i()}" role="option" data-hit href="${Rn(`article.html?a=${n.ref.slug}`)}"><span class="media photo"><img src="${n.ref.image}" alt=""></span><span><b>${s(n.title)}</b><span>${e(n.ref.tag)} · ${n.ref.minutes} min read</span></span>${t("arrow")}</a>`).join("")}</div>`
			};
			o = r.products.length + r.collections.length + r.faqs.length + r.pages.length + r.articles.length;
			let u = r.suggestion ? ` Did you mean <button class="link-btn" type="button" data-suggest="${e(r.suggestion)}">${e(r.suggestion)}</button>?` : "", d = c.length && r.products.length ? `<p class="search__note">${t("sliders")}<span>Products ${c.join(", ")}</span></p>` : r.loose ? `<p class="search__note">${t("search")}<span>No exact match, so here are the closest.${u}</span></p>` : "";
			a = o ? d + r.order.map((e) => l[e]()).join("") + (r.products.length > 1 && !r.q.question ? `<a class="search__all" id="${i()}" role="option" data-hit href="${Rn(`shop.html?q=${encodeURIComponent(n.trim())}`)}">See all ${r.products.length} products for “${e(n.trim())}” ${t("arrow")}</a>` : "") : `<div class="search__empty">${c.length ? `Nothing ${c.join(", ")} for “${e(n.trim())}”.` : `No results for “${e(n.trim())}”.`}${u}<br><a class="link" style="margin-top:10px" href="${window.AURA.site.whatsappHref}" target="_blank" rel="noopener">Ask us on WhatsApp ${t("arrow")}</a></div>`;
		} else {
			let n = Bn();
			this.result = null, a = (n.length ? `<div class="search__group"><div class="search__ghead"><h3>Recent</h3><button class="text-btn small" type="button" data-recent-clear>Clear</button></div><div class="search__suggest">${n.map((n) => `<button class="chip chip--sm" type="button" data-suggest="${e(n)}">${t("clock")}${e(n)}</button>`).join("")}</div></div>` : "") + `<div class="search__group"><h3>Try</h3><div class="search__suggest">${Hn.map((t) => `<button class="chip chip--sm" type="button" data-suggest="${e(t)}">${e(t)}</button>`).join("")}</div></div><div class="search__group" role="group" aria-label="Bestsellers"><h3>Bestsellers</h3>${window.AURA.products.slice(0, 4).map((e) => this.productHit(e, [], i())).join("")}</div>`;
		}
		this.out.innerHTML = a, this.active = -1, this.input.removeAttribute("aria-activedescendant"), clearTimeout(this.statusT), this.status && (this.statusT = setTimeout(() => {
			this.status.textContent = n.trim() ? o ? `${o} results` : "No results" : "";
		}, 500));
	}
	productHit(e, t, n) {
		let { esc: r, fmt: i } = this.A;
		return `<a class="search__hit" id="${n}" role="option" data-hit href="${Rn(`product.html?p=${e.handle}`)}"><span class="media" style="--tint:${e.tint}"><img src="${e.images[0]}" alt=""></span><span><b>${Ln(e.name, t, r)}</b><span>${Ln(e.type, t, r)}</span></span><span class="price">${i(e.from)}</span></a>`;
	}
};
customElements.define("aura-search", Un);
//#endregion
//#region src/footer/aura-sky.js
var Wn = Math.PI * 2, Gn = [
	"160,192,255",
	"192,212,255",
	"228,236,255",
	"255,248,236",
	"255,234,204",
	"255,212,172"
], Kn = 48, qn = 1.6, Jn = {
	far: .25,
	mid: .55,
	near: 1
}, Yn = (e) => Math.max(0, Math.min(1, e)), Xn = (e) => 1 - (1 - e) ** 3, Zn = (e, t, n) => {
	let r = Yn((n - e) / (t - e));
	return r * r * (3 - 2 * r);
}, Qn = (e, t) => (e % t + t) % t, G = (e, t) => e + Math.random() * (t - e);
function $n(e) {
	return () => {
		e = e + 1831565813 | 0;
		let t = Math.imul(e ^ e >>> 15, 1 | e);
		return t = t + Math.imul(t ^ t >>> 7, 61 | t) ^ t, ((t ^ t >>> 14) >>> 0) / 4294967296;
	};
}
var er = (e) => (e = Math.sin(e * 127.1 + 311.7) * 43758.5453, e - Math.floor(e)), tr = (e) => {
	let t = Math.floor(e), n = e - t;
	return er(t) + (er(t + 1) - er(t)) * n * n * (3 - 2 * n);
};
function nr(e) {
	let t = document.createElement("canvas");
	t.width = t.height = 64;
	let n = t.getContext("2d"), r = n.createRadialGradient(32, 32, 0, 32, 32, 32);
	return r.addColorStop(0, "rgba(255,255,255,1)"), r.addColorStop(.1, `rgba(${e},1)`), r.addColorStop(.22, `rgba(${e},.3)`), r.addColorStop(.5, `rgba(${e},.04)`), r.addColorStop(1, `rgba(${e},0)`), n.fillStyle = r, n.fillRect(0, 0, 64, 64), t;
}
function rr() {
	let e = document.createElement("canvas");
	e.width = e.height = 128;
	let t = e.getContext("2d");
	for (let e of [!1, !0]) {
		let n = e ? t.createLinearGradient(64, 0, 64, 128) : t.createLinearGradient(0, 64, 128, 64);
		n.addColorStop(0, "rgba(200,225,255,0)"), n.addColorStop(.5, "rgba(235,244,255,.9)"), n.addColorStop(1, "rgba(200,225,255,0)"), t.fillStyle = n, e ? t.fillRect(63.25, 0, 1.5, 128) : t.fillRect(0, 63.25, 128, 1.5);
	}
	return e;
}
var ir = class extends HTMLElement {
	connectedCallback() {
		this.reduced = window.A?.reduced ?? matchMedia("(prefers-reduced-motion: reduce)").matches, this.touch = matchMedia("(hover: none)").matches, this.canvas = this.querySelector("canvas") || this.appendChild(document.createElement("canvas")), this.ctx = this.canvas.getContext("2d"), this.sprites ??= Gn.map(nr), this.spike ??= rr(), this.meteors = [], this.px = this.py = this.tx = this.ty = 0, this.loop = this.loop.bind(this), this.play = this.play.bind(this), this.near = new IntersectionObserver(([e]) => {
			e.isIntersecting && (this.near.disconnect(), this.wanted = !0, this.resize());
		}, { rootMargin: "600px 0px" }), this.ro = new ResizeObserver(() => {
			this.wanted && (clearTimeout(this.rt), this.rt = setTimeout(() => this.resize(), 120));
		}), this.seen = new IntersectionObserver(([e]) => {
			this.onScreen = e.isIntersecting, this.onScreen && !this.litAt && (this.litAt = performance.now() / 1e3), this.play();
		}, { threshold: .12 }), this.near.observe(this), this.ro.observe(this), this.seen.observe(this), document.addEventListener("visibilitychange", this.play), this.touch && (this.onScroll = () => {
			this.movedAt = performance.now();
		}, addEventListener("scroll", this.onScroll, { passive: !0 })), !this.reduced && matchMedia("(pointer: fine)").matches && (this.onPointer = (e) => {
			this.tx = e.clientX / innerWidth - .5, this.ty = e.clientY / innerHeight - .5;
		}, addEventListener("pointermove", this.onPointer, { passive: !0 }));
	}
	disconnectedCallback() {
		this.near?.disconnect(), this.ro?.disconnect(), this.seen?.disconnect(), document.removeEventListener("visibilitychange", this.play), this.onPointer && removeEventListener("pointermove", this.onPointer), this.onScroll && removeEventListener("scroll", this.onScroll), cancelAnimationFrame(this.raf), this.raf = 0, clearTimeout(this.rt);
	}
	resize() {
		let e = this.clientWidth, t = this.clientHeight;
		e && t && (e !== this.w || t !== this.h) && (this.w = e, this.h = t, this.dpr = Math.min(devicePixelRatio || 1, 2), this.canvas.width = Math.round(e * this.dpr), this.canvas.height = Math.round(t * this.dpr), this.paint(), this.draw(performance.now() / 1e3), this.play());
	}
	play() {
		this.reduced || !this.base || !this.onScreen || document.hidden ? (cancelAnimationFrame(this.raf), this.raf = 0) : this.raf ||= requestAnimationFrame(this.loop);
	}
	loop(e) {
		this.raf = 0, this.touch && (e - (this.movedAt ?? -1e9) < 180 || e - (this.drawnAt ?? -1e9) < 32) || (this.drawnAt = e, this.draw(e / 1e3)), this.play();
	}
	paint() {
		let { w: e, h: t, dpr: n } = this, r = $n(1307), i = e * t, a = (t) => {
			let r = document.createElement("canvas");
			r.width = Math.round(e * n), r.height = Math.round(t * n);
			let i = r.getContext("2d");
			return i.scale(n, n), [r, i];
		}, o = () => {
			let e = r();
			return e < .08 ? 0 : e < .3 ? 1 : e < .62 ? 2 : e < .82 ? 3 : e < .94 ? 4 : 5;
		}, s = this.fade = (e) => Zn(0, t * .4, e) * (1 - .3 * Zn(t * .65, t, e)), c = Array.from({ length: 8 }, () => ({
			x: r() * e,
			y: r() * t,
			s: 60 + r() * 200,
			k: r() < .65 ? .6 : -.5
		})), l = (t, n) => {
			let r = .5;
			for (let i of c) {
				let a = Math.min(Math.abs(t - i.x), e - Math.abs(t - i.x)), o = n - i.y;
				r += i.k * Math.exp(-(a * a + o * o) / (i.s * i.s));
			}
			return Yn(r);
		}, [u, d] = a(t);
		d.fillStyle = "#05080d", d.fillRect(0, 0, e, t);
		let f = (n, r, i) => {
			d.save(), d.translate(e / 2, t), d.scale(1, r / n);
			let a = d.createRadialGradient(0, 0, 0, 0, 0, n);
			for (let [e, t] of i) a.addColorStop(e, t);
			d.fillStyle = a, d.fillRect(-n, -n, n * 2, n), d.restore();
		};
		f(Math.max(e * .55, 240), t * .8, [
			[0, "rgba(9,26,46,.9)"],
			[.55, "rgba(7,19,35,.45)"],
			[1, "rgba(6,14,26,0)"]
		]), f(Math.max(e * .22, 120), t * .62, [
			[0, "rgba(14,38,66,.75)"],
			[.6, "rgba(10,28,50,.25)"],
			[1, "rgba(10,28,50,0)"]
		]);
		let p = (n, i, c, u) => {
			let [d, f] = a(t + 96);
			for (let a = n | 0; a--;) {
				let n = r() * e, a = r() * (t + 96) - Kn, d = r() ** u, p = o();
				if (r() > l(n, a)) continue;
				let m = (c[0] + c[1] * d) * s(a);
				if (m < .012) continue;
				f.fillStyle = `rgba(${Gn[p]},${m.toFixed(3)})`;
				let h = i[0] + i[1] * d;
				for (let t of n < 2 ? [0, e] : n > e - 2 ? [0, -e] : [0]) f.beginPath(), f.arc(n + t, a + Kn, h, 0, Wn), f.fill();
			}
			return d;
		};
		this.far = p(i / 90, [.22, .3], [.05, .35], 6), this.mid = p(i / 650, [.32, .45], [.14, .5], 3), this.stars = [];
		for (let n = Math.max(24, Math.min(160, i / 7500 | 0)); n--;) {
			let n = r() * e, i = r() * t, a = r() ** 2.4, c = r(), l = r(), u = c < .45 ? "far" : c < .85 ? "mid" : "near", d = (.3 + .6 * a) * s(i), f = l < .45, p = !f && l < .8;
			d < .03 || this.stars.push({
				x: n,
				y: i,
				a: d,
				d: Jn[u],
				c: o(),
				c2: o(),
				fast: f,
				r: (.8 + a * 2.2) * (u === "near" ? 1.25 : u === "far" ? .8 : 1),
				sp: f ? 2.5 + 5 * r() : p ? .06 + .2 * r() : .5 + r(),
				amp: f ? .25 + .3 * r() + .25 * i / t : p ? .45 + .5 * r() : .08,
				o: r() * 1e3,
				delay: (1 - a) * 1.6 + r() * .6,
				glint: 0
			});
		}
		this.base = u;
	}
	draw(e) {
		let { ctx: t, dpr: n, w: r, h: i } = this;
		if (!this.base) return;
		let a = this.reduced ? 99 : this.litAt ? e - this.litAt : -1, o = Math.min(.1, Math.max(0, e - (this.last ?? e)));
		this.last = e;
		let s = 1 - Math.exp(-o * 2.5);
		this.px += (this.tx - this.px) * s, this.py += (this.ty - this.py) * s;
		let c = this.reduced ? 0 : e * qn, l = this.reduced || this.touch ? 0 : Math.min(0, Math.max(-36, -(this.getBoundingClientRect().top - (document.documentElement.clientHeight - i)) * .08)), u = (e) => -(c + this.px * 30) * e, d = (e) => -this.py * 14 * e + l * (1.1 - e);
		t.setTransform(1, 0, 0, 1, 0, 0), t.globalCompositeOperation = "source-over", t.globalAlpha = 1, t.drawImage(this.base, 0, 0), t.globalCompositeOperation = "lighter", t.setTransform(n, 0, 0, n, 0, 0);
		for (let [e, o, s] of [[
			this.far,
			Jn.far,
			.8
		], [
			this.mid,
			Jn.mid,
			.3
		]]) {
			let c = Xn(Yn((a - s) / 2.4));
			if (c <= 0) continue;
			let l = Math.round(Qn(u(o), r) * n) / n, f = Math.round((d(o) - Kn) * n) / n;
			t.globalAlpha = c, t.drawImage(e, l - r, f, r, i + 96), t.drawImage(e, l, f, r, i + 96);
		}
		if (!this.reduced && a > 2.5 && e >= (this.nextGlint ??= e + 1)) {
			let t = this.stars[Math.random() * this.stars.length | 0];
			t && !t.glint && t.a > .2 && (t.glint = e, t.gl = G(.5, 1.4)), this.nextGlint = e + G(.8, 4.3);
		}
		for (let n of this.stars) {
			let i = 1, o = 0;
			if (!this.reduced) {
				let t = Yn((a - n.delay) / .9);
				if (t <= 0) continue;
				if (i = Xn(t) * (1 + .5 * Math.sin(t * Math.PI)), i *= 1 - n.amp * tr(e * n.sp + n.o), n.glint) {
					let t = (e - n.glint) / n.gl;
					t >= 1 ? n.glint = 0 : o = Math.sin(t * Math.PI) ** 3;
				}
			}
			let s = Math.min(1, n.a * i + (1 - n.a * i) * o * .9);
			if (s < .01) continue;
			let c = Qn(n.x + u(n.d), r), l = n.y + d(n.d), f = n.r * (.85 + .15 * Math.min(i, 1.2) + o * .6), p = n.fast && tr(e * n.sp * 1.7 + n.o + 99) > .62 ? n.c2 : n.c;
			if (t.globalAlpha = s, t.drawImage(this.sprites[p], c - f, l - f, f * 2, f * 2), o > .05) {
				let e = f * 3.5;
				t.globalAlpha = o * .5, t.drawImage(this.spike, c - e, l - e, e * 2, e * 2);
			}
		}
		!this.reduced && a > 3 && (e >= (this.nextMeteor ??= e + G(1.5, 4.5)) && (this.meteors.push(this.meteor(e)), this.nextMeteor = e + (Math.random() < .12 ? G(.25, .85) : 1.5 - Math.log(1 - Math.random()) * 5.5)), !this.sat && e >= (this.nextSat ??= e + G(6, 16)) && (this.sat = this.satellite(e))), this.meteors = this.meteors.filter((t) => this.streak(t, e)), this.sat && !this.pass(this.sat, e) && (this.sat = null, this.nextSat = e + G(25, 60)), t.globalAlpha = 1;
	}
	meteor(e) {
		let t = Math.random(), n = t > .95, r = t > .72, i = Math.random() < .5 ? -1 : 1, a = G(.15, .6), o = n ? G(450, 650) : G(600, 1200);
		return {
			t0: e,
			life: n ? G(1, 1.5) : r ? G(.55, .95) : G(.25, .55),
			linger: n ? 1.6 : 0,
			x: this.w * G(.1, .9),
			y: this.h * G(.22, .55),
			vx: Math.cos(a) * i * o,
			vy: Math.sin(a) * o,
			len: n ? G(200, 340) : r ? G(110, 220) : G(35, 100),
			a: n ? .8 : r ? G(.4, .65) : G(.18, .38),
			w: n ? G(1.4, 2) : r ? G(.8, 1.2) : G(.5, .8),
			head: n ? "205,255,232" : "235,245,255",
			glow: n || r
		};
	}
	streak(e, t) {
		let n = t - e.t0;
		if (n < 0 || n >= e.life + e.linger) return !1;
		let r = this.ctx, i = Math.hypot(e.vx, e.vy), a = e.vx / i, o = e.vy / i;
		if (n > e.life) {
			let t = 1 - (n - e.life) / e.linger, i = e.x + e.vx * e.life, s = e.y + e.vy * e.life;
			return r.globalAlpha = .14 * t * t, r.strokeStyle = "rgb(150,200,230)", r.lineWidth = e.w * 1.6, r.lineCap = "round", r.beginPath(), r.moveTo(i, s), r.lineTo(i - a * e.len * 1.4, s - o * e.len * 1.4), r.stroke(), !0;
		}
		let s = n / e.life, c = e.len * Math.min(1, s * 2.5), l = e.x + e.vx * n, u = e.y + e.vy * n, d = l - a * c, f = u - o * c, p = e.a * Math.sin(s * Math.PI) ** .8, m = r.createLinearGradient(l, u, d, f);
		if (m.addColorStop(0, `rgba(${e.head},${p})`), m.addColorStop(.25, `rgba(168,212,242,${p * .4})`), m.addColorStop(1, "rgba(168,212,242,0)"), r.globalAlpha = 1, r.strokeStyle = m, r.lineWidth = e.w, r.lineCap = "round", r.beginPath(), r.moveTo(l, u), r.lineTo(d, f), r.stroke(), e.glow) {
			let t = 2 + e.w * 2;
			r.globalAlpha = p * .8, r.drawImage(this.sprites[e.head === "235,245,255" ? 2 : 0], l - t, u - t, t * 2, t * 2);
		}
		return !0;
	}
	satellite(e) {
		let t = Math.random() < .5 ? 1 : -1;
		return {
			t0: e,
			dur: G(18, 32),
			dir: t,
			y0: this.h * G(.25, .55),
			dy: this.h * G(-.15, .15),
			a: G(.3, .5),
			flareAt: Math.random() < .3 ? G(.3, .7) : -1
		};
	}
	pass(e, t) {
		let n = (t - e.t0) / e.dur;
		if (n < 0 || n >= 1) return !1;
		let r = this.w + 20, i = e.dir > 0 ? -10 + n * r : this.w + 10 - n * r, a = e.y0 + e.dy * n, o = (n - e.flareAt) * e.dur / .8, s = e.flareAt < 0 ? 0 : Math.exp(-o * o), c = Math.min(1, (e.a + s * .6) * this.fade(a)), l = 1.4 + s * 2;
		return this.ctx.globalAlpha = c, this.ctx.drawImage(this.sprites[2], i - l, a - l, l * 2, l * 2), !0;
	}
};
customElements.define("aura-sky", ir);
//#endregion
//#region src/footer/aura-watch.js
var ar = [[67, 67.37], [424.11, 67.37]], or = -Math.PI / 2, sr = class extends HTMLElement {
	connectedCallback() {
		if (this.reduced = window.A?.reduced ?? matchMedia("(prefers-reduced-motion: reduce)").matches, this.svg = this.querySelector("svg"), this.lenses = [...this.querySelectorAll(".watch-lens")].map((e, t) => ({
			el: e,
			c: ar[t],
			a: or,
			on: .55,
			flash: 0
		})), this.reduced || !this.svg || !this.lenses.length) return;
		this.ac = new AbortController();
		let e = this.ac.signal;
		this.loop = this.loop.bind(this), this.touch = matchMedia("(hover: none)").matches;
		let t = (e) => {
			e.pointerType !== "touch" && (this.pointer = {
				x: e.clientX,
				y: e.clientY,
				at: performance.now(),
				touch: e.pointerType !== "mouse"
			});
		};
		addEventListener("pointermove", t, {
			passive: !0,
			signal: e
		}), addEventListener("pointerdown", t, {
			passive: !0,
			signal: e
		}), this.touch && addEventListener("scroll", () => {
			this.movedAt = performance.now();
		}, {
			passive: !0,
			signal: e
		}), document.documentElement.addEventListener("pointerleave", () => {
			this.pointer = null;
		}, { signal: e });
		let n = this.closest(".site-footer");
		n && (n.addEventListener("pointerover", (e) => {
			if (e.pointerType === "touch") return;
			let t = e.target.closest("a, button");
			t !== this.noticed && (this.noticed = t) && this.notice(.5);
		}, { signal: e }), n.addEventListener("focusin", (e) => {
			if (!e.target.matches(":focus-visible")) return;
			let t = e.target.getBoundingClientRect();
			this.pointer = {
				x: t.left + t.width / 2,
				y: t.top + t.height / 2,
				at: performance.now(),
				touch: !1,
				focus: !0
			}, this.notice(.6);
		}, { signal: e }), n.addEventListener("focusout", (e) => {
			!n.contains(e.relatedTarget) && this.pointer?.focus && (this.pointer = null);
		}, { signal: e })), document.addEventListener("visibilitychange", () => this.play(), { signal: e }), this.io = new IntersectionObserver(([e]) => {
			this.onScreen = e.isIntersecting, this.play();
		}), this.io.observe(this);
	}
	notice(e) {
		for (let t of this.lenses) t.flash = Math.max(t.flash, e);
		this.play();
	}
	disconnectedCallback() {
		this.ac?.abort(), this.io?.disconnect(), cancelAnimationFrame(this.raf), this.raf = 0;
	}
	play() {
		!this.onScreen || document.hidden ? (cancelAnimationFrame(this.raf), this.raf = 0) : this.raf ||= requestAnimationFrame(this.loop);
	}
	loop(e) {
		if (this.raf = 0, this.touch && (e - (this.movedAt ?? -1e9) < 180 || e - (this.drawnAt ?? -1e9) < 32)) {
			this.play();
			return;
		}
		this.drawnAt = e;
		let t = e / 1e3, n = Math.min(.1, Math.max(0, t - (this.last ?? t)));
		this.last = t;
		let r = this.svg.getScreenCTM(), i = this.pointer, a = !!i && !!r && (!i.touch || e - i.at < 3e3);
		if (a && !this.watching) for (let e of this.lenses) e.flash = 1;
		this.watching = a, this.lenses.forEach((e, o) => {
			let s = a ? Math.atan2(i.y - (r.d * e.c[1] + r.f), i.x - (r.a * e.c[0] + r.e)) : or + Math.sin(t * .3 + o * .9) * 1.1, c = Math.atan2(Math.sin(s - e.a), Math.cos(s - e.a));
			e.a += c * (1 - Math.exp(-n * (a ? 4 : 1.5))), e.on += ((a ? 1 : .55) - e.on) * (1 - Math.exp(-n * 2)), e.flash *= Math.exp(-n * 2.2), e.el.setAttribute("transform", `translate(${e.c[0]} ${e.c[1]}) rotate(${(e.a * 180 / Math.PI).toFixed(2)})`), e.el.style.opacity = Math.min(1, e.on * (.9 + .1 * Math.sin(t * .8 + o * 2)) + e.flash * .45).toFixed(3);
		}), this.play();
	}
};
customElements.define("aura-watch", sr);
//#endregion
//#region src/footer/nightfall.js
var cr = ".quote-panel, .co-panel.on-dark", lr = (e, t) => {
	let n = 0;
	for (let r = e; r && r !== t; r = r.offsetParent) n += r.offsetTop;
	return n;
};
function ur(e, t) {
	e.classList.add("is-nightfall");
	let n = [...e.querySelectorAll("[data-horizon]")], r = new ResizeObserver(() => {
		let r = n.find((e) => e.getClientRects().length) || t, i = lr(r, e), a = r.offsetHeight, o = e.offsetHeight, s = Math.round(i + (r.dataset.horizon === "base" ? a : a / 2));
		e.style.setProperty("--nightfall-at", `${s}px`);
		let c = o - s + 4, l = Math.min(c, o - (i + a) + 4);
		e.style.setProperty("--nightfall-start", (l / c).toFixed(4)), e.style.setProperty("--nightfall-from", `${s}px`), e.style.setProperty("--nightfall-to", `${o}px`), e.classList.remove("is-climbing"), e.offsetWidth, e.classList.add("is-climbing");
	});
	[
		e,
		t,
		...n
	].forEach((e) => r.observe(e, { box: "border-box" }));
}
window.A?.ready(() => {
	let e = [...document.querySelector("main")?.children || []].flatMap((e) => e.classList.contains("shopify-section") ? [...e.children] : [e]).filter((e) => ![
		"SCRIPT",
		"STYLE",
		"LINK"
	].includes(e.tagName) && !["fixed", "absolute"].includes(getComputedStyle(e).position)).at(-1), t = e?.matches(".section") && e.querySelector(cr);
	t && ur(e, t);
});
//#endregion
//#region src/footer/footer-settle.js
var dr = matchMedia("(hover: none)"), fr = .35, pr = .6, mr = 140;
window.A?.ready((e) => {
	let t = document.querySelector(".site-footer");
	if (!t || e.reduced) return;
	let n = scrollY, r = !1, i = 0, a = 0, o = () => {
		if (!dr.matches || i || !r || t.querySelector(".foot-col.is-open")) return;
		let e = t.getBoundingClientRect().top, n = document.documentElement.scrollHeight - innerHeight, a = n - scrollY;
		e <= innerHeight * fr && a > 2 && a < innerHeight * pr && window.scrollTo({
			top: n,
			behavior: "smooth"
		});
	}, s = () => {
		clearTimeout(a), a = setTimeout(o, mr);
	};
	addEventListener("scroll", () => {
		let e = scrollY;
		e !== n && (r = e > n), n = e, s();
	}, { passive: !0 });
	let c = (e) => {
		i = e.touches.length, i || s();
	};
	addEventListener("touchstart", c, { passive: !0 }), addEventListener("touchend", c, { passive: !0 }), addEventListener("touchcancel", c, { passive: !0 });
});
//#endregion
//#region src/hero/aura-clouds.js
var hr = .5, gr = 30, _r = "attribute vec2 p; void main() { gl_Position = vec4(p, 0., 1.); }", vr = "\n#ifdef GL_FRAGMENT_PRECISION_HIGH\nprecision highp float;\n#else\nprecision mediump float;\n#endif\nuniform vec2 uRes;\nuniform float uTime;\nuniform float uHorizon;\nuniform sampler2D uMask;\n\nfloat hash(vec2 p) { p = fract(p * vec2(123.34, 456.21)); p += dot(p, p + 45.32); return fract(p.x * p.y); }\n// gradient noise, about -.7 to .7: smoother and less blobby than value noise\nvec2 grad(vec2 i) { float a = hash(i) * 6.2831853; return vec2(cos(a), sin(a)); }\nfloat gnoise(vec2 p) {\n  vec2 i = floor(p), f = fract(p), u = f * f * f * (f * (f * 6. - 15.) + 10.);\n  return mix(mix(dot(grad(i), f), dot(grad(i + vec2(1., 0.)), f - vec2(1., 0.)), u.x),\n             mix(dot(grad(i + vec2(0., 1.)), f - vec2(0., 1.)), dot(grad(i + vec2(1., 1.)), f - vec2(1., 1.)), u.x), u.y);\n}\nfloat fbm(vec2 p, int n) {\n  float s = 0., a = .5;\n  mat2 r = mat2(.8, .6, -.6, .8);\n  for (int i = 0; i < 6; i++) { if (i >= n) break; s += a * gnoise(p); p = r * p * 2.03 + 17.1; a *= .5; }\n  return s;\n}\n// cloud density at a point on the deck: clusters with clear sky between,\n// billowy shapes, edges eaten away by fine detail\nfloat density(vec2 W, float time) {\n  float cover = gnoise(W * .22 + vec2(time * .003, 3.7)) * .5;\n  float d = fbm(W, 5) + cover - .08;\n  d -= (1. - smoothstep(0., .3, d)) * .18 * fbm(W * 3.1 + 9.3, 3);\n  return d;\n}\nvoid main() {\n  vec2 uv = gl_FragCoord.xy / uRes; uv.y = 1. - uv.y;\n  float m = texture2D(uMask, uv).r;\n  if (m < .01) { gl_FragColor = vec4(0.); return; }\n  // perspective onto the cloud deck: overhead is near and large, the horizon far and small\n  float h = max(uHorizon - uv.y, .015);\n  float t = .35 / h;\n  vec2 P = vec2((uv.x - .5) * (uRes.x / uRes.y) * t, t) * 1.5;\n  P.x -= uTime * .014;\n  // a slow warp, so the clouds change shape as they drift\n  vec2 q = vec2(fbm(P * .5 + vec2(0., uTime * .005), 3), fbm(P * .5 + vec2(5.2, 1.3) - uTime * .004, 3));\n  vec2 W = P + q * .9;\n  float d = density(W, uTime);\n  float c = smoothstep(0., .32, d);\n  if (c <= 0.) { gl_FragColor = vec4(0.); return; }\n  // lit from the upper left: sides facing the sun bright, the far side and undersides blue-grey\n  float toward = density(W + vec2(-.07, -.09), uTime);\n  float lit = clamp(.62 + (d - toward) * 3.2 - d * .35, 0., 1.);\n  vec3 shade = vec3(.70, .76, .86), sun = vec3(1., .992, .975);\n  vec3 col = mix(shade, sun, lit);\n  col = mix(col, sun, (1. - c) * .5);                       // thin edges glow\n  float a = c * .97 * m * smoothstep(0., .14, h);           // thinning into the haze at the horizon\n  gl_FragColor = vec4(col * a, a);\n}", yr = class extends HTMLElement {
	connectedCallback() {
		this.reduced = window.A?.reduced ?? matchMedia("(prefers-reduced-motion: reduce)").matches, this.canvas = this.querySelector("canvas") || this.appendChild(document.createElement("canvas"));
		let e = this.gl = this.canvas.getContext("webgl", {
			alpha: !0,
			premultipliedAlpha: !0,
			antialias: !1,
			powerPreference: "low-power"
		});
		if (!e || !this.setup(e)) return;
		this.loop = this.loop.bind(this), this.play = this.play.bind(this), this.t0 = performance.now();
		let t = new Image();
		t.crossOrigin = "anonymous", t.onload = () => {
			e.bindTexture(e.TEXTURE_2D, e.createTexture()), e.texImage2D(e.TEXTURE_2D, 0, e.LUMINANCE, e.LUMINANCE, e.UNSIGNED_BYTE, t);
			for (let [t, n] of [
				[e.TEXTURE_MIN_FILTER, e.LINEAR],
				[e.TEXTURE_MAG_FILTER, e.LINEAR],
				[e.TEXTURE_WRAP_S, e.CLAMP_TO_EDGE],
				[e.TEXTURE_WRAP_T, e.CLAMP_TO_EDGE]
			]) e.texParameteri(e.TEXTURE_2D, t, n);
			this.ready = !0, this.resize(), this.play();
		}, t.src = this.getAttribute("mask"), this.ro = new ResizeObserver(() => this.resize()), this.io = new IntersectionObserver(([e]) => {
			this.onScreen = e.isIntersecting, this.play();
		}), this.ro.observe(this), this.io.observe(this), document.addEventListener("visibilitychange", this.play), this.onScroll = () => {
			this.movedAt = performance.now();
		}, addEventListener("scroll", this.onScroll, { passive: !0 }), this.canvas.addEventListener("webglcontextlost", (e) => {
			e.preventDefault(), this.ready = !1, this.play();
		});
	}
	disconnectedCallback() {
		this.ro?.disconnect(), this.io?.disconnect(), document.removeEventListener("visibilitychange", this.play), removeEventListener("scroll", this.onScroll), cancelAnimationFrame(this.raf), this.raf = 0;
	}
	setup(e) {
		let t = (t, n) => {
			let r = e.createShader(t);
			return e.shaderSource(r, n), e.compileShader(r), e.getShaderParameter(r, e.COMPILE_STATUS) ? r : null;
		}, n = t(e.VERTEX_SHADER, _r), r = t(e.FRAGMENT_SHADER, vr);
		if (!n || !r) return !1;
		let i = e.createProgram();
		return e.attachShader(i, n), e.attachShader(i, r), e.bindAttribLocation(i, 0, "p"), e.linkProgram(i), e.getProgramParameter(i, e.LINK_STATUS) ? (e.useProgram(i), e.bindBuffer(e.ARRAY_BUFFER, e.createBuffer()), e.bufferData(e.ARRAY_BUFFER, new Float32Array([
			-1,
			-1,
			3,
			-1,
			-1,
			3
		]), e.STATIC_DRAW), e.enableVertexAttribArray(0), e.vertexAttribPointer(0, 2, e.FLOAT, !1, 0, 0), this.u = Object.fromEntries([
			"uRes",
			"uTime",
			"uHorizon",
			"uMask"
		].map((t) => [t, e.getUniformLocation(i, t)])), e.uniform1i(this.u.uMask, 0), e.uniform1f(this.u.uHorizon, parseFloat(this.getAttribute("horizon")) || .7), !0) : !1;
	}
	resize() {
		let e = Math.max(1, Math.round(this.clientWidth * hr)), t = Math.max(1, Math.round(this.clientHeight * hr));
		!this.ready || e === this.canvas.width && t === this.canvas.height || (this.canvas.width = e, this.canvas.height = t, this.gl.viewport(0, 0, e, t), this.gl.uniform2f(this.u.uRes, e, t), this.draw(performance.now()));
	}
	play() {
		this.reduced || !this.ready || !this.onScreen || document.hidden ? (cancelAnimationFrame(this.raf), this.raf = 0) : this.raf ||= requestAnimationFrame(this.loop);
	}
	loop(e) {
		this.raf = 0, e - (this.last ?? 0) >= 1e3 / gr - 2 && e - (this.movedAt ?? -1e9) > 180 && (this.last = e, this.draw(e)), this.play();
	}
	draw(e) {
		if (!this.ready) return;
		let t = this.reduced ? 40 : 40 + (e - this.t0) / 1e3 % 2e4;
		this.gl.uniform1f(this.u.uTime, t), this.gl.drawArrays(this.gl.TRIANGLES, 0, 3), this.classList.add("is-on");
	}
};
customElements.define("aura-clouds", yr);
//#endregion
//#region src/hero/aura-spots.js
var br = "<svg class=\"ico\" viewBox=\"0 0 24 24\" aria-hidden=\"true\" focusable=\"false\"><path d=\"M5 12h14\"/><path d=\"m13 6 6 6-6 6\"/></svg>", xr = class extends HTMLElement {
	connectedCallback() {
		this.spots = [...this.querySelectorAll(".hs-spot")], this.spots.forEach((e) => {
			this.fill(e), e.addEventListener("pointerenter", () => this.fit(e)), e.addEventListener("focusin", () => this.fit(e));
		}), this.addEventListener("click", (e) => {
			let t = e.target.closest(".hs-spot__beam");
			if (!t) return;
			let n = t.closest(".hs-spot");
			this.open(n.classList.contains("is-open") ? null : n);
		}), this.away = (e) => {
			e.target.closest?.(".hs-spot") || this.open(null);
		}, this.esc = (e) => {
			e.key === "Escape" && this.open(null);
		}, document.addEventListener("click", this.away), document.addEventListener("keydown", this.esc);
	}
	disconnectedCallback() {
		document.removeEventListener("click", this.away), document.removeEventListener("keydown", this.esc);
	}
	fit(e) {
		let t = e.querySelector(".hs-spot__card");
		if (!t) return;
		let n = this.getBoundingClientRect(), r = e.getBoundingClientRect().left, i = t.offsetWidth / 2, a = Math.min(0, n.right - 16 - (r + i)) + Math.max(0, n.left + 16 - (r - i));
		t.style.setProperty("--shift", `${Math.round(a)}px`);
	}
	open(e) {
		e && this.fit(e), this.spots.forEach((t) => {
			let n = t === e;
			t.classList.toggle("is-open", n), t.querySelector(".hs-spot__beam")?.setAttribute("aria-expanded", n);
		});
	}
	fill(e) {
		let t = window.AURA, n = e.querySelector(".hs-spot__card"), r = t?.byHandle(e.dataset.handle);
		r && n && !n.children.length && (n.href = t.route(`product.html?p=${r.handle}`), n.innerHTML = `<span class="hs-spot__media" style="--tint:${r.tint}"><img src="${r.images[0]}" alt="" loading="lazy" width="1200" height="1200"></span><span class="hs-spot__text"><b>${((e) => String(e).replace(/[&<>"]/g, (e) => ({
			"&": "&amp;",
			"<": "&lt;",
			">": "&gt;",
			"\"": "&quot;"
		})[e]))(r.name)}</b><span class="hs-spot__price">${((e) => `€${Number(e).toLocaleString("en-IE")}`)(r.from)}</span><span class="hs-spot__go">View product ${br}</span></span>`, e.querySelector(".hs-spot__beam")?.setAttribute("aria-label", `${r.name}: show product`));
	}
};
customElements.define("aura-spots", xr);
//#endregion
//#region src/film/aura-film.js
var Sr = "(max-width: 760px), (orientation: portrait)", Cr = class extends HTMLElement {
	connectedCallback() {
		this.video = this.querySelector("video"), this.stage = this.querySelector(".film__stage") || this, this.caps = [...this.querySelectorAll("[data-from]")];
		let e = window.A?.reduced ?? matchMedia("(prefers-reduced-motion: reduce)").matches;
		this.fine = matchMedia("(hover: hover) and (pointer: fine)").matches, this.mode = e || !this.video ? "still" : this.fine ? "scrub" : "play", this.p = 0, this.e = 1, this.t = 0, this.raf = 0, this.shown = 0, this.update = this.update.bind(this), this.show = this.show.bind(this), this.tick = this.tick.bind(this), this.play = this.play.bind(this), this.near = new IntersectionObserver(([e]) => {
			e.isIntersecting && this.load();
		}, { rootMargin: "100% 0px" }), this.seen = new IntersectionObserver(([e]) => {
			this.onScreen = e.isIntersecting, this.play();
		}), this.near.observe(this), this.seen.observe(this), document.addEventListener("visibilitychange", this.play), addEventListener("scroll", this.update, { passive: !0 }), addEventListener("resize", this.update), this.update();
	}
	disconnectedCallback() {
		this.near?.disconnect(), this.seen?.disconnect(), document.removeEventListener("visibilitychange", this.play), removeEventListener("scroll", this.update), removeEventListener("resize", this.update), cancelAnimationFrame(this.raf), this.raf = 0, cancelAnimationFrame(this.shown), this.shown = 0;
	}
	load() {
		if (this.loaded || this.mode === "still") return;
		this.loaded = !0;
		let e = this.video, t = e.dataset;
		e.muted = !0, e.preload = "auto", e.addEventListener("loadedmetadata", () => {
			this.dur = e.duration, this.update(), this.play();
		}, { once: !0 }), e.src = matchMedia(Sr).matches && t.srcPortrait || t.src;
	}
	update() {
		let e = this.getBoundingClientRect(), t = this.stage.offsetHeight;
		this.p = Math.min(1, Math.max(0, -e.top / Math.max(1, e.height - t))), this.e = Math.min(1, Math.max(0, e.top / Math.max(1, t))), this.shown ||= requestAnimationFrame(this.show), this.mode === "scrub" && this.dur && !this.raf && (this.raf = requestAnimationFrame(this.tick));
	}
	show() {
		this.shown = 0;
		let e = this.p;
		this.caps.forEach((t, n) => {
			let r = this.caps[n + 1];
			t.classList.toggle("is-active", e >= (parseFloat(t.dataset.from) || 0) && (!r || e < parseFloat(r.dataset.from)));
		}), this.fine && (this.style.setProperty("--p", e.toFixed(4)), this.style.setProperty("--e", this.e.toFixed(4)));
	}
	tick() {
		this.raf = 0;
		let e = this.video, t = this.p * (this.dur - .05);
		this.t += (t - this.t) * .18, Math.abs(t - this.t) < .004 && (this.t = t), !e.seeking && Math.abs(e.currentTime - this.t) > 1 / 60 && (e.currentTime = this.t), (this.t !== t || e.seeking) && (this.raf = requestAnimationFrame(this.tick));
	}
	play() {
		if (this.mode !== "play" || !this.dur) return;
		let e = this.video;
		this.onScreen && !document.hidden ? (this.again && (this.again = !1, e.currentTime = 0), e.ended || e.play().catch(() => {})) : (e.pause(), e.ended && !this.onScreen && (this.again = !0));
	}
};
customElements.define("aura-film", Cr);
//#endregion
//#region src/motion/quiet.js
var wr = 0;
addEventListener("scroll", () => {
	wr = performance.now();
}, { passive: !0 });
var Tr = (e, t = 1e3) => window.requestIdleCallback ? requestIdleCallback(e, { timeout: t }) : setTimeout(e, 50);
function Er(e, t) {
	let n = () => {
		performance.now() - wr > 300 || t?.() ? e() : setTimeout(() => Tr(n), 60);
	};
	Tr(n);
}
var Dr = (e) => new Promise((t) => Er(t, e)), Or = /* @__PURE__ */ n({
	PLACES: () => Ar,
	RINGS: () => kr
}), kr, Ar, jr = t((() => {
	kr = [
		[
			129.2,
			11.4,
			131.1,
			15.5,
			130.5,
			18.6,
			129.9,
			19.6,
			124.8,
			22.7,
			123.6,
			25.4,
			121.3,
			27.2,
			120.4,
			29.9,
			119.6,
			39.3,
			119.9,
			42.3,
			121.3,
			43.8,
			119.8,
			45,
			119.1,
			46.7,
			119.9,
			51.4,
			115,
			52.1,
			112.8,
			53.2,
			111.3,
			55.2,
			110.9,
			57.2,
			111.3,
			62.4,
			113,
			66.7,
			112.2,
			67.3,
			112.2,
			68.1,
			115.7,
			67.7,
			120.3,
			65.7,
			121.3,
			65.8,
			125.4,
			63.5,
			126.5,
			64,
			128.7,
			66.5,
			128.9,
			67.8,
			127.2,
			70,
			124.8,
			70.7,
			123.8,
			72.3,
			118.1,
			77.2,
			118.6,
			77.9,
			123.7,
			76.6,
			124.5,
			74.6,
			130.4,
			72.6,
			128.6,
			71.9,
			128.6,
			71.2,
			129.7,
			70.4,
			133.4,
			70.4,
			137.1,
			72.9,
			139.1,
			75,
			141.9,
			76.4,
			143.1,
			77.9,
			144.8,
			84.2,
			145.2,
			91.8,
			150.7,
			93.6,
			153.5,
			93.9,
			157.4,
			93.6,
			158.9,
			91.7,
			160,
			92.3,
			160.4,
			94.6,
			161.8,
			94.6,
			164,
			96.8,
			165.7,
			99.4,
			166.5,
			102.5,
			165.9,
			106.7,
			164,
			108.8,
			161.1,
			108,
			155.4,
			105.2,
			158.5,
			108.3,
			160.9,
			115.1,
			160.4,
			115.8,
			160.9,
			117.3,
			160.1,
			117.6,
			159.7,
			118.5,
			160,
			121.2,
			157.9,
			122.3,
			160.9,
			123.4,
			160.2,
			124.1,
			157.7,
			124.2,
			155.9,
			125.6,
			154.9,
			125.7,
			156.1,
			127.3,
			155.8,
			130.2,
			157.8,
			130.1,
			159.6,
			129.1,
			164.2,
			124.8,
			165.4,
			122.9,
			166.3,
			117,
			166,
			115.3,
			164.5,
			113.4,
			164.2,
			110.9,
			165.3,
			108.7,
			166.1,
			108.3,
			167.4,
			104.5,
			168.2,
			103.7,
			169.1,
			103.9,
			169.9,
			105.5,
			170.9,
			106,
			170,
			107.2,
			171.8,
			109.7,
			172.1,
			111.5,
			171.6,
			113.4,
			173.6,
			117.3,
			173.4,
			118.9,
			173.8,
			120,
			171.3,
			123.4,
			170.6,
			129.3,
			168.3,
			132.5,
			166.8,
			139,
			165.5,
			139.6,
			164.3,
			141.5,
			156.3,
			140.3,
			154.9,
			140.4,
			152.8,
			141.6,
			146.7,
			138.2,
			143,
			133.2,
			142.2,
			133.3,
			141.7,
			135.8,
			140.9,
			136.3,
			143.3,
			140.7,
			146.3,
			143.9,
			154,
			146.9,
			155.5,
			148.5,
			156.5,
			151,
			156.6,
			154,
			155.8,
			157.5,
			152.5,
			161.1,
			150.5,
			161.6,
			149.5,
			159.7,
			153.7,
			155.4,
			154.9,
			153,
			152.9,
			155.3,
			149.3,
			157.1,
			147.9,
			163.1,
			144.7,
			167,
			143.6,
			170.4,
			140.7,
			173.7,
			137,
			174.9,
			138,
			179.8,
			138.2,
			181.8,
			137.7,
			182.8,
			135.8,
			183.9,
			132.5,
			184.1,
			131.9,
			185.1,
			133.4,
			189.3,
			133.6,
			195.5,
			132.9,
			196.7,
			129.4,
			200.4,
			128,
			201,
			125.4,
			201.4,
			120.1,
			199.9,
			112.6,
			203.7,
			111,
			204.1,
			108.5,
			202.6,
			104.5,
			204.4,
			103,
			204.2,
			101.6,
			203.5,
			98.1,
			200.3,
			93.6,
			199.9,
			86,
			196.6,
			77.4,
			196.2,
			73.2,
			198.5,
			72.2,
			198.4,
			71.4,
			191.9,
			69,
			188.2,
			68.5,
			184.8,
			66.1,
			182.3,
			63.1,
			181.4,
			60.8,
			181.8,
			57.9,
			183.2,
			52.6,
			182.5,
			54.3,
			187.1,
			58.2,
			192.8,
			63.1,
			195.2,
			67.4,
			198.7,
			73.5,
			201.1,
			73.7,
			203.3,
			72.8,
			205,
			71.3,
			204.4,
			66.9,
			206.6,
			64.4,
			207.1,
			61.1,
			208.5,
			55.8,
			215.1,
			44.2,
			219.6,
			43.1,
			219,
			46.3,
			216.6,
			46.4,
			214,
			48.4,
			211.6,
			52.6,
			208.3,
			51.3,
			207.4,
			48.4,
			208.1,
			47.1,
			209,
			49,
			209,
			48,
			211,
			46.6,
			211.7,
			45.3,
			211.3,
			42.7,
			208.6,
			41.3,
			208.6,
			38.6,
			210.5,
			39,
			209,
			37.9,
			208.3,
			34.9,
			209,
			35.6,
			207.2,
			35.4,
			205,
			34.7,
			203.1,
			33.2,
			201.8,
			33.2,
			200.7,
			33.8,
			198.8,
			39,
			192.8,
			39,
			190.1,
			38,
			187.6,
			39.5,
			186.4,
			39.4,
			183.1,
			38.6,
			181.8,
			34.6,
			180.3,
			34,
			179.1,
			25.8,
			172.3,
			24.5,
			171.9,
			24.5,
			172.6,
			27.6,
			176.4,
			31.7,
			179.5,
			32.4,
			181.8,
			31.1,
			182.5,
			27.1,
			181.8,
			27.1,
			182.5,
			33.8,
			187.1,
			34.8,
			189.8,
			34.7,
			191.6,
			32.2,
			194.1,
			31.7,
			196.9,
			28.9,
			198.6,
			28.5,
			199.6,
			29.1,
			203.6,
			27,
			207.1,
			25,
			207.2,
			21.6,
			204.8,
			19.2,
			205.2,
			17.4,
			201.1,
			17.1,
			199.7,
			19.9,
			198.4,
			21.7,
			196.3,
			22.6,
			196.2,
			21.8,
			199.1,
			21.6,
			200.6,
			22.2,
			201.4,
			23,
			201.1,
			23.6,
			199.9,
			25.3,
			193.2,
			23.1,
			187.9,
			23.5,
			191.6,
			22.1,
			195.3,
			18.5,
			197.7,
			16.7,
			196.9,
			15.5,
			198.4,
			17.2,
			204.4,
			16.7,
			205.2,
			12.2,
			200.7,
			12.6,
			198.4,
			14.1,
			196.4,
			14.3,
			195.2,
			12.8,
			192.3,
			10.3,
			192.4,
			10.3,
			193.2,
			11.8,
			193.7,
			12.6,
			195.5,
			10,
			194.2,
			10.3,
			196.2,
			9.4,
			197.7,
			6.7,
			196.8,
			5.8,
			197.6,
			3,
			196.2,
			3,
			196.9,
			6.1,
			198.9,
			6.6,
			200.2,
			4.9,
			201.4,
			3.3,
			201.2,
			1.9,
			197.8,
			-4.3,
			194,
			-7.1,
			190.7,
			-7.3,
			192.3,
			-6.1,
			194.7,
			-10.4,
			193.2,
			-14.1,
			194.7,
			-15.2,
			194.7,
			-17.9,
			188.5,
			-16.9,
			183.3,
			-17.9,
			180.7,
			-18.3,
			180.3,
			-18.9,
			180.8,
			-19.1,
			183.4,
			-19.7,
			184,
			-21.5,
			180.9,
			-23.4,
			180.3,
			-23.8,
			178.7,
			-23.4,
			178.7,
			-24.2,
			177.2,
			-25.7,
			178,
			-27,
			177.2,
			-27,
			176.4,
			-24.5,
			173.4,
			-23,
			172,
			-21,
			171.2,
			-24.5,
			169.7,
			-26.6,
			171,
			-27.4,
			170.4,
			-26.6,
			168.3,
			-23.8,
			164.4,
			-22,
			164.3,
			-21.5,
			166.7,
			-19.1,
			166.3,
			-18.3,
			164.3,
			-17.4,
			163.6,
			-21,
			163.8,
			-22,
			162.8,
			-22,
			161,
			-20.9,
			159.8,
			-18.3,
			159,
			-18.3,
			158.3,
			-19.7,
			158.3,
			-23.4,
			159.7,
			-27.9,
			159.3,
			-29.3,
			160.5,
			-31.5,
			158.3,
			-33.5,
			157.8,
			-33.7,
			156.8,
			-32.2,
			156.6,
			-29.8,
			154.9,
			-27.3,
			154.1,
			-23.8,
			150.7,
			-25,
			150.1,
			-26.2,
			150.7,
			-28.1,
			153.3,
			-28.9,
			153.6,
			-31.9,
			153.5,
			-32.9,
			153,
			-31.6,
			151.8,
			-27,
			150.7,
			-27,
			150,
			-32.3,
			151.1,
			-38.9,
			151.3,
			-45.3,
			147.3,
			-46.8,
			144.4,
			-49.5,
			143.6,
			-49.6,
			142.9,
			-48.3,
			141.5,
			-49.2,
			139.3,
			-48.1,
			139.3,
			-42.6,
			137.3,
			-41.9,
			136.6,
			-42.5,
			135.6,
			-41.3,
			134.8,
			-36.3,
			134.8,
			-34.1,
			133.7,
			-33.4,
			135.2,
			-29.5,
			136.3,
			-27.3,
			133,
			-26.4,
			135.7,
			-25.3,
			137.3,
			-24.5,
			137.3,
			-24.7,
			134.8,
			-23.2,
			135.8,
			-22.4,
			134.9,
			-22.2,
			133.3,
			-25.4,
			131.3,
			-27,
			129.5,
			-27,
			128.8,
			-25.1,
			129.6,
			-21.1,
			133.6,
			-19.4,
			134.5,
			-16.7,
			137.1,
			-15.3,
			136,
			-16.1,
			133.3,
			-12.3,
			135.9,
			-7.7,
			136.7,
			-5.2,
			138.5,
			-4.7,
			137.8,
			-5.8,
			133.3,
			-8.3,
			134.8,
			-8.1,
			132.1,
			-11.2,
			129.3,
			-11,
			127.2,
			-14.7,
			124.2,
			-12.8,
			122.8,
			-10.6,
			122.7,
			-10.6,
			121.8,
			-12.7,
			121.4,
			-15.8,
			119.4,
			-22.2,
			118.1,
			-26.1,
			115.8,
			-27.7,
			118.9,
			-28.1,
			113.9,
			-40.7,
			106.1,
			-41,
			105.2,
			-40.6,
			103.7,
			-34,
			103.7,
			-31.1,
			102.5,
			-30.6,
			101.4,
			-32,
			100.6,
			-34.3,
			102.2,
			-34.5,
			100.1,
			-30.1,
			99.2,
			-27.9,
			96.9,
			-32.6,
			97.8,
			-33.7,
			96.8,
			-36.1,
			97.7,
			-37.9,
			95.4,
			-37.9,
			94.6,
			-34.7,
			93.6,
			-33.8,
			91.5,
			-30.6,
			90.1,
			-30.6,
			89.3,
			-32.8,
			89.4,
			-34.7,
			88.5,
			-36.8,
			91.3,
			-38.7,
			92,
			-39.7,
			95.4,
			-41.6,
			96.3,
			-45.6,
			95.5,
			-47.5,
			96.9,
			-50.3,
			95.4,
			-53.5,
			95.4,
			-59,
			98.4,
			-60.2,
			97.7,
			-64.2,
			98.6,
			-66.5,
			98.4,
			-69,
			91.4,
			-70.5,
			89.9,
			-72,
			89.3,
			-71.6,
			87.7,
			-72,
			82.5,
			-72.4,
			82.5,
			-73,
			86.3,
			-77,
			90.4,
			-77.3,
			91.5,
			-76.1,
			92.3,
			-76.1,
			93.2,
			-77.5,
			93.8,
			-77.1,
			96.8,
			-77.5,
			97.7,
			-79.5,
			96.9,
			-80.9,
			99.9,
			-85.2,
			101.5,
			-88.6,
			99.2,
			-93.8,
			99.9,
			-95.9,
			101.5,
			-98.6,
			100.6,
			-110,
			101.5,
			-115.2,
			103.7,
			-119.1,
			102.7,
			-119.2,
			101.9,
			-118.1,
			99.2,
			-113.4,
			97.7,
			-116.1,
			97.7,
			-116.1,
			96.9,
			-114.7,
			96.2,
			-113.8,
			94.6,
			-115.3,
			94.8,
			-119.1,
			96.9,
			-121.1,
			94.7,
			-121.6,
			92.9,
			-120.7,
			91.6,
			-123.4,
			88.9,
			-128.3,
			91,
			-127.9,
			93.2,
			-126.2,
			91.6,
			-124.6,
			91.4,
			-123,
			92.7,
			-121.5,
			95.4,
			-122,
			96.1,
			-123.3,
			95.6,
			-124.3,
			96.9,
			-125.2,
			96.3,
			-127.6,
			97,
			-128.4,
			97.7,
			-129.3,
			99.9,
			-129.9,
			99.9,
			-130.6,
			98.4,
			-134.3,
			96.1,
			-135.8,
			92.3,
			-137.1,
			92.3,
			-135.5,
			90.9,
			-133.4,
			90.9,
			-135.5,
			87.9,
			-136,
			84.6,
			-137.9,
			80.2,
			-137.8,
			78.1,
			-137.2,
			76.9,
			-135,
			76.4,
			-133.9,
			76.8,
			-134,
			77.8,
			-135.7,
			79.4,
			-133.8,
			80.2,
			-134,
			82.3,
			-135.2,
			83.3,
			-135.2,
			84,
			-133.8,
			84.7,
			-132,
			84.8,
			-132.9,
			87.1,
			-131.7,
			86.8,
			-130.6,
			87.2,
			-130.2,
			88.1,
			-131.1,
			89.3,
			-130.1,
			90.5,
			-128.6,
			89.9,
			-125.2,
			87.1,
			-126.2,
			85.7,
			-127.9,
			86.3,
			-124.8,
			82.5,
			-126.6,
			83.3,
			-126.2,
			82,
			-123.3,
			79.4,
			-127.5,
			77.9,
			-128.8,
			77.9,
			-127.5,
			75,
			-125.8,
			73.7,
			-123.9,
			74.1,
			-122,
			76.4,
			-122.5,
			76.4,
			-122.5,
			77.2,
			-121.4,
			77.4,
			-121.5,
			78.7,
			-119.8,
			79.3,
			-118.4,
			78.7,
			-120.3,
			77.2,
			-119.8,
			76.4,
			-121.2,
			75.3,
			-121.2,
			74.6,
			-120.3,
			74.2,
			-122.6,
			72.4,
			-122.7,
			69.1,
			-121.3,
			66.6,
			-119.8,
			66.6,
			-119.4,
			66.1,
			-118.3,
			61.5,
			-117.5,
			61.2,
			-117.9,
			62.8,
			-117,
			62.6,
			-115.2,
			60.5,
			-115.3,
			57.1,
			-115.9,
			56.7,
			-116.7,
			57.3,
			-116.9,
			59.9,
			-120.7,
			62.1,
			-123.8,
			61.2,
			-123.8,
			60.5,
			-123.3,
			60.5,
			-123.3,
			57.5,
			-124.5,
			56.7,
			-124.9,
			53.6,
			-125.7,
			53,
			-123.5,
			50.7,
			-119.9,
			51.6,
			-113.4,
			55.2,
			-103.9,
			55.2,
			-102,
			54.5,
			-100.6,
			55.2,
			-101.1,
			53.3,
			-102,
			52.2,
			-100.2,
			51.4,
			-102.5,
			49.6,
			-103.2,
			48.6,
			-103,
			46.9,
			-104.3,
			46.1,
			-100.6,
			44.6,
			-100.6,
			43.8,
			-113,
			41.6,
			-115.4,
			42.7,
			-116.1,
			42,
			-123.3,
			40,
			-122.8,
			38,
			-124.3,
			32.1,
			-123.3,
			27.2,
			-118,
			23.9,
			-115.1,
			22.8,
			-110.4,
			23.2,
			-109.3,
			22.6,
			-109.3,
			21.9,
			-117.7,
			22.8,
			-119.8,
			24.1,
			-120.7,
			24,
			-124.8,
			22.1,
			-130,
			22.6,
			-132.5,
			22,
			-131.5,
			20.7,
			-127.5,
			18,
			-129.8,
			15.9,
			-131.1,
			18,
			-134.1,
			18.8,
			-137.1,
			18.8,
			-136.6,
			16.6,
			-141.4,
			17.2,
			-142.9,
			15.9,
			-142.3,
			15.3,
			-139.6,
			15.9,
			-138.4,
			14.1,
			-137.9,
			12,
			-136.5,
			10.4,
			-134,
			9.4,
			-130.2,
			9,
			-130.8,
			7.8,
			-135.2,
			9,
			-134.4,
			7.3,
			-132.9,
			6.8,
			-132.9,
			5.9,
			-133.9,
			4.8,
			-138.9,
			5.1,
			-139.8,
			4.4,
			-141.1,
			1.4,
			-139.9,
			1.4,
			-138.8,
			2.2,
			-137.9,
			1.1,
			-133.6,
			1.4,
			-132.7,
			1.1,
			-130.4,
			-2.1,
			-126.9,
			-2.3,
			-124.3,
			-1.2,
			-124.5,
			1.1,
			-123.5,
			2.9,
			-121.8,
			2.2,
			-119.3,
			3.7,
			-121.5,
			.7,
			-121.2,
			-.5,
			-120.1,
			-.6,
			-117.8,
			1.8,
			-116.1,
			2.2,
			-116.1,
			1.4,
			-117.5,
			.7,
			-117.5,
			-.1,
			-115.2,
			-.1,
			-115.2,
			-.8,
			-118.9,
			-3.5,
			-121.9,
			-4.5,
			-122.9,
			-8.4,
			-121.9,
			-9.2,
			-119,
			-8.5,
			-116.6,
			-10.9,
			-112.4,
			-9.5,
			-108.5,
			-2.7,
			-106.4,
			-.8,
			-105.4,
			-1.6,
			-105.4,
			-2.5,
			-106.4,
			-6.5,
			-105.2,
			-7.7,
			-103.9,
			-7.2,
			-103.3,
			-5.6,
			-103.4,
			-3.7,
			-104.3,
			-2.4,
			-103.3,
			-1.7,
			-99.7,
			-1.6,
			-103,
			-3.9,
			-100.3,
			-6.5,
			-101.3,
			-8.4,
			-102.7,
			-7.7,
			-104,
			-8.7,
			-103.5,
			-13.7,
			-104.8,
			-16.8,
			-103.7,
			-18.1,
			-102.7,
			-17.9,
			-101.9,
			-16.5,
			-101,
			-12.1,
			-99.9,
			-12.1,
			-99.4,
			-13.4,
			-100.6,
			-15.3,
			-98.4,
			-18.3,
			-97,
			-19,
			-92.8,
			-18.6,
			-89.7,
			-16.8,
			-68.2,
			-15,
			-64.5,
			-13.8,
			-59.2,
			-14.5,
			-59.2,
			-15.3,
			-62.5,
			-16.8,
			-62.5,
			-17.5,
			-60.6,
			-17.5,
			-60.6,
			-18.2,
			-64.9,
			-19.1,
			-66.1,
			-19.8,
			-65.1,
			-20.3,
			-58.6,
			-20.5,
			-56.1,
			-19.8,
			-58.3,
			-21.5,
			-60.2,
			-24.3,
			-58.8,
			-28.1,
			-61.3,
			-26.8,
			-62,
			-25.9,
			-61.7,
			-24.8,
			-62.2,
			-24.7,
			-63.7,
			-25.9,
			-66.1,
			-25,
			-66.1,
			-25.9,
			-63.3,
			-27.4,
			-63.3,
			-28.1,
			-64.6,
			-28,
			-67.7,
			-25.9,
			-71.6,
			-26.6,
			-71.6,
			-27.4,
			-68.7,
			-28.4,
			-67.7,
			-29.4,
			-67.9,
			-31.1,
			-69.5,
			-30.2,
			-73.6,
			-32,
			-75,
			-31.3,
			-79.7,
			-27.4,
			-81.1,
			-28,
			-89.3,
			-42.5,
			-88.8,
			-43.3,
			-94.8,
			-50.8,
			-93,
			-51.5,
			-87.8,
			-51.2,
			-86.6,
			-51.6,
			-87.3,
			-53.7,
			-91.4,
			-57.7,
			-91.5,
			-60,
			-92.9,
			-63,
			-95.7,
			-66,
			-95.2,
			-68.3,
			-96.1,
			-71.6,
			-98.8,
			-72.7,
			-102.5,
			-72.9,
			-104.8,
			-74.4,
			-104.3,
			-75.9,
			-117.7,
			-89,
			-121.2,
			-89.9,
			-125.2,
			-92.6,
			-125.2,
			-93.2,
			-113.3,
			-91.6,
			-111.6,
			-90.2,
			-110,
			-90.6,
			-109.1,
			-87.8,
			-104.8,
			-86.5,
			-99.7,
			-84.1,
			-100.4,
			-82.6,
			-101.6,
			-81.9,
			-101.6,
			-81.2,
			-99.2,
			-81.1,
			-98.4,
			-81.7,
			-98.8,
			-83.4,
			-97.9,
			-84.4,
			-95.6,
			-84.7,
			-94.6,
			-86.3,
			-91.9,
			-87.1,
			-88.5,
			-87,
			-83.7,
			-85.4,
			-81.6,
			-84.1,
			-81.5,
			-85.6,
			-85.2,
			-88.7,
			-83.7,
			-89.5,
			-82,
			-89.5,
			-80,
			-87.2,
			-74.1,
			-86.5,
			-72.8,
			-85.8,
			-66.9,
			-77.8,
			-64.8,
			-73.6,
			-64.6,
			-72.2,
			-63.1,
			-70.7,
			-59.2,
			-69.1,
			-61.1,
			-72,
			-60,
			-72.5,
			-59.9,
			-73.6,
			-59.7,
			-76.6,
			-60.5,
			-77.4,
			-60.5,
			-78.1,
			-58.6,
			-78.8,
			-54.3,
			-78.1,
			-46.5,
			-80.4,
			-48.8,
			-81.2,
			-60.4,
			-82.7,
			-61.1,
			-83.1,
			-62.5,
			-85.7,
			-63.4,
			-86.2,
			-66,
			-86.2,
			-66.5,
			-84.9,
			-67.7,
			-85.8,
			-75.8,
			-88.4,
			-77.7,
			-90,
			-81.1,
			-91,
			-85.3,
			-90.9,
			-86.3,
			-91.4,
			-92.1,
			-91,
			-94.3,
			-92.7,
			-96.1,
			-91.7,
			-101.3,
			-91.7,
			-104.1,
			-91,
			-105.7,
			-92.1,
			-106.1,
			-91.7,
			-107.9,
			-94.4,
			-107.7,
			-95.8,
			-108.4,
			-97.8,
			-107.9,
			-99,
			-108.4,
			-100.1,
			-106.2,
			-100.2,
			-105.5,
			-100.9,
			-105.2,
			-102.4,
			-108,
			-101.4,
			-109.7,
			-101.3,
			-112.8,
			-104.3,
			-119.4,
			-107.4,
			-123.8,
			-107.7,
			-126.1,
			-109.2,
			-124.9,
			-110.6,
			-119.5,
			-112.2,
			-118.4,
			-113.3,
			-118.6,
			-118.7,
			-117.9,
			-120.6,
			-120.3,
			-121.2,
			-120.3,
			-122.1,
			-118.4,
			-122.8,
			-119.4,
			-123.3,
			-120.1,
			-123.3,
			-121.5,
			-122.1,
			-120.8,
			-124.6,
			-120.3,
			-125.2,
			-119.3,
			-124.4,
			-116.1,
			-125.9,
			-113.1,
			-126.2,
			-112,
			-127.4,
			-116.8,
			-128,
			-117.9,
			-127.4,
			-117,
			-126.6,
			-117.8,
			-126.2,
			-120.9,
			-129.1,
			-125.9,
			-128.5,
			-130,
			-126.8,
			-130.6,
			-122.1,
			-130.3,
			-120.9,
			-133.4,
			-120.6,
			-131.8,
			-122.7,
			-132.4,
			-125,
			-134.2,
			-127,
			-136.1,
			-128.2,
			-140.5,
			-128.9,
			-139.8,
			-124,
			-140.8,
			-123.1,
			-147.7,
			-125.2,
			-150.7,
			-128.9,
			-153.8,
			-129.6,
			-154.4,
			-131.3,
			-153.4,
			-131.9,
			-154.2,
			-132.9,
			-154.1,
			-135.4,
			-154.8,
			-135.8,
			-155.6,
			-135.5,
			-157.1,
			-134.2,
			-156.6,
			-132.7,
			-159.3,
			-133.9,
			-160,
			-134.9,
			-159.4,
			-136.5,
			-161.2,
			-138,
			-160.5,
			-142.1,
			-160,
			-143.4,
			-158.4,
			-144,
			-154.4,
			-142.5,
			-152.9,
			-142.4,
			-153.6,
			-142.1,
			-153.9,
			-141,
			-147.5,
			-142.4,
			-147.5,
			-141.8,
			-149.8,
			-141,
			-149.8,
			-140.3,
			-147.9,
			-139.7,
			-147.2,
			-139.8,
			-145.5,
			-141.6,
			-143.9,
			-140.3,
			-141.8,
			-142.7,
			-140.2,
			-141.7,
			-131.3,
			-139.4,
			-129.3,
			-139.5,
			-127.5,
			-140.2,
			-126.4,
			-142.8,
			-125.7,
			-141,
			-126.6,
			-138.7,
			-113.4,
			-138,
			-115.7,
			-139.5,
			-114.3,
			-141,
			-121.3,
			-141.6,
			-123.3,
			-140.3,
			-124.8,
			-146.8,
			-124.5,
			-147.9,
			-126.4,
			-147.7,
			-127,
			-146.8,
			-127,
			-144.9,
			-127.5,
			-144.9,
			-128.9,
			-148.6,
			-131.6,
			-150.3,
			-137.9,
			-151.6,
			-143.9,
			-154.9,
			-147.1,
			-156.1,
			-146.6,
			-157.7,
			-149.8,
			-159.3,
			-149.8,
			-159.9,
			-148.5,
			-160.1,
			-147.3,
			-162.4,
			-146.4,
			-163,
			-146.3,
			-164.9,
			-155.7,
			-167.6,
			-155.7,
			-168.3,
			-154.8,
			-168.3,
			-155.2,
			-171.8,
			-152.1,
			-172.1,
			-151.6,
			-173.6,
			-152.4,
			-176.8,
			-152.1,
			-178.2,
			-147.4,
			-174.5,
			-145,
			-171.3,
			-142.3,
			-172.6,
			-141.2,
			-175.4,
			-141.8,
			-178.1,
			-144.3,
			-178.9,
			-138,
			-182,
			-138.4,
			-183.4,
			-135,
			-181.8,
			-132,
			-178.9,
			-130.5,
			-179.7,
			-126.1,
			-176.6,
			-122.9,
			-175.8,
			-121.6,
			-174.3,
			-120.7,
			-174.3,
			-121.1,
			-176.6,
			-120.4,
			-176.4,
			-118.4,
			-175.1,
			-118.8,
			-174.3,
			-115.6,
			-173.9,
			-113.4,
			-171.7,
			-106.4,
			-169,
			-101.6,
			-168.3,
			-101.6,
			-169.2,
			-107.6,
			-172.2,
			-109.7,
			-172.8,
			-112,
			-172.8,
			-113.1,
			-174.8,
			-117,
			-178.2,
			-117,
			-178.9,
			-115.2,
			-179.6,
			-115.2,
			-180.4,
			-117.7,
			-180.5,
			-119.8,
			-179.6,
			-119.9,
			-181.5,
			-120.7,
			-182.6,
			-122.9,
			-183.4,
			-122,
			-181.2,
			-126.1,
			-182.8,
			-128.1,
			-184.4,
			-129.3,
			-186.4,
			-126.6,
			-186.4,
			-126.6,
			-187.3,
			-129.7,
			-190.4,
			-131.1,
			-191,
			-135.3,
			-191.1,
			-136.1,
			-192.5,
			-134.1,
			-192.7,
			-133.4,
			-195.6,
			-139.3,
			-197.8,
			-140.2,
			-200.1,
			-139.8,
			-200.9,
			-137.1,
			-199,
			-134.1,
			-198.6,
			-131.3,
			-199.4,
			-129.7,
			-198.1,
			-125.6,
			-196.7,
			-124.8,
			-194.9,
			-121.1,
			-192.8,
			-112.7,
			-191.6,
			-110.4,
			-190.6,
			-104.7,
			-189.6,
			-100.6,
			-186.1,
			-99.3,
			-185.8,
			-100,
			-184.6,
			-100.2,
			-181.2,
			-97.9,
			-182.7,
			-97.9,
			-185,
			-95.6,
			-186.4,
			-93.4,
			-185.2,
			-92.5,
			-185.8,
			-93.5,
			-189.7,
			-100.3,
			-192.6,
			-102.5,
			-192.9,
			-103.4,
			-194.3,
			-114.2,
			-199.9,
			-115.2,
			-202,
			-119.3,
			-204.6,
			-115.2,
			-204.3,
			-102.3,
			-197.5,
			-99.3,
			-197.8,
			-104.3,
			-200.9,
			-108.4,
			-205.4,
			-112.2,
			-206.8,
			-115.7,
			-210.1,
			-118.4,
			-211.5,
			-117,
			-213,
			-117.5,
			-216.1,
			-117,
			-215.3,
			-116.6,
			-216.1,
			-114.7,
			-214.3,
			-114.1,
			-214,
			-114.3,
			-215.3,
			-109.7,
			-213,
			-110.7,
			-212.2,
			-106.6,
			-207.9,
			-104.8,
			-209.6,
			-104.8,
			-210.7,
			-103.6,
			-210.8,
			-101.6,
			-209.2,
			-100,
			-209.2,
			-99.4,
			-207.3,
			-94.7,
			-206.2,
			-92.8,
			-205.3,
			-93.4,
			-203.9,
			-92.5,
			-203.5,
			-91.3,
			-203.7,
			-89.7,
			-205,
			-90.5,
			-208.9,
			-89.7,
			-210,
			-87.5,
			-207.3,
			-84.8,
			-205.4,
			-84.3,
			-206.2,
			-87.5,
			-209.2,
			-87.8,
			-211,
			-86.1,
			-210,
			-87,
			-211.9,
			-88.4,
			-213,
			-85.3,
			-212.6,
			-83.1,
			-211.3,
			-82.9,
			-210.4,
			-81.1,
			-209.2,
			-80.6,
			-211.5,
			-79.8,
			-211.1,
			-77.9,
			-211.5,
			-76.6,
			-209.2,
			-75.6,
			-209.2,
			-75.8,
			-207.4,
			-72.6,
			-207.4,
			-70.7,
			-205.9,
			-70.2,
			-204.6,
			-71.1,
			-203.9,
			-71.1,
			-203.1,
			-67.9,
			-204.6,
			-62.5,
			-203.1,
			-59.9,
			-204.6,
			-58.6,
			-206.2,
			-58.3,
			-205,
			-55.6,
			-203.9,
			-53.4,
			-199.5,
			-52,
			-200.1,
			-51.5,
			-199.6,
			-47.5,
			-200.1,
			-46,
			-201.7,
			-45.4,
			-201.3,
			-42.9,
			-201.6,
			-43.1,
			-199.3,
			-42,
			-197.8,
			-43.3,
			-197.1,
			-42.5,
			-196.4,
			-42.5,
			-195.6,
			-44.9,
			-195.6,
			-47,
			-194.1,
			-39,
			-194.9,
			-34.7,
			-194.1,
			-32,
			-197.8,
			-32.5,
			-193.7,
			-31.3,
			-190.4,
			-30.3,
			-189.9,
			-29.7,
			-188.8,
			-30,
			-187.9,
			-31,
			-188.8,
			-33.1,
			-188.4,
			-33.7,
			-188,
			-33.7,
			-187.3,
			-30.7,
			-187.3,
			-29.3,
			-188.1,
			-28.8,
			-190.4,
			-27.8,
			-189.7,
			-27.5,
			-188.5,
			-27.8,
			-187.2,
			-28.8,
			-186.4,
			-26.9,
			-186.6,
			-25.6,
			-188.8,
			-23.9,
			-186.9,
			-19.6,
			-185.2,
			-16.4,
			-180.7,
			-16.9,
			-178.9,
			-15.6,
			-176.6,
			-17.9,
			-176.6,
			-16.1,
			-175.8,
			-16.9,
			-175.1,
			-16.5,
			-173.6,
			-19.7,
			-173.6,
			-18.5,
			-170.1,
			-20.2,
			-168.8,
			-25.2,
			-167.6,
			-23.8,
			-166.8,
			-19.7,
			-166.7,
			-16.1,
			-165.5,
			-15.6,
			-166.7,
			-12.8,
			-166.6,
			-10.6,
			-167.6,
			-9.5,
			-166.4,
			-9.1,
			-166.6,
			-8.8,
			-167.6,
			-10.1,
			-169.8,
			-8.3,
			-170.6,
			-10.1,
			-172.3,
			-12,
			-172.8,
			-11.5,
			-174.3,
			-13.1,
			-175.4,
			-13,
			-176.6,
			-5.6,
			-176.4,
			2,
			-174.3,
			3,
			-173.6,
			1.8,
			-172.1,
			2.8,
			-170.7,
			10.5,
			-167.9,
			11.2,
			-166.7,
			8.5,
			-164.5,
			9.9,
			-164.5,
			12,
			-162.6,
			12.8,
			-161.1,
			13.3,
			-157,
			14,
			-157.5,
			14.6,
			-159.9,
			21.7,
			-160.9,
			22.6,
			-157.7,
			24,
			-157,
			27.5,
			-157.4,
			30.5,
			-155.8,
			31,
			-151.6,
			33.1,
			-150.1,
			33.5,
			-148.7,
			33.4,
			-148.2,
			29.7,
			-146.9,
			28.7,
			-147,
			28.1,
			-147.9,
			27.8,
			-146.1,
			29.9,
			-143.6,
			31,
			-143.3,
			32.2,
			-145.5,
			32.8,
			-145.4,
			33.8,
			-144,
			36.2,
			-143.4,
			40.8,
			-140.9,
			53.5,
			-139.5,
			57.3,
			-140.1,
			58.6,
			-139.5,
			59.8,
			-137.5,
			60.6,
			-137.2,
			62.7,
			-138,
			61.7,
			-136.5,
			61.7,
			-135.8,
			62.6,
			-135.7,
			64.9,
			-136.5,
			62.7,
			-140.3,
			68.5,
			-139.5,
			72.7,
			-135,
			72.7,
			-134.2,
			71,
			-134.2,
			71.7,
			-130.4,
			70.4,
			-127,
			69.9,
			-122.8,
			70.7,
			-124,
			71.7,
			-127.4,
			73.9,
			-129.5,
			74.9,
			-131.3,
			76.1,
			-135.8,
			76.1,
			-136.9,
			73.7,
			-139,
			73.1,
			-140.3,
			74.2,
			-141,
			76.5,
			-138,
			81.3,
			-135,
			80.8,
			-134.2,
			81.7,
			-134.2,
			81.7,
			-133.4,
			80.8,
			-133.4,
			81.7,
			-130.4,
			80.4,
			-131.3,
			80.8,
			-128.2,
			82.1,
			-128.8,
			83.4,
			-128.2,
			85.4,
			-125.9,
			84.6,
			-129,
			82.6,
			-130.4,
			82.6,
			-131.3,
			83.9,
			-131.6,
			88.6,
			-130.8,
			93.5,
			-132.4,
			96.4,
			-134.9,
			97.6,
			-135.1,
			100.4,
			-133.4,
			103.6,
			-132.7,
			104.7,
			-131.9,
			106.3,
			-132.7,
			104.9,
			-132.7,
			104.9,
			-133.4,
			107.8,
			-133.4,
			109.5,
			-131.5,
			110.7,
			-131.4,
			109.5,
			-134.3,
			110.4,
			-135,
			111.5,
			-134.9,
			113,
			-133,
			114.9,
			-128.2,
			111.5,
			-124.7,
			110.2,
			-122.1,
			111.3,
			-119.1,
			108.9,
			-122.8,
			107.9,
			-120.8,
			105.9,
			-120.3,
			106.3,
			-119.1,
			105.8,
			-117.7,
			104.1,
			-115.6,
			103.1,
			-115.2,
			103.1,
			-114.5,
			105.3,
			-113,
			104.9,
			-115,
			106.3,
			-115.4,
			110.2,
			-115.1,
			111.8,
			-116.7,
			111.8,
			-111.3,
			112.4,
			-109.6,
			115,
			-105.3,
			117.3,
			-103.1,
			122.2,
			-94.4,
			122.4,
			-89.7,
			121.4,
			-83.2,
			121.8,
			-81.2,
			126.2,
			-72.3,
			125.8,
			-69.8,
			127.4,
			-64.6,
			128.9,
			-61.9,
			131.8,
			-59.2,
			131.3,
			-58.4,
			133.5,
			-53.1,
			134.6,
			-51.9,
			135.3,
			-49.8,
			136.5,
			-48.9,
			132.6,
			-43.2,
			133.8,
			-37.1,
			133.6,
			-32.6,
			134,
			-32,
			130.9,
			-25.9,
			131.3,
			-23.9,
			129.1,
			-18.9,
			129.1,
			-14.9,
			129.6,
			-12.7,
			125.8,
			-11.1,
			121.6,
			-5.8,
			121.8,
			-4.6,
			127.3,
			-.9,
			127.9,
			-.8,
			131.1,
			-3.7,
			131.9,
			-3.6,
			132.7,
			-1.6,
			131.5,
			-.8,
			127.7,
			-.1,
			128.6,
			1.4,
			127.4,
			4.7,
			123.1,
			6.8,
			125.6,
			8.1,
			126.7,
			7.9,
			127.2,
			6.8
		],
		[
			-127,
			62.1,
			-126.4,
			63.4,
			-126.6,
			65.2,
			-125.2,
			65.2,
			-126.6,
			68.1,
			-127.8,
			68.7,
			-133.6,
			68.9,
			-136.7,
			66.8,
			-138.3,
			66.4,
			-139.8,
			68.1,
			-140.9,
			67.3,
			-142,
			68.1,
			-142.8,
			65.9,
			-143.9,
			64.8,
			-147.1,
			64.3,
			-147.1,
			63.6,
			-140.2,
			62.1,
			-135.2,
			63.2,
			-133.8,
			62.8,
			-133.1,
			61.8,
			-133.1,
			56.8,
			-130.6,
			56.7,
			-126.6,
			53.1,
			-125.2,
			54.5,
			-125.3,
			57.9,
			-124.3,
			61.2,
			-125.5,
			61.9,
			-127,
			61.2
		],
		[
			-107.6,
			-32.2,
			-107.1,
			-30.6,
			-107.6,
			-29.8,
			-109.3,
			-29.1,
			-113,
			-29.3,
			-114.7,
			-28,
			-116.2,
			-28,
			-116.9,
			-29,
			-114.7,
			-30.6,
			-106.9,
			-34.2,
			-105.7,
			-33.9,
			-105.6,
			-33
		],
		[
			-107.6,
			-13.2,
			-109.4,
			-13.2,
			-110.8,
			-14.8,
			-110.2,
			-17.8,
			-109,
			-19.2,
			-106.7,
			-18.5,
			-105.4,
			-16.5
		],
		[
			-150.5,
			-163.1,
			-152.8,
			-162.4,
			-156.8,
			-165.4,
			-157.9,
			-167,
			-157.7,
			-167.8,
			-150.8,
			-165.5,
			-149.2,
			-163.8,
			-149.4,
			-163.1
		],
		[
			-31.9,
			178.5,
			-32.8,
			178.6,
			-33.3,
			178,
			-32.9,
			177.2,
			-34.2,
			176.4,
			-34.2,
			174.2,
			-33.1,
			173.4,
			-31.7,
			173.3,
			-28.8,
			174.2,
			-29.6,
			177
		],
		[
			-117.7,
			-194.7,
			-121.6,
			-194.5,
			-123.8,
			-195.8,
			-124,
			-196.9,
			-122.3,
			-197.8,
			-117,
			-196,
			-116.1,
			-195
		],
		[
			-127.9,
			46.8,
			-128.5,
			47,
			-129.7,
			45.8,
			-132.7,
			44.6,
			-132.7,
			43.2,
			-128,
			43.4,
			-126.8,
			44,
			-126,
			45.1
		],
		[
			119.5,
			211.2,
			117.2,
			209.8,
			122.1,
			209.6,
			123.6,
			208.3,
			123.1,
			206,
			124.2,
			207.9,
			124.5,
			210.5
		]
	], Ar = {
		dublin: [118.8, -5.6],
		cork: [-28.2, -166],
		galway: [-66.8, -14.3],
		wicklow: [133.1, -46.4],
		kildare: [75.7, -26.7],
		navan: [90.8, 28],
		drogheda: [112.4, 35.2]
	};
})), Mr = /* @__PURE__ */ n({
	default: () => Nr,
	deviation: () => mi,
	flatten: () => gi,
	refine: () => _i
});
function Nr(e, t, n = 2) {
	let r = t && t.length, i = r ? t[0] * n : e.length;
	Si.size && Si.clear();
	let a = Pr(e, 0, i, n, !0), o = [];
	if (!a || a.next === a.prev) return o;
	let s = 0, c = 0, l = 0;
	if (r && (a = Vr(e, t, a, n)), e.length > 80 * n) {
		s = e[0], c = e[1];
		let t = s, r = c;
		for (let a = n; a < i; a += n) {
			let n = e[a], i = e[a + 1];
			n < s && (s = n), i < c && (c = i), n > t && (t = n), i > r && (r = i);
		}
		l = Math.max(t - s, r - c), l = l === 0 ? 0 : 32767 / l;
	}
	return Ir(a, o, s, c, l), o;
}
function Pr(e, t, n, r, i) {
	let a = null;
	if (i === hi(e, t, n, r) > 0) for (let i = t; i < n; i += r) a = di(i / r | 0, e[i], e[i + 1], a);
	else for (let i = n - r; i >= t; i -= r) a = di(i / r | 0, e[i], e[i + 1], a);
	return a && ii(a, a.next) && (fi(a), a = a.next), a;
}
function Fr(e, t = e) {
	let n = t === e, r = e, i;
	do
		i = !1, r !== r.next && (Si.size === 0 || !Si.has(r)) && (ii(r, r.next) || K(r.prev, r, r.next) === 0) ? ((n || r === t) && (t = r.prev), Ci = !0, fi(r), r = r.prev, i = !0) : (n || r !== t) && (r = r.next, i = !n);
	while (i || r !== t);
	return t;
}
function Ir(e, t, n, r, i) {
	i && Zr(e, n, r, i);
	let a = e, o = !1;
	for (; e.prev !== e.next;) {
		let s = e.prev, c = e.next;
		if (K(s, e, c) < 0 && (i ? Rr(e, n, r, i) : Lr(e))) t.push(s.i, e.i, c.i), fi(e), e = c, a = c;
		else if (e = c, e === a) {
			if (Ci = !1, e = Fr(e), Ci) {
				a = e;
				continue;
			}
			if (!o) {
				e = zr(e, t), a = e, o = !0;
				continue;
			}
			Br(e, t, n, r, i);
			break;
		}
	}
}
function Lr(e) {
	let t = e.prev, n = e, r = e.next, i = t.x, a = n.x, o = r.x, s = t.y, c = n.y, l = r.y, u = Math.min(i, a, o), d = Math.min(s, c, l), f = Math.max(i, a, o), p = Math.max(s, c, l), m = r.next;
	for (; m !== t;) {
		if (m.x >= u && m.x <= f && m.y >= d && m.y <= p && (i !== m.x || s !== m.y) && ni(i, s, a, c, o, l, m.x, m.y) && K(m.prev, m, m.next) >= 0) return !1;
		m = m.next;
	}
	return !0;
}
function Rr(e, t, n, r) {
	let i = e.prev, a = e, o = e.next, s = i.x, c = a.x, l = o.x, u = i.y, d = a.y, f = o.y, p = Math.min(s, c, l), m = Math.min(u, d, f), h = Math.max(s, c, l), g = Math.max(u, d, f), _ = ei(p, m, t, n, r), v = ei(h, g, t, n, r), y = e.prevZ;
	for (; y && y.z >= _;) {
		if (y.x >= p && y.x <= h && y.y >= m && y.y <= g && y !== o && (s !== y.x || u !== y.y) && ni(s, u, c, d, l, f, y.x, y.y) && K(y.prev, y, y.next) >= 0) return !1;
		y = y.prevZ;
	}
	let b = e.nextZ;
	for (; b && b.z <= v;) {
		if (b.x >= p && b.x <= h && b.y >= m && b.y <= g && b !== o && (s !== b.x || u !== b.y) && ni(s, u, c, d, l, f, b.x, b.y) && K(b.prev, b, b.next) >= 0) return !1;
		b = b.nextZ;
	}
	return !0;
}
function zr(e, t) {
	let n = e, r = !1;
	do {
		let i = n.prev, a = n.next.next;
		ai(i, n, n.next, a, !1) && ci(i, a) && ci(a, i) && (t.push(i.i, n.i, a.i), fi(n), fi(n.next), n = e = a, r = !0), n = n.next;
	} while (n !== e);
	return r ? Fr(n) : n;
}
function Br(e, t, n, r, i) {
	let a = e;
	do {
		let e = a.next.next;
		for (; e !== a.prev;) {
			if (a.i !== e.i && ri(a, e)) {
				let o = ui(a, e);
				a = Fr(a, a.next), o = Fr(o, o.next), Ir(a, t, n, r, i), Ir(o, t, n, r, i);
				return;
			}
			e = e.next;
		}
		a = a.next;
	} while (a !== e);
}
function Vr(e, t, n, r) {
	let i = [];
	for (let n = 0, a = t.length; n < a; n++) {
		let o = Pr(e, t[n] * r, n < a - 1 ? t[n + 1] * r : e.length, r, !1);
		o === o.next && Si.add(o), i.push(ti(o));
	}
	i.sort(Hr), Wr(e.length / r, t.length), Gr(n, n), wi = !0;
	for (let e = 0; e < i.length; e++) n = Ur(i[e], n);
	return wi = !1, Fr(n);
}
function Hr(e, t) {
	return e.x - t.x || e.y - t.y || (e.next.y - e.y) / (e.next.x - e.x) - (t.next.y - t.y) / (t.next.x - t.x);
}
function Ur(e, t) {
	let n = Yr(e, t);
	if (!n) return t;
	let r = ui(n, e), i = r.next;
	return Gr(n, i.next), Fr(r, r.next), Fr(n, n.next);
}
function Wr(e, t) {
	let n = Math.ceil((e + 2 * t) / Ti) + t + 2;
	q.length < n * 4 && (q = new Float64Array(n * 4)), Ei = 0;
}
function Gr(e, t) {
	let n = e;
	do {
		let e = Ei++;
		Di[e] = n;
		let r = n.x, i = n.y, a = n.x, o = n.y, s = 0;
		do {
			let t = n.next;
			n.z = e, t.x < r && (r = t.x), t.x > a && (a = t.x), t.y < i && (i = t.y), t.y > o && (o = t.y), n = t;
		} while (++s < Ti && n !== t);
		Oi[e] = n;
		let c = e * 4;
		q[c] = r, q[c + 1] = i, q[c + 2] = a, q[c + 3] = o;
	} while (n !== t);
}
function Kr(e, t) {
	let n = e.z * 4;
	t.x < q[n] && (q[n] = t.x), t.y < q[n + 1] && (q[n + 1] = t.y), t.x > q[n + 2] && (q[n + 2] = t.x), t.y > q[n + 3] && (q[n + 3] = t.y);
}
function qr(e) {
	let t = Oi[e];
	for (; t.prev.next !== t;) t = t.next;
	return Oi[e] = t, t;
}
function Jr(e) {
	let t = Di[e];
	for (; t.prev.next !== t;) t = t.next;
	return Di[e] = t, t;
}
function Yr(e, t) {
	let n = t, r = e.x, i = e.y, a = -Infinity, o;
	if (ii(e, n)) return n;
	for (let t = 0, s = 0; t < Ei; t++, s += 4) {
		if (i < q[s + 1] || i > q[s + 3] || q[s] > r || q[s + 2] <= a) continue;
		let c = qr(t);
		n = Jr(t);
		do {
			if (n.prev.next === n) {
				if (ii(e, n.next)) return n.next;
				if (i <= n.y && i >= n.next.y && n.next.y !== n.y) {
					let e = n.x + (i - n.y) * (n.next.x - n.x) / (n.next.y - n.y);
					if (e <= r && e > a && (a = e, o = n.x < n.next.x ? n : n.next, e === r)) return o;
				}
			}
			n = n.next;
		} while (n !== c);
	}
	if (!o) return null;
	let s = o.x, c = o.y, l = Math.min(i, c), u = Math.max(i, c), d = Infinity;
	for (let t = 0, f = 0; t < Ei; t++, f += 4) {
		if (q[f + 2] < s || q[f] > r || q[f + 3] < l || q[f + 1] > u) continue;
		let p = qr(t);
		n = Jr(t);
		do {
			if (n.prev.next === n && r >= n.x && n.x >= s && r !== n.x && ni(i < c ? r : a, i, s, c, i < c ? a : r, i, n.x, n.y)) {
				let t = Math.abs(i - n.y) / (r - n.x);
				(ci(n, e) || n.y === i && n.next.y === i && n.next.x > r) && (t < d || t === d && (n.x > o.x || n.x === o.x && Xr(o, n))) && (o = n, d = t);
			}
			n = n.next;
		} while (n !== p);
	}
	return o;
}
function Xr(e, t) {
	return K(e.prev, e, t.prev) < 0 && K(t.next, e, e.next) < 0;
}
function Zr(e, t, n, r) {
	let i = e, a = 0;
	do
		i.z = ei(i.x, i.y, t, n, r), J[a++] = i, i = i.next;
	while (i !== e);
	Qr(a);
	let o = null;
	for (let e = 0; e < a; e++) {
		let t = J[e];
		t.prevZ = o, o && (o.nextZ = t), o = t;
	}
	o.nextZ = null, J.fill(null, 0, a), ki.fill(null, 0, a);
}
function Qr(e) {
	if (e <= 32) for (let t = 1; t < e; t++) {
		let e = J[t], n = e.z, r = t - 1;
		for (; r >= 0 && J[r].z > n;) J[r + 1] = J[r], r--;
		J[r + 1] = e;
	}
	else {
		Ai.length < e && (Ai = new Uint32Array(e), ji = new Uint32Array(e), ki = Array(e));
		for (let t = 0; t < e; t++) Ai[t] = J[t].z;
		$r(e, J, Ai, ki, ji, 0), $r(e, ki, ji, J, Ai, 8), $r(e, J, Ai, ki, ji, 16), $r(e, ki, ji, J, Ai, 24);
	}
}
function $r(e, t, n, r, i, a) {
	Mi.fill(0);
	for (let t = 0; t < e; t++) Mi[n[t] >>> a & 255]++;
	let o = 0;
	for (let e = 0; e < 256; e++) {
		let t = Mi[e];
		Mi[e] = o, o += t;
	}
	for (let o = 0; o < e; o++) {
		let e = n[o], s = Mi[e >>> a & 255]++;
		r[s] = t[o], i[s] = e;
	}
}
function ei(e, t, n, r, i) {
	return e = (e - n) * i | 0, t = (t - r) * i | 0, e = (e | e << 8) & 16711935, e = (e | e << 4) & 252645135, e = (e | e << 2) & 858993459, e = (e | e << 1) & 1431655765, t = (t | t << 8) & 16711935, t = (t | t << 4) & 252645135, t = (t | t << 2) & 858993459, t = (t | t << 1) & 1431655765, e | t << 1;
}
function ti(e) {
	let t = e, n = e;
	do
		(t.x < n.x || t.x === n.x && t.y < n.y) && (n = t), t = t.next;
	while (t !== e);
	return n;
}
function ni(e, t, n, r, i, a, o, s) {
	return (i - o) * (t - s) >= (e - o) * (a - s) && (e - o) * (r - s) >= (n - o) * (t - s) && (n - o) * (a - s) >= (i - o) * (r - s);
}
function ri(e, t) {
	let n = ii(e, t) && K(e.prev, e, e.next) > 0 && K(t.prev, t, t.next) > 0;
	return e.next.i !== t.i && (n || ci(e, t) && ci(t, e) && (K(e.prev, e, t.prev) !== 0 || K(e, t.prev, t) !== 0)) && !si(e, t) && (n || li(e, t));
}
function K(e, t, n) {
	return (t.y - e.y) * (n.x - t.x) - (t.x - e.x) * (n.y - t.y);
}
function ii(e, t) {
	return e.x === t.x && e.y === t.y;
}
function ai(e, t, n, r, i = !0) {
	let a = K(e, t, n), o = K(e, t, r), s = K(n, r, e), c = K(n, r, t);
	return (a > 0 && o < 0 || a < 0 && o > 0) && (s > 0 && c < 0 || s < 0 && c > 0) ? !0 : i ? !!(a === 0 && oi(e, n, t) || o === 0 && oi(e, r, t) || s === 0 && oi(n, e, r) || c === 0 && oi(n, t, r)) : !1;
}
function oi(e, t, n) {
	return t.x <= Math.max(e.x, n.x) && t.x >= Math.min(e.x, n.x) && t.y <= Math.max(e.y, n.y) && t.y >= Math.min(e.y, n.y);
}
function si(e, t) {
	let n = Math.min(e.x, t.x), r = Math.max(e.x, t.x), i = Math.min(e.y, t.y), a = Math.max(e.y, t.y), o = e;
	do {
		let s = o.next;
		if (o.x > r && s.x > r || o.x < n && s.x < n || o.y > a && s.y > a || o.y < i && s.y < i) o = s;
		else {
			if (o.i !== e.i && s.i !== e.i && o.i !== t.i && s.i !== t.i && ai(o, s, e, t)) return !0;
			o = s;
		}
	} while (o !== e);
	return !1;
}
function ci(e, t) {
	return K(e.prev, e, e.next) < 0 ? K(e, t, e.next) >= 0 && K(e, e.prev, t) >= 0 : K(e, t, e.prev) < 0 || K(e, e.next, t) < 0;
}
function li(e, t) {
	let n = e, r = !1, i = (e.x + t.x) / 2, a = (e.y + t.y) / 2;
	do {
		let e = n.next;
		n.y > a != e.y > a && i < (e.x - n.x) * (a - n.y) / (e.y - n.y) + n.x && (r = !r), n = e;
	} while (n !== e);
	return r;
}
function ui(e, t) {
	let n = pi(e.i, e.x, e.y), r = pi(t.i, t.x, t.y), i = e.next, a = t.prev;
	return e.next = t, t.prev = e, n.next = i, i.prev = n, r.next = n, n.prev = r, a.next = r, r.prev = a, r;
}
function di(e, t, n, r) {
	let i = pi(e, t, n);
	return r ? (i.next = r.next, i.prev = r, r.next.prev = i, r.next = i) : (i.prev = i, i.next = i), i;
}
function fi(e) {
	e.next.prev = e.prev, e.prev.next = e.next, e.prevZ && (e.prevZ.nextZ = e.nextZ), e.nextZ && (e.nextZ.prevZ = e.prevZ), wi && Kr(e.prev, e.next);
}
function pi(e, t, n) {
	return {
		i: e,
		x: t,
		y: n,
		prev: null,
		next: null,
		z: 0,
		prevZ: null,
		nextZ: null
	};
}
function mi(e, t, n, r) {
	let i = t && t.length, a = i ? t[0] * n : e.length, o = Math.abs(hi(e, 0, a, n));
	if (i) for (let r = 0, i = t.length; r < i; r++) {
		let a = t[r] * n, s = r < i - 1 ? t[r + 1] * n : e.length;
		o -= Math.abs(hi(e, a, s, n));
	}
	let s = 0;
	for (let t = 0; t < r.length; t += 3) {
		let i = r[t] * n, a = r[t + 1] * n, o = r[t + 2] * n;
		s += Math.abs((e[i] - e[o]) * (e[a + 1] - e[i + 1]) - (e[i] - e[a]) * (e[o + 1] - e[i + 1]));
	}
	if (s === 0) {
		let t = 0;
		for (let r = 0; r < e.length; r += n) t = Math.max(t, Math.abs(e[r]), Math.abs(e[r + 1]));
		return Math.abs(o) <= e.length * t * t * 2 ** -52 ? 0 : 1;
	}
	return Math.abs((s - o) / o);
}
function hi(e, t, n, r) {
	let i = 0;
	for (let a = t, o = n - r; a < n; a += r) i += (e[o] - e[a]) * (e[a + 1] + e[o + 1]), o = a;
	return i;
}
function gi(e) {
	let t = [], n = [], r = e[0][0].length, i = 0, a = 0;
	for (let o of e) {
		for (let e of o) for (let n = 0; n < r; n++) t.push(e[n]);
		a && (i += a, n.push(i)), a = o.length;
	}
	return {
		vertices: t,
		holes: n,
		dimensions: r
	};
}
function _i(e, t, n = 2) {
	let r = e, i = r.length;
	if (i < 6) return;
	xi(i), Li++, Y.fill(-1, 0, i);
	let a = 0;
	for (let e = 0; e < i; e++) {
		let t = r[e], n = r[bi(e)], i = t < n ? t : n, o = t < n ? n : t, s = (Math.imul(i, 2654435761) ^ Math.imul(o, 2246822507)) & Ii;
		for (; Fi[s] === Li;) {
			let t = Pi[s];
			if (t !== -1) {
				let n = r[t], c = r[bi(t)];
				if (n === i && c === o || n === o && c === i) {
					Y[e] = t, Y[t] = e, Pi[s] = -1, X[t] = 1, Ni[a++] = t;
					break;
				}
			}
			s = s + 1 & Ii;
		}
		Fi[s] !== Li && (Pi[s] = e, Fi[s] = Li);
	}
	for (; a > 0;) {
		let e = Ni[--a];
		X[e] = 0;
		let i = Y[e];
		if (i === -1) continue;
		let o = e - e % 3, s = i - i % 3, c = o + (e + 2) % 3, l = o + (e + 1) % 3, u = s + (i + 2) % 3, d = s + (i + 1) % 3, f = r[c], p = r[e], m = r[l], h = r[u], g = t[f * n], _ = t[f * n + 1], v = t[p * n], y = t[p * n + 1], b = t[m * n], x = t[m * n + 1], S = t[h * n], C = t[h * n + 1];
		if (!yi(g, _, v, y, b, x, S, C) && vi(g, _, v, y, S, C) > 0 && vi(g, _, S, C, b, x) > 0) {
			r[e] = h, r[i] = f;
			let t = Y[u], n = Y[c];
			Y[e] = t, t !== -1 && (Y[t] = e), Y[i] = n, n !== -1 && (Y[n] = i), Y[c] = u, Y[u] = c, t !== -1 && X[e] === 0 && (X[e] = 1, Ni[a++] = e), n !== -1 && X[i] === 0 && (X[i] = 1, Ni[a++] = i), Y[l] !== -1 && X[l] === 0 && (X[l] = 1, Ni[a++] = l), Y[d] !== -1 && X[d] === 0 && (X[d] = 1, Ni[a++] = d);
		}
	}
}
function vi(e, t, n, r, i, a) {
	return (n - e) * (a - t) - (r - t) * (i - e);
}
function yi(e, t, n, r, i, a, o, s) {
	let c = e - o, l = t - s, u = n - o, d = r - s, f = i - o, p = a - s, m = c * c + l * l, h = u * u + d * d, g = f * f + p * p, _ = m + h + g;
	return c * (d * g - h * p) - l * (u * g - h * f) + m * (u * p - d * f) <= 1e-13 * _ * _;
}
function bi(e) {
	return e - e % 3 + (e + 1) % 3;
}
function xi(e) {
	(!Ni || Ni.length < e) && (Ni = new Int32Array(e)), (!Y || Y.length < e) && (Y = new Int32Array(e)), (!X || X.length < e) && (X = new Uint8Array(e));
	let t = 1;
	for (; t < e * 4;) t <<= 1;
	(!Pi || Pi.length < t) && (Pi = new Int32Array(t), Fi = new Uint32Array(t)), Ii = t - 1;
}
var Si, Ci, wi, Ti, q, Ei, Di, Oi, J, ki, Ai, ji, Mi, Ni, Y, Pi, Fi, X, Ii, Li, Ri = t((() => {
	Si = /* @__PURE__ */ new Set(), Ci = !1, wi = !1, Ti = 16, q = /* @__PURE__ */ new Float64Array(), Ei = 0, Di = [], Oi = [], J = [], ki = [], Ai = /* @__PURE__ */ new Uint32Array(), ji = /* @__PURE__ */ new Uint32Array(), Mi = /* @__PURE__ */ new Uint32Array(256), Ii = 0, Li = 0;
})), zi = .01, Bi = .13, Vi = .028, Hi = 2.9, Z = 512, Ui = [
	.145,
	.533,
	.788
], Wi = [
	{
		key: "dublin",
		name: "Dublin",
		r: .62,
		at: 1
	},
	{
		key: "cork",
		name: "Cork",
		r: .46,
		at: 1.3
	},
	{
		key: "galway",
		name: "Galway",
		r: .46,
		at: 1.6
	}
], Gi = [
	"drogheda",
	"navan",
	"kildare",
	"wicklow"
], Ki = 1.7, qi = [
	["galway", "dublin"],
	["dublin", "cork"],
	["cork", "galway"]
], Ji = 2.1, Yi = .3, Xi = 3.5, Zi = 1.3, Qi = 78, $i = 54, ea = -7, ta = 3.5, na = [5, 3], ra = (e, t) => [
	e[0] - t[0],
	e[1] - t[1],
	e[2] - t[2]
], ia = (e, t) => [
	e[1] * t[2] - e[2] * t[1],
	e[2] * t[0] - e[0] * t[2],
	e[0] * t[1] - e[1] * t[0]
], aa = (e) => {
	let t = Math.hypot(...e) || 1;
	return e.map((e) => e / t);
}, oa = (e, t) => e[0] * t[0] + e[1] * t[1] + e[2] * t[2], sa = (e, t, n, r) => {
	let i = 1 / Math.tan(e / 2), a = 1 / (n - r);
	return [
		i / t,
		0,
		0,
		0,
		0,
		i,
		0,
		0,
		0,
		0,
		(r + n) * a,
		-1,
		0,
		0,
		2 * r * n * a,
		0
	];
}, ca = (e, t, n) => {
	let r = aa(ra(e, t)), i = aa(ia(n, r)), a = ia(r, i);
	return [
		i[0],
		a[0],
		r[0],
		0,
		i[1],
		a[1],
		r[1],
		0,
		i[2],
		a[2],
		r[2],
		0,
		-oa(i, e),
		-oa(a, e),
		-oa(r, e),
		1
	];
}, la = (e, t) => {
	let n = Array(16);
	for (let r = 0; r < 4; r++) for (let i = 0; i < 4; i++) {
		let a = 0;
		for (let n = 0; n < 4; n++) a += e[r + n * 4] * t[n + i * 4];
		n[r + i * 4] = a;
	}
	return n;
}, ua = (e, t, n, r) => {
	let i = e[3] * t + e[7] * n + e[11] * r + e[15];
	return [(e[0] * t + e[4] * n + e[8] * r + e[12]) / i, (e[1] * t + e[5] * n + e[9] * r + e[13]) / i];
}, da = (e) => e < 0 ? 0 : e > 1 ? 1 : e, fa = (e) => 1 - (1 - e) ** 3, pa = (e) => 1 - (1 - e) ** 5, ma = (e) => e < .5 ? 4 * e * e * e : 1 - (-2 * e + 2) ** 3 / 2, ha = (e) => 1 + 2.9 * (e - 1) ** 3 + 1.9 * (e - 1) ** 2, ga = (e, t, n) => da((e - t) / n), _a = "#version 300 es\nprecision highp float;\n", va = "\nuniform sampler2D uSdf;\nuniform float uD;\nfloat sdf(vec2 p) {\n  vec2 uv = vec2(p.x + uD, uD - p.y) / (2. * uD);\n  if (any(lessThan(uv, vec2(0.))) || any(greaterThan(uv, vec2(1.)))) return 1.;\n  return texture(uSdf, uv).r;\n}\nvec2 outward(vec2 p, float e) {\n  vec2 g = vec2(sdf(p + vec2(e, 0.)) - sdf(p - vec2(e, 0.)), sdf(p + vec2(0., e)) - sdf(p - vec2(0., e)));\n  float l = length(g);\n  return l > 1e-6 ? g / l : vec2(0.);\n}", ya = `${_a}
layout(location = 0) in vec2 aP;
uniform mat4 uVP;
out vec2 vP;
void main() { vP = aP; gl_Position = uVP * vec4(aP, 0., 1.); }`, ba = `${_a}${va}
in vec2 vP;
uniform float uH, uGrid;
uniform vec3 uL;
uniform vec2 uGridAt, uGridStep;
out vec4 o;
float line(float v, float step) {
  float d = abs(fract(v / step + .5) - .5) * step;
  return 1. - smoothstep(0., fwidth(v), d);
}
void main() {
  float d = sdf(vP);
  // toward the light from here: is the slab in the way?
  vec2 dir = uL.xy / uL.z;
  float s1 = sdf(vP + dir * uH * .45), s2 = sdf(vP + dir * uH);
  float shade = (1. - smoothstep(-.004, .03, s1)) * .5 + (1. - smoothstep(-.01, .11, s2)) * .5;
  float lift = uH / ${Bi.toFixed(3)};
  float a = (shade * .2 + (1. - smoothstep(0., .035, d)) * .13 + (1. - smoothstep(0., .6, d)) * .07) * lift;
  a *= step(0., d + .002);
  vec2 g = vP - uGridAt;
  float fade = 1. - smoothstep(1.1, 2.55, length(vP * vec2(1.12, .82)));
  float ga = max(line(g.x, uGridStep.x), line(g.y, uGridStep.y)) * fade * uGrid * .085 * step(0., d);
  vec3 sc = vec3(.13, .17, .24);
  o = vec4(sc * a + sc * ga * (1. - a), a + ga * (1. - a));
}`, xa = `${_a}
layout(location = 0) in vec3 aP;
layout(location = 1) in vec2 aN;
uniform mat4 uVP;
uniform float uH;
out vec3 vP;
flat out vec2 vN;
void main() { vP = vec3(aP.xy, aP.z * uH); vN = aN; gl_Position = uVP * vec4(vP, 1.); }`, Sa = `${_a}${va}
in vec3 vP;
flat in vec2 vN;
uniform float uH, uBevel;
uniform vec3 uL;
out vec4 o;
void main() {
  float r = min(uBevel, uH * .6) + 1e-4, th;
  bool wall = dot(vN, vN) > .5;
  vec2 out2;
  if (wall) {
    // the coast's general direction, not every rock of it: the field's slope taken wide
    vec2 g = outward(vP.xy, .035);
    out2 = length(g) > .5 ? normalize(mix(vN, g, .85)) : vN;
    th = 1.5708 - .7854 * clamp((uH - vP.z) / r, 0., 1.);
  } else {
    out2 = outward(vP.xy, uD / ${Z}.);
    th = .7854 * clamp(1. + sdf(vP.xy) / r, 0., 1.);
  }
  vec3 n = vec3(out2 * sin(th), cos(th));
  float l = dot(n, uL);
  float wrap = clamp((l + .5) / 1.5, 0., 1.);
  vec3 sky = vec3(.9, .92, .955), sun = vec3(1., .99, .97), albedo = vec3(.99, .985, .972);
  vec3 col = albedo * (sky * (.56 + .2 * n.z) + sun * wrap * .36);
  if (wall) col *= mix(.86, 1., smoothstep(0., uH * .9, vP.z));
  o = vec4(min(col, vec3(1.)), 1.);
}`, Ca = `${_a}
layout(location = 0) in vec2 aC;
layout(location = 1) in vec4 aI;     // centre, radius, kind (0 disc, 1 pin, 2 town)
layout(location = 2) in vec2 aA;     // shown 0…1, ripple phase
uniform mat4 uVP;
uniform float uH;
out vec2 vUV;
flat out float vK;
flat out vec2 vA;
void main() {
  vUV = aC; vK = aI.w; vA = aA;
  vec2 p = aI.xy + aC * aI.z;
  gl_Position = uVP * vec4(p, uH + (aI.w < .5 ? .004 : .008), 1.);
}`, wa = `${_a}
in vec2 vUV;
flat in float vK;
flat in vec2 vA;
uniform float uT;
out vec4 o;
const vec3 BLUE = vec3(${Ui.join(",")});
void main() {
  float r = length(vUV), aa = fwidth(r);
  if (vK < .5) {
    // coverage: no disc, only rings running out through it, the first as the city pins in
    float ring = aa * 1.4 + .006;
    float rp = fract(uT / 5.2 + vA.y);
    float a = (1. - smoothstep(0., ring, abs(r - rp))) * (1. - rp) * smoothstep(0., .2, rp) * .55 * step(.999, vA.x);
    a += (1. - smoothstep(0., ring, abs(r - vA.x))) * (1. - vA.x) * .6 * smoothstep(0., .08, vA.x) * step(vA.x, .999);
    o = vec4(BLUE * a, a);
    return;
  }
  bool pin = vK < 1.5;
  float ring = pin ? .42 : .5, core = pin ? .24 : .28;
  float w = 1. - smoothstep(ring - aa, ring, r);
  float b = 1. - smoothstep(core - aa, core, r);
  float halo = 1. - smoothstep(0., 1., r); halo *= halo * (pin ? .32 : .22);
  vec3 col = mix(vec3(1.), BLUE, b);
  o = vec4(col * w + BLUE * halo * (1. - w), w + halo * (1. - w)) * vA.x;
}`, Ta = `${_a}
layout(location = 0) in vec2 aP;
layout(location = 1) in vec4 aR;     // distance along, 0…1 along, -1…1 across, which route
uniform mat4 uVP;
uniform float uH;
out vec4 vR;
void main() { vR = aR; gl_Position = uVP * vec4(aP, uH + .003, 1.); }`, Ea = `${_a}
in vec4 vR;
uniform vec3 uProg;
uniform float uW, uGap;
out vec4 o;
const vec3 BLUE = vec3(${Ui.join(",")});
void main() {
  float prog = vR.w < .5 ? uProg.x : vR.w < 1.5 ? uProg.y : uProg.z;
  if (vR.y > prog) discard;
  float px = fwidth(vR.x);
  float r = max(.0085, px * 1.1);
  float d = length(vec2((fract(vR.x / uGap) - .5) * uGap, vR.z * uW));
  float a = (1. - smoothstep(r - px * .7, r + px * .7, d)) * .72;
  o = vec4(BLUE * a, a);
}`, Da = `${_a}
layout(location = 0) in vec3 aC;
uniform mat4 uVP;
uniform vec2 uPos;
uniform float uRot, uS, uH;
out vec3 vL;
void main() {
  vL = vec3(aC.xy * .9, (aC.z * .5 + .5) * .6);
  float c = cos(uRot), s = sin(uRot);
  vec2 w = uPos + mat2(c, s, -s, c) * vL.xy * uS;
  gl_Position = uVP * vec4(w, uH + vL.z * uS, 1.);
}`, Oa = `${_a}
in vec3 vL;
uniform vec3 uEyeL, uLL;
out vec4 o;
const vec3 BLUE = vec3(${Ui.join(",")});
const vec3 SCREEN = vec3(.781, 0., .625);   // the windscreen's slope
float box(vec3 p, vec3 b, float r) { vec3 q = abs(p) - b + r; return length(max(q, 0.)) + min(max(q.x, max(q.y, q.z)), 0.) - r; }
float smin(float a, float b, float k) { float h = clamp(.5 + .5 * (b - a) / k, 0., 1.); return mix(b, a, h) - k * h * (1. - h); }
float smax(float a, float b, float k) { return -smin(-a, -b, k); }
vec3 wheel(vec3 p) { return vec3(p.x - (p.x > 0. ? .3 : -.28), abs(p.y) - .158, p.z - .085); }
vec2 map(vec3 p) {
  float cargo = smax(box(p - vec3(-.03, 0., .31), vec3(.45, .2, .19), .075), dot(p - vec3(.42, 0., .3), SCREEN), .04);
  float b = smin(cargo, box(p - vec3(.36, 0., .2), vec3(.13, .195, .09), .06), .05);
  vec3 w = wheel(p);
  b = smax(b, .105 - length(w.xz), .02);                       // the wheel arches
  vec2 tw = vec2(length(w.xz) - .072, abs(w.y) - .026);
  float wh = min(max(tw.x, tw.y), 0.) + length(max(tw, 0.)) - .012;
  return wh < b ? vec2(wh, 1.) : vec2(b, 0.);
}
vec3 normalAt(vec3 p) {
  vec2 e = vec2(.002, 0.);
  return normalize(vec3(map(p + e.xyy).x - map(p - e.xyy).x, map(p + e.yxy).x - map(p - e.yxy).x, map(p + e.yyx).x - map(p - e.yyx).x));
}
vec3 shade(vec3 p, vec3 rd) {
  vec3 n = normalAt(p), V = -rd;
  vec3 col = vec3(.1, .12, .165);
  float glass = 0., lamp = 0.;
  if (map(p).y > .5) {
    float r = length(wheel(p).xz);
    col = abs(n.y) > .6 && r < .045 ? vec3(.7, .73, .77) : vec3(.045, .05, .06);
  } else {
    float side = abs(n.y);
    float pillar = .42 - (p.z - .3) * .8;                      // where the windscreen meets the side
    if ((dot(n, SCREEN) > .8 && p.z > .31) || (side > .7 && p.x > .1 && p.x < pillar - .035 && p.z > .335 && p.z < .465)) glass = 1.;
    else if (side > .6) {
      // the livery: a blue sweep rising toward the back, a paler streak over it, the round white "a"
      float sweep = .14 + .19 * smoothstep(.3, -.48, p.x);
      if (p.x < .28 && p.z < sweep) col = BLUE;
      else if (p.x < .22 && p.z < sweep + .028) col = vec3(.5, .76, .93);
      vec2 q = p.xz - vec2(-.1, .335);
      float rr = length(q), stem = -sign(p.y) * .079;
      if ((rr < .098 && rr > .06) || (abs(q.x - stem) < .019 && q.y > -.098 && q.y < .07)) col = vec3(.96, .97, .98);
    }
    if (n.x > .55 && p.z > .17 && p.z < .245 && abs(p.y) > .1) lamp = 1.;
    if (n.x < -.6 && p.z > .22 && p.z < .34 && abs(p.y) > .14) col = vec3(.75, .1, .09);
  }
  if (lamp > 0.) return vec3(1., .97, .88);
  vec3 Hh = normalize(uLL + V);
  float l = dot(n, uLL), wrap = clamp((l + .35) / 1.35, 0., 1.);
  float fres = pow(1. - clamp(dot(n, V), 0., 1.), 3.);
  vec3 c;
  if (glass > 0.) {
    // dark glass with the sky in it
    c = vec3(.09, .12, .17) + vec3(.55, .66, .8) * (.18 + .8 * fres) * (.6 + .4 * n.z);
  } else c = col * (vec3(.82, .86, .93) * (.42 + .3 * n.z) + vec3(1., .98, .95) * wrap * .72);
  // a highlight on the glass only: on a van this small the body's rounded edges are a pixel wide,
  // and a highlight on one (the back of the roof, facing the light) reads as a stray hairline;
  // the roof gets an even lift instead
  c += pow(max(dot(n, Hh), 0.), 60.) * .9 * glass;
  c += vec3(.05, .06, .08) * smoothstep(.97, 1., n.z) * (1. - glass);
  return c * mix(.62, 1., smoothstep(0., .15, p.z));
}
void main() {
  vec3 rd = normalize(vL - uEyeL);
  // a pixel's width in van units, per unit of distance: the ray's own spread (not the box face's,
  // which seen edge-on would smear the soft edge below into a line); taken before any discard
  float spread = length(fwidth(rd)) * .5;
  // only the face the ray comes in by; march from there
  vec3 inv = 1. / rd, t0 = (vec3(-.9, -.9, 0.) - uEyeL) * inv, t1 = (vec3(.9, .9, .6) - uEyeL) * inv;
  float tn = max(max(min(t0.x, t1.x), min(t0.y, t1.y)), min(t0.z, t1.z));
  if (length(vL - uEyeL) > tn + .02) discard;
  vec3 ro = uEyeL + rd * tn;
  float t = 0., dmin = 1e9, tmin = 0.;
  bool hit = false;
  for (int i = 0; i < 96; i++) {
    float d = map(ro + rd * t).x;
    if (d < dmin) { dmin = d; tmin = t; }
    // within half a pixel is a hit: a ray skimming along a side creeps in tiny steps and would
    // otherwise run out of them and be taken for a near miss, a pale line just inside the edge
    if (d < max(.0008, spread * (tn + t) * .5)) { hit = true; break; }
    t += d * .9;
    if (t > 3.) break;
  }
  // its shadow on the map, falling away from the light, and darker right under it
  vec4 sh = vec4(0.);
  if (rd.z < 0.) {
    vec2 g = (ro + rd * (-ro.z / rd.z)).xy;
    vec2 q = g + uLL.xy / uLL.z * .2;
    float a = (1. - smoothstep(-.06, .16, length(max(abs(q) - vec2(.4, .15), 0.)) - .06)) * .3;
    a = max(a, (1. - smoothstep(0., .07, length(max(abs(g) - vec2(.42, .16), 0.)))) * .38);
    sh = vec4(vec3(.1, .13, .19) * a, a);
  }
  if (hit) { o = vec4(shade(ro + rd * t, rd), 1.); return; }
  // a soft edge one pixel wide where the ray only just missed
  // (from the ray's own spread, not the box face's: a face seen edge-on would smear it into a line)
  float px = clamp(spread * (tn + tmin), .001, .03);
  float cov = 1. - smoothstep(0., px, dmin);
  o = cov > 0. ? vec4(shade(ro + rd * tmin, rd), 1.) * cov + sh * (1. - cov) : sh;
  if (o.a < .002) discard;
}`;
function ka(e, t, n) {
	let r = e.createProgram();
	for (let [i, a] of [[e.VERTEX_SHADER, t], [e.FRAGMENT_SHADER, n]]) {
		let t = e.createShader(i);
		e.shaderSource(t, a), e.compileShader(t), e.attachShader(r, t);
	}
	return e.linkProgram(r), r;
}
function Aa(e, t, n, r, i, a) {
	for (let o = 0; o < t; o++) ja(e, o, t, n, r, i, a);
	for (let o = 0; o < n; o++) ja(e, o * t, 1, t, r, i, a);
}
function ja(e, t, n, r, i, a, o) {
	a[0] = 0, o[0] = -0x56bc75e2d63100000, o[1] = 0x56bc75e2d63100000, i[0] = e[t];
	for (let s = 1, c = 0, l = 0; s < r; s++) {
		i[s] = e[t + s * n];
		let r = s * s;
		do {
			let e = a[c];
			l = (i[s] - i[e] + r - e * e) / (s - e) / 2;
		} while (l <= o[c] && --c > -1);
		c++, a[c] = s, o[c] = l, o[c + 1] = 0x56bc75e2d63100000;
	}
	for (let s = 0, c = 0; s < r; s++) {
		for (; o[c + 1] < s;) c++;
		let r = a[c], l = s - r;
		e[t + s * n] = i[r] + l * l;
	}
}
function Ma(e) {
	let t = document.createElement("canvas");
	t.width = t.height = Z;
	let n = t.getContext("2d", { willReadFrequently: !0 }), r = Z / (2 * Hi);
	n.beginPath();
	for (let t of e) for (let e = 0; e < t.length; e += 2) n[e ? "lineTo" : "moveTo"]((t[e] + Hi) * r, (Hi - t[e + 1]) * r);
	n.fill();
	let i = n.getImageData(0, 0, Z, Z).data, a = new Float64Array(Z * Z), o = new Float64Array(Z * Z);
	for (let e = 0; e < Z * Z; e++) {
		let t = i[e * 4 + 3] / 255;
		if (t >= 1) a[e] = 0, o[e] = 0x56bc75e2d63100000;
		else if (t <= 0) a[e] = 0x56bc75e2d63100000, o[e] = 0;
		else {
			let n = .5 - t;
			a[e] = n > 0 ? n * n : 0, o[e] = n < 0 ? n * n : 0;
		}
	}
	let s = new Float64Array(Z), c = new Uint16Array(Z), l = /* @__PURE__ */ new Float64Array(513);
	Aa(a, Z, Z, s, c, l), Aa(o, Z, Z, s, c, l);
	let u = new Float32Array(Z * Z);
	for (let e = 0; e < Z * Z; e++) u[e] = (Math.sqrt(a[e]) - Math.sqrt(o[e])) / r;
	return u;
}
var Na = class extends HTMLElement {
	connectedCallback() {
		this.reduced = document.documentElement.classList.contains("reduce") || matchMedia("(prefers-reduced-motion: reduce)").matches, this.touch = matchMedia("(hover: none)").matches, this.loop = this.loop.bind(this), this.play = this.play.bind(this), this.near = new IntersectionObserver(([e]) => {
			e.isIntersecting && this.start();
		}, { rootMargin: "100% 0px" }), this.near.observe(this);
		let e = () => Tr(() => this.start(), 4e3);
		document.readyState === "complete" ? e() : addEventListener("load", e, { once: !0 });
	}
	start() {
		!this.started && this.isConnected && (this.started = !0, this.near.disconnect(), this.make());
	}
	pause() {
		return Dr(() => {
			let e = this.getBoundingClientRect();
			return e.top < innerHeight && e.bottom > 0;
		});
	}
	disconnectedCallback() {
		this.near?.disconnect(), this.io?.disconnect(), this.ro?.disconnect(), document.removeEventListener("visibilitychange", this.play), removeEventListener("scroll", this.onScroll), this.host?.removeEventListener("pointermove", this.onPointer), this.host?.removeEventListener("pointerleave", this.onPointer), cancelAnimationFrame(this.raf), this.raf = 0;
	}
	async make() {
		let e;
		try {
			e = await Promise.all([Promise.resolve().then(() => (jr(), Or)), Promise.resolve().then(() => (Ri(), Mr))]);
		} catch {
			e = null;
		}
		await this.pause();
		let t = document.createElement("canvas"), n = t.getContext("webgl2", {
			alpha: !0,
			premultipliedAlpha: !0,
			antialias: !0,
			powerPreference: "low-power"
		});
		if (!n || !e) {
			this.still();
			return;
		}
		let r = [
			[ya, ba],
			[xa, Sa],
			[Ca, wa],
			[Ta, Ea],
			[Da, Oa]
		].map(([e, t]) => ka(n, e, t)), i = n.getExtension("KHR_parallel_shader_compile");
		if (i) for (; !r.every((e) => n.getProgramParameter(e, i.COMPLETION_STATUS_KHR));) await new Promise(requestAnimationFrame);
		if (await this.pause(), !this.setup(n, r, ...e)) {
			this.still();
			return;
		}
		if (await this.pause(), this.field(n), await this.pause(), !this.isConnected) return;
		this.canvas = t, this.gl = n, this.labels = Wi.map((e) => Object.assign(document.createElement("span"), {
			className: "aura-map__label",
			textContent: e.name
		}));
		let a = document.createElement("div");
		a.className = "aura-map__labels", a.setAttribute("aria-hidden", "true"), a.append(...this.labels), this.append(t, a), this.ready = !0, this.t0 = null, this.pointer = [0, 0], this.lean = [0, 0], this.ro = new ResizeObserver(() => this.resize()), this.ro.observe(this), this.io = new IntersectionObserver(([e]) => {
			this.onScreen = e.isIntersecting, e.intersectionRatio >= .3 && this.t0 == null && (this.t0 = performance.now()), this.play();
		}, { threshold: [0, .3] }), this.io.observe(this), document.addEventListener("visibilitychange", this.play), this.touch ? (this.onScroll = () => {
			this.movedAt = performance.now();
		}, addEventListener("scroll", this.onScroll, { passive: !0 })) : this.reduced || (this.host = this.closest("section") || this, this.onPointer = (e) => {
			if (e.type === "pointerleave") {
				this.pointer = [0, 0];
				return;
			}
			let t = this.getBoundingClientRect();
			this.pointer = [Math.max(-1, Math.min(1, (e.clientX - t.left) / t.width * 2 - 1)), Math.max(-1, Math.min(1, (e.clientY - t.top) / t.height * 2 - 1))], this.play();
		}, this.host.addEventListener("pointermove", this.onPointer, { passive: !0 }), this.host.addEventListener("pointerleave", this.onPointer, { passive: !0 })), t.addEventListener("webglcontextlost", (e) => {
			e.preventDefault(), this.ready = !1, this.play(), this.still();
		}), this.resize();
	}
	still() {
		this.querySelector("img") || (this.replaceChildren(Object.assign(new Image(), {
			src: window.AURA.asset("assets/img/install-ireland.webp"),
			alt: "",
			className: "aura-map__still"
		})), this.classList.add("is-still"));
	}
	setup(e, t, { RINGS: n, PLACES: r }, { default: i }) {
		let a = (t) => {
			if (!e.getProgramParameter(t, e.LINK_STATUS)) return console.warn(e.getProgramInfoLog(t)), null;
			let n = {}, r = e.getProgramParameter(t, e.ACTIVE_UNIFORMS);
			for (let i = 0; i < r; i++) {
				let r = e.getActiveUniform(t, i).name;
				n[r] = e.getUniformLocation(t, r);
			}
			return {
				p: t,
				u: n
			};
		};
		if ([this.ground, this.land, this.mark, this.route, this.van] = t.map(a), !this.ground || !this.land || !this.mark || !this.route || !this.van) return !1;
		let o = this.rings = n.map((e) => e.map((e) => e * zi));
		this.places = Object.fromEntries(Object.entries(r).map(([e, t]) => [e, t.map((e) => e * zi)])), this.fitPts = [];
		for (let e = 0; e < o[0].length; e += 16) this.fitPts.push([o[0][e], o[0][e + 1]]);
		let s = [], c = [], l = [];
		for (let e of o) {
			let t = s.length / 3, n = i(e);
			for (let t = 0; t < e.length; t += 2) s.push(e[t], e[t + 1], 1), c.push(0, 0);
			for (let e of n) l.push(t + e);
			let r = e.length / 2;
			for (let t = 0; t < r; t++) {
				let n = (t + 1) % r, i = e[t * 2], a = e[t * 2 + 1], o = e[n * 2], u = e[n * 2 + 1], d = Math.hypot(o - i, u - a) || 1, f = (u - a) / d, p = -(o - i) / d, m = s.length / 3;
				s.push(i, a, 0, o, u, 0, o, u, 1, i, a, 1), c.push(f, p, f, p, f, p, f, p), l.push(m, m + 1, m + 2, m, m + 2, m + 3);
			}
		}
		this.landVao = e.createVertexArray(), e.bindVertexArray(this.landVao);
		let u = (t, n, r) => {
			e.bindBuffer(e.ARRAY_BUFFER, e.createBuffer()), e.bufferData(e.ARRAY_BUFFER, new Float32Array(t), e.STATIC_DRAW), e.enableVertexAttribArray(n), e.vertexAttribPointer(n, r, e.FLOAT, !1, 0, 0);
		};
		u(s, 0, 3), u(c, 1, 2), e.bindBuffer(e.ELEMENT_ARRAY_BUFFER, e.createBuffer()), e.bufferData(e.ELEMENT_ARRAY_BUFFER, new Uint32Array(l), e.STATIC_DRAW), this.landCount = l.length, this.groundVao = e.createVertexArray(), e.bindVertexArray(this.groundVao);
		let d = 4.5;
		u([
			-4.5,
			-4.5,
			d,
			-4.5,
			d,
			d,
			-4.5,
			-4.5,
			d,
			d,
			-4.5,
			d
		], 0, 2), this.marks = [
			...Wi.map((e, t) => ({
				c: this.places[e.key],
				r: e.r,
				k: 0,
				phase: t * .31
			})),
			...Wi.map((e) => ({
				c: this.places[e.key],
				r: .1,
				k: 1
			})),
			...Gi.map((e) => ({
				c: this.places[e],
				r: .055,
				k: 2
			}))
		], this.markVao = e.createVertexArray(), e.bindVertexArray(this.markVao), u([
			-1,
			-1,
			1,
			-1,
			1,
			1,
			-1,
			-1,
			1,
			1,
			-1,
			1
		], 0, 2), e.bindBuffer(e.ARRAY_BUFFER, e.createBuffer()), e.bufferData(e.ARRAY_BUFFER, new Float32Array(this.marks.flatMap((e) => [
			e.c[0],
			e.c[1],
			e.r,
			e.k
		])), e.STATIC_DRAW), e.enableVertexAttribArray(1), e.vertexAttribPointer(1, 4, e.FLOAT, !1, 0, 0), e.vertexAttribDivisor(1, 1), this.markBuf = e.createBuffer(), this.markData = new Float32Array(this.marks.length * 2), e.bindBuffer(e.ARRAY_BUFFER, this.markBuf), e.bufferData(e.ARRAY_BUFFER, this.markData, e.DYNAMIC_DRAW), e.enableVertexAttribArray(2), e.vertexAttribPointer(2, 2, e.FLOAT, !1, 0, 0), e.vertexAttribDivisor(2, 1);
		let f = Wi.map((e) => this.places[e.key]), p = [0, 1].map((e) => f.reduce((t, n) => t + n[e], 0) / f.length);
		this.routes = qi.map(([e, t]) => {
			let n = this.places[e], r = this.places[t], i = Math.hypot(r[0] - n[0], r[1] - n[1]), a = [(n[0] + r[0]) / 2, (n[1] + r[1]) / 2], o = [-(r[1] - n[1]) / i, (r[0] - n[0]) / i];
			return o[0] * (a[0] - p[0]) + o[1] * (a[1] - p[1]) < 0 && (o = [-o[0], -o[1]]), {
				A: n,
				B: r,
				C: [a[0] + o[0] * i * .13, a[1] + o[1] * i * .13],
				dur: 1.5 + i * 1.4
			};
		});
		let m = .02, h = [], g = [], _ = [];
		this.routes.forEach((e, t) => {
			let n = 0, r = null;
			for (let i = 0; i <= 64; i++) {
				let a = i / 64, o = this.bez(e, a), s = this.tangent(e, a), c = Math.hypot(s[0], s[1]);
				r && (n += Math.hypot(o[0] - r[0], o[1] - r[1])), r = o;
				let l = -s[1] / c * m, u = s[0] / c * m, d = h.length / 2;
				h.push(o[0] + l, o[1] + u, o[0] - l, o[1] - u), g.push(n, a, 1, t, n, a, -1, t), i && _.push(d - 2, d - 1, d, d - 1, d + 1, d);
			}
		}), this.routeVao = e.createVertexArray(), e.bindVertexArray(this.routeVao), u(h, 0, 2), u(g, 1, 4), e.bindBuffer(e.ELEMENT_ARRAY_BUFFER, e.createBuffer()), e.bufferData(e.ELEMENT_ARRAY_BUFFER, new Uint16Array(_), e.STATIC_DRAW), this.routeCount = _.length;
		let v = [];
		for (let [e, t, n] of [
			[
				0,
				1,
				2
			],
			[
				1,
				2,
				0
			],
			[
				2,
				0,
				1
			]
		]) for (let r of [-1, 1]) for (let [i, a] of [
			[-1, -1],
			[1, -1],
			[1, 1],
			[-1, -1],
			[1, 1],
			[-1, 1]
		]) {
			let o = [];
			o[e] = r, o[t] = i, o[n] = a, v.push(...o);
		}
		return this.vanVao = e.createVertexArray(), e.bindVertexArray(this.vanVao), u(v, 0, 3), e.bindVertexArray(null), e.useProgram(this.route.p), e.uniform1f(this.route.u.uW, m), e.uniform1f(this.route.u.uGap, .05), !0;
	}
	field(e) {
		e.activeTexture(e.TEXTURE0), e.bindTexture(e.TEXTURE_2D, e.createTexture()), e.pixelStorei(e.UNPACK_ALIGNMENT, 1), e.texImage2D(e.TEXTURE_2D, 0, e.R16F, Z, Z, 0, e.RED, e.FLOAT, Ma(this.rings));
		for (let [t, n] of [
			[e.TEXTURE_MIN_FILTER, e.LINEAR],
			[e.TEXTURE_MAG_FILTER, e.LINEAR],
			[e.TEXTURE_WRAP_S, e.CLAMP_TO_EDGE],
			[e.TEXTURE_WRAP_T, e.CLAMP_TO_EDGE]
		]) e.texParameteri(e.TEXTURE_2D, t, n);
		let t = 111.32 * Math.cos(53.4 * Math.PI / 180) * zi, n = 110.57 * zi, r = this.L = aa([
			-.5,
			.55,
			.78
		]);
		for (let { p: t, u: n } of [this.ground, this.land]) e.useProgram(t), e.uniform1i(n.uSdf, 0), e.uniform1f(n.uD, Hi), e.uniform3f(n.uL, ...r);
		e.useProgram(this.ground.p), e.uniform2f(this.ground.u.uGridAt, .05 * t, -.4 * n), e.uniform2f(this.ground.u.uGridStep, t, n * .5), e.useProgram(this.land.p), e.uniform1f(this.land.u.uBevel, Vi), e.clearColor(0, 0, 0, 0), e.blendFunc(e.ONE, e.ONE_MINUS_SRC_ALPHA);
	}
	resize() {
		if (!this.ready) return;
		let e = Math.min(devicePixelRatio || 1, 2);
		this.w = this.clientWidth, this.h = this.clientHeight;
		let t = Math.max(1, Math.round(this.w * e)), n = Math.max(1, Math.round(this.h * e));
		(t !== this.canvas.width || n !== this.canvas.height) && (this.canvas.width = t, this.canvas.height = n), this.fit(), this.draw(performance.now());
	}
	camera(e, t, n) {
		let r = e * Math.PI / 180, i = t * Math.PI / 180, a = [
			0,
			-.08,
			0
		], o = [
			a[0] + n * Math.cos(r) * Math.sin(i),
			a[1] - n * Math.cos(r) * Math.cos(i),
			a[2] + n * Math.sin(r)
		];
		return this.eye = o, la(sa(26 * Math.PI / 180, this.w / this.h, n * .5, n * 1.6), ca(o, a, [
			0,
			0,
			1
		]));
	}
	fit() {
		let e = (e, t) => {
			let n = 10;
			for (let r = 0; r < 4; r++) {
				let r = 0;
				for (let [t, i] of e) {
					let e = this.camera(t, i, n);
					for (let [t, n] of this.fitPts) for (let i of [0, Bi]) {
						let [a, o] = ua(e, t, n, i);
						r = Math.max(r, Math.abs(a), Math.abs(o));
					}
				}
				n *= r / t;
			}
			return n;
		}, t = this.reduced ? 0 : ta + na[0], n = this.reduced ? 0 : na[1];
		this.distIn = e([
			[Qi - n, -na[0]],
			[Qi - n, na[0]],
			[Qi + n, -na[0]],
			[Qi + n, na[0]]
		], .86), this.dist = e([
			[$i - n, ea - t],
			[$i - n, ea + t],
			[$i + n, ea - t],
			[$i + n, ea + t]
		], .86);
	}
	bez({ A: e, B: t, C: n }, r) {
		let i = 1 - r;
		return [i * i * e[0] + 2 * i * r * n[0] + r * r * t[0], i * i * e[1] + 2 * i * r * n[1] + r * r * t[1]];
	}
	tangent({ A: e, B: t, C: n }, r) {
		return [2 * (1 - r) * (n[0] - e[0]) + 2 * r * (t[0] - n[0]), 2 * (1 - r) * (n[1] - e[1]) + 2 * r * (t[1] - n[1])];
	}
	heading(e, t) {
		let n = this.tangent(e, t);
		return Math.atan2(n[1], n[0]);
	}
	vanAt(e) {
		let t = this.routes, n = t.reduce((e, t) => e + Zi + t.dur, 0);
		if (this.reduced) return {
			pos: this.bez(t[0], .62),
			rot: this.heading(t[0], .62)
		};
		let r = e % n;
		for (let [i, a] of t.entries()) {
			if (r < Zi) {
				let o = this.heading(a, 0), s = e < n && i === 0 ? o : this.heading(t[(i + t.length - 1) % t.length], 1), c = (o - s + Math.PI * 3) % (Math.PI * 2) - Math.PI;
				return {
					pos: a.A,
					rot: s + c * ma(ga(r, .25, .9500000000000001))
				};
			}
			if (r -= Zi, r < a.dur) {
				let e = .5 - .5 * Math.cos(Math.PI * r / a.dur);
				return {
					pos: this.bez(a, e),
					rot: this.heading(a, e)
				};
			}
			r -= a.dur;
		}
		return {
			pos: t[0].A,
			rot: this.heading(t[0], 0)
		};
	}
	play() {
		!this.ready || !this.onScreen || document.hidden || this.t0 == null || this.reduced ? (cancelAnimationFrame(this.raf), this.raf = 0) : this.raf ||= requestAnimationFrame(this.loop);
	}
	loop(e) {
		this.raf = 0;
		let t = this.t0 != null && e - this.t0 > 4e3;
		(!this.touch || !t || e - (this.last ?? 0) >= 31 && e - (this.movedAt ?? -1e9) > 180) && (this.last = e, this.draw(e)), this.play();
	}
	draw(e) {
		if (!this.ready || !this.w) return;
		let t = this.gl, n = this.reduced ? 99 : this.t0 == null ? 0 : (e - this.t0) / 1e3, r = this.reduced ? 0 : e / 1e3, i = .02 + .98 * pa(ga(n, 0, 1.6)), a = ma(ga(n, 0, 2.1));
		this.lean[0] += (this.pointer[0] - this.lean[0]) * .06, this.lean[1] += (this.pointer[1] - this.lean[1]) * .06;
		let o = this.reduced ? 0 : Math.sin(r * Math.PI * 2 / 26) * ta * a, s = Qi + -24 * a + this.lean[1] * na[1], c = ea * a + o + this.lean[0] * na[0], l = this.camera(s, c, this.distIn + (this.dist - this.distIn) * a), u = Bi * i, d = Wi.map((e) => ga(n, e.at, 1.1)), f = qi.map((e, t) => ga(n, Ji + t * .3, 1.2));
		[
			...d.map(fa),
			...Wi.map((e) => da(ha(ga(n, e.at, .7)))),
			...Gi.map((e, t) => da(ha(ga(n, Ki + t * .12, .5))))
		].forEach((e, t) => {
			this.markData[t * 2] = e, this.markData[t * 2 + 1] = this.marks[t].phase ?? 0;
		}), t.viewport(0, 0, this.canvas.width, this.canvas.height), t.clear(t.COLOR_BUFFER_BIT | t.DEPTH_BUFFER_BIT), t.enable(t.BLEND), t.disable(t.DEPTH_TEST), t.useProgram(this.ground.p), t.uniformMatrix4fv(this.ground.u.uVP, !1, l), t.uniform1f(this.ground.u.uH, u), t.uniform1f(this.ground.u.uGrid, fa(ga(n, .3, 1.6))), t.bindVertexArray(this.groundVao), t.drawArrays(t.TRIANGLES, 0, 6), t.disable(t.BLEND), t.enable(t.DEPTH_TEST), t.depthMask(!0), t.useProgram(this.land.p), t.uniformMatrix4fv(this.land.u.uVP, !1, l), t.uniform1f(this.land.u.uH, u), t.bindVertexArray(this.landVao), t.drawElements(t.TRIANGLES, this.landCount, t.UNSIGNED_INT, 0), t.enable(t.BLEND), t.depthMask(!1), t.useProgram(this.mark.p), t.uniformMatrix4fv(this.mark.u.uVP, !1, l), t.uniform1f(this.mark.u.uH, u), t.uniform1f(this.mark.u.uT, r % 5200), t.bindVertexArray(this.markVao), t.bindBuffer(t.ARRAY_BUFFER, this.markBuf), t.bufferSubData(t.ARRAY_BUFFER, 0, this.markData), t.drawArraysInstanced(t.TRIANGLES, 0, 6, this.marks.length), t.useProgram(this.route.p), t.uniformMatrix4fv(this.route.u.uVP, !1, l), t.uniform1f(this.route.u.uH, u), t.uniform3f(this.route.u.uProg, ...f.map(ma)), t.bindVertexArray(this.routeVao), t.drawElements(t.TRIANGLES, this.routeCount, t.UNSIGNED_SHORT, 0);
		let p = this.reduced ? 1 : da(ha(ga(n, Xi, .6)));
		if (p > .01) {
			let { pos: e, rot: r } = this.vanAt(Math.max(0, n - Xi)), i = Yi * p, a = u + .002, o = Math.cos(-r), s = Math.sin(-r), c = (e, t) => [o * e - s * t, s * e + o * t], d = c(this.eye[0] - e[0], this.eye[1] - e[1]), f = c(this.L[0], this.L[1]);
			t.useProgram(this.van.p), t.uniformMatrix4fv(this.van.u.uVP, !1, l), t.uniform2f(this.van.u.uPos, ...e), t.uniform1f(this.van.u.uRot, r), t.uniform1f(this.van.u.uS, i), t.uniform1f(this.van.u.uH, a), t.uniform3f(this.van.u.uEyeL, d[0] / i, d[1] / i, (this.eye[2] - a) / i), t.uniform3f(this.van.u.uLL, f[0], f[1], this.L[2]), t.bindVertexArray(this.vanVao), t.drawArrays(t.TRIANGLES, 0, 36);
		}
		t.depthMask(!0), t.bindVertexArray(null);
		let m = (e, t, n) => {
			let [r, i] = ua(l, e, t, n);
			return [(r + 1) / 2 * this.w, (1 - i) / 2 * this.h];
		};
		Wi.forEach((e, t) => {
			let [n, r] = m(...this.places[e.key], u), i = this.labels[t];
			i.style.transform = `translate(${n.toFixed(1)}px, ${r.toFixed(1)}px)`, i.classList.toggle("is-on", d[t] > .25);
		}), this.classList.add("is-on");
	}
};
customElements.define("aura-map", Na);
//#endregion
//#region src/install/aura-coverage.js
var Pa = ([e, t]) => [280 + e * .98, 310 - t * .98], Fa, Ia = () => Fa ||= Promise.resolve().then(() => (jr(), Or)).then(({ RINGS: e, PLACES: t }) => {
	let n = e.map((e) => {
		let t = [];
		for (let n = 0; n < e.length; n += 2) t.push(Pa(e.slice(n, n + 2)));
		return `M${t.map((e) => e.map((e) => e.toFixed(2)).join(",")).join("L")}Z`;
	});
	return {
		coast: n,
		outline: n.join(""),
		PLACES: t
	};
}), La = 0, Ra = "\n  :host {\n    display: block;\n    width: 100%;\n    aspect-ratio: 1;\n    container-type: inline-size;\n    border-radius: var(--r-xl, 44px);\n    overflow: hidden;\n    background: #fff;\n    color: var(--ink, #0D1116);\n    isolation: isolate;\n  }\n  svg { display: block; width: 100%; height: 100%; overflow: hidden; }\n  text { font-family: var(--f-body, Inter, sans-serif); fill: var(--ink, #0D1116); }\n  .micro { font-size: 13px; font-weight: 400; fill: var(--muted, #5F6871); }\n  .heading { font-size: 13.5px; font-weight: 400; fill: var(--muted, #5F6871); }\n  .city-name { font-family: var(--f-display, 'Inter Tight', sans-serif); font-size: 16px; font-weight: 500; letter-spacing: -.15px; }\n  .town-name { font-size: 12.5px; font-weight: 400; fill: var(--muted, #5F6871); }\n  .land { fill: var(--canvas, #F3F1EC); }\n  .coast { fill: none; stroke: var(--ink, #0D1116); stroke-opacity: .28; stroke-width: .8; stroke-linejoin: round; stroke-linecap: round; }\n  .area-fill { fill: var(--blue-soft, #DDEBF6); fill-opacity: .72; }\n  .area-edge { fill: none; stroke: var(--blue, #2588C9); stroke-opacity: .33; stroke-width: .8; }\n  .hub { fill: var(--blue, #2588C9); stroke: #fff; stroke-width: 2; }\n  .town { fill: var(--ink-2, #2A3038); stroke: #fff; stroke-width: 1.4; }\n  .leader { fill: none; stroke: var(--ink, #0D1116); stroke-opacity: .25; stroke-width: .7; stroke-linecap: round; stroke-linejoin: round; }\n  .rule { stroke: var(--line-2, rgba(13,17,22,.16)); stroke-width: .7; }\n  .blue { fill: var(--blue, #2588C9); }\n  .quiet { fill: var(--muted, #5F6871); }\n  @container (max-width: 479px) {\n    .town-detail { display: none; }\n    .city-name { font-size: 23px; }\n    .micro { font-size: 17px; }\n    .heading { font-size: 18px; }\n    .legend-nearby { transform: translate(178px, 0); }\n  }\n", za = class extends HTMLElement {
	constructor() {
		super(), this.attachShadow({ mode: "open" }).innerHTML = `<style>${Ra}</style>`, this.animations = [], this.started = !1, this.inView = !1, this.motion = matchMedia("(prefers-reduced-motion: reduce)"), this.onVisibility = () => this.syncPlayback(), this.onMotion = () => {
			this.motion.matches && this.finish();
		};
	}
	connectedCallback() {
		document.addEventListener("visibilitychange", this.onVisibility), this.motion.addEventListener("change", this.onMotion), "IntersectionObserver" in window ? (this.near = new IntersectionObserver(([e]) => {
			e.isIntersecting && (this.near.disconnect(), this.load());
		}, { rootMargin: "100% 0px" }), this.near.observe(this), this.observer = new IntersectionObserver((e) => {
			this.inView = e[0].isIntersecting, this.inView && this.ready && !this.started && this.start(), this.syncPlayback();
		}, { threshold: .18 }), this.observer.observe(this)) : (this.inView = !0, this.load());
	}
	async load() {
		if (this.ready) return;
		let e = await Ia();
		!this.ready && this.isConnected && (this.render(e), this.ready = !0, this.motion.matches ? this.finish() : this.inView && this.start());
	}
	disconnectedCallback() {
		this.near?.disconnect(), this.observer?.disconnect(), document.removeEventListener("visibilitychange", this.onVisibility), this.motion.removeEventListener("change", this.onMotion), this.animations.forEach((e) => e.pause());
	}
	render({ coast: e, outline: t, PLACES: n }) {
		let r = `aura-coverage-${++La}`, i = [
			{
				key: "dublin",
				name: "Dublin",
				radius: 67,
				label: [480, 321]
			},
			{
				key: "cork",
				name: "Cork",
				radius: 43,
				label: [320, 491]
			},
			{
				key: "galway",
				name: "Galway",
				radius: 42,
				label: [147, 351],
				anchor: "end"
			}
		], a = [
			{
				key: "navan",
				name: "Navan",
				label: [329, 266],
				anchor: "end"
			},
			{
				key: "drogheda",
				name: "Drogheda",
				label: [475, 241]
			},
			{
				key: "kildare",
				name: "Kildare",
				label: [326, 356],
				anchor: "end"
			},
			{
				key: "wicklow",
				name: "Wicklow",
				label: [478, 404]
			}
		], o = (e, t, n, r) => {
			let i = [t[0] + (n === "end" ? 9 : -9), t[1] - 5], a = Math.hypot(i[0] - e[0], i[1] - e[1]);
			return `<path class="leader" d="M${e.map((e, t) => e + (i[t] - e) * r / a)}L${i}"/>`;
		}, s = document.createElement("template");
		s.innerHTML = `
      <svg viewBox="0 0 620 620" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
        <defs>
          <clipPath id="${r}-land"><path d="${t}"/></clipPath>
        </defs>
        <g>
          <path d="M38 43H56" stroke="var(--blue, #2588C9)" stroke-width="1.5"/>
          <text class="heading" x="66" y="47">Installation coverage</text>
          <text class="micro" x="582" y="47" text-anchor="end">Ireland</text>
        </g>
        <path class="land" d="${t}"/>
        ${i.map((e) => {
			let [t, i] = Pa(n[e.key]);
			return `<g clip-path="url(#${r}-land)"><g class="coverage" style="transform-origin:${t}px ${i}px"><circle class="area-fill" cx="${t}" cy="${i}" r="${e.radius}"/></g></g>
            <g class="coverage" style="transform-origin:${t}px ${i}px"><circle class="area-edge" cx="${t}" cy="${i}" r="${e.radius}"/></g>`;
		}).join("")}
        <g>${e.map((e) => `<path class="coast" d="${e}" pathLength="1"/>`).join("")}</g>
        ${i.map((e) => {
			let t = Pa(n[e.key]);
			return `<g class="hub-dot" style="transform-origin:${t[0]}px ${t[1]}px"><circle class="hub" cx="${t[0]}" cy="${t[1]}" r="4"/></g>
            <g class="city-label">${o(t, e.label, e.anchor, 8)}<text class="city-name" x="${e.label[0]}" y="${e.label[1]}" text-anchor="${e.anchor || "start"}">${e.name}</text></g>`;
		}).join("")}
        ${a.map((e) => {
			let t = Pa(n[e.key]);
			return `<g class="town-dot"><circle class="town" cx="${t[0]}" cy="${t[1]}" r="2.7"/></g>
            <g class="town-detail">${o(t, e.label, e.anchor, 5)}<text class="town-name" x="${e.label[0]}" y="${e.label[1]}" text-anchor="${e.anchor || "start"}">${e.name}</text></g>`;
		}).join("")}
        <g class="legend">
          <path class="rule" d="M38 559H582"/>
          <circle class="blue" cx="43" cy="585" r="3.5"/><text class="micro" x="55" y="589">Key regions</text>
          <g class="legend-nearby" transform="translate(156 0)"><circle class="quiet" cx="2.5" cy="585" r="2.5"/><text class="micro" x="14" y="589">Nearby areas</text></g>
        </g>
      </svg>`, this.shadowRoot.append(s.content), this.motion.matches || this.prepare();
	}
	prepare() {
		let e = this.shadowRoot, t = (e, t, n, r, i = "cubic-bezier(.16, 1, .3, 1)") => {
			let a = e.animate(t, {
				delay: n,
				duration: r,
				easing: i,
				fill: "both"
			});
			a.pause(), this.animations.push(a);
		};
		e.querySelectorAll(".coast").forEach((e, n) => {
			t(e, [{
				strokeDasharray: "1 1",
				strokeDashoffset: 1,
				opacity: 0
			}, {
				strokeDasharray: "1 1",
				strokeDashoffset: 0,
				opacity: 1
			}], n ? 400 : 0, n ? 650 : 1100);
		}), t(e.querySelector(".land"), [{ opacity: 0 }, { opacity: 1 }], 650, 650), e.querySelectorAll(".hub-dot").forEach((e, n) => {
			t(e, [{
				opacity: 0,
				transform: "scale(.3)"
			}, {
				opacity: 1,
				transform: "scale(1)"
			}], 1150 + n * 240, 430);
		}), e.querySelectorAll(".coverage").forEach((e, n) => {
			t(e, [{
				opacity: 0,
				transform: "scale(.05)"
			}, {
				opacity: 1,
				transform: "scale(1)"
			}], 1330 + Math.floor(n / 2) * 240, 750);
		}), e.querySelectorAll(".town-dot").forEach((e, n) => {
			t(e, [{ opacity: 0 }, { opacity: 1 }], 2070 + n * 90, 300);
		}), e.querySelectorAll(".city-label, .town-detail").forEach((e, n) => {
			t(e, [{
				opacity: 0,
				transform: "translateY(4px)"
			}, {
				opacity: 1,
				transform: "translateY(0)"
			}], 2260 + n * 65, 430);
		}), t(e.querySelector(".legend"), [{ opacity: 0 }, { opacity: 1 }], 2640, 460), Promise.all(this.animations.map((e) => e.finished)).then(() => {
			this.animations.forEach((e) => e.cancel()), this.animations = [];
		}).catch(() => {});
	}
	start() {
		this.started = !0, this.syncPlayback();
	}
	syncPlayback() {
		let e = this.started && this.inView && !document.hidden;
		this.animations.forEach((t) => e ? t.play() : t.pause());
	}
	finish() {
		this.started = !0, this.animations.forEach((e) => e.cancel()), this.animations = [];
	}
};
customElements.get("aura-coverage") || customElements.define("aura-coverage", za);
//#endregion
//#region src/blinds/aura-blinds.js
var Ba = {
	size: [1536, 1024],
	pxPerM: 318,
	cassette: {
		x0: 481,
		x1: 1053,
		top: 95,
		bottom: 125
	},
	barRest: {
		top: 123,
		bottom: 133
	},
	fabric: {
		x0: 491,
		x1: 1043,
		top: 125,
		stop: 562
	},
	glass: {
		top: 160,
		bottom: 536
	},
	focus: [.49, .4],
	src: {
		day: window.AURA_ASSETS ? window.AURA_ASSETS + "blinds-plate-day" : "assets/img/blinds-plate-day",
		shut: window.AURA_ASSETS ? window.AURA_ASSETS + "blinds-plate-shut" : "assets/img/blinds-plate-shut",
		eve: window.AURA_ASSETS ? window.AURA_ASSETS + "blinds-plate-evening" : "assets/img/blinds-plate-evening"
	},
	widths: [1024, 1536]
}, Va = {
	screen: {
		name: "Sheer screen",
		weave: window.AURA_ASSETS ? window.AURA_ASSETS + "blinds-weave-screen.webp" : "assets/img/blinds-weave-screen.webp",
		contrast: .55,
		trans: .16,
		open: .26,
		block: .5,
		colours: [
			["Chalk", "#E8E5DF"],
			["Stone", "#BDB5A8"],
			["Graphite", "#63666B"],
			["Charcoal", "#36393D"]
		]
	},
	linen: {
		name: "Light filtering",
		weave: window.AURA_ASSETS ? window.AURA_ASSETS + "blinds-weave-linen.webp" : "assets/img/blinds-weave-linen.webp",
		contrast: .9,
		trans: .3,
		open: 0,
		block: .74,
		colours: [
			["Linen", "#D3CABC"],
			["Oat", "#BBAE9A"],
			["Sage", "#A2A690"],
			["Slate", "#868D94"]
		]
	},
	blackout: {
		name: "Blackout",
		weave: window.AURA_ASSETS ? window.AURA_ASSETS + "blinds-weave-blackout.webp" : "assets/img/blinds-weave-blackout.webp",
		contrast: .35,
		trans: 0,
		open: 0,
		block: .98,
		colours: [
			["White", "#ECEAE5"],
			["Dove", "#C8C4BD"],
			["Mist", "#9BA5AC"],
			["Charcoal", "#3E4248"]
		]
	}
}, Ha = 2.8, Ua = .22, Wa = "\nattribute vec2 aP;\nvarying vec2 vUv;\nvoid main() { vUv = vec2(aP.x * .5 + .5, .5 - aP.y * .5); gl_Position = vec4(aP, 0., 1.); }", Ga = "\n#ifdef GL_FRAGMENT_PRECISION_HIGH\nprecision highp float;\n#else\nprecision mediump float;\n#endif\nvarying vec2 vUv;\nuniform sampler2D uDay, uShut, uEve;   // the plates: open by day, blind down by day, evening\nuniform sampler2D uBack;               // day | evening, blurred: the light coming through the cloth\nuniform sampler2D uView2;              // day | evening, softened: the garden seen through a weave\nuniform sampler2D uRows;               // 256 x 3: wall light left, right (by height); cassette white (across)\nuniform sampler2D uWeaveA, uWeaveB;\nuniform vec4 uView;                    // plate uv = uView.xy + vUv * uView.zw\nuniform vec4 uFab;                     // cloth x0, x1, top, stop\nuniform vec4 uBar;                     // hem bar bottom at rest, bar height, -, one metre (uv y)\nuniform float uDrop, uBlock, uEvening, uMix, uHover, uAspect;\nuniform vec3 uColA, uColB;             // linear albedo\nuniform vec4 uPropA, uPropB;           // trans, open, weave contrast, 1 / weave mean\nuniform vec2 uTile;                    // plate uv per weave tile\nuniform vec2 uPx;                      // plate uv per canvas pixel\n\n// gamma 2 in and out: close to sRGB, and a multiply instead of a pow\nvec3 lin(vec3 c) { return c * c; }\nfloat aa(float d, float w) { return clamp(d / w + .5, 0., 1.); }\nfloat hash(vec2 p) { p = fract(p * vec2(123.34, 456.21)); p += dot(p, p + 45.32); return fract(p.x * p.y); }\n// day on the left half of an atlas, evening on the right: only what is showing is read\nvec3 pair(sampler2D t, vec2 p) {\n  vec2 q = vec2(clamp(p.x, .004, .996) * .5, p.y);\n  if (uEvening <= 0.) return lin(texture2D(t, q).rgb);\n  vec3 e = lin(texture2D(t, q + vec2(.5, 0.)).rgb);\n  if (uEvening >= 1.) return e;\n  return mix(lin(texture2D(t, q).rgb), e, uEvening);\n}\n\nvoid main() {\n  vec2 p = uView.xy + vUv * uView.zw;\n  float barBot = mix(uBar.x, uFab.w, uDrop), barTop = barBot - uBar.y;\n  float inX = aa(p.x - uFab.x, uPx.x) * aa(uFab.y - p.x, uPx.x);\n\n  // the room. By day it takes on the light the cloth takes away, except in the recess,\n  // where the glass keeps its own light (the cloth is drawn over it)\n  vec3 room;\n  if (uEvening < 1.) {\n    room = lin(texture2D(uDay, p).rgb);\n    if (uBlock > 0.) {\n      float inRecess = inX * aa(p.y - uFab.z, uPx.y) * aa(uFab.w + uBar.w * .01 - p.y, uPx.y);\n      room = mix(room, lin(texture2D(uShut, p).rgb), uBlock * (1. - inRecess));\n    }\n    if (uEvening > 0.) room = mix(room, lin(texture2D(uEve, p).rgb), uEvening);\n  } else room = lin(texture2D(uEve, p).rgb);\n\n  // under the hem bar a soft shadow, deepening as it nears the window board\n  float below = p.y - barBot;\n  if (uDrop > .002 && below > 0. && inX > 0.) {\n    float near = 1. - smoothstep(0., uBar.w * .06, uFab.w - barBot);\n    room *= 1. - inX * exp(-below / (uBar.w * (.008 + near * .01))) * (.22 + near * .3);\n  }\n\n  float inCloth = inX * aa(p.y - uFab.z, uPx.y) * aa(barTop - p.y, uPx.y);\n  float inBar = inX * aa(p.y - barTop, uPx.y) * aa(barBot - p.y, uPx.y);\n  // the weave hangs from the hem, so it travels with the cloth (read outside any branch: it is mipmapped)\n  vec2 tuv = vec2(p.x - uFab.x, p.y - barTop) / uTile;\n  float wv = texture2D(uWeaveB, tuv).r * uPropB.w;\n  if (uMix < 1.) wv = mix(texture2D(uWeaveA, tuv).r * uPropA.w, wv, uMix);\n  vec3 col = room;\n\n  if (inCloth + inBar > 0.) {\n    float tx = clamp((p.x - uFab.x) / (uFab.y - uFab.x), 0., 1.);\n    if (inCloth > 0.) {\n      // light on the room side: as on the wall beside the window at this height, either side\n      float wy = clamp((p.y - uFab.z) / (uFab.w - uFab.z), 0., 1.);\n      vec3 E = mix(lin(texture2D(uRows, vec2(wy, 1. / 6.)).rgb), lin(texture2D(uRows, vec2(wy, .5)).rgb), tx) * 1.25;\n      vec3 alb = mix(uColA, uColB, uMix);\n      vec4 pr = mix(uPropA, uPropB, uMix);\n      float w = 1. + (wv - 1.) * pr.z;\n      vec3 cloth = alb * w * E * (1. - pr.y);\n      if (pr.x > 0.) cloth += pr.x * alb * w * pair(uBack, p);\n      if (pr.y > 0.) cloth += pr.y * pair(uView2, p);\n      // the cassette's shadow at the top, the edges turning a touch, a faint grain like the photo's\n      cloth *= 1. - .2 * exp(-max(p.y - uFab.z, 0.) / (uBar.w * .012));\n      float edge = min(p.x - uFab.x, uFab.y - p.x) / uBar.w * uAspect;\n      cloth *= 1. - .05 * (1. - smoothstep(0., .02, edge));\n      cloth *= 1. + (hash(floor(vUv * uView.zw / uPx)) - .5) * .018;\n      col = mix(col, cloth, inCloth);\n    }\n    if (inBar > 0.) {\n      // the hem bar: the cassette's own white, as lit, on a rounded aluminium profile\n      vec3 cas = lin(texture2D(uRows, vec2(tx, 5. / 6.)).rgb);\n      float yb = clamp((p.y - barTop) / uBar.y, 0., 1.);\n      float prof = mix(1.06, .74, smoothstep(.2, 1., yb)) * (1. - .3 * (1. - smoothstep(0., .14, yb)));\n      col = mix(col, cas * prof * (1. + uHover * .05), inBar);\n    }\n  }\n  gl_FragColor = vec4(sqrt(max(col, 0.)), 1.);\n}", Ka = (e, t, n) => e + (t - e) * n, qa = (e) => e * e * (3 - 2 * e), Ja = (e) => [
	1,
	3,
	5
].map((t) => (parseInt(e.slice(t, t + 2), 16) / 255) ** 2);
function Ya(e) {
	let t = new Image();
	return t.decoding = "async", t.src = e, t.decode().then(() => t);
}
function Xa(e, t) {
	let n = e, r = e.naturalWidth || e.width, i = e.naturalHeight || e.height;
	for (; r / 2 >= t;) {
		r = Math.round(r / 2), i = Math.round(i / 2);
		let e = document.createElement("canvas");
		e.width = r, e.height = i;
		let t = e.getContext("2d");
		t.imageSmoothingQuality = "high", t.drawImage(n, 0, 0, r, i), n = e;
	}
	return n;
}
function Za(e, t) {
	let n = e.width, r = e.height;
	for (; n < t;) {
		n *= 2, r *= 2;
		let t = document.createElement("canvas");
		t.width = n, t.height = r;
		let i = t.getContext("2d");
		i.imageSmoothingQuality = "high", i.drawImage(e, 0, 0, n, r), e = t;
	}
	return e;
}
function Qa(e, t) {
	let n = document.createElement("canvas");
	n.width = e.width * 2, n.height = e.height;
	let r = n.getContext("2d");
	return r.drawImage(e, 0, 0), r.drawImage(t, e.width, 0, e.width, e.height), n;
}
var $a = 256;
function eo(e, t) {
	let [n, r] = t.size, i = document.createElement("canvas");
	i.width = n, i.height = r;
	let a = i.getContext("2d", { willReadFrequently: !0 }), o = t.pxPerM, s = (e, t, n, r, i, a) => {
		let o = [
			0,
			0,
			0
		], s = 0;
		for (let c = n; c < r; c++) for (let n = e; n < t; n++) {
			let e = (c * a + n) * 4;
			o[0] += (i[e] / 255) ** 2, o[1] += (i[e + 1] / 255) ** 2, o[2] += (i[e + 2] / 255) ** 2, s++;
		}
		return o.map((e) => e / Math.max(1, s));
	};
	return e.map((e) => {
		a.drawImage(e, 0, 0, n, r);
		let i = new Float32Array($a * 3 * 3), c = t.fabric.top, l = t.fabric.stop;
		[[t.cassette.x0 - .2 * o, t.cassette.x0 - .06 * o], [t.cassette.x1 + .06 * o, t.cassette.x1 + .2 * o]].forEach(([e, t], r) => {
			let u = Math.max(0, Math.round(e)), d = Math.min(n, Math.round(t)) - u, f = a.getImageData(u, c, d, l - c).data;
			for (let e = 0; e < $a; e++) {
				let t = (e + .5) / $a * (l - c), n = Math.max(2, .03 * o), a = s(0, d, Math.max(0, Math.floor(t - n)), Math.min(l - c, Math.ceil(t + n)), f, d);
				i.set(a, (r * $a + e) * 3);
			}
		});
		let u = Math.round(t.cassette.top + (t.cassette.bottom - t.cassette.top) * .3), d = Math.round(t.cassette.bottom - (t.cassette.bottom - t.cassette.top) * .3), f = t.fabric.x0, p = t.fabric.x1 - t.fabric.x0, m = a.getImageData(f, u, p, d - u).data;
		for (let e = 0; e < $a; e++) {
			let t = Math.floor(e / $a * p), n = Math.max(t + 1, Math.floor((e + 1) / $a * p));
			i.set(s(t, n, 0, d - u, m, p), (2 * $a + e) * 3);
		}
		return i;
	});
}
function to(e) {
	let t = Xa(e, 32), n = t.getContext("2d", { willReadFrequently: !0 }).getImageData(0, 0, t.width, t.height).data, r = 0;
	for (let e = 0; e < n.length; e += 4) r += n[e];
	return r / (n.length / 4) / 255;
}
var no = class {
	constructor(e) {
		this.canvas = e;
		let t = this.gl = e.getContext("webgl", {
			alpha: !1,
			antialias: !1,
			depth: !1,
			stencil: !1,
			premultipliedAlpha: !1,
			preserveDrawingBuffer: !1,
			powerPreference: "low-power"
		});
		if (!t) throw Error("no webgl");
		if (t.getParameter(t.MAX_TEXTURE_IMAGE_UNITS) < 8) throw Error("too few texture units");
		let n = (e, n) => {
			let r = t.createShader(e);
			if (t.shaderSource(r, n), t.compileShader(r), !t.getShaderParameter(r, t.COMPILE_STATUS)) throw Error(t.getShaderInfoLog(r));
			return r;
		}, r = this.pr = t.createProgram();
		if (t.attachShader(r, n(t.VERTEX_SHADER, Wa)), t.attachShader(r, n(t.FRAGMENT_SHADER, Ga)), t.linkProgram(r), !t.getProgramParameter(r, t.LINK_STATUS)) throw Error(t.getProgramInfoLog(r));
		t.useProgram(r);
		let i = t.createBuffer();
		t.bindBuffer(t.ARRAY_BUFFER, i), t.bufferData(t.ARRAY_BUFFER, new Float32Array([
			-1,
			-1,
			3,
			-1,
			-1,
			3
		]), t.STATIC_DRAW);
		let a = t.getAttribLocation(r, "aP");
		t.enableVertexAttribArray(a), t.vertexAttribPointer(a, 2, t.FLOAT, !1, 0, 0), this.u = {}, [
			"uDay",
			"uShut",
			"uEve",
			"uBack",
			"uView2",
			"uRows",
			"uWeaveA",
			"uWeaveB"
		].forEach((e, n) => t.uniform1i(this.loc(e), n));
	}
	loc(e) {
		return this.u[e] ??= this.gl.getUniformLocation(this.pr, e);
	}
	texture(e, t, { repeat: n = !1, data: r = null, w: i = 0, h: a = 0 } = {}) {
		let o = this.gl, s = o.createTexture();
		o.activeTexture(o.TEXTURE0 + e), o.bindTexture(o.TEXTURE_2D, s), o.pixelStorei(o.UNPACK_FLIP_Y_WEBGL, !1), r ? o.texImage2D(o.TEXTURE_2D, 0, o.RGBA, i, a, 0, o.RGBA, o.UNSIGNED_BYTE, r) : o.texImage2D(o.TEXTURE_2D, 0, o.RGBA, o.RGBA, o.UNSIGNED_BYTE, t);
		let c = n ? o.REPEAT : o.CLAMP_TO_EDGE;
		return o.texParameteri(o.TEXTURE_2D, o.TEXTURE_WRAP_S, c), o.texParameteri(o.TEXTURE_2D, o.TEXTURE_WRAP_T, c), o.texParameteri(o.TEXTURE_2D, o.TEXTURE_MAG_FILTER, o.LINEAR), n ? (o.generateMipmap(o.TEXTURE_2D), o.texParameteri(o.TEXTURE_2D, o.TEXTURE_MIN_FILTER, o.LINEAR_MIPMAP_LINEAR)) : o.texParameteri(o.TEXTURE_2D, o.TEXTURE_MIN_FILTER, o.LINEAR), s;
	}
	update(e, t, n, r, i) {
		let a = this.gl;
		a.activeTexture(a.TEXTURE0 + e), a.bindTexture(a.TEXTURE_2D, t), a.texSubImage2D(a.TEXTURE_2D, 0, 0, 0, r, i, a.RGBA, a.UNSIGNED_BYTE, n);
	}
	bind(e, t) {
		let n = this.gl;
		n.activeTexture(n.TEXTURE0 + e), n.bindTexture(n.TEXTURE_2D, t);
	}
	set(e, ...t) {
		let n = this.gl, r = this.loc(e);
		t.length === 1 ? n.uniform1f(r, t[0]) : t.length === 2 ? n.uniform2f(r, ...t) : t.length === 3 ? n.uniform3f(r, ...t) : n.uniform4f(r, ...t);
	}
	draw(e, t) {
		let n = this.gl;
		n.viewport(0, 0, e, t), n.drawArrays(n.TRIANGLES, 0, 3);
	}
};
function ro(e) {
	let t = Ba, [n, r] = t.size, i = e.querySelector("[data-blind-media]"), a = i.querySelector("img"), o = e.querySelector("[data-blind-handle]"), s = e.querySelector("[data-blind-range]"), c = e.querySelector("[data-blind-pct]"), l = e.querySelector("[data-blind-status]"), u = e.querySelector("[data-blind-light]"), d = e.querySelector("[data-blind-privacy]"), f = e.querySelector("[data-blind-note]"), p = e.querySelector("[data-blind-colour]"), m = e.querySelector("[data-blind-swatches]"), h = [...e.querySelectorAll("[data-blind-to]")], g = window.A?.reduced ?? matchMedia("(prefers-reduced-motion: reduce)").matches, _ = matchMedia("(hover: hover) and (pointer: fine)").matches, v = {
		drop: 0,
		target: 0,
		vel: 0,
		type: "linen",
		colour: 1,
		eve: 0,
		eveTo: 0,
		mix: 1,
		from: null,
		hover: 0,
		touched: !1,
		sched: ""
	}, y = null, b = 0, x = 0, S = [
		0,
		0,
		1,
		1
	], C = 0, w = 0, T = null, E = {}, D = {}, O = {}, ee = null, k = null, te = new Uint8Array($a * 3 * 4).fill(255), ne = () => {
		if (C = i.clientWidth, w = i.clientHeight, !C || !w) return;
		let e = C / w, o = n / r, s = 1, c = 1;
		e < o ? s = e / o : c = o / e, C < 600 && (s *= .84, c *= .84);
		let [l, u] = t.focus;
		S = [
			Math.min(Math.max(l - s / 2, 0), 1 - s),
			Math.min(Math.max(u - c / 2, 0), 1 - c),
			s,
			c
		];
		let d = C / S[2], f = w / S[3];
		Object.assign(a.style, {
			width: `${d}px`,
			height: `${f}px`,
			left: `${-S[0] * d}px`,
			top: `${-S[1] * f}px`,
			objectFit: "fill"
		}), y && ie(), ce(), L();
	}, re = !1, j = !1, M = 0, ie = () => {
		let e = Math.min(devicePixelRatio || 1, 2, S[2] * n / C) * (j && re ? .5 : 1), t = Math.round(C * e), r = Math.round(w * e);
		(y.canvas.width !== t || y.canvas.height !== r) && (y.canvas.width = t, y.canvas.height = r);
	}, ae = (e, t) => [(e / n - S[0]) / S[2] * C, (t / r - S[1]) / S[3] * w], oe = (e) => (S[1] + e / w * S[3]) * r, se = (e) => Ka(t.barRest.bottom, t.fabric.stop, e), ce = () => {
		let [e, n] = ae(t.fabric.x0, se(v.drop)), [r] = ae(t.fabric.x1, 0);
		o.style.transform = `translate(${e}px, ${n}px)`, o.style.width = `${r - e}px`;
	}, N = () => Va[v.type], le = (e) => Math.min(1, Math.max(0, (se(e) - t.glass.top) / (t.glass.bottom - t.glass.top))), P = (e, t) => le(t) * Va[e].block, ue = (e) => e <= 0 ? "Fully open" : e >= 100 ? "Fully closed" : `${e}% closed`, de = () => {
		let e = le(v.drop), t = v.eveTo > 0;
		return e < .5 ? "Open to view" : e < .97 ? "Partial" : v.type === "screen" ? t ? "Low once lamps are on" : "Good by day" : v.type === "linen" && t ? "Shapes may show" : "Full";
	}, fe = {
		screen: ["Keeps the view of the garden and takes the glare off it.", "After dark, with lamps on, a sheer can be seen through from outside."],
		linen: ["Lets soft daylight through and keeps the room private.", "Shuts out the view. Lamplit shapes can show faintly from outside."],
		blackout: ["Blocks nearly all daylight: for bedrooms and screens.", "Blocks the view both ways, and the street light."]
	}, pe = {}, me = (e, t, n, r = !1) => {
		pe[t] !== n && (pe[t] = n, e[r ? "innerHTML" : "textContent"] = n);
	}, F = () => {
		let e = Math.round(v.drop * 100);
		me(c, "pct", `${e}<small>%</small>`, !0), me(l, "status", v.sched && Math.abs(v.target - v.drop) < .002 ? v.sched : ue(e));
		let t = Math.round((1 - P(v.type, v.drop)) * 100 / 5) * 5;
		me(u, "light", v.eveTo > 0 ? "Evening" : `${t}%`), (pe.v !== t || pe.eve !== v.eveTo) && (pe.v = t, pe.eve = v.eveTo, u.parentElement.style.setProperty("--v", v.eveTo > 0 ? 0 : t / 100)), me(d, "priv", de()), me(f, "note", fe[v.type][+(v.eveTo > 0)]), Ee();
	}, I = e.querySelector("[data-blind-fallback]"), L = () => {
		F(), ce();
		let e = N().colours[v.colour][1];
		if (!y) {
			if (!I) return;
			let [n, r] = ae(t.fabric.x0, t.fabric.top), [i] = ae(t.fabric.x1, 0), [, a] = ae(0, se(v.drop));
			Object.assign(I.style, {
				left: `${n}px`,
				top: `${r}px`,
				width: `${i - n}px`,
				height: `${Math.max(0, a - r)}px`,
				background: e
			});
			return;
		}
		let i = y, { width: a, height: o } = y.canvas, s = N(), c = v.from ? Va[v.from.type] : s, l = Ja(v.from ? c.colours[v.from.colour][1] : e), u = Ja(e), d = Ka(v.from ? P(v.from.type, v.drop) : P(v.type, v.drop), P(v.type, v.drop), v.mix), f = qa(v.eve);
		if (O.block !== d || O.eve !== f) {
			O.block = d, O.eve = f;
			let [e, t, n] = ee;
			for (let r = 0; r < e.length; r++) {
				let i = (e[r] + (t[r] - e[r]) * d) * (1 - f) + n[r] * f;
				te[(r / 3 | 0) * 4 + r % 3] = Math.min(255, Math.round(Math.sqrt(i) * 255));
			}
			i.update(5, k, te, $a, 3);
		}
		i.set("uView", ...S), i.set("uFab", t.fabric.x0 / n, t.fabric.x1 / n, t.fabric.top / r, t.fabric.stop / r), i.set("uBar", t.barRest.bottom / r, (t.barRest.bottom - t.barRest.top) / r, 0, t.pxPerM / r), i.set("uDrop", v.drop), i.set("uBlock", d), i.set("uEvening", f), i.set("uMix", v.from ? qa(v.mix) : 1), i.set("uHover", v.hover), i.set("uColA", ...l), i.set("uColB", ...u);
		let p = (e, t) => [
			e.trans,
			e.open,
			e.contrast,
			1 / (D[t] || .6)
		];
		i.set("uPropA", ...p(c, v.from?.type ?? v.type)), i.set("uPropB", ...p(s, v.type)), i.bind(6, E[v.from?.type ?? v.type]), i.bind(7, E[v.type]), i.set("uTile", .3 * t.pxPerM / n, .3 * t.pxPerM / r), i.set("uPx", S[2] / a, S[3] / o), i.set("uAspect", n / r), i.draw(a, o);
	}, he = (e) => {
		let t = (e - (x || e)) / 1e3, n = Math.min(.05, t);
		x = e, j ? y && !re && (M = t > .03 ? M + 1 : 0, M > 5 && (re = !0, ie())) : (j = !0, y && re && ie());
		let r = !1, i = 1 / (T ? Ha * .45 : Ha), a = i / Ua, o = v.target - v.drop;
		if (Math.abs(o) < 5e-4 && Math.abs(v.vel) < a * n * 1.5) v.drop = v.target, v.vel = 0;
		else {
			let e = Math.sign(o) * Math.min(i, Math.sqrt(2 * a * Math.abs(o)));
			v.vel += Math.max(-a * n, Math.min(a * n, e - v.vel)), v.drop = Math.min(1, Math.max(0, v.drop + v.vel * n)), r = !0;
		}
		v.eve !== v.eveTo && (v.eve += Math.sign(v.eveTo - v.eve) * n / 1.6, v.eve = Math.min(1, Math.max(0, v.eve)), Math.abs(v.eve - v.eveTo) < .001 && (v.eve = v.eveTo), r = !0), v.mix < 1 && (v.mix = Math.min(1, v.mix + n / .45), v.mix >= 1 && (v.from = null), r = !0), r || (j = !1, y && re && ie()), (De || !r) && L(), r ? b = requestAnimationFrame(he) : (b = 0, x = 0);
	}, R = () => {
		b ||= requestAnimationFrame(he);
	}, ge = () => {
		s.value = Math.round(v.target * 100), s.style.setProperty("--fill", `${v.target * 100}%`), h.forEach((e) => e.setAttribute("aria-pressed", String(Number(e.dataset.blindTo) === Math.round(v.target * 100))));
	}, z = (e, { instant: t = !1, sched: n = "" } = {}) => {
		v.target = Math.min(1, Math.max(0, e)), v.sched = n, ge(), g || t ? (v.drop = v.target, v.vel = 0, L()) : R();
	}, B = () => {
		v.touched = !0;
	};
	s.addEventListener("input", () => {
		B(), z(s.value / 100);
	}), h.forEach((e) => e.addEventListener("click", () => {
		B(), z(e.dataset.blindTo / 100);
	}));
	let _e = () => {
		m.innerHTML = N().colours.map(([e, t], n) => `<button type="button" class="swatch" style="--c:${t}" aria-label="${e}" aria-pressed="${n === v.colour}"></button>`).join(""), p.textContent = N().colours[v.colour][0];
	}, ve = (e, t) => {
		(e !== v.type || t !== v.colour) && (v.from = {
			type: v.type,
			colour: v.colour
		}, v.mix = +!!g, g && (v.from = null), v.type = e, v.colour = t, v.target < .3 && z(.62), R(), L());
	};
	e.querySelectorAll("input[name=\"blind-fabric\"]").forEach((e) => e.addEventListener("change", () => {
		e.checked && (B(), ve(e.value, Math.min(v.colour, Va[e.value].colours.length - 1)), _e());
	})), m.addEventListener("click", (e) => {
		let t = e.target.closest(".swatch");
		t && (B(), ve(v.type, [...m.children].indexOf(t)), _e());
	});
	let ye = 0;
	e.querySelectorAll("input[name=\"blind-time\"]").forEach((t) => t.addEventListener("change", () => {
		if (!t.checked) return;
		B();
		let n = t.value === "evening";
		v.eveTo = +!!n, e.classList.toggle("is-evening", n), clearTimeout(ye), g && (v.eve = v.eveTo), ye = setTimeout(() => z(+!!n, { sched: n ? "Closed at sunset" : "Opened at 7:30" }), g ? 0 : 900), R(), F();
	}));
	let be = (e) => {
		let n = i.getBoundingClientRect();
		return (oe((e - n.top) * w / n.height) - t.barRest.bottom) / (t.fabric.stop - t.barRest.bottom);
	}, V = (e) => {
		let n = i.getBoundingClientRect(), [r, a] = ae(t.cassette.x0, t.cassette.bottom), [o, s] = ae(t.cassette.x1, t.fabric.stop), c = (e.clientX - n.left) * C / n.width, l = (e.clientY - n.top) * w / n.height;
		return c > r && c < o && l > a - 10 && l < s + 16;
	}, xe = (t) => {
		t.button > 0 || (T = { id: t.pointerId }, i.setPointerCapture(t.pointerId), e.classList.add("is-dragging"), B(), z(be(t.clientY)), t.preventDefault());
	};
	o.addEventListener("pointerdown", xe), _ && i.addEventListener("pointerdown", (e) => {
		e.target !== o && V(e) && xe(e);
	}), i.addEventListener("pointermove", (e) => {
		if (T && e.pointerId === T.id) {
			z(be(e.clientY));
			return;
		}
		if (!_) return;
		let t = V(e);
		i.classList.toggle("is-over", t);
		let n = +!!t;
		n !== v.hover && (v.hover = n, L());
	});
	let Se = (t) => {
		T && t.pointerId === T.id && (T = null, e.classList.remove("is-dragging"));
	};
	i.addEventListener("pointerup", Se), i.addEventListener("pointercancel", Se), i.addEventListener("pointerleave", () => {
		v.hover && (v.hover = 0, i.classList.remove("is-over"), L());
	});
	let Ce = {
		screen: "sheer screen",
		linen: "light-filtering",
		blackout: "blackout"
	}, we = document.querySelector("[data-blind-sum]"), Te = "", Ee = () => {
		let e = `<span>We’ll bring samples of <b>${Ce[v.type]}</b> fabric in <b>${N().colours[v.colour][0]}</b>, and the full catalogue.</span>`;
		we && e !== Te && (we.innerHTML = Te = e);
	};
	document.querySelectorAll("[data-blind-try]").forEach((t) => t.addEventListener("click", () => {
		let n = e.querySelector(`input[name="blind-fabric"][value="${t.dataset.blindTry}"]`), r = e.getBoundingClientRect().top + scrollY - (innerHeight - e.offsetHeight) / 2;
		window.A?.lenis ? window.A.lenis.scrollTo(Math.max(0, r), { duration: g ? 0 : 1.1 }) : scrollTo({
			top: Math.max(0, r),
			behavior: g ? "auto" : "smooth"
		}), setTimeout(() => {
			n.checked || (n.checked = !0, n.dispatchEvent(new Event("change", { bubbles: !0 }))), v.target < .5 && z(.75);
		}, g ? 0 : 650);
	}));
	let De = !0;
	new IntersectionObserver((e) => {
		let t = De;
		De = e[0].isIntersecting, De && !t && L();
	}).observe(i), e.blinds = {
		st: v,
		view: () => S,
		moveTo: z,
		paint: L
	}, _e(), ge(), F(), new ResizeObserver(ne).observe(i), ne();
	let Oe = (e) => `${e}-${t.widths.find((e) => e >= Math.min(devicePixelRatio || 1, 2) * C * (1 / S[2])) || t.widths.at(-1)}.webp`;
	(window.requestIdleCallback || ((e) => setTimeout(e, 200)))(async () => {
		let n;
		try {
			let r = document.createElement("canvas");
			r.className = "blinds-cfg__gl", r.setAttribute("aria-hidden", "true"), n = new no(r);
			let [a, s, c, ...l] = await Promise.all([
				Ya(Oe(t.src.day)),
				Ya(Oe(t.src.shut)),
				Ya(Oe(t.src.eve)),
				...Object.values(Va).map((e) => Ya(e.weave))
			]);
			n.texture(0, a), n.texture(1, s), n.texture(2, c), n.texture(3, Qa(Za(Xa(a, 48), 384), Za(Xa(c, 48), 384))), n.texture(4, Qa(Xa(a, 768), Xa(c, 768))), ee = eo([
				a,
				s,
				c
			], t), k = n.texture(5, null, {
				data: te,
				w: $a,
				h: 3
			}), Object.keys(Va).forEach((e, t) => {
				E[e] = n.texture(6, l[t], { repeat: !0 }), D[e] = to(l[t]);
			}), r.addEventListener("webglcontextlost", (t) => {
				t.preventDefault(), y = null, r.remove(), e.classList.remove("has-gl"), L();
			}), y = n;
			let u = n.gl.getExtension("WEBGL_debug_renderer_info");
			re = /swiftshader|llvmpipe|software|basic render/i.test(u ? n.gl.getParameter(u.UNMASKED_RENDERER_WEBGL) : ""), i.insertBefore(r, o), e.classList.add("has-gl"), ne();
		} catch (t) {
			console.warn("blinds: drawn flat", t), y = null, e.classList.add("no-gl"), L();
		}
		if (!g && "IntersectionObserver" in window) {
			let e = 0, t = () => {
				e = performance.now();
			};
			addEventListener("scroll", t, { passive: !0 });
			let n = new IntersectionObserver((r) => {
				if (!r[0].isIntersecting) return;
				n.disconnect();
				let i = () => {
					if (v.touched) return removeEventListener("scroll", t);
					if (performance.now() - e < 450) return setTimeout(i, 200);
					removeEventListener("scroll", t), z(.62);
				};
				setTimeout(i, 900);
			}, { threshold: .5 });
			n.observe(i);
		}
	}, { timeout: 1200 });
}
document.querySelectorAll("[data-blinds]").forEach(ro);
//#endregion
//#region src/guard/guard-window.js
var io = 1.3, ao = 1.45, oo = .025, so = .033, co = [.024, .028], lo = .09, uo = 62, fo = 8, po = .013, mo = io / 2, ho = -.033 / 2, go = [-.625, .625], _o = [oo, 1.425], vo = go[1] - go[0] - lo - co[0], yo = (e) => go[1] - (1 - e) * vo, bo = {
	graphite: [
		.03,
		.032,
		.031
	],
	navy: [
		.045,
		.062,
		.1
	],
	titanium: [
		.33,
		.335,
		.32
	],
	quartz: [
		.8,
		.8,
		.79
	]
}, xo = {
	graphite: {
		f0: [
			.05,
			.05,
			.052
		],
		dif: [
			.03,
			.031,
			.034
		],
		gloss: 64
	},
	navy: {
		f0: [
			.05,
			.055,
			.07
		],
		dif: [
			.022,
			.028,
			.062
		],
		gloss: 58
	},
	titanium: {
		f0: [
			.5,
			.51,
			.53
		],
		dif: [
			.07,
			.072,
			.075
		],
		gloss: 46
	},
	quartz: {
		f0: [
			.05,
			.05,
			.05
		],
		dif: [
			.74,
			.735,
			.72
		],
		gloss: 30
	}
}, So = [
	"graphite",
	"navy",
	"titanium",
	"quartz"
], Co = {
	strip: .03,
	key: .9,
	rim: .35,
	fill: .012,
	expo: 1.2,
	aperture: 1.6,
	blur: .02
}, wo = (e, t, n, r) => ({
	p: e,
	eye: t,
	at: n,
	fov: r
}), To = [
	wo(0, [
		-.36,
		.78,
		.2
	], [
		-.24,
		.74,
		ho
	], 30),
	wo(.18, [
		-.06,
		.74,
		.2
	], [
		.06,
		.71,
		ho
	], 30),
	wo(.22, [
		.1,
		.7,
		.21
	], [
		.22,
		.7,
		ho
	], 30),
	wo(.3, [
		.32,
		.72,
		.23
	], [
		.43,
		.74,
		ho
	], 30),
	wo(.38, [
		.5,
		.92,
		.25
	], [
		.6,
		1.02,
		ho
	], 30),
	wo(.46, [
		.44,
		1.32,
		.25
	], [
		.6,
		1.42,
		-.01
	], 30),
	wo(.55, [
		.95,
		1.5,
		.18
	], [
		.62,
		1.42,
		-.015
	], 30),
	wo(.62, [
		.25,
		.16,
		.17
	], [
		.15,
		.52,
		ho
	], 34),
	wo(.72, [
		-.02,
		.12,
		.16
	], [
		-.05,
		.56,
		ho
	], 34),
	wo(.82, [
		-.75,
		.95,
		2
	], [
		0,
		.72,
		0
	], 40),
	wo(1, [
		-.3,
		.78,
		2.65
	], [
		0,
		.72,
		0
	], 40)
], Eo = [
	{
		p: [0, .2],
		from: .55,
		to: .55
	},
	{
		p: [.2, .37],
		from: .55,
		to: 1,
		snap: !0
	},
	{
		p: [.37, .58],
		from: 1,
		to: 1
	},
	{
		p: [.58, .72],
		from: 1,
		to: .72
	},
	{
		p: [.72, .89],
		from: .72,
		to: 1,
		snap: !0
	},
	{
		p: [.89, 1],
		from: 1,
		to: 1
	}
], Do = [
	[.25, .35],
	[.46, .54],
	[.6, .7]
], Oo = [
	[
		0,
		-.44,
		.1
	],
	[
		.18,
		-.06,
		.1
	],
	[
		.3,
		.3,
		.11
	],
	[
		.38,
		.5,
		.13
	],
	[
		.55,
		.88,
		.2
	],
	[
		.6,
		.5,
		.12
	],
	[
		.72,
		-.3,
		.12
	],
	[
		.85,
		-1,
		.6
	],
	[
		1,
		-1,
		.6
	]
], ko = [.74, .84], Ao = [.9, .98], jo = {
	metal: 0,
	cloth: 1,
	cap: 2
}, Mo = 7, No = "\nattribute vec3 aPos; attribute vec3 aNor; attribute float aAux;\nuniform mat4 uVP; uniform vec3 uOff;\nvarying vec3 vPos; varying vec3 vNor; varying float vAux;\nvoid main() { vPos = aPos + uOff; vNor = aNor; vAux = aAux; gl_Position = uVP * vec4(vPos, 1.0); }", Po = `
#extension GL_OES_standard_derivatives : enable
precision highp float;
varying vec3 vPos; varying vec3 vNor; varying float vAux;
uniform vec3 uEye; uniform float uMat;
uniform vec3 uStrip; uniform float uStripK; uniform vec3 uKeyDir; uniform vec3 uKey; uniform vec3 uRimDir; uniform vec3 uRim; uniform vec3 uAmb;
uniform vec3 uDark; uniform float uExpo; uniform vec2 uLens; uniform vec4 uIn;
uniform vec3 uClothA; uniform vec3 uClothB; uniform vec3 uMetF0; uniform vec4 uMetDif; uniform vec3 uPleat;
uniform sampler2D uNoise;

vec3 aces(vec3 x) { return clamp((x * (2.51 * x + 0.03)) / (x * (2.43 * x + 0.59) + 0.14), 0.0, 1.0); }
float ign(vec2 p) { return fract(52.9829189 * fract(dot(p, vec2(0.06711056, 0.00583715)))); }

// how far light wraps round a surface: the cloth's soft fibres carry it a little past the turn
float gWrap = 0.0;
vec3 shine(vec3 N, vec3 V, vec3 l, vec3 C, vec3 alb, vec3 F0, float gloss) {
  vec3 H = normalize(l + V);
  float nl = max((dot(N, l) + gWrap) / (1.0 + gWrap), 0.0);
  float sp = pow(max(dot(N, H), 0.0), gloss) * (gloss + 8.0) / 25.0 * smoothstep(-0.2, 0.3, dot(N, l));
  return C * (alb * nl + F0 * sp);
}

void main() {
  vec3 P = vPos, V = normalize(uEye - P);
  vec3 N = normalize(vNor); if (dot(N, V) < 0.0) N = -N;
  // pleats counted from the bar (uPleat: the bar's edge, a pleat's width, where the turn has got to)
  float q = (uPleat.x - P.x) / uPleat.y;
  // pleats finer than a few pixels fade to the flat cloth they'd blur into, so they never shimmer
  float fine = smoothstep(0.2, 0.45, fwidth(q));
  // the non-woven's fibres: fine noise, fading out where it'd be finer than the pixels
  vec2 fp = P.xy * vec2(620.0, 410.0);
  float fade = 1.0 - smoothstep(0.3, 0.8, length(fwidth(fp)) / 128.0 * 3.0);
  // every texture read up here, outside any branch: under ANGLE on Windows, Direct3D's compiler
  // can take minutes over a texture read inside flow control
  float f1 = texture2D(uNoise, fp / 128.0).r, f2 = texture2D(uNoise, fp / 37.0).g;
  vec4 nz = texture2D(uNoise, P.xy * 3.1 + P.z * 1.7);

  vec3 alb, F0; float gloss, sheen = 0.0;
  if (uMat < 0.5) {             // anodised aluminium: matte, its highlights soft and wide
    alb = uMetDif.rgb; F0 = uMetF0 * (0.96 + 0.04 * nz.g); gloss = uMetDif.a;
  } else if (uMat < 1.5) {      // the cloth's room side
    float fib = (f1 * 0.6 + f2 * 0.4) - 0.5;
    N = normalize(mix(N + vec3(fib * 0.22, (f2 - 0.5) * 0.12, 0.0) * fade, vec3(0.0, 0.0, 1.0), fine)); if (dot(N, V) < 0.0) N = -N;
    // each face of a pleat turns over to the next colour as the ripple passes it
    float turn = smoothstep(0.0, 1.0, (uPleat.z - floor(q * 2.0) * 0.5) / 2.5);
    alb = mix(uClothA, uClothB, turn) * (1.0 + fib * 0.22 * fade);
    alb *= mix(mix(0.35, 1.0, smoothstep(0.0, 0.35, vAux)), 0.8, fine);  // deep in the crease, where the layers are bonded
    float edge = min(P.y - uIn.z, uIn.w - P.y);                          // into the rails' tracks
    alb *= mix(0.4, 1.0, smoothstep(0.0, 0.03, edge));
    F0 = vec3(0.05); gloss = 14.0; sheen = 1.0; gWrap = 0.35;
  } else {                      // the corner caps: moulded in the frame's colour, a little less glossy
    alb = uMetDif.rgb * 1.15 + 0.008; F0 = vec3(0.045); gloss = 24.0;
  }

  vec3 col = alb * uAmb;
  // the strip light: tall, low at the side, from its nearest point, so it rakes across the folds at
  // every height and falls off away from it
  {
    vec3 lp = vec3(uStrip.x, clamp(P.y, -0.3, ${1.75.toFixed(2)}), uStrip.z);
    vec3 d = lp - P; float d2 = dot(d, d);
    col += shine(N, V, d * inversesqrt(d2), vec3(1.0, 0.98, 0.95) * uStripK / (d2 + 0.012), alb, F0, gloss);
  }
  // the softbox, for the whole blind
  col += shine(N, V, uKeyDir, uKey, alb, F0, gloss * 0.35);
  // the rim, from behind and above: the frame's edges and the tops of the crests
  col += shine(N, V, uRimDir, uRim, alb, F0, gloss);
  // sheen where the cloth turns from the eye
  col += sheen * pow(1.0 - max(dot(N, V), 0.0), 5.0) * uStripK * 0.6 * alb;

  col = uDark + aces(col * uExpo) * (1.0 - uDark);
  col += (ign(gl_FragCoord.xy + 17.0) - 0.5) / 255.0;                     // no banding in the dark
  // the alpha carries the lens's blur for this pixel: 0.5 in focus, less nearer, more further
  float dist = length(uEye - P);
  float coc = clamp((dist - uLens.x) / dist * uLens.y, -1.0, 1.0);
  gl_FragColor = vec4(pow(col, vec3(1.0 / 2.2)), 0.5 + 0.5 * coc);
}`, Fo = "attribute vec2 aXY; void main() { gl_Position = vec4(aXY, 0.0, 1.0); }", Io = "\nprecision highp float;\nuniform sampler2D uImg; uniform vec2 uRes; uniform vec2 uDir; uniform float uMax; uniform float uLast;\nvoid main() {\n  vec2 uv = gl_FragCoord.xy / uRes;\n  vec4 c = texture2D(uImg, uv);\n  float cs = c.a * 2.0 - 1.0, rc = abs(cs) * uMax;\n  vec3 acc = c.rgb; float ws = 1.0;\n  for (int i = -9; i <= 9; i++) {\n    float o = float(i) / 9.0 * uMax, d = abs(o);\n    vec4 s = texture2D(uImg, uv + uDir * o / uRes);\n    float ss = s.a * 2.0 - 1.0;\n    float cover = smoothstep(d - 1.0, d + 1.0, abs(ss) * uMax);\n    float lim = mix(1.0, smoothstep(d - 1.0, d + 1.0, rc), step(cs, ss));\n    float w = cover * lim * (1.0 - step(abs(float(i)), 0.0));\n    acc += s.rgb * w; ws += w;\n  }\n  vec3 col = acc / ws;\n  // the last pass: a lens's faint fall-off at the corners\n  vec2 v = uv - 0.5;\n  col *= 1.0 - uLast * 0.22 * smoothstep(0.2, 0.75, dot(v, v) * 2.0);\n  gl_FragColor = vec4(col, c.a);\n}";
function Lo(e, t) {
	return [
		e[0] - t[0],
		e[1] - t[1],
		e[2] - t[2]
	];
}
function Ro(e, t) {
	return [
		e[0] + t[0],
		e[1] + t[1],
		e[2] + t[2]
	];
}
function zo(e, t) {
	return [
		e[0] * t,
		e[1] * t,
		e[2] * t
	];
}
var Bo = (e, t, n) => e.map((e, r) => e + (t[r] - e) * n), Vo = (e, t) => e[0] * t[0] + e[1] * t[1] + e[2] * t[2], Ho = (e, t) => [
	e[1] * t[2] - e[2] * t[1],
	e[2] * t[0] - e[0] * t[2],
	e[0] * t[1] - e[1] * t[0]
], Uo = (e) => zo(e, 1 / (Math.hypot(...e) || 1)), Wo = {
	mul(e, t) {
		let n = /* @__PURE__ */ new Float32Array(16);
		for (let r = 0; r < 4; r++) for (let i = 0; i < 4; i++) {
			let a = 0;
			for (let n = 0; n < 4; n++) a += e[n * 4 + i] * t[r * 4 + n];
			n[r * 4 + i] = a;
		}
		return n;
	},
	persp(e, t, n, r) {
		let i = 1 / Math.tan(e / 2), a = /* @__PURE__ */ new Float32Array(16);
		return a[0] = i / t, a[5] = i, a[10] = (r + n) / (n - r), a[11] = -1, a[14] = 2 * r * n / (n - r), a;
	},
	look(e, t) {
		let n = Uo(Lo(e, t)), r = Uo(Ho([
			0,
			1,
			0
		], n)), i = Ho(n, r);
		return new Float32Array([
			r[0],
			i[0],
			n[0],
			0,
			r[1],
			i[1],
			n[1],
			0,
			r[2],
			i[2],
			n[2],
			0,
			-Vo(r, e),
			-Vo(i, e),
			-Vo(n, e),
			1
		]);
	}
};
function Go(e, t = 0, n = 1) {
	return Math.min(n, Math.max(t, e));
}
var Ko = (e) => e * e * (3 - 2 * e), qo = (e) => e < .5 ? 4 * e * e * e : 1 - (-2 * e + 2) ** 3 / 2, Jo = ([e, t], n) => Go((n - e) / (t - e)), Yo = (e, t, n, r, i) => e.map((a, o) => {
	let s = e[o], c = t[o], l = n[o], u = r[o], d = i * i, f = d * i;
	return .5 * (2 * c + (l - s) * i + (2 * s - 5 * c + 4 * l - u) * d + (3 * c - s - 3 * l + u) * f);
}), Xo = (e) => {
	let t = Math.sin(e * 127.1 + 311.7) * 43758.5453;
	return t - Math.floor(t);
};
function Zo(e) {
	let t = Eo.find((t) => e <= t.p[1]) || Eo[Eo.length - 1], n = Jo(t.p, e);
	if (!t.snap) return t.from + (t.to - t.from) * qo(n);
	let r = t.to - (t.to - t.from) * .05;
	return n < .9 ? t.from + (r - t.from) * Math.sin(n / .9 * Math.PI / 2) : r + (t.to - r) * ((n - .9) / .1) ** 2;
}
function Qo(e) {
	let t = Math.max(1, Oo.findIndex((t) => t[0] >= e)), n = Oo[t - 1], r = Oo[t] || n, i = Ko(Jo([n[0], r[0]], e));
	return [n[1] + (r[1] - n[1]) * i, n[2] + (r[2] - n[2]) * i];
}
var $o = class {
	constructor() {
		this.v = [], this.i = [];
	}
	vert(e, t, n = 1) {
		return this.v.push(e[0], e[1], e[2], t[0], t[1], t[2], n), this.v.length / Mo - 1;
	}
	rail(e, t, n, r, i, a, o, s, c = !1) {
		let l = [];
		[
			[
				1,
				1,
				0
			],
			[
				-1,
				1,
				1
			],
			[
				-1,
				-1,
				2
			],
			[
				1,
				-1,
				3
			]
		].forEach(([e, t, n]) => {
			for (let c = 0; c <= 3; c++) {
				let u = (n + c / 3) * Math.PI / 2;
				l.push([
					r + e * (i / 2 - s) + s * Math.cos(u),
					a + t * (o / 2 - s) + s * Math.sin(u),
					Math.cos(u),
					Math.sin(u)
				]);
			}
		});
		let u = (t, n, r) => e === 0 ? [
			t,
			n,
			r
		] : [
			n,
			t,
			r
		], d = this.v.length / Mo;
		l.forEach(([e, r, i, a]) => {
			this.vert(u(t, e, r), u(0, i, a)), this.vert(u(n, e, r), u(0, i, a));
		});
		let f = l.length;
		for (let e = 0; e < f; e++) {
			let t = d + e * 2, n = d + (e + 1) % f * 2;
			this.i.push(t, t + 1, n + 1, t, n + 1, n);
		}
		c && [t, n].forEach((e, t) => {
			let n = this.vert(u(e, r, a), u(t ? 1 : -1, 0, 0)), i = l.map(([n, r]) => this.vert(u(e, n, r), u(t ? 1 : -1, 0, 0)));
			i.forEach((e, t) => this.i.push(n, e, i[(t + 1) % f]));
		});
	}
};
function es() {
	let e = new $o(), t = .0035, n = -.033 / 2;
	return e.rail(0, -.62, .62, ao - oo / 2, oo, n, so, t), e.rail(0, -.62, .62, oo / 2, oo, n, so, t), e.rail(1, .03, 1.42, -.6375000000000001, oo, n, so, t), e.rail(1, .03, 1.42, mo - oo / 2, oo, n, so, t), e;
}
function ts() {
	let e = new $o();
	return [
		[-1, -1],
		[1, -1],
		[-1, 1],
		[1, 1]
	].forEach(([t, n]) => {
		let r = t < 0 ? -.6512 : .614, i = t < 0 ? -.614 : .6512, a = n < 0 ? -.0012 : 1.414, o = n < 0 ? .036 : 1.4512;
		e.rail(1, a, o, (r + i) / 2, i - r, -.015700000000000002, .036500000000000005, .004, !0);
	}), e;
}
function ns() {
	let e = new $o();
	return e.rail(1, _o[0], _o[1], co[0] / 2, co[0], ho, co[1], .005, !0), e;
}
var rs = class extends HTMLElement {
	connectedCallback() {
		this.ready || (this.ready = !0, this.canvas = this.querySelector("canvas"), (this.gl = this.canvas.getContext("webgl", {
			antialias: !1,
			alpha: !1,
			depth: !1,
			powerPreference: "high-performance"
		})) && (this.reduced = window.A?.reduced ?? matchMedia("(prefers-reduced-motion: reduce)").matches, this.p = 0, this.lean = [0, 0], this.leanTo = [0, 0], this.scale = 1, this.slow = 0, this.t0 = performance.now(), this.build(), this.frame = this.frame.bind(this), new ResizeObserver(() => this.resize()).observe(this), matchMedia("(hover: hover) and (pointer: fine)").matches && addEventListener("pointermove", (e) => {
			this.leanTo = [e.clientX / innerWidth - .5, e.clientY / innerHeight - .5], this.wake();
		}, { passive: !0 }), this.io = new IntersectionObserver(([e]) => {
			this.on = e.isIntersecting, this.wake();
		}), this.io.observe(this), document.addEventListener("visibilitychange", () => this.wake())));
	}
	disconnectedCallback() {
		this.io?.disconnect(), cancelAnimationFrame(this.raf), this.raf = 0;
	}
	drive(e) {
		e !== this.p && (this.p = e, this.wake());
	}
	get live() {
		return this.on && !document.hidden && !this.reduced && !(this.p >= .9999 && this.drewAt === this.p);
	}
	wake() {
		this.live && !this.raf && (this.raf = requestAnimationFrame(this.frame));
	}
	build() {
		let e = this.gl, t = (t, n, r) => {
			let i = (t, n) => {
				let r = e.createShader(t);
				return e.shaderSource(r, n), e.compileShader(r), e.getShaderParameter(r, e.COMPILE_STATUS) || console.error(e.getShaderInfoLog(r)), r;
			}, a = e.createProgram();
			e.attachShader(a, i(e.VERTEX_SHADER, t)), e.attachShader(a, i(e.FRAGMENT_SHADER, n)), e.linkProgram(a);
			let o = {};
			return r.forEach((t) => {
				o[t] = e.getUniformLocation(a, t);
			}), {
				p: a,
				u: o
			};
		};
		e.getExtension("OES_standard_derivatives"), this.main = t(No, Po, [
			"uVP",
			"uOff",
			"uEye",
			"uMat",
			"uStrip",
			"uStripK",
			"uKeyDir",
			"uKey",
			"uRimDir",
			"uRim",
			"uAmb",
			"uDark",
			"uExpo",
			"uLens",
			"uIn",
			"uClothA",
			"uClothB",
			"uMetF0",
			"uMetDif",
			"uPleat",
			"uNoise"
		]), this.main.a = [
			"aPos",
			"aNor",
			"aAux"
		].map((t) => e.getAttribLocation(this.main.p, t)), this.lens = t(Fo, Io, [
			"uImg",
			"uRes",
			"uDir",
			"uMax",
			"uLast"
		]), this.lens.a = e.getAttribLocation(this.lens.p, "aXY");
		let n = (t, n) => {
			let r = e.createBuffer();
			e.bindBuffer(e.ARRAY_BUFFER, r), e.bufferData(e.ARRAY_BUFFER, new Float32Array(t.v), n ? e.DYNAMIC_DRAW : e.STATIC_DRAW);
			let i = e.createBuffer();
			return e.bindBuffer(e.ELEMENT_ARRAY_BUFFER, i), e.bufferData(e.ELEMENT_ARRAY_BUFFER, new Uint16Array(t.i), e.STATIC_DRAW), {
				vb: r,
				ib: i,
				n: t.i.length
			};
		};
		this.meshes = {
			frame: n(es()),
			caps: n(ts()),
			bar: n(ns())
		}, this.cols = 497, this.clothV = new Float32Array(this.cols * 2 * Mo), this.clothZ = new Float32Array(this.cols);
		let r = [];
		for (let e = 0; e < this.cols - 1; e++) {
			let t = e * 2;
			r.push(t, t + 1, t + 3, t, t + 3, t + 2);
		}
		this.meshes.cloth = n({
			v: this.clothV,
			i: r
		}, !0), this.clothAt = "", this.depth = Float32Array.from({ length: uo }, (e, t) => 1 + (Xo(t) - .5) * .14), this.triB = e.createBuffer(), e.bindBuffer(e.ARRAY_BUFFER, this.triB), e.bufferData(e.ARRAY_BUFFER, new Float32Array([
			-1,
			-1,
			3,
			-1,
			-1,
			3
		]), e.STATIC_DRAW);
		let i = /* @__PURE__ */ new Uint8Array(65536), a = Float32Array.from({ length: 65536 }, Math.random), o = new Float32Array(a.length);
		for (let e = 0; e < 128; e++) for (let t = 0; t < 128; t++) for (let n = 0; n < 4; n++) {
			let r = 0;
			for (let i = -1; i <= 1; i++) r += a[(e * 128 + (t + i + 128) % 128) * 4 + n] + a[((e + i + 128) % 128 * 128 + t) * 4 + n];
			o[(e * 128 + t) * 4 + n] = r / 6;
		}
		a = o;
		for (let e = 0; e < 4; e++) {
			let t = 1, n = 0;
			for (let r = e; r < a.length; r += 4) t = Math.min(t, a[r]), n = Math.max(n, a[r]);
			for (let r = e; r < a.length; r += 4) i[r] = (a[r] - t) / (n - t) * 255;
		}
		this.noise = this.texture(128, 128, i, !0), e.clearColor(18 / 255, 19 / 255, 20 / 255, 1);
	}
	texture(e, t, n, r) {
		let i = this.gl, a = i.createTexture();
		i.bindTexture(i.TEXTURE_2D, a), i.texImage2D(i.TEXTURE_2D, 0, i.RGBA, e, t, 0, i.RGBA, i.UNSIGNED_BYTE, n), i.texParameteri(i.TEXTURE_2D, i.TEXTURE_MIN_FILTER, i.LINEAR), i.texParameteri(i.TEXTURE_2D, i.TEXTURE_MAG_FILTER, i.LINEAR);
		let o = r ? i.REPEAT : i.CLAMP_TO_EDGE;
		return i.texParameteri(i.TEXTURE_2D, i.TEXTURE_WRAP_S, o), i.texParameteri(i.TEXTURE_2D, i.TEXTURE_WRAP_T, o), a;
	}
	targets() {
		let e = this.gl, t = this.canvas.width, n = this.canvas.height;
		(this.rt || []).forEach((t) => {
			e.deleteTexture(t.tex), e.deleteFramebuffer(t.fb), t.depth && e.deleteRenderbuffer(t.depth);
		}), this.rt = [0, 1].map((r) => {
			let i = this.texture(t, n, null, !1), a = e.createFramebuffer();
			e.bindFramebuffer(e.FRAMEBUFFER, a), e.framebufferTexture2D(e.FRAMEBUFFER, e.COLOR_ATTACHMENT0, e.TEXTURE_2D, i, 0);
			let o = null;
			return r === 0 && (o = e.createRenderbuffer(), e.bindRenderbuffer(e.RENDERBUFFER, o), e.renderbufferStorage(e.RENDERBUFFER, e.DEPTH_COMPONENT16, t, n), e.framebufferRenderbuffer(e.FRAMEBUFFER, e.DEPTH_ATTACHMENT, e.RENDERBUFFER, o)), {
				tex: i,
				fb: a,
				depth: o
			};
		}), e.bindFramebuffer(e.FRAMEBUFFER, null);
	}
	cloth(e, t, n) {
		let r = go[0], i = (e - co[0] - r) / uo, a = Math.sqrt(Math.max(po * po - i * i / 4, 0)), o = this.clothV, s = this.clothZ;
		for (let e = 0; e < this.cols; e++) {
			let r = e / fo, i = Math.min(61, Math.floor(r)), o = 2 * Math.sin(Math.PI * (r - i)) ** .62 - 1, c = (uo - r - t) / 2.2;
			s[e] = ho + a / 2 * o * this.depth[i] + n * Math.exp(-c * c);
		}
		for (let e = 0; e < this.cols; e++) {
			let t = Math.max(0, e - 1), n = Math.min(this.cols - 1, e + 1), a = Uo([
				-(s[n] - s[t]) / ((n - t) / fo * i),
				0,
				1
			]), c = e / fo, l = r + c * i, u = 2 * Math.sin(Math.PI * (c - Math.floor(c))) ** .62 - 1;
			[_o[0] - .004, _o[1] + .004].forEach((t, n) => {
				o.set([
					l,
					t,
					s[e],
					a[0],
					a[1],
					a[2],
					.5 + .5 * u
				], (e * 2 + n) * Mo);
			});
		}
	}
	resize() {
		let e = this.getBoundingClientRect();
		this.W = e.width, this.H = e.height, this.fit(), this.draw(performance.now());
	}
	fit() {
		let e = Math.min(devicePixelRatio || 1, 1.5) * this.scale;
		this.canvas.width = Math.round(this.W * e), this.canvas.height = Math.round(this.H * e), this.targets();
	}
	frame(e) {
		this.raf = 0, this.last && e - this.last < 200 && (this.slow = this.slow * .92 + (e - this.last > 36 ? .08 : 0), this.slow > .6 && this.scale > .75 && (this.scale *= .85, this.slow = 0, this.fit())), this.last = e, this.draw(e), this.p < .06 && this.wake();
	}
	take(e) {
		let t = Zo(e), n = 0, r = -1;
		for (let t of Do) if (e >= t[1]) n++;
		else if (e > t[0]) {
			r = Jo(t, e);
			break;
		} else break;
		let i = To.findIndex((t) => t.p >= e), a = Math.max(1, i < 0 ? To.length - 1 : i) - 1, o = To[Math.max(0, a - 1)], s = To[a], c = To[a + 1], l = To[Math.min(To.length - 1, a + 2)], u = Jo([s.p, c.p], e), d = (e) => Yo(o[e], s[e], c[e], l[e], u);
		return {
			cover: t,
			turn: r,
			a: So[n],
			b: So[Math.min(n + 1, So.length - 1)],
			view: {
				eye: d("eye"),
				at: d("at"),
				fov: s.fov + (c.fov - s.fov) * Ko(u)
			}
		};
	}
	draw(e) {
		let t = this.gl;
		if (!t || !this.W || !this.rt) return;
		let n = this.p, r = (e - this.t0) / 1e3;
		this.lean[0] += (this.leanTo[0] - this.lean[0]) * .04, this.lean[1] += (this.leanTo[1] - this.lean[1]) * .04;
		let i = this.take(n), a = yo(i.cover), o = i.turn < 0 ? -9 : -3 + i.turn * 70, s = i.turn < 0 ? 0 : .005 * (1 - i.turn), c = [
			a,
			o,
			s
		].join();
		c !== this.clothAt && (this.cloth(a, o, s), this.clothAt = c, t.bindBuffer(t.ARRAY_BUFFER, this.meshes.cloth.vb), t.bufferSubData(t.ARRAY_BUFFER, 0, this.clothV));
		let l = i.turn < 0 ? 0 : 1, u = Go((o + 3) / 3) * l, d = Ko(Go((i.turn - .15) / .6)) * l, f = (e) => {
			let t = xo[i.a], n = xo[i.b];
			return {
				f0: Bo(t.f0, n.f0, e),
				dif: [...Bo(t.dif, n.dif, e), t.gloss + (n.gloss - t.gloss) * e]
			};
		}, p = 1 - Ko(Jo(Ao, n));
		this.light = p;
		let [m, h] = Qo(n), g = this.H > this.W * 1.05, _ = this.W / this.H, { eye: v, at: y, fov: b } = i.view;
		g && (v = Ro(y, zo(Lo(v, y), 1.3)), b += 10);
		let x = this.reduced ? 0 : 1 - Ko(Go(n / .05));
		v = Ro(v, zo([
			Math.sin(r * .21) * .012 + this.lean[0] * .03,
			Math.sin(r * .17) * .006 - this.lean[1] * .02,
			Math.sin(r * .13) * .008
		], x));
		let S = Math.hypot(...Lo(y, v));
		b *= Math.PI / 180;
		let C = Wo.mul(Wo.persp(b, _, .01, 30), Wo.look(v, y)), w = this.canvas.width, T = this.canvas.height;
		t.bindFramebuffer(t.FRAMEBUFFER, this.rt[0].fb), t.viewport(0, 0, w, T), t.clear(t.COLOR_BUFFER_BIT | t.DEPTH_BUFFER_BIT), t.enable(t.DEPTH_TEST), t.disable(t.BLEND);
		let E = this.main, D = E.u;
		t.useProgram(E.p), t.uniformMatrix4fv(D.uVP, !1, C), t.uniform3fv(D.uEye, v), t.uniform3fv(D.uStrip, [
			m,
			0,
			h
		]), t.uniform1f(D.uStripK, Co.strip * p), t.uniform3fv(D.uKeyDir, Uo([
			-.6,
			.45,
			.65
		])), t.uniform3fv(D.uKey, zo([
			.97,
			.98,
			1
		], Co.key * Ko(Jo(ko, n)) * p)), t.uniform3fv(D.uRimDir, Uo([
			.35,
			.75,
			-.55
		])), t.uniform3fv(D.uRim, zo([
			1,
			.98,
			.96
		], Co.rim * p)), t.uniform3fv(D.uAmb, zo([
			.6,
			.62,
			.66
		], Co.fill * p)), t.uniform3fv(D.uDark, [
			18 / 255,
			19 / 255,
			20 / 255
		].map((e) => e ** 2.2)), t.uniform1f(D.uExpo, Co.expo), t.uniform2fv(D.uLens, [S, Co.aperture]), t.uniform4fv(D.uIn, [
			go[0],
			go[1],
			_o[0],
			_o[1]
		]), t.uniform3fv(D.uClothA, bo[i.a]), t.uniform3fv(D.uClothB, bo[i.b]), t.uniform3fv(D.uPleat, [
			a - co[0],
			(a - co[0] - go[0]) / uo,
			o
		]), t.activeTexture(t.TEXTURE0), t.bindTexture(t.TEXTURE_2D, this.noise), t.uniform1i(D.uNoise, 0);
		let O = (e, n, r = [
			0,
			0,
			0
		], i = 0) => {
			if (t.bindBuffer(t.ARRAY_BUFFER, e.vb), t.bindBuffer(t.ELEMENT_ARRAY_BUFFER, e.ib), [
				3,
				3,
				1
			].reduce((e, n, r) => (t.enableVertexAttribArray(E.a[r]), t.vertexAttribPointer(E.a[r], n, t.FLOAT, !1, 28, e * 4), e + n), 0), t.uniform1f(D.uMat, n), t.uniform3fv(D.uOff, r), n !== jo.cloth) {
				let e = f(i);
				t.uniform3fv(D.uMetF0, e.f0), t.uniform4fv(D.uMetDif, e.dif);
			}
			t.drawElements(t.TRIANGLES, e.n, t.UNSIGNED_SHORT, 0);
		}, ee = this.meshes;
		O(ee.cloth, jo.cloth), O(ee.bar, jo.metal, [
			a - co[0],
			0,
			0
		], u), O(ee.frame, jo.metal, void 0, d), O(ee.caps, jo.cap, void 0, d), E.a.forEach((e) => t.disableVertexAttribArray(e)), t.disable(t.DEPTH_TEST);
		let k = this.lens;
		t.useProgram(k.p), t.bindBuffer(t.ARRAY_BUFFER, this.triB), t.enableVertexAttribArray(k.a), t.vertexAttribPointer(k.a, 2, t.FLOAT, !1, 0, 0), t.uniform2fv(k.u.uRes, [w, T]), t.uniform1f(k.u.uMax, Co.blur * T), t.uniform1i(k.u.uImg, 0), [[
			this.rt[0].tex,
			this.rt[1].fb,
			[1, 0],
			0
		], [
			this.rt[1].tex,
			null,
			[0, 1],
			1
		]].forEach(([e, n, r, i]) => {
			t.bindFramebuffer(t.FRAMEBUFFER, n), t.bindTexture(t.TEXTURE_2D, e), t.uniform2fv(k.u.uDir, r), t.uniform1f(k.u.uLast, i), t.drawArrays(t.TRIANGLES, 0, 3);
		}), t.disableVertexAttribArray(k.a), this.drewAt = n;
	}
};
customElements.define("guard-window", rs);
//#endregion
//#region src/guard/guard-close.js
var is = {
	hero: .1,
	read: [.1, .2],
	frame: [.02, .16],
	travel: [.12, .62],
	latch: .63,
	unlatch: .61
}, as = {
	quote: [.07, .14],
	latch: .14,
	unlatch: .16,
	travel: [.16, .45],
	frame: [.52, .73],
	line: [.52, .82]
}, os = {
	hero: .03,
	read: [.84, .9],
	shut: .965
}, ss = 180, cs = .985, ls = [
	18,
	19,
	20
], us = [
	241,
	239,
	234
], ds = [
	143,
	146,
	150
], fs = (e, t = 0, n = 1) => Math.min(n, Math.max(t, e)), ps = ([e, t], n) => fs((n - e) / (t - e)), ms = (e) => e < .5 ? 4 * e * e * e : 1 - (-2 * e + 2) ** 3 / 2, hs = (e) => 1 - (1 - e) ** 3, gs = (e) => e * e * (3 - 2 * e), _s = (e, t, n) => `rgb(${e.map((e, r) => Math.round(ls[r] + (Math.min(255, e * t) - ls[r]) * n)).join(" ")})`;
function vs(e = /* @__PURE__ */ new Date()) {
	let t = Math.PI / 180, n = 53.35, r = (Date.UTC(e.getUTCFullYear(), e.getUTCMonth(), e.getUTCDate()) - Date.UTC(e.getUTCFullYear(), 0, 0)) / 864e5, i = -23.44 * Math.cos(2 * Math.PI / 365 * (r + 10)), a = (e.getUTCHours() + e.getUTCMinutes() / 60 + -6.26 / 15 - 12) * 15, o = Math.sin(n * t) * Math.sin(i * t) + Math.cos(n * t) * Math.cos(i * t) * Math.cos(a * t), s = Math.asin(o) / t;
	return s > 2 ? {
		lux: Math.round(fs(11e4 * o * .35 * .025, 90, 2400) / 10) * 10,
		when: "day"
	} : s > -6 ? {
		lux: Math.round(fs(8 + s * 6, 4, 60)),
		when: "dusk"
	} : {
		lux: 3,
		when: "night"
	};
}
var ys = class extends HTMLElement {
	connectedCallback() {
		this.ready || (this.ready = !0, this.open = this.dataset.mode === "open", this.stage = this.querySelector(".g-close__stage"), this.blind = this.querySelector(".g-blind"), this.hero = this.querySelector(".g-close__hero"), this.scene = this.querySelector("guard-window"), !((window.A?.reduced ?? matchMedia("(prefers-reduced-motion: reduce)").matches) || !this.stage || !this.blind) && (this.drawn = !this.open && !!this.scene?.gl, this.classList.toggle("is-drawn", this.drawn), this.latched = this.open, this.snapAt = 0, this.last = "", this.open || this.setTime(), this.measure = this.measure.bind(this), this.frame = this.frame.bind(this), this.measure(), addEventListener("resize", this.measure, { passive: !0 }), this.io = new IntersectionObserver(([e]) => {
			this.on = e.isIntersecting, this.on && !this.raf && (this.raf = requestAnimationFrame(this.frame));
		}, { rootMargin: "10% 0px" }), this.io.observe(this)));
	}
	disconnectedCallback() {
		this.io?.disconnect(), removeEventListener("resize", this.measure), cancelAnimationFrame(this.raf), this.raf = 0;
	}
	setTime() {
		let e = /* @__PURE__ */ new Date(), { lux: t, when: n } = vs(e), r = e.toLocaleTimeString("en-IE", {
			hour: "2-digit",
			minute: "2-digit",
			hour12: !1
		});
		this.lux = t, this.luxOut = this.querySelector("[data-lux]");
		let i = this.querySelector("[data-clock]");
		i && (i.textContent = `${r} · ${{
			day: "daylight",
			dusk: "dusk",
			night: "street light"
		}[n]} outside`);
	}
	measure() {
		let e = this.stage.clientWidth;
		this.H = this.stage.clientHeight, this.f = parseFloat(getComputedStyle(this.blind.querySelector(".g-blind__frame")).borderTopWidth) || 12, this.inner = e - this.f * 2, this.stack = fs(this.inner * .055, 34, 84), this.pleats = Math.max(24, Math.round(this.inner / fs(e * .014, 15, 24)));
		let t = this.f * 2 + this.stack + 4;
		this.out = Math.max(e / (e - t * 2), this.H / (this.H - this.f * 2 - 4)), this.last = "";
	}
	frame(e) {
		this.raf = this.on ? requestAnimationFrame(this.frame) : 0;
		let t = this.getBoundingClientRect(), n = this.H, r = t.height - n, i = r > 0 ? fs(-t.top / r) : 0, a = fs(t.top / n), o, s, c = 0;
		if (this.drawn) {
			let e = [i.toFixed(5), n].join();
			return e === this.last ? void 0 : (this.last = e, this.drawnFrame(i, 1 - gs(fs(scrollY / (t.top + scrollY + os.hero * r)))));
		}
		if (this.open) o = 1 - hs(ps(as.frame, i)), s = cs * (1 - ms(ps(as.travel, i))), this.latched && i > as.unlatch ? this.latched = !1 : !this.latched && i <= as.latch && (this.latched = !0, this.snapAt = e);
		else {
			let n = t.top + scrollY;
			c = 1 - gs(fs(scrollY / (n + is.hero * r))), o = hs(ps(is.frame, i)), s = cs * ms(ps(is.travel, i)), !this.latched && i >= is.latch ? (this.latched = !0, this.snapAt = e) : this.latched && i < is.unlatch && (this.latched = !1);
		}
		if (this.latched) {
			let t = fs((e - this.snapAt) / ss);
			s += (1 - s) * t * t;
		}
		let l = [
			i.toFixed(4),
			a.toFixed(4),
			s.toFixed(4),
			this.inner,
			n
		].join();
		if (l === this.last) return;
		this.last = l;
		let u = this.stack + s * (this.inner - this.stack - this.f), d = u / this.pleats, f = (1 - s) ** .32, p = this.stage.style, m = (e, t) => p.setProperty(e, t);
		m("--fr", o.toFixed(4)), m("--cw", u.toFixed(1) + "px"), m("--pp", d.toFixed(2) + "px"), m("--po", gs(fs((d - 3) / 3)).toFixed(3)), m("--c-v", _s(us, .74, f)), m("--c-m", _s(us, .9, f)), m("--c-r", _s(us, 1.02, f)), m("--fc", _s(ds, 1, f)), m("--bh", (.14 * f).toFixed(3)), m("--lit", f.toFixed(3)), this.open && m("--dk", s > .6 ? "100%" : "0px");
		let h = o < .002;
		if (this.blind.style.visibility = h ? "hidden" : "", this.blind.style.transform = !h && o < 1 ? `scale(${(1 + (1 - o) * (this.out - 1)).toFixed(4)})` : "", this.open) {
			let e = gs(ps(as.quote, i));
			m("--qo", ((1 - e) * (1 - gs(fs((a - .3) / .4)))).toFixed(3)), m("--qy", (e * -24).toFixed(1) + "px"), m("--by", (gs(ps(as.line, i)) * -.18 * n).toFixed(1) + "px");
		} else {
			let e = this.latched && s > .999, t = e ? 0 : gs(ps(is.read, i));
			this.classList.toggle("is-shut", e), m("--ho", c.toFixed(3)), this.hero && (this.hero.style.visibility = c < .005 ? "hidden" : ""), this.scene && (this.scene.covered = s > .995), m("--ro", t.toFixed(3)), m("--sh", (t * f).toFixed(3)), this.luxOut && (this.luxOut.textContent = Math.round(this.lux * f).toLocaleString("en-IE"));
		}
	}
	drawnFrame(e, t) {
		let n = this.scene;
		n.drive(e);
		let r = n.light ?? 1, i = e >= os.shut, a = i ? 0 : gs(ps(os.read, e)), o = this.stage.style;
		this.classList.toggle("is-shut", i), o.setProperty("--ho", t.toFixed(3)), this.hero && (this.hero.style.visibility = t < .005 ? "hidden" : ""), o.setProperty("--ro", a.toFixed(3)), o.setProperty("--sh", (a * r).toFixed(3)), this.luxOut && (this.luxOut.textContent = Math.round(this.lux * r).toLocaleString("en-IE"));
	}
};
customElements.define("guard-close", ys);
//#endregion
//#region src/guard/guard-torch.js
var bs = (e, t = 0, n = 1) => Math.min(n, Math.max(t, e)), xs = class extends HTMLElement {
	connectedCallback() {
		this.ready || (this.ready = !0, this.media = this.querySelector(".g-torch__media"), this.plate = this.querySelector(".g-torch__plate") || this.media, this.cap = this.querySelector(".g-torch__cap"), this.spots = [...this.querySelectorAll(".g-torch__spots li")].map((e) => ({
			li: e,
			x: parseFloat(e.style.getPropertyValue("--x")) / 100,
			y: parseFloat(e.style.getPropertyValue("--y")) / 100
		})), this.media && this.spots.length && (this.spots.forEach((e) => e.li.classList.toggle("is-left", e.x > .7)), this.narrow = matchMedia("(max-width: 899px)"), this.reduced = window.A?.reduced ?? matchMedia("(prefers-reduced-motion: reduce)").matches, this.pos = {
			x: this.spots[0].x,
			y: this.spots[0].y
		}, this.goal = { ...this.pos }, this.used = !1, this.wander = 1, this.lastStep = 0, this.frame = this.frame.bind(this), this.media.addEventListener("pointermove", (e) => {
			e.pointerType === "mouse" && this.aim(e);
		}), this.media.addEventListener("pointerdown", (e) => {
			e.pointerType !== "mouse" && this.aim(e);
		}), this.spots.forEach((e) => {
			let t = e.li.querySelector("button");
			e.name = t.querySelector("b")?.textContent || "", e.line = t.querySelector("span")?.textContent || "";
			let n = () => this.goTo(e);
			t.addEventListener("click", n), t.addEventListener("focus", n);
		}), this.cap?.addEventListener("click", () => this.goTo(this.spots[((this.capped ?? -1) + 1) % this.spots.length])), this.io = new IntersectionObserver(([e]) => {
			this.on = e.isIntersecting, this.on && this.measure(), this.kick();
		}, { threshold: .15 }), this.io.observe(this.media), this.measure = () => {
			this.rect = this.plate.getBoundingClientRect(), this.rad = parseFloat(getComputedStyle(this).getPropertyValue("--tr")) * innerWidth / 100 * .55 || 120;
		}, addEventListener("resize", () => {
			this.measure(), this.paint();
		}, { passive: !0 }), this.measure(), this.paint()));
	}
	goTo(e) {
		this.take(), this.goal = {
			x: e.x,
			y: e.y
		}, this.kick();
	}
	disconnectedCallback() {
		this.io?.disconnect(), cancelAnimationFrame(this.raf), this.raf = 0;
	}
	take() {
		this.used || (this.used = !0, this.classList.add("is-used"));
	}
	aim(e) {
		let t = this.plate.getBoundingClientRect();
		this.take(), this.goal = {
			x: bs((e.clientX - t.left) / t.width),
			y: bs((e.clientY - t.top) / t.height)
		}, this.kick();
	}
	kick() {
		this.on && !this.raf && (this.raf = requestAnimationFrame(this.frame));
	}
	frame(e) {
		if (this.raf = 0, !this.on) return;
		if (this.lastStep ||= e, !this.used && !this.reduced && e - this.lastStep > (this.narrow.matches ? 4200 : 2600)) {
			this.lastStep = e;
			let t = this.spots[this.wander++ % this.spots.length];
			this.goal = {
				x: t.x,
				y: t.y
			};
		}
		let t = this.reduced ? 1 : this.used ? .16 : .022;
		this.pos.x += (this.goal.x - this.pos.x) * t, this.pos.y += (this.goal.y - this.pos.y) * t, this.paint(), (Math.abs(this.goal.x - this.pos.x) + Math.abs(this.goal.y - this.pos.y) > 5e-4 || !this.used && !this.reduced) && (this.raf = requestAnimationFrame(this.frame));
	}
	paint() {
		let e = this.rect;
		this.style.setProperty("--tx", (this.pos.x * 100).toFixed(2) + "%"), this.style.setProperty("--ty", (this.pos.y * 100).toFixed(2) + "%");
		let t = this.rad, n = this.spots.map((t) => Math.hypot((t.x - this.pos.x) * e.width, (t.y - this.pos.y) * e.height)), r = Math.min(...n);
		this.spots.forEach((e, i) => e.li.classList.toggle("is-lit", n[i] < t && (!this.narrow.matches || n[i] === r))), this.narrow.matches && this.caption(n.indexOf(r));
	}
	caption(e) {
		if (!this.cap || e === this.capped) return;
		this.capped = e;
		let t = this.spots[e], n = String(e + 1).padStart(2, "0"), r = String(this.spots.length).padStart(2, "0"), i = () => {
			this.cap.innerHTML = `<span class="g-torch__n">${n} / ${r}<i>Next</i></span><b>${t.name}</b><span>${t.line}</span>`, this.cap.classList.remove("is-swap");
		};
		clearTimeout(this.swap), !this.cap.innerHTML || this.reduced ? i() : (this.cap.classList.add("is-swap"), this.swap = setTimeout(i, 220));
	}
};
customElements.define("guard-torch", xs);
//#endregion
//#region src/guard/guard-cell.js
var Q = "236, 234, 229", Ss = "255, 244, 222", Cs = "255, 146, 78", ws = 3, Ts = .34, Es = 240, Ds = (e, t, n) => Math.min(n, Math.max(t, e)), $ = (e, t) => e + Math.random() * (t - e);
function Os(e, t = 48) {
	let n = document.createElement("canvas");
	n.width = n.height = t;
	let r = n.getContext("2d"), i = t / 2, a = r.createRadialGradient(i, i, 0, i, i, i);
	return a.addColorStop(0, `rgba(${e}, 1)`), a.addColorStop(.3, `rgba(${e}, .5)`), a.addColorStop(1, `rgba(${e}, 0)`), r.fillStyle = a, r.fillRect(0, 0, t, t), n;
}
var ks = class extends HTMLElement {
	connectedCallback() {
		this.ready || (this.ready = !0, this.fig = this.querySelector(".g-cell__fig"), this.under = this.querySelector(".g-cell__still"), this.canvas = this.querySelector(".g-cell__canvas"), this.ctx = this.canvas?.getContext("2d"), this.ctx && this.under && (this.tabs = [...this.querySelectorAll("[role=\"tab\"]")], this.says = [...this.querySelectorAll("[data-for]")], this.reduced = window.A?.reduced ?? matchMedia("(prefers-reduced-motion: reduce)").matches, this.mode = this.dataset.mode || "light", this.w = {
			light: 0,
			heat: 0,
			sound: 0
		}, this.w[this.mode] = 1, this.parts = [], this.waves = [], this.glints = [], this.motes = [], this.heat = [], this.t = 0, this.spawn = 0, this.waveIn = 0, this.dots = {
			sun: Os(Ss),
			warm: Os(Cs),
			paper: Os(Q),
			glint: Os("255, 252, 246")
		}, this.frame = this.frame.bind(this), this.tabs.forEach((e) => e.addEventListener("click", () => this.set(e.dataset.mode))), this.querySelector("[role=\"tablist\"]")?.addEventListener("keydown", (e) => {
			if (e.key !== "ArrowRight" && e.key !== "ArrowLeft") return;
			let t = this.tabs.findIndex((e) => e.dataset.mode === this.mode), n = this.tabs.length, r = this.tabs[(t + (e.key === "ArrowRight" ? 1 : n - 1)) % n];
			this.set(r.dataset.mode), r.focus();
		}), this.size = this.size.bind(this), new ResizeObserver(this.size).observe(this.canvas), this.io = new IntersectionObserver(([e]) => {
			this.on = e.isIntersecting, this.on && !this.raf && (this.prev = 0, this.raf = requestAnimationFrame(this.frame));
		}, { threshold: .05 }), this.io.observe(this.canvas)));
	}
	disconnectedCallback() {
		this.io?.disconnect(), cancelAnimationFrame(this.raf), this.raf = 0;
	}
	set(e) {
		if (e in this.w && e !== this.mode) {
			this.mode = this.dataset.mode = e, this.tabs.forEach((t) => {
				let n = t.dataset.mode === e;
				t.setAttribute("aria-selected", n), t.tabIndex = n ? 0 : -1;
			}), this.says.forEach((t) => {
				t.dataset.for === e ? (t.style.transition = "none", t.classList.remove("is-out"), t.offsetWidth, t.style.transition = "", t.classList.add("is-on")) : t.classList.contains("is-on") && (t.classList.remove("is-on"), t.classList.add("is-out"));
			});
			for (let e of this.parts) e.kill = !0;
			for (let e of this.waves) e.kill = !0;
			this.W && (this.reduced ? this.still() : this.seed(e));
		}
	}
	size() {
		let e = this.canvas.getBoundingClientRect();
		if (!e.width) return;
		let t = this.dpr = Math.min(1.5, devicePixelRatio || 1), n = this.W = e.width, r = this.H = e.height;
		for (let e of [this.canvas, this.under]) e.width = Math.round(n * t), e.height = Math.round(r * t);
		this.ctx.setTransform(t, 0, 0, t, 0, 0), this.gx = n * .19, this.gap = Math.max(6, n * .012), this.xo = this.gx - this.gap - 18, this.xb = n * .52, this.xf = n * .66, this.d = (this.xf - this.xb) * .28, this.xi = this.xf + 16, this.yt = r * .16, this.yb = r * .78, this.ch = (this.yb - this.yt) / ws, this.wall = Math.min(48, r * .1), this.sx = -n * .04, this.sy = (this.yt + this.yb) / 2, this.maxR = Math.hypot(n - this.sx, r / 2), this.paths(), this.paintStill();
		let i = this.fig.style;
		i.setProperty("--l1", `${(this.gx - this.gap / 2) / n * 100}%`), i.setProperty("--l2", `${(this.xb + this.xf) / 2 / n * 100}%`), i.setProperty("--l3", `${(this.xi + n) / 2 / n * 100}%`), i.setProperty("--lt", `${(this.yb + 12 + this.wall + 10) / r * 100}%`), this.heat = this.hex.map(() => 0), this.motes = Array.from({ length: Ds(Math.round(n * r / 9e3), 20, 56) }, () => this.mote()), this.reduced ? this.still() : !this.parts.length && !this.waves.length && this.seed(this.mode);
	}
	zig(e) {
		let t = ((e - this.yt) % this.ch + this.ch) % this.ch / this.ch;
		return this.d * Math.abs(t - .5) * 2;
	}
	backAt(e) {
		return this.xb + this.zig(Ds(e, this.yt, this.yb));
	}
	frontAt(e) {
		return this.xf - this.zig(Ds(e, this.yt, this.yb));
	}
	rowAt(e) {
		return Ds(Math.floor((e - this.yt) / this.ch), 0, 2);
	}
	inOpening(e) {
		return e > this.yt + 2 && e < this.yb - 2;
	}
	paths() {
		let { xb: e, xf: t, d: n, ch: r, yt: i } = this;
		this.hex = [], this.cells = new Path2D(), this.back = new Path2D(), this.lining = new Path2D(), this.back.moveTo(e + n, i), this.lining.moveTo(e + n + 4.5, i);
		for (let a = 0; a < ws; a++) {
			let o = i + a * r, s = o + r / 2, c = o + r, l = new Path2D();
			l.moveTo(e + n, o), l.lineTo(e, s), l.lineTo(e + n, c), l.lineTo(t - n, c), l.lineTo(t, s), l.lineTo(t - n, o), l.closePath(), this.hex.push(l), this.cells.addPath(l), this.back.lineTo(e, s), this.back.lineTo(e + n, c), this.lining.lineTo(e + 4.5, s), this.lining.lineTo(e + n + 4.5, c);
		}
	}
	paintStill() {
		let { W: e, H: t, dpr: n, gx: r, gap: i, xb: a, xf: o, yt: s, yb: c, xo: l, xi: u } = this, d = this.under.getContext("2d");
		d.setTransform(n, 0, 0, n, 0, 0), d.clearRect(0, 0, e, t), d.lineJoin = "round";
		let f = s - 12, p = c + 12, m = this.wall;
		for (let [e, t] of [[f, -1], [p, 1]]) {
			let n = e + t * m, r = d.createLinearGradient(0, e, 0, n);
			r.addColorStop(0, `rgba(${Q}, .3)`), r.addColorStop(1, `rgba(${Q}, 0)`), d.strokeStyle = r, d.lineWidth = 1, d.beginPath(), d.moveTo(l, n), d.lineTo(l, e), d.lineTo(u, e), d.lineTo(u, n), d.stroke();
			let i = d.createLinearGradient(0, e, 0, n);
			i.addColorStop(0, `rgba(${Q}, .09)`), i.addColorStop(1, `rgba(${Q}, 0)`), d.save(), d.beginPath(), d.rect(l, Math.min(e, n), u - l, m), d.clip(), d.strokeStyle = i, d.beginPath();
			for (let t = l - m; t < u; t += 7) d.moveTo(t, e), d.lineTo(t + m, n);
			d.stroke(), d.restore();
		}
		for (let [e, t] of [[f, s], [c, p]]) d.fillStyle = `rgba(${Q}, .14)`, d.fillRect(r - i - 4, e, i + 8, t - e), d.strokeStyle = `rgba(${Q}, .36)`, d.lineWidth = 1, d.strokeRect(r - i - 4, e, i + 8, t - e);
		d.fillStyle = "rgba(190, 210, 224, .06)", d.fillRect(r - i, s, i, c - s), d.lineWidth = 1.5, d.strokeStyle = "rgba(190, 210, 224, .55)";
		for (let e of [r - i, r]) d.beginPath(), d.moveTo(e, s), d.lineTo(e, c), d.stroke();
		let h = d.createLinearGradient(0, s, 0, c);
		[
			[0, 0],
			[.28, .26],
			[.5, 0],
			[.74, .14],
			[1, 0]
		].forEach(([e, t]) => h.addColorStop(e, `rgba(255, 255, 255, ${t})`)), d.lineWidth = 1, d.strokeStyle = h, d.beginPath(), d.moveTo(r - i + 2.5, s), d.lineTo(r - i + 2.5, c), d.stroke();
		for (let [e, t] of [[f, s], [c, p]]) d.fillStyle = "rgba(143, 146, 150, .5)", d.fillRect(a - 3, e, o - a + 6, t - e), d.fillStyle = "rgba(255, 255, 255, .16)", d.fillRect(a - 3, e, o - a + 6, 1);
		h = d.createLinearGradient(a, 0, o, 0), h.addColorStop(0, `rgba(${Q}, .1)`), h.addColorStop(.6, `rgba(${Q}, .035)`), h.addColorStop(1, `rgba(${Q}, .02)`), d.fillStyle = h, d.fill(this.cells), d.save(), d.clip(this.cells);
		for (let [e, t] of [[14, .12], [6, .22]]) d.lineWidth = e, d.strokeStyle = `rgba(0, 0, 0, ${t})`, d.stroke(this.cells);
		d.restore(), d.lineWidth = 1.2, d.strokeStyle = `rgba(${Q}, .34)`, d.stroke(this.cells), d.lineWidth = 1.8, d.strokeStyle = "rgba(250, 248, 243, .85)", d.stroke(this.back), h = d.createLinearGradient(0, s, 0, c);
		for (let e = 0; e <= 8; e++) h.addColorStop(e / 8, e % 2 ? "rgba(150, 158, 170, .5)" : "rgba(228, 233, 240, .95)");
		d.lineWidth = 1.2, d.strokeStyle = h, d.stroke(this.lining), h = this.ctx.createLinearGradient(a, 0, o, 0), h.addColorStop(0, `rgba(${Cs}, .34)`), h.addColorStop(.5, `rgba(${Cs}, .12)`), h.addColorStop(1, `rgba(${Cs}, .03)`), this.cellWarm = h, h = this.ctx.createLinearGradient(0, 0, 0, t), [
			[0, 0],
			[(s - 56) / t, 0],
			[s / t, 1],
			[c / t, 1],
			[(c + 56) / t, 0],
			[1, 0]
		].forEach(([e, t]) => h.addColorStop(Ds(e, 0, 1), `rgba(${Q}, ${t})`)), this.ink = h;
		let g = c - s, _ = this.haze ||= document.createElement("canvas"), v = n / 2;
		_.width = Math.round((a - r) * v), _.height = Math.round(g * 2 * v);
		let y = _.getContext("2d");
		y.setTransform(v, 0, 0, v, 0, 0), y.clearRect(0, 0, a - r, g * 2), y.lineWidth = 10, y.strokeStyle = `rgba(${Cs}, .04)`;
		for (let e = 0; e < 5; e++) {
			let t = (a - 14 - r) * (e + .5) / 5;
			y.beginPath();
			for (let n = 0; n <= g * 2; n += 10) {
				let r = t + Math.sin(n / g * Math.PI * 4 + e * 1.7) * 4;
				n ? y.lineTo(r, n) : y.moveTo(r, n);
			}
			y.stroke();
		}
	}
	mote() {
		let e = $(this.yt + 8, this.yb - 8);
		return {
			bx: $(this.gx + 8, this.backAt(e) - 8),
			by: e,
			x: 0,
			y: 0,
			z: Math.random(),
			ph: $(0, 6.28)
		};
	}
	addLight() {
		let e = Math.random(), t = this.W * (.5 + e * .25);
		this.parts.push({
			k: "light",
			x: $(-40, 0),
			y: $(this.yt + 3, this.yb - 3),
			vx: t,
			vy: t * $(-.04, .04),
			a: 1,
			z: e,
			s: 0
		});
	}
	addHeat() {
		this.parts.push({
			k: "heat",
			x: $(-30, this.xo * .6),
			y: $(this.yt + 6, this.yb - 6),
			vx: this.W * $(.08, .13),
			vy: 0,
			a: 0,
			z: Math.random(),
			s: 0,
			ph: $(0, 6.28)
		});
	}
	seed(e) {
		if (this.seeding = !0, e === "sound") {
			for (let e = this.maxR; e > 0; e -= this.W * .45 * Ts) this.waves.push({
				r: e,
				a: 1,
				seed: $(0, 99)
			});
			this.waveIn = Ts;
		} else {
			let t = e === "light" ? 56 : 38, n = e === "light" ? 1.3 : 4.5;
			for (let r = 0; r < t; r++) {
				e === "light" ? this.addLight() : this.addHeat();
				let t = this.parts[this.parts.length - 1];
				for (let e = $(0, n); e > 0; e -= 1 / 30) this.move(t, Math.min(e, 1 / 30));
			}
		}
		this.seeding = !1;
	}
	move(e, t) {
		let { W: n } = this;
		if (e.x > this.xo && e.x < this.xi && !this.inOpening(e.y)) {
			e.a = 0;
			return;
		}
		if (e.k === "light") {
			e.x += e.vx * t, e.y += e.vy * t;
			let n = this.backAt(e.y) - 1;
			e.s === 0 && e.x >= n && (e.x = n, e.vx *= -.8, e.vy += $(-.2, .2) * Math.abs(e.vx), e.s = 1, !this.seeding && Math.random() < .5 && this.glints.push({
				x: n + 2,
				y: e.y,
				a: .45 + e.z * .45
			})), e.s === 1 && (e.a -= t * 1.4);
			return;
		}
		let r = Math.sin(this.t * 1.6 + e.ph) * 12;
		if (e.s === 0) e.x += e.vx * t, e.y += r * t, e.a = Math.min(.9, e.a + t * 1.2), e.x >= this.backAt(e.y) + 3 && (Math.random() < .2 ? (e.s = 2, e.vx = n * .015, e.vy = $(-1, 1) * n * .012) : (e.s = 1, e.vx = -e.vx * .45));
		else if (e.s === 1) e.x += e.vx * t, e.y += r * t, e.a -= t * .45;
		else if (e.s === 2) {
			e.vx += $(-1, 1) * n * .25 * t, e.vy += $(-1, 1) * n * .25 * t, e.vx *= 1 - t * 2, e.vy *= 1 - t * 2, e.x += e.vx * t, e.y = Ds(e.y + e.vy * t, this.yt + 4, this.yb - 4);
			let r = this.backAt(e.y) + 6, i = this.frontAt(e.y) - 5;
			e.x < r && (e.x = r, e.vx = Math.abs(e.vx)), e.x > i && (Math.random() < .3 ? (e.s = 3, e.vx = n * .03, e.a *= .45) : (e.x = i, e.vx = -Math.abs(e.vx)));
			let a = this.rowAt(e.y);
			this.heat[a] = Math.min(1, this.heat[a] + t * .5), e.a -= t * .3;
		} else e.x += e.vx * t, e.y += r * t * .5, e.a -= t * .6;
	}
	step(e) {
		let { W: t, H: n } = this;
		this.t += e;
		for (let t in this.w) this.w[t] += (+(t === this.mode) - this.w[t]) * Math.min(1, e * 5);
		if (this.mode === "sound") this.waveIn -= e, this.waveIn <= 0 && (this.waveIn += Ts, this.waves.push({
			r: 0,
			a: 1,
			seed: $(0, 99)
		}));
		else {
			for (this.spawn += e * (this.mode === "light" ? 46 : 10); this.spawn >= 1 && this.parts.length < Es;) this.spawn--, this.mode === "light" ? this.addLight() : this.addHeat();
			this.spawn %= 1;
		}
		for (let t of this.parts) this.move(t, e), t.kill && (t.a -= e * 3);
		this.parts = this.parts.filter((e) => e.a > 0 && e.x > -60 && e.x < t + 40 && e.y > -40 && e.y < n + 40);
		for (let t of this.glints) t.a -= e * 4;
		this.glints = this.glints.filter((e) => e.a > 0);
		for (let t = 0; t < this.heat.length; t++) this.heat[t] = Math.max(0, this.heat[t] - e * .1);
		for (let n of this.waves) n.r += e * t * .45, n.kill && (n.a -= e * 3);
		this.waves = this.waves.filter((e) => e.a > 0 && e.r < this.maxR);
		for (let t of this.motes) {
			t.bx += Math.sin(this.t * .3 + t.ph) * e * 3, t.by += (Math.cos(this.t * .23 + t.ph) * 4 + this.w.heat * Math.sin(this.t * 1.6 + t.ph) * 10) * e, t.by < this.yt + 8 ? t.by = this.yb - 8 : t.by > this.yb - 8 && (t.by = this.yt + 8), t.bx = Ds(t.bx, this.gx + 8, this.backAt(t.by) - 8);
			let n = 0;
			for (let e of this.waves) {
				let r = e.r - Math.hypot(t.bx - this.sx, t.by - this.sy);
				r > -24 && r < 24 && (n += Math.sin(r / 24 * Math.PI) * 3.2 * e.a);
			}
			n *= this.w.sound;
			let r = t.bx - this.sx, i = t.by - this.sy, a = Math.hypot(r, i) || 1;
			t.x = t.bx + r / a * n, t.y = t.by + i / a * n;
		}
	}
	draw() {
		let { ctx: e, W: t, H: n, w: r, t: i, gx: a, xb: o, yt: s, yb: c, dots: l } = this;
		if (e.globalCompositeOperation = "source-over", e.globalAlpha = 1, e.clearRect(0, 0, t, n), e.globalCompositeOperation = "lighter", r.heat > .01) {
			let t = c - s;
			e.save(), e.beginPath(), e.rect(a + 2, s, o - a - 2, t), e.clip(), e.globalAlpha = r.heat, e.drawImage(this.haze, a, s - i * 16 % t, o - a, t * 2), e.restore(), e.fillStyle = this.cellWarm;
			for (let t = 0; t < this.hex.length; t++) this.heat[t] > .01 && (e.globalAlpha = r.heat * this.heat[t], e.fill(this.hex[t]));
			e.globalAlpha = 1;
		}
		this.waves.length && this.drawWaves();
		for (let t of this.motes) {
			let n = 3 + t.z * 4, a = t.x - n / 2, o = t.y - n / 2, s = .75 + Math.sin(i * 2.1 + t.ph * 3) * .25;
			r.light > .01 && (e.globalAlpha = r.light * (.25 + t.z * .45) * s, e.drawImage(l.sun, a, o, n, n)), r.heat > .01 && (e.globalAlpha = r.heat * (.12 + t.z * .2), e.drawImage(l.warm, a, o, n, n)), r.sound > .01 && (e.globalAlpha = r.sound * (.2 + t.z * .3), e.drawImage(l.paper, a, o, n, n));
		}
		let u = t * .1;
		e.lineCap = "round", e.strokeStyle = `rgb(${Ss})`;
		for (let t of this.parts) {
			let n = Ds(t.a, 0, 1) * Ds(t.x / u, 0, 1);
			if (!(n <= 0)) {
				if (t.k === "light") {
					let r = (18 + t.z * 38) * (t.s ? .6 : 1) / Math.hypot(t.vx, t.vy), i = n * (.32 + t.z * .55);
					e.beginPath(), e.moveTo(t.x - t.vx * r, t.y - t.vy * r), e.lineTo(t.x, t.y), t.z > .65 && (e.globalAlpha = i * .06, e.lineWidth = 4 + t.z * 2, e.stroke()), e.globalAlpha = i, e.lineWidth = .5 + t.z * .9, e.stroke();
				} else {
					let r = (t.s === 2 ? 4 : 7) + t.z * (t.s === 2 ? 4 : 9);
					e.globalAlpha = n * (.22 + t.z * .2) * (t.s === 3 ? .5 : 1), e.drawImage(l.warm, t.x - r * 1.5, t.y - r * 1.5, r * 3, r * 3);
				}
			}
		}
		for (let t of this.glints) e.globalAlpha = t.a, e.drawImage(l.glint, t.x - 7, t.y - 7, 14, 14);
		e.globalAlpha = 1, e.globalCompositeOperation = "source-over";
	}
	drawWaves() {
		let { ctx: e, W: t, H: n, sx: r, sy: i, xb: a, xf: o, d: s, xo: c, xi: l, yt: u, yb: d, t: f } = this, p = this.w.sound, m = this.waves.map((e) => [e, e.a * p * (1 - e.r / this.maxR)]).filter(([e, t]) => e.r > 0 && t > .01), h = (e, t = u - 56, n = d + 56) => [Math.asin(Ds((t - i) / e, -1, 1)), Math.asin(Ds((n - i) / e, -1, 1))], g = (t, [n, a], o = r) => {
			e.beginPath(), e.arc(o, i, t, n, a);
		}, _ = (t, n, r, i, a) => {
			e.save(), e.beginPath(), e.rect(t, n, r, i), e.clip(), a(), e.restore();
		};
		e.strokeStyle = this.ink;
		let v = () => {
			for (let [t, n] of m) if (g(t.r, h(t.r)), e.lineWidth = 1.5, e.globalAlpha = .6 * n, e.stroke(), t.r > 8 && (g(t.r - 8, h(t.r - 8)), e.lineWidth = 1, e.globalAlpha = .2 * n, e.stroke()), t.r > a - r) {
				let [i, o] = h(t.r);
				g(t.r, [Math.PI - o, Math.PI - i], 2 * a - r), e.lineWidth = 1, e.globalAlpha = .13 * n, e.stroke();
			}
		};
		_(-20, -20, c + 20, n + 40, v), _(c, u, a + s - c, d - u, v), e.save(), e.clip(this.cells), e.lineWidth = 1.1;
		for (let [t, n] of m) {
			let [a, o] = h(t.r, u, d);
			e.beginPath();
			for (let n = 0; n <= 24; n++) {
				let s = a + (o - a) * n / 24, c = t.r + Math.sin(s * 37 + t.seed + f * 9) * Math.sin(s * 13 + f * 5) * 5, l = r + Math.cos(s) * c, u = i + Math.sin(s) * c;
				n ? e.lineTo(l, u) : e.moveTo(l, u);
			}
			e.globalAlpha = .34 * n, e.stroke();
		}
		e.restore();
		let y = () => {
			e.setLineDash([2, 6]), e.lineWidth = 1;
			for (let [t, n] of m) g(t.r, h(t.r)), e.globalAlpha = .16 * n, e.stroke();
		};
		_(o, u, l - o, d - u, y), _(l, -20, t - l + 20, n + 40, y), e.lineWidth = 1.4, e.strokeStyle = `rgb(${Q})`;
		for (let t = 0; t < this.hex.length; t++) {
			let n = u + (t + .5) * this.ch, o = Math.hypot(a - r, n - i), s = 0;
			for (let e of this.waves) s = Math.max(s, (1 - Math.abs(e.r - o) / 18) * e.a);
			s > 0 && (e.globalAlpha = .34 * s * p, e.stroke(this.hex[t]));
		}
		e.globalAlpha = 1;
	}
	still() {
		this.parts = [], this.waves = [], this.glints = [];
		for (let e in this.w) this.w[e] = +(e === this.mode);
		this.seed(this.mode), this.step(0), this.draw();
	}
	frame(e) {
		if (this.raf = 0, !this.on || !this.W) return;
		if (this.reduced) {
			this.still();
			return;
		}
		let t = this.prev ? Math.min(.05, (e - this.prev) / 1e3) : 1 / 60;
		this.prev = e, this.step(t), this.draw(), this.raf = requestAnimationFrame(this.frame);
	}
};
customElements.define("guard-cell", ks);
//#endregion
//#region src/guard/guard-buy.js
var As = (e, t, n) => Math.min(n, Math.max(t, e)), js = [
	"Graphite",
	"Quartz",
	"Navy",
	"Titanium"
], Ms = {
	rtl: "Right to left",
	ltr: "Left to right",
	ttb: "Top to bottom"
}, Ns = {
	rtl: "folded to the right",
	ltr: "folded to the left",
	ttb: "folded to the top"
}, Ps = {
	diy: 189,
	pro: 238
}, Fs = window.AURA_ASSETS || "assets/img/guard2/", Is = (e) => window.A?.fmt ? A.fmt(e) : "€" + e, Ls = (e) => `${Math.round(e).toLocaleString("en-IE")}`, Rs = (e) => ({
	"g-frame": "frame",
	"g-cloth": "cloth",
	dir: "dir",
	fit: "fit",
	"properties[Frame]": "frame",
	"properties[Fabric]": "cloth",
	"properties[Opening]": "dir"
})[e], zs = () => window.AURA_SHOPIFY ? window.A?.byHandle("guard-2")?.price || [] : [Ps.pro, Ps.diy], Bs = class extends HTMLElement {
	connectedCallback() {
		if (this.ready) return;
		this.ready = !0;
		let e = (e) => this.querySelector(e);
		this.box = e("[data-view-box]"), this.inW = e("[data-w]"), this.inH = e("[data-h]"), this.form = e("[data-buy-form]"), this.reduced = window.A?.reduced ?? matchMedia("(prefers-reduced-motion: reduce)").matches, this.state = {
			frame: "Titanium",
			cloth: "Quartz",
			dir: "rtl",
			w: 1200,
			h: 1400,
			fit: "diy",
			view: "room"
		}, this.want = this.src();
		for (let t of ["frame", "cloth"]) e(`[data-chips="${t}"] input`) || (e(`[data-chips="${t}"]`).innerHTML = js.map((e) => `<label title="${e}"><input type="radio" name="g-${t}" value="${e}" ${e === this.state[t] ? "checked" : ""} aria-label="${e}"><span class="g-chip g-chip--${t} g-chip--${e.toLowerCase()}"></span></label>`).join(""));
		this.form.addEventListener("change", (e) => {
			let t = e.target, n = Rs(t.name);
			n && (this.state[n] = t.dataset.dir || t.value, this.render());
		}), this.form.addEventListener("pointerover", (e) => {
			let t = e.target.closest("label")?.querySelector("input"), n = t && Rs(t.name);
			n && n !== "fit" && (new Image().src = this.src({
				...this.state,
				[n]: t.dataset.dir || t.value
			}));
		}), this.querySelectorAll("[data-view]").forEach((e) => e.addEventListener("click", () => {
			this.state.view = e.dataset.view, this.render();
		}));
		let t = () => this.setSize(+this.inW.value || this.state.w, +this.inH.value || this.state.h);
		for (let e of [this.inW, this.inH]) e.addEventListener("change", t), e.addEventListener("input", () => {
			+e.value >= 300 && t();
		});
		this.measure(), this.form.addEventListener("submit", (e) => {
			e.preventDefault(), this.add();
		}), this.render();
	}
	src(e = this.state, t = e.view) {
		return `${Fs}${e.frame.toLowerCase()}-${e.cloth.toLowerCase()}-${e.dir}-${t}.webp`;
	}
	setSize(e, t) {
		let n = As(Math.round(e), 300, 2500), r = As(Math.round(t), 300, 2500), i = n !== this.state.w || r !== this.state.h;
		if (this.state.w = n, this.state.h = r, document.activeElement !== this.inW && (this.inW.value = n), document.activeElement !== this.inH && (this.inH.value = r), this.render(), i) {
			let e = this.querySelector(".g-buy__price");
			e.classList.remove("is-pulse"), e.offsetWidth, e.classList.add("is-pulse");
		}
	}
	render() {
		let e = this.state, t = (e) => this.querySelector(e);
		t("[data-name-frame]").textContent = e.frame, t("[data-name-cloth]").textContent = e.cloth, t("[data-size-say]").textContent = `${Ls(e.w)} × ${Ls(e.h)} mm`;
		let [n, r] = zs(), i = e.fit === "pro" ? n : r;
		if (t("[data-price-say]").textContent = r == null ? "—" : Is(r), t("[data-total]").textContent = i == null ? "—" : Is(i), window.AURA_SHOPIFY) {
			this.querySelectorAll("[data-total]").forEach((e) => {
				e.textContent = i == null ? "—" : Is(i);
			}), this.querySelectorAll("[data-fit-price]").forEach((e) => {
				let t = e.dataset.fitPrice === "pro" ? n : r;
				e.textContent = t == null ? "—" : Is(t);
			});
			let a = window.A.Cart.variantFor("guard-2", e.fit, "");
			t("[data-guard-variant]").value = a?.id || "", t("[type=\"submit\"]").disabled = !a?.available || this.adding, document.querySelectorAll("[data-guard-price=\"diy\"]").forEach((e) => {
				e.textContent = r == null ? "—" : Is(r);
			}), document.querySelectorAll("[data-guard-fitting-extra]").forEach((e) => {
				e.textContent = n == null || r == null ? "—" : Is(n - r);
			});
		}
		this.querySelectorAll("[data-view]").forEach((t) => {
			t.setAttribute("aria-pressed", t.dataset.view === e.view);
			let n = t.querySelector("img"), r = this.src(e, t.dataset.view);
			n.getAttribute("src") !== r && (n.src = r);
		}), this.show();
	}
	show() {
		let e = this.state, t = this.src();
		if (this.want === t) return;
		this.want = t;
		let n = new Image();
		n.className = `g-buy__img g-buy__img--${e.view}`, n.width = 1080, n.height = 864, n.src = t, n.alt = e.view === "room" ? `Guard 2 in a window, ${e.frame} frame and ${e.cloth} fabric, ${Ns[e.dir]}` : `Guard 2 shut, ${e.frame} frame and ${e.cloth} fabric, opening ${Ms[e.dir].toLowerCase()}`, n.decode().catch(() => {}).then(() => {
			if (this.want !== t) return;
			this.box.append(n);
			let e = () => {
				for (; n.isConnected && n.previousElementSibling;) n.previousElementSibling.remove();
			};
			this.reduced ? (n.classList.add("is-on"), e()) : (requestAnimationFrame(() => requestAnimationFrame(() => n.classList.add("is-on"))), n.addEventListener("transitionend", e, { once: !0 }));
		});
	}
	measure() {
		let e = Object.fromEntries([...this.querySelectorAll("[data-m]")].map((e) => [e.dataset.m, e])), t = this.querySelector("[data-m-out]"), n = (t) => {
			let n = parseFloat(e[t].value);
			return n > 0 ? n : null;
		}, r = (e) => {
			let t = e.map(n);
			return t.every((e) => e != null) ? Math.min(...t) : null;
		};
		this.querySelector("[data-three]").addEventListener("input", () => {
			let e = r([
				"wt",
				"wm",
				"wb"
			]), i = r([
				"hl",
				"hm",
				"hr"
			]), a = n("d"), o = n("o") || 0;
			(e != null || i != null) && this.setSize(e ?? this.state.w, i ?? this.state.h);
			let s = "", c = "";
			a != null && (a < 30 ? (s = `${Ls(a)} mm deep: Guard needs 30 mm, so it won’t fit this recess.`, c = "no") : a - o < 30 ? (s = "Deep enough, but the handle leaves less than 30 mm clear. Ask us before you order.", c = "no") : (s = `It fits, with ${Ls(a - o)} mm clear.`, c = "ok")), e != null && i != null && (s = `Made to ${Ls(e)} × ${Ls(i)} mm. ${s}`), t.textContent = s.trim(), t.dataset.tone = c;
		});
	}
	async add() {
		let e = this.state, t = window.A;
		if (!t?.Cart) return;
		if (window.AURA_SHOPIFY) {
			if (this.adding || !this.form.reportValidity()) return;
			let n = {
				Fabric: e.cloth,
				Frame: e.frame,
				Size: `${Ls(e.w)} × ${Ls(e.h)} mm`,
				Opening: Ms[e.dir]
			}, r = {
				wt: "Width top",
				wm: "Width middle",
				wb: "Width bottom",
				hl: "Height left",
				hm: "Height middle",
				hr: "Height right",
				d: "Recess depth",
				o: "Handle projection"
			};
			this.querySelectorAll("[data-m]").forEach((e) => {
				e.value !== "" && (n[r[e.dataset.m]] = `${Ls(+e.value)} mm`);
			}), this.adding = !0, this.render();
			try {
				await t.Cart.add("guard-2", e.fit, "", 1, n) !== !1 && t.openCart();
			} finally {
				this.adding = !1, this.render();
			}
			return;
		}
		let n = `${e.frame} frame · ${e.cloth} fabric · ${Ms[e.dir]} · ${Ls(e.w)} × ${Ls(e.h)} mm`;
		t.Cart.add("guard-2", e.fit === "pro" ? "pro" : "diy", n), t.toast("<b>Guard 2</b> added to cart", [
			"View cart",
			"#",
			"cart-open"
		]);
	}
};
customElements.define("guard-buy", Bs), document.querySelectorAll("[data-noon]").forEach((e) => {
	e.addEventListener("change", (t) => {
		let n = t.target.value;
		e.querySelectorAll("[data-shot]").forEach((e) => e.classList.toggle("is-on", e.dataset.shot === n)), e.querySelectorAll(".g-noon__say [data-for]").forEach((e) => {
			e.hidden = e.dataset.for !== n;
		});
	});
}), document.querySelectorAll("[data-pick-pro]").forEach((e) => e.addEventListener("click", () => {
	let e = document.querySelector("guard-buy input[name=\"fit\"][value=\"pro\"]");
	e && !e.checked && (e.checked = !0, e.dispatchEvent(new Event("change", { bubbles: !0 })));
}));
var Vs = [
	["How is Guard 2 different from a blackout blind or curtains?", "A blackout roller or curtain can stop light through the fabric, but light still comes round its edges. Guard 2’s blind runs inside an aluminium frame made to fit your recess, with brush and weather strip sealing all four sides where the frame meets it. With no gap, no light gets in."],
	["Does the white Quartz fabric block all the light?", "Yes. Every fabric colour blocks 100% of light, Quartz included. The room side is the colour you choose, and the side facing the glass is always Quartz, to reflect light."],
	["What does it look like from outside?", "White. Whatever colour faces the room, the fabric’s outer face is always Quartz, so every window with Guard 2 looks the same from the street, and the white reflects sunlight."],
	["Which windows does it fit?", "Tilt-and-turn, casement, fixed, sliding, sash, hung, bay and awning windows, and skylights. It doesn’t fit arched windows or a recess that isn’t square, and it needs 30 mm of depth clear of handles and locks. If your window is older or you’re not sure, send us a photo before you order."],
	["What if I measure wrong?", "Guard’s free measurement guarantee covers it. If the fit isn’t right, Guard remakes it to your corrected measurements and sends it by express delivery at no cost. If the remake still isn’t right, the return is collected from your door. Or choose Aura measuring and fitting, and we take the measurements."],
	["Does it help with heat and noise?", "Yes, within limits. The reflective thermal barrier and the honeycomb keep summer heat out and winter warmth in, and the non-woven polyester absorbs sound and reduces noise from outside. It’s a blind, not double glazing: the room is quieter, not silent."],
	["How do I clean it?", "Wipe it with a damp cloth. The polyester fabric resists dust and stains, and needs no special cleaners. The frame’s matte finish hides smudges."],
	["How do delivery, returns and warranty work through Aura?", "Each Guard 2 is made to order, and we confirm the delivery time when you order. Guard’s terms apply: a 30-night home trial, even once it’s made and fitted; free collection for returns; a free remake if the fit is wrong; and a 2-year warranty."]
], Hs = document.querySelector("[data-guard-faq]");
//#endregion
//#region src/why/why.js
Hs && !window.AURA_SHOPIFY && window.A?.faqHTML && (Hs.innerHTML = A.faqHTML(Vs)), window.A?.ready(({ fmt: e, reduced: t }) => {
	let n = document.querySelector("[data-calc]");
	if (n) {
		let r = (e) => n.querySelector(e), i = r("[data-calc-fee]"), a = r("[data-calc-years]"), o = r("[data-calc-out]"), s = r("[data-calc-fee-cap]"), c = r("[data-calc-months-cap]"), l = r("[data-calc-bars]"), u = +a.max, d = +a.min, f = [], p = [];
		for (let e = d; e <= u; e++) {
			let t = `--x:${(e - d) / (u - d)};--h:${e / u};--i:${e - d}`, n = document.createElement("span"), r = document.createElement("span");
			n.className = "calc__bar", r.className = "calc__yr", n.style.cssText = r.style.cssText = t, r.textContent = e, f.push(n), p.push(r);
		}
		let m = document.createElement("span");
		m.className = "calc__tip", l.append(...f, ...p, m);
		let h = 0, g = (t) => {
			if (f.forEach((e, n) => e.classList.toggle("is-peek", n + d === t)), h = t, !t) return m.classList.remove("is-on");
			m.style.cssText = f[t - d].style.cssText, m.textContent = e(i.value * 12 * t), m.classList.add("is-on");
		};
		a.addEventListener("pointermove", (e) => {
			if (e.pointerType !== "mouse") return;
			let t = a.getBoundingClientRect(), n = (e.clientX - t.left - 8) / (t.width - 16);
			g(Math.min(u, Math.max(d, Math.round(d + n * (u - d)))));
		}), a.addEventListener("pointerleave", () => g(0));
		let _ = +o.textContent.replace(/\D/g, ""), v, y = (n) => {
			cancelAnimationFrame(v);
			let r = _, i = performance.now(), a = t ? 1 : 500, s = (t) => {
				let c = Math.min(1, (t - i) / a), l = 1 - (1 - c) ** 3;
				_ = Math.round(r + (n - r) * l), o.textContent = e(_), c < 1 && (v = requestAnimationFrame(s));
			};
			v = requestAnimationFrame(s);
		}, b = (e, n) => {
			e.textContent !== n && (e.textContent = n, !t && (e.classList.add("is-new"), e.offsetWidth, e.classList.remove("is-new")));
		}, x = (e) => e.style.setProperty("--fill", (e.value - e.min) / (e.max - e.min) * 100 + "%"), S = () => {
			let e = +i.value, t = +a.value;
			r("[data-calc-fee-out]").textContent = `€${e}`, r("[data-calc-years-out]").textContent = `${t} year${t > 1 ? "s" : ""}`, b(s, `€${e} a month`), b(c, `${t * 12} months`), [f, p].forEach((e) => e.forEach((e, n) => {
				e.classList.toggle("is-on", n + d <= t), e.classList.toggle("is-cur", n + d === t);
			})), h && g(h), x(i), x(a), y(e * 12 * t);
		};
		i.addEventListener("input", S), a.addEventListener("input", S), S();
	}
	let r = document.querySelector("[data-compare]");
	if (r) {
		let e = [...r.querySelectorAll(".compare__row:not(.compare__row--head)")];
		e.forEach((t) => t.querySelector(".compare__toggle").addEventListener("click", () => {
			let n = !t.classList.contains("is-open");
			e.forEach((e) => {
				e.classList.toggle("is-open", n && e === t), e.querySelector(".compare__toggle").setAttribute("aria-expanded", n && e === t);
			});
		}));
	}
});
//#endregion
//#region src/quote/quote-form.js
var Us = {
	type: Ce,
	visualDuration: .3,
	bounce: .12
}, Ws = {
	type: Ce,
	visualDuration: .4,
	bounce: 0
}, Gs = matchMedia("(prefers-reduced-motion: reduce)").matches, Ks = matchMedia("(hover: hover) and (pointer: fine)").matches;
document.addEventListener("change", (e) => {
	let t = e.target;
	if (Gs || !t.checked || !t.matches?.(".pick input")) return;
	let n = t.nextElementSibling;
	n.classList.remove("is-waking"), n.offsetWidth, n.classList.add("is-waking"), clearTimeout(n.wake), n.wake = setTimeout(() => n.classList.remove("is-waking"), 1400);
}), Ks && !Gs && document.querySelectorAll(".picks").forEach((e) => {
	let t = [...e.querySelectorAll(".pick > span")];
	e.addEventListener("pointermove", (n) => {
		t.forEach((e) => {
			let t = e.getBoundingClientRect();
			e.style.setProperty("--mx", `${n.clientX - t.left}px`), e.style.setProperty("--my", `${n.clientY - t.top}px`);
		}), e.classList.add("is-lit");
	}), e.addEventListener("pointerleave", () => e.classList.remove("is-lit"));
});
var qs = class extends HTMLElement {
	connectedCallback() {
		this.puck || (this.puck = document.createElement("span"), this.puck.className = "seg-puck", this.puck.setAttribute("aria-hidden", "true"), this.prepend(this.puck), this.at = null, this.addEventListener("change", () => this.place()), new ResizeObserver(() => this.place(!0)).observe(this));
	}
	place(e = !1) {
		let t = this.querySelector("input:checked")?.closest("label");
		if (!t || !t.offsetWidth) {
			this.classList.remove("has-puck"), this.at = null;
			return;
		}
		let n = {
			left: t.offsetLeft,
			top: t.offsetTop,
			width: t.offsetWidth,
			height: t.offsetHeight
		}, r = Object.fromEntries(Object.entries(n).map(([e, t]) => [e, `${t}px`]));
		if (e || Gs || !this.at) it(this.puck, r, { duration: 0 });
		else {
			let e = n.left > this.at.left, t = n.top > this.at.top;
			it(this.puck, r, {
				left: e ? Ws : Us,
				width: Us,
				top: t ? Ws : Us,
				height: Us
			});
		}
		this.at = n, this.classList.add("has-puck");
	}
};
customElements.define("aura-seg", qs);
var Js = (e) => String(e).replace(/[&<>"]/g, (e) => ({
	"&": "&amp;",
	"<": "&lt;",
	">": "&gt;",
	"\"": "&quot;"
})[e]), Ys = (e) => e.length < 2 ? e.join("") : `${e.slice(0, -1).join(", ")} and ${e.at(-1)}`, Xs = (e) => e.dataset.say ?? e.value;
document.querySelectorAll("form[data-quote]").forEach((e) => {
	let t = e.querySelector("[data-quote-sum]"), n = e.querySelector("select[name=\"area\"], select[name=\"contact[area]\"]");
	if (!t) return;
	let r = {}, i = () => {
		let i = [...e.querySelectorAll(".pick input:checked")].map(Xs), a = e.querySelector("aura-seg input:checked"), o = n?.selectedOptions[0], s = {
			what: Ys(i),
			home: a ? Xs(a) : "your home",
			where: o ? o.dataset.say ?? o.textContent.trim() : ""
		}, c = (e) => `<b${r[e] !== void 0 && r[e] !== s[e] ? " class=\"is-new\"" : ""}>${Js(s[e])}</b>`, l = s.where ? ` in ${c("where")}` : "", u = o?.hasAttribute("data-check") ? " and check installer availability" : "";
		t.innerHTML = `<span>${i.length ? `We’ll quote ${c("what")} for ${c("home")}${l}${u}.` : `We’ll recommend devices for ${c("home")}${l}${u}.`}</span>`, r = s;
	};
	e.addEventListener("change", i), i(), e.hasAttribute("data-shopify-contact") && e.addEventListener("submit", (t) => {
		let n;
		e.querySelectorAll("[required]").forEach((e) => {
			let t = e.type === "email" ? /^\S+@\S+\.\S+$/.test(e.value) : e.value.trim().length > 1;
			e.closest(".field")?.classList.toggle("is-invalid", !t), !t && !n && (n = e);
		}), n ? (t.preventDefault(), n.focus()) : e.querySelector("[type=\"submit\"]")?.classList.add("is-loading");
	});
});
//#endregion
//#region src/quote/quote-dust.js
var Zs = 2300, Qs = 1650, $s = 260, ec = .7, tc = matchMedia("(pointer: coarse)"), nc = (e, t, n) => Math.max(t, Math.min(n, e)), rc = (e, t, n) => t > e ? Math.min(t, e + n) : Math.max(t, e - n), ic = "#version 300 es\nprecision highp float;\n", ac = "\nuniform vec2 uSize;     // the canvas\nuniform vec4 uSheet;    // the card: left, right, top, corner radius (its foot is on the line)\nuniform vec3 uPrint;    // the middle of the print's base on the line, and px per unit of its drawing\nuniform float uReach;   // the farthest corner of the card from the print\nuniform float uForm;    // 0 all in the print .. 1 the card made\nuniform float uTime;\nuniform float uDpr;\n\nvec3 mod289(vec3 x) { return x - floor(x * (1. / 289.)) * 289.; }\nvec2 mod289(vec2 x) { return x - floor(x * (1. / 289.)) * 289.; }\nvec3 permute(vec3 x) { return mod289(((x * 34.) + 1.) * x); }\nfloat snoise(vec2 v) {\n  const vec4 C = vec4(.211324865405187, .366025403784439, -.577350269189626, .024390243902439);\n  vec2 i = floor(v + dot(v, C.yy)), x0 = v - i + dot(i, C.xx);\n  vec2 i1 = x0.x > x0.y ? vec2(1., 0.) : vec2(0., 1.);\n  vec4 x12 = x0.xyxy + C.xxzz;\n  x12.xy -= i1;\n  i = mod289(i);\n  vec3 p = permute(permute(i.y + vec3(0., i1.y, 1.)) + i.x + vec3(0., i1.x, 1.));\n  vec3 m = max(.5 - vec3(dot(x0, x0), dot(x12.xy, x12.xy), dot(x12.zw, x12.zw)), 0.);\n  m = m * m; m = m * m;\n  vec3 x = 2. * fract(p * C.www) - 1., h = abs(x) - .5, a0 = x - floor(x + .5);\n  m *= 1.79284291400159 - .85373472095314 * (a0 * a0 + h * h);\n  vec3 g = vec3(a0.x * x0.x + h.x * x0.y, a0.yz * x12.xz + h.yz * x12.yw);\n  return 130. * dot(m, g);\n}\n// a swirling flow (the curl of the noise): neighbours move together, as smoke does\nvec2 curl(vec2 p) {\n  const float e = .08;\n  return vec2(snoise(p + vec2(0., e)) - snoise(p - vec2(0., e)), snoise(p - vec2(e, 0.)) - snoise(p + vec2(e, 0.))) / (2. * e);\n}\nconst vec3 BLUE = vec3(.145, .533, .788), ICE = vec3(.659, .831, .949);\n// the card, round along the top; it runs on below the line so its foot is never an edge\nfloat sdSheet(vec2 q) {\n  float r = uSheet.w;\n  vec2 c = vec2((uSheet.x + uSheet.y) * .5, (uSheet.z - 400.) * .5), h = vec2((uSheet.y - uSheet.x) * .5, (uSheet.z + 400.) * .5);\n  vec2 d = abs(q - c) - h + r;\n  return length(max(d, 0.)) + min(max(d.x, d.y), 0.) - r;\n}\n// one front spreads out of the print (and draws back into it): how far it has got toward q, boiling\n// a little as it goes, and evening out as it finishes. Every grain rides it out and stops at its place\nfloat front(vec2 q) {\n  vec2 d = q - uPrint.xy;\n  float t = clamp(uForm, 0., 1.);\n  return t * t * (3. - 2. * t) * (uReach + 450.) * (1. + .09 * (1. - t * t) * snoise(normalize(d + 1e-4) * 1.6 + vec2(uTime * .25, 0.)));\n}\n// whether the card has condensed out of its grains at q yet: once they've all landed there (lag px behind\n// the front), along a line that billows like a cloud's edge. Never a soft fade: navy fading in over the\n// page reads as a grey haze, not as grains\nfloat solid(vec2 q, float lag) {\n  return smoothstep(0., 22., front(q) - distance(q, uPrint.xy) - lag + 45. * snoise(q * .007 + vec2(0., uTime * .2)));\n}\n// the card's own colour: its blue hour, as the page draws it (--blue-hour), with a hairline of light\n// along its top (main.css: inset 0 1px 0)\nvec3 blueHour(vec2 q) {\n  float h = uSheet.z, w = uSheet.y - uSheet.x, px = .5 / uDpr;\n  vec3 c = mix(vec3(.051, .082, .122), vec3(.043, .067, .098), clamp((h - q.y) / (h * .55), 0., 1.));\n  vec2 e = (q - vec2((uSheet.x + uSheet.y) * .5, -.25 * h)) / vec2(.8 * w, .6 * h);\n  c = mix(c, BLUE, .2 * max(0., 1. - length(e) / .7));\n  return mix(c, vec3(1.), .06 * smoothstep(-px, px, sdSheet(q + vec2(0., 1.))));\n}", oc = "\nin vec2 aQuad;\nuniform vec2 uSize;\nuniform vec4 uBox;   // left, bottom, right, top\nout vec2 vQ;\nvoid main() { vQ = mix(uBox.xy, uBox.zw, aQuad * .5 + .5); gl_Position = vec4(vQ / uSize * 2. - 1., 0., 1.); }", sc = `${ac}
uniform sampler2D uPic;   // what's on the card, in its own colours
uniform float uContent;   // how much of that picture shows (the real form takes over from it)
in vec2 vQ;
out vec4 o;
vec2 erf2(vec2 x) { vec2 s = sign(x), a = abs(x); x = 1. + (.278393 + (.230389 + .078108 * (a * a)) * a) * a; x *= x; return s - s / (x * x); }
void main() {
  vec2 q = vQ;
  float px = .5 / uDpr, cover = (1. - smoothstep(-px, px, sdSheet(q))) * solid(q, 230.);
  vec4 c = vec4(0.);
  if (cover > 0.) {
    vec2 uv = vec2((q.x - uSheet.x) / (uSheet.y - uSheet.x), 1. - q.y / uSheet.z);
    vec4 pic = texture(uPic, uv) * uContent * solid(q, 380.);
    // (and half a level of noise, so its dark gradient never bands)
    vec2 g = floor(q * uDpr);
    c = vec4(pic.rgb + blueHour(q) * (1. - pic.a) + (fract(52.9829189 * fract(dot(g, vec2(.06711056, .00583715)))) - .5) / 255., 1.) * cover;
  }
  // its shadow on the page either side, as it has on the night (main.css: 0 40px 90px -50px), once it's
  // nearly made
  vec2 sx = erf2((q.x - vec2(uSheet.x + 50., uSheet.y - 50.)) / 63.64), sy = erf2((q.y - vec2(-400., uSheet.z - 90.)) / 63.64);
  float sh = .2125 * (sx.x - sx.y) * (sy.x - sy.y) * smoothstep(.55, 1., uForm);
  o = c + vec4(0., 0., 0., sh) * (1. - c.a);
}`, cc = `${ac}
in vec4 aHome;
in vec4 aSeed;
uniform sampler2D uPic;
uniform vec4 uPointer;   // where the mouse is and how fast it's moving (px/s)
out vec4 vCol;
out float vSize, vSpan;
const float PI = 3.14159265;
void main() {
  vec4 s = aSeed;
  bool words = aHome.z > 1.5;
  vec2 home = vec2(mix(uSheet.x, uSheet.y, aHome.x), uSheet.z * (1. - aHome.y));
  vec4 pic = texture(uPic, aHome.xy);
  vec3 own = pic.rgb + blueHour(home) * (1. - pic.a);
  // out of a point on the print's ridges
  float ra = PI * s.z, rr = (5. + 40. * s.w) * uPrint.z;
  vec2 from = uPrint.xy + vec2(cos(ra), sin(ra)) * rr;
  // its path: out from the print on the front, until the front reaches its place (what's on the card
  // rides a little way behind it)
  vec2 out_ = home - uPrint.xy;
  float len = length(out_);
  vec2 dir = out_ / max(len, 1.);
  float edgeAt = front(home) - (words ? 150. : 0.) - 170. * fract(s.y * 7.31 + s.x), r = clamp(edgeAt, 0., len);
  // on the front it rolls like smoke, on the shared flow; settled behind it, it's still
  float swirl = (1. - smoothstep(0., 90., edgeAt - len)) * smoothstep(0., 30., edgeAt);
  vec2 pos = uPrint.xy + (from - uPrint.xy) * (1. - smoothstep(0., 60., r)) + dir * r;
  pos += (curl(pos * .004 + vec2(0., uTime * .15)) * 30. + curl(pos * .013 + vec2(uTime * .35, 3.)) * 12. + (vec2(s.x, fract(s.z * 13.7)) - .5) * 10.) * swirl;
  // the mouse stirs them
  vec2 dp = pos - uPointer.xy;
  pos += clamp(uPointer.zw * .06, -45., 45.) * exp(-dot(dp, dp) / 7000.) * swirl;
  // in the air a few catch the blue hour's light; landed, each is its own place's colour, and goes into
  // the card as it condenses under it, so it's seen no more but never goes
  vec3 col = mix(own, s.w > .95 ? ICE : BLUE, swirl * .75 * smoothstep(.45, 1., s.w));
  float a = mix(1., .9, swirl) * smoothstep(0., 12., edgeAt) * (1. - smoothstep(.9, 1., solid(home, mix(230., 380., pic.a))));
  vCol = vec4(col * a, a);
  // and settling, the card's own swell till they all but touch, so where they've landed is the card
  // already, in grain, before it closes up between them (what's on it stays fine, so it stays legible)
  float fine = words ? 1.25 : .95 + .65 * s.y;
  vSize = mix(fine, mix(2.9, fine, pic.a), 1. - swirl) * uDpr;
  vSpan = max(vSize, 1.) + 1.5;
  gl_PointSize = vSpan;
  gl_Position = a < .004 ? vec4(2., 2., 2., 1.) : vec4(pos / uSize * 2. - 1., 0., 1.);
}`, lc = `${ac}
in vec4 aSeed;
uniform float uStill;   // 1 while the card's made and still; brushing ends as it goes
uniform vec4 uWake[48];     // where the mouse was (px in the canvas) and how fast it was going (px/s)
uniform float uWakeAt[48];  // and when
out vec4 vCol;
out float vSize, vSpan;
void main() {
  vec4 s = aSeed;
  // its place on the edge: up the left side, round the corner, along the top, round and down the right
  float w = uSheet.y - uSheet.x, h = uSheet.z, r = min(uSheet.w, w * .5);
  float side = max(0., h - r), arc = 1.5707963 * r, top = max(0., w - 2. * r), d = s.x * (2. * side + 2. * arc + top);
  vec2 p, n;
  if (d < side) { p = vec2(0., d); n = vec2(-1., 0.); }
  else if (d < side + arc) { float a = 3.14159265 - (d - side) / r; n = vec2(cos(a), sin(a)); p = vec2(r, h - r) + r * n; }
  else if (d < side + arc + top) { p = vec2(r + d - side - arc, h); n = vec2(0., 1.); }
  else if (d < side + 2. * arc + top) { float a = 1.5707963 - (d - side - arc - top) / r; n = vec2(cos(a), sin(a)); p = vec2(w - r, h - r) + r * n; }
  else { p = vec2(w, h - r - (d - side - 2. * arc - top)); n = vec2(1., 0.); }
  vec2 home = p + vec2(uSheet.x, 0.) - n * (.6 + 2.4 * s.y);
  // how hard the mouse brushed past it (a faster move brushes harder, and a wider swath), and the move
  // that first brushed it off: it rides that one
  float push = 0., f[48];
  for (int i = 0; i < 48; i++) {
    vec2 dm = home - uWake[i].xy;
    float v = length(uWake[i].zw), t = uTime - uWakeAt[i];
    f[i] = t >= 0. && t < 1.5 ? v * exp(-dot(dm, dm) / (1100. + v * v * .0012)) : 0.;
    push = max(push, f[i]);
  }
  vec4 m = vec4(0.);
  float age = -1.;
  for (int i = 0; i < 48; i++) if (age < 0. && f[i] > max(60., push * .5)) { m = uWake[i]; age = uTime - uWakeAt[i]; }
  float a = uStill * smoothstep(80., 420., push) * (1. - smoothstep(.12, 1.25, age)) * step(0., age);
  // carried on the way the mouse went, a little either side, slowing; off the edge; and curling as it goes
  float sp = min(length(m.zw), 1600.);
  vec2 dir = m.zw / max(sp, 1.), across = vec2(-dir.y, dir.x);
  float tau = .42, go = 1. - exp(-max(age, 0.) / tau);
  vec2 pos = home + (dir + across * (fract(s.w * 7.13) - .5) * .8) * sp * .26 * tau * go * (.35 + .9 * s.z) + n * 16. * go;
  // the flow folds them as one, so they swirl apart in skeins rather than spray; then each its own way
  pos += curl(home * .0055 + vec2(uTime * .05, 0.)) * 30. * go * go + curl(pos * .016 + vec2(s.w * 2., uTime * .3)) * 9. * age;
  // its own colour as it leaves (so over the card it isn't seen); out on the page, a little of the blue
  a *= .85;
  vec3 col = mix(blueHour(home), BLUE, .45 * smoothstep(0., 50., sdSheet(pos)));
  vCol = vec4(col * a, a);
  vSize = (.9 + .6 * s.w) * uDpr;
  vSpan = max(vSize, 1.) + 1.5;
  gl_PointSize = vSpan;
  gl_Position = a < .004 ? vec4(2., 2., 2., 1.) : vec4(pos / uSize * 2. - 1., 0., 1.);
}`, uc = "\nin vec4 vCol;\nin float vSize, vSpan;\nout vec4 o;\nvoid main() {\n  float r = max(vSize, 1.) * .5, d = length(gl_PointCoord - .5) * vSpan;\n  o = vCol * (1. - smoothstep(r - .5, r + .5, d)) * min(1., vSize * vSize);\n}", dc = /* @__PURE__ */ new Map(), fc = (e, t) => {
	let n = e.innerHTML + t.stroke + t.fill + t.strokeWidth, r = dc.get(n);
	if (!r) {
		let i = e.cloneNode(!0);
		i.removeAttribute("class"), i.removeAttribute("style"), i.setAttribute("xmlns", "http://www.w3.org/2000/svg");
		for (let [e, n] of [
			["fill", t.fill],
			["stroke", t.stroke],
			["stroke-width", t.strokeWidth],
			["stroke-linecap", t.strokeLinecap],
			["stroke-linejoin", t.strokeLinejoin]
		]) i.setAttribute(e, n);
		r = new Image(), r.src = `data:image/svg+xml;charset=utf-8,${encodeURIComponent(new XMLSerializer().serializeToString(i))}`, dc.set(n, r);
	}
	return r.complete && r.naturalWidth ? r : null;
}, pc = (e) => {
	let t = e.match(/[\d.]+/g);
	return t ? t.length > 3 ? +t[3] : 1 : 0;
};
function mc(e, t) {
	let n = Math.max(1, Math.round(e.offsetWidth)), r = Math.max(1, Math.round(e.offsetHeight)), i = document.createElement("canvas");
	i.width = Math.round(n * t), i.height = Math.round(r * t);
	let a = i.getContext("2d");
	a.scale(i.width / n, i.height / r);
	let o = e.getBoundingClientRect(), s = document.createRange(), c = (e) => ({
		l: e.left - o.left,
		t: e.top - o.top,
		w: e.width,
		h: e.height
	}), l = (e, t, n = 0) => {
		a.beginPath();
		let r = Math.max(0, Math.min(t - n, (e.w - 2 * n) / 2, (e.h - 2 * n) / 2));
		a.roundRect ? a.roundRect(e.l + n, e.t + n, e.w - 2 * n, e.h - 2 * n, r) : a.rect(e.l + n, e.t + n, e.w - 2 * n, e.h - 2 * n);
	}, u = (e) => {
		a.font = `${e.fontStyle} ${e.fontWeight} ${e.fontSize} ${e.fontFamily}`, "letterSpacing" in a && (a.letterSpacing = e.letterSpacing === "normal" ? "0px" : e.letterSpacing);
	}, d = (e) => pc(e.color) === 0 || pc(e.webkitTextFillColor || "rgb(0,0,0)") === 0 ? "#9fcdf0" : e.color, f = (e, t) => {
		u(t), a.fillStyle = d(t);
		let n = t.textTransform === "uppercase" ? e.textContent.toUpperCase() : e.textContent;
		for (let t of e.textContent.matchAll(/\S+/g)) {
			s.setStart(e, t.index), s.setEnd(e, t.index + t[0].length);
			let r = s.getClientRects()[0];
			if (!r || !r.width) continue;
			let i = n.slice(t.index, t.index + t[0].length);
			a.fillText(i, r.left - o.left, r.top - o.top + a.measureText(i).fontBoundingBoxAscent);
		}
	}, p = (e, t) => {
		let n = parseFloat(e.borderTopLeftRadius) || 0;
		pc(e.backgroundColor) > 0 && (l(t, n), a.fillStyle = e.backgroundColor, a.fill());
		let r = [
			"Top",
			"Right",
			"Bottom",
			"Left"
		].map((t) => ({
			w: e[`border${t}Style`] === "none" ? 0 : parseFloat(e[`border${t}Width`]) || 0,
			c: e[`border${t}Color`]
		}));
		if (r.every((e) => e.w === r[0].w && e.c === r[0].c)) r[0].w > 0 && pc(r[0].c) > 0 && (l(t, n, r[0].w / 2), a.lineWidth = r[0].w, a.strokeStyle = r[0].c, a.stroke());
		else {
			let [e, n, i, o] = r;
			for (let [r, s, c, l, u] of [
				[
					e,
					t.l,
					t.t,
					t.w,
					e.w
				],
				[
					n,
					t.l + t.w - n.w,
					t.t,
					n.w,
					t.h
				],
				[
					i,
					t.l,
					t.t + t.h - i.w,
					t.w,
					i.w
				],
				[
					o,
					t.l,
					t.t,
					o.w,
					t.h
				]
			]) r.w > 0 && pc(r.c) > 0 && (a.fillStyle = r.c, a.fillRect(s, c, l, u));
		}
		for (let n of e.boxShadow.matchAll(/(rgba?\([^)]*\)) (-?[\d.]+)px (-?[\d.]+)px ([\d.]+)px (-?[\d.]+)px inset/g)) {
			let e = +n[3];
			+n[4] || !e || (a.fillStyle = n[1], a.fillRect(t.l, e < 0 ? t.t + t.h + e : t.t, t.w, Math.abs(e)));
		}
	}, m = (t) => {
		for (let n of t.childNodes) {
			if (n.nodeType === 3) {
				n.textContent.trim() && f(n, getComputedStyle(t));
				continue;
			}
			if (n.nodeType !== 1) continue;
			let r = getComputedStyle(n);
			if (r.display === "none" || r.visibility === "hidden" || +r.opacity == 0 && n.parentElement !== e) continue;
			let i = c(n.getBoundingClientRect());
			if (!i.w || !i.h) continue;
			if (p(r, i), n.localName === "svg") {
				let e = fc(n, r);
				e && a.drawImage(e, i.l, i.t, i.w, i.h);
				continue;
			}
			if (n.matches("input:not([type=\"checkbox\"], [type=\"radio\"], [type=\"hidden\"]), textarea")) {
				let e = n.value || n.placeholder;
				if (e) {
					let t = n.value ? r : getComputedStyle(n, "::placeholder");
					u(r), a.fillStyle = t.color;
					let o = a.measureText(e);
					a.fillText(e, i.l + (parseFloat(r.paddingLeft) || 0), i.t + i.h / 2 + (o.fontBoundingBoxAscent - o.fontBoundingBoxDescent) / 2);
				}
				continue;
			}
			let o = r.overflowX !== "visible" || r.overflowY !== "visible";
			o && (a.save(), a.beginPath(), a.rect(i.l, i.t, i.w, i.h), a.clip()), m(n), o && a.restore();
		}
	}, h = e.style.cssText;
	e.style.transition = "none", e.style.visibility = "visible";
	try {
		m(e);
	} finally {
		e.style.cssText = h;
	}
	return {
		cv: i,
		w: n,
		h: r
	};
}
var hc = document.createElement("canvas");
function gc({ section: e, slot: t, panel: n, print: r, pad: i }) {
	if (typeof WebGL2RenderingContext > "u") return null;
	let a = document.createElement("canvas");
	a.className = "quote-dust", a.setAttribute("aria-hidden", "true");
	let o = null, s = !1, c = null, l = null, u, d, f, p, m, h, g, _, v, y = (e, t, n) => {
		let r = (e, t) => {
			let n = o.createShader(e);
			return o.shaderSource(n, ic + t), o.compileShader(n), n;
		}, i = r(o.VERTEX_SHADER, e), a = r(o.FRAGMENT_SHADER, t), s = o.createProgram();
		return o.attachShader(s, i), o.attachShader(s, a), n.forEach((e, t) => o.bindAttribLocation(s, t, e)), o.linkProgram(s), {
			p: s,
			v: i,
			f: a
		};
	}, b = ({ p: e, v: t, f: n }) => {
		if (!o.getProgramParameter(e, o.LINK_STATUS)) {
			for (let e of [t, n]) o.getShaderParameter(e, o.COMPILE_STATUS) || console.warn("quote-dust:", o.getShaderInfoLog(e));
			return console.warn("quote-dust:", o.getProgramInfoLog(e)), null;
		}
		let r = {}, i = o.getProgramParameter(e, o.ACTIVE_UNIFORMS);
		for (let t = 0; t < i; t++) {
			let n = o.getActiveUniform(e, t).name;
			r[n] = o.getUniformLocation(e, n);
		}
		return r.uPic && (o.useProgram(e), o.uniform1i(r.uPic, 0)), {
			p: e,
			u: r
		};
	}, x = (e, t) => {
		o.useProgram(e.p);
		for (let n in t) {
			let r = e.u[n], i = t[n];
			r && (typeof i == "number" ? o.uniform1f(r, i) : o[`uniform${i.length}fv`](r, i));
		}
	}, S = (e) => {
		let t = new Float32Array(e);
		for (let n = 0; n < e; n++) t[n] = Math.random();
		return t;
	}, C = tc.matches || innerWidth < 700, w = C ? 7e4 : 2e5, T = C ? 22e3 : 5e4, E = w + T, D = tc.matches ? 0 : 24e3, O = 0, ee = (e, t, n, r) => (e < r || e > n - r) && t < r && Math.hypot(e - nc(e, r, n - r), t - r) > r, k = (e, t) => {
		let n = Math.min(O, e / 2), r = Math.max(1, Math.round(Math.sqrt(w * e / t))), i = Math.ceil(w / r);
		for (let a = 0; a < w; a++) {
			let o = (a % r + Math.random()) / r * e, s = (Math.floor(a / r) + Math.random()) / i * t;
			for (; ee(o, s, e, n);) o = Math.random() * e, s = Math.random() * t;
			p[a * 4] = o / e, p[a * 4 + 1] = s / t, p[a * 4 + 2] = 1;
		}
		ne();
	}, te = () => {
		if (!s) return;
		let e = mc(n, le);
		o.bindTexture(o.TEXTURE_2D, h), o.texImage2D(o.TEXTURE_2D, 0, o.RGBA, o.RGBA, o.UNSIGNED_BYTE, e.cv), hc.width = e.w, hc.height = e.h;
		let t = hc.getContext("2d", { willReadFrequently: !0 });
		t.clearRect(0, 0, e.w, e.h), t.drawImage(e.cv, 0, 0, e.w, e.h);
		let r = t.getImageData(0, 0, e.w, e.h).data, i = [];
		for (let e = 3; e < r.length; e += 4) r[e] > 50 && i.push(e >> 2);
		for (let t = 0; t < T; t++) {
			let n = (w + t) * 4;
			if (p[n + 2] = 2, !i.length) {
				p[n] = p[n + 1] = -1;
				continue;
			}
			let r = i[i.length >= T ? Math.floor((t + Math.random()) * i.length / T) : Math.floor(Math.random() * i.length)];
			p[n] = (r % e.w + Math.random()) / e.w, p[n + 1] = (Math.floor(r / e.w) + Math.random()) / e.h;
		}
		ne(), De();
	}, ne = () => {
		o.bindBuffer(o.ARRAY_BUFFER, m), o.bufferData(o.ARRAY_BUFFER, p, o.DYNAMIC_DRAW);
	}, re = [
		() => {
			if (o = a.getContext("webgl2", {
				alpha: !0,
				premultipliedAlpha: !0,
				antialias: !1,
				depth: !1,
				stencil: !1,
				powerPreference: "high-performance"
			}), !o) return !1;
			c = o.getExtension("KHR_parallel_shader_compile"), l = [
				y(oc, sc, ["aQuad"]),
				y(cc, uc, ["aHome", "aSeed"]),
				y(lc, uc, ["aSeed"])
			];
		},
		() => ([u, d, f] = l.map(b), !!(u && d && f)),
		() => {
			p = new Float32Array(E * 4), m = o.createBuffer();
			let e = o.createBuffer(), t = o.createBuffer(), n = o.createBuffer();
			o.bindBuffer(o.ARRAY_BUFFER, e), o.bufferData(o.ARRAY_BUFFER, S(E * 4), o.STATIC_DRAW), o.bindBuffer(o.ARRAY_BUFFER, t), o.bufferData(o.ARRAY_BUFFER, S(D * 4), o.STATIC_DRAW);
			let r = (e) => {
				let t = o.createVertexArray();
				return o.bindVertexArray(t), e.forEach(([e, t], n) => {
					o.bindBuffer(o.ARRAY_BUFFER, e), o.enableVertexAttribArray(n), o.vertexAttribPointer(n, t, o.FLOAT, !1, 0, 0);
				}), o.bindVertexArray(null), t;
			};
			o.bindBuffer(o.ARRAY_BUFFER, n), o.bufferData(o.ARRAY_BUFFER, new Float32Array([
				-1,
				-1,
				1,
				-1,
				-1,
				1,
				1,
				1
			]), o.STATIC_DRAW), g = r([[n, 2]]), _ = r([[m, 4], [e, 4]]), v = r([[t, 4]]), h = o.createTexture(), o.bindTexture(o.TEXTURE_2D, h), o.pixelStorei(o.UNPACK_PREMULTIPLY_ALPHA_WEBGL, !0), o.texImage2D(o.TEXTURE_2D, 0, o.RGBA, 1, 1, 0, o.RGBA, o.UNSIGNED_BYTE, /* @__PURE__ */ new Uint8Array(4));
			for (let [e, t] of [
				[o.TEXTURE_MIN_FILTER, o.LINEAR],
				[o.TEXTURE_MAG_FILTER, o.LINEAR],
				[o.TEXTURE_WRAP_S, o.CLAMP_TO_EDGE],
				[o.TEXTURE_WRAP_T, o.CLAMP_TO_EDGE]
			]) o.texParameteri(o.TEXTURE_2D, e, t);
		},
		() => {
			s = !0, me();
		},
		() => {
			document.fonts?.ready.then(() => setTimeout(() => Er(() => be && te(), () => ye), 600));
		}
	], j = 0, M = !1, ie = () => !c || l.every(({ p: e }) => o.getProgramParameter(e, c.COMPLETION_STATUS_KHR)), ae = (e) => window.requestIdleCallback ? requestIdleCallback(e, { timeout: 2e3 }) : setTimeout(e, 50), oe = () => {
		!be || j >= re.length || (re[j]() === !1 ? je() : j++);
	};
	function se(e) {
		for (; be && j < re.length;) if (e) oe();
		else {
			if (M) return;
			M = !0, j === 1 && !ie() ? setTimeout(() => {
				M = !1, se();
			}, 50) : ae(() => {
				M = !1, oe(), se();
			});
			return;
		}
	}
	t.prepend(a), e.classList.add("has-dust");
	let ce = 1, N = 1, le = 1, P = [
		0,
		1,
		1,
		0
	], ue = [
		0,
		0,
		1
	], de = 1, fe = "", pe = 0, me = () => {
		if (!s) return;
		let e = t.offsetWidth, o = t.offsetHeight;
		if (!e || !o) return;
		let c = t.getBoundingClientRect(), l = r.getBoundingClientRect(), u = getComputedStyle(n), d = Math.round(nc(Math.min(c.left, document.documentElement.clientWidth - c.right), 0, 240)), f = e < 600 ? 150 : 220;
		ce = e + d * 2, N = o + f;
		let p = le;
		le = Math.min(devicePixelRatio || 1, 2), Object.assign(a.style, {
			left: `${-d}px`,
			top: `${-f}px`,
			width: `${ce}px`,
			height: `${N}px`
		});
		let m = Math.round(ce * le), h = Math.round(N * le);
		(a.width !== m || a.height !== h) && (a.width = m, a.height = h);
		let g = n.offsetWidth, _ = n.offsetHeight, v = d + n.offsetLeft;
		O = parseFloat(u.borderTopLeftRadius) || 0, P = [
			v,
			v + g,
			_,
			O
		];
		let y = d + l.left + l.width / 2 - c.left;
		ue = [
			y,
			0,
			i.offsetWidth / 100
		], de = Math.hypot(Math.max(y - P[0], P[1] - y), P[2]);
		let b = `${g}x${_}x${O}`;
		(b !== fe || le !== p) && (fe = b, k(g, _), clearTimeout(pe), pe = setTimeout(() => Er(() => be && te(), () => ye), 250)), De();
	}, F = 0, I = 0, L = 0, he = 1, R = 0, ge = 0, z = Math.random() * 100, B = 0, _e = 0, ve = !1, ye = !1, be = !0, V = {
		cx: 0,
		cy: 0,
		has: !1,
		dx: 0,
		dy: 0,
		vx: 0,
		vy: 0,
		x: -1e4,
		y: -1e4
	}, xe = /* @__PURE__ */ new Float32Array(192), Se = (/* @__PURE__ */ new Float32Array(48)).fill(-1e4), Ce = -1e4, we = -1e4, Te = () => F > 0 || I > 0, Ee = () => z - Se[47] < 1.5;
	function De() {
		if (!s || (o.bindFramebuffer(o.FRAMEBUFFER, null), o.viewport(0, 0, a.width, a.height), o.clearColor(0, 0, 0, 0), o.clear(o.COLOR_BUFFER_BIT), !Te() || !F)) return;
		o.enable(o.BLEND), o.blendFunc(o.ONE, o.ONE_MINUS_SRC_ALPHA), o.activeTexture(o.TEXTURE0), o.bindTexture(o.TEXTURE_2D, h);
		let e = {
			uSize: [ce, N],
			uSheet: P,
			uPrint: ue,
			uReach: de,
			uForm: F,
			uTime: z,
			uDpr: le
		}, t = [
			V.x,
			V.y,
			nc(V.vx, -2500, 2500),
			nc(V.vy, -2500, 2500)
		];
		x(u, {
			...e,
			uContent: he,
			uBox: [
				Math.max(0, P[0] - 140),
				0,
				Math.min(ce, P[1] + 140),
				Math.min(N, P[2] + 4)
			]
		}), o.bindVertexArray(g), o.drawArrays(o.TRIANGLE_STRIP, 0, 4), F < 1 && (x(d, {
			...e,
			uPointer: t
		}), o.bindVertexArray(_), o.drawArrays(o.POINTS, 0, E)), ge > 0 && D && Ee() && (x(f, {
			...e,
			uStill: ge
		}), o.uniform4fv(f.u["uWake[0]"], xe), o.uniform1fv(f.u["uWakeAt[0]"], Se), o.bindVertexArray(v), o.drawArrays(o.POINTS, 0, D)), o.bindVertexArray(null), o.disable(o.BLEND);
	}
	function Oe(t) {
		if (B = 0, tc.matches && F === I && (ve = !ve)) {
			ke();
			return;
		}
		let n = _e ? nc((t - _e) / 1e3, 0, 1 / 30) : 1 / 60;
		_e = t, z += n, z >= L && (F = rc(F, I, n * 1e3 / (I > F ? Zs : Qs)));
		let r = I === 1 && F === 1;
		R = r ? R + n : 0, he = r ? rc(he, R > ec ? 0 : 1, n / .3) : 1, ge = r ? 1 : rc(ge, 0, n / .3);
		let i = a.getBoundingClientRect(), o = V.dx || V.dy;
		if (V.vx += (V.dx / n - V.vx) * .35, V.vy += (-V.dy / n - V.vy) * .35, V.dx = V.dy = 0, V.has && (V.x = V.cx - i.left, V.y = i.bottom - V.cy), r && o && Math.hypot(V.x - Ce, V.y - we) > 8 && z - Se[0] > 1.5) {
			let [e, t, n, r] = P, i = V.x - nc(V.x, e + r, t - r), a = V.y - Math.min(V.y, n - r), o = i > 0 && a > 0 ? Math.hypot(i, a) - r : Math.max(e - V.x, V.x - t, V.y - n);
			Math.abs(o) < 70 && (xe.copyWithin(0, 4), Se.copyWithin(0, 1), xe.set([
				V.x,
				V.y,
				nc(V.vx, -2500, 2500),
				nc(V.vy, -2500, 2500)
			], 188), Se[47] = z, Ce = V.x, we = V.y);
		}
		e.classList.toggle("is-formed", r), De(), Te() && (F !== I || z < L || r && R < 1.2 || o || Ee()) ? ke() : _e = 0;
	}
	function ke() {
		!B && be && ye && Te() && (B = requestAnimationFrame(Oe));
	}
	function Ae() {
		I || (F = 0, ge = 0, De());
	}
	function je() {
		be = !1, cancelAnimationFrame(B), B = 0, clearTimeout(pe), e.classList.remove("has-dust", "is-formed"), a.remove();
	}
	let Me = new ResizeObserver(me);
	return Me.observe(t), Me.observe(n), new IntersectionObserver(([e]) => {
		ye = e.isIntersecting, ye || Ae(), ke();
	}, { rootMargin: "100px 0px" }).observe(a), new IntersectionObserver(([e], t) => {
		e.isIntersecting && (t.disconnect(), se());
	}, { rootMargin: "250% 0px" }).observe(t), addEventListener("resize", me), addEventListener("pointermove", (e) => {
		e.pointerType === "mouse" && (V.has && (V.dx += e.clientX - V.cx, V.dy += e.clientY - V.cy), V.cx = e.clientX, V.cy = e.clientY, V.has = !0, D && F === 1 && ke());
	}, { passive: !0 }), a.addEventListener("webglcontextlost", je), {
		rise: Zs,
		get alive() {
			return be;
		},
		open() {
			se(!0), be && (F || te(), I = 1, L = 0, ke());
		},
		close() {
			te(), I = 0, L = z + $s / 1e3, e.classList.remove("is-formed"), ye || Ae(), ke();
		}
	};
}
//#endregion
//#region src/quote/quote-print.js
var _c = matchMedia("(max-width: 999px)"), vc = 900, yc = 900, bc = .25, xc = (e, t, n) => Math.max(t, Math.min(n, e)), Sc = [
	[
		5,
		196,
		344
	],
	[
		10,
		186,
		354,
		300
	],
	[
		15,
		184,
		356,
		232
	],
	[
		20,
		183,
		357,
		276,
		331
	],
	[
		25,
		182,
		358,
		214
	],
	[
		30,
		181,
		359,
		255,
		312
	],
	[
		35,
		181,
		359,
		290
	],
	[
		40,
		186,
		356,
		226,
		309
	],
	[
		45,
		198,
		342,
		262
	]
], Cc = 6, wc = (e, t, n) => {
	let r = (t) => [50 + e * Math.cos(t * Math.PI / 180), 50 + e * Math.sin(t * Math.PI / 180)].map((e) => e.toFixed(2)), [i, a] = r(t), [o, s] = r(n);
	return `M${i} ${a}A${e} ${e} 0 0 1 ${o} ${s}`;
}, Tc = ([e, t, n, ...r]) => {
	let i = "", a = t;
	for (let t of r) i += wc(e, a, t - Cc), a = t + Cc;
	return i + wc(e, a, n);
};
function Ec(e, t, n, r) {
	let i = t.querySelector(".quote-print__pad"), a = i.querySelector("svg"), o = t.querySelector(".quote-print__say"), s = n.closest(".quote-slot"), c = n.querySelector(".quote-form form"), l = () => e.classList.contains("is-open");
	e.classList.add("has-print", "is-instant"), n.offsetWidth, requestAnimationFrame(() => requestAnimationFrame(() => e.classList.remove("is-instant")));
	let u = r.reduced ? null : gc({
		section: e,
		slot: s,
		panel: n,
		print: t,
		pad: i
	}), d = () => !!u?.alive, f = () => d() ? u.rise : yc, p = (e) => Sc.map((t, n) => {
		let r = document.createElementNS("http://www.w3.org/2000/svg", "path");
		return r.setAttribute("d", Tc(t)), r.setAttribute("class", e), r.style.setProperty("--i", n), e === "quote-print__lit" && r.setAttribute("pathLength", "1"), a.append(r), r;
	}), m = p("quote-print__ridge"), h = p("quote-print__lit"), g = "rest", _ = 0, v = {
		rest: "Hold for a free quote",
		reading: "Reading",
		hint: "Hold a little longer",
		done: "Unlocked"
	}, y = (e) => {
		e !== g && (g = e, o.textContent = v[e], t.dataset.say = e);
	};
	i.addEventListener("pointermove", (e) => {
		if (e.pointerType !== "mouse") return;
		let t = a.getBoundingClientRect(), n = Math.hypot((e.clientX - t.left) * 100 / t.width - 50, (e.clientY - t.top) * 50 / t.height - 50);
		m.forEach((e, t) => e.style.setProperty("--hl", xc(1 - Math.abs(n - Sc[t][0]) / 7, 0, 1).toFixed(2)));
	}), i.addEventListener("pointerleave", () => m.forEach((e) => e.style.removeProperty("--hl")));
	let b = 0, x = !1, S = 0, C = 0, w = !1, T = () => h.forEach((e, t) => e.style.setProperty("--off", (1 - xc(b * (Sc.length + 2) - t, 0, 1)).toFixed(3))), E = (e) => {
		let n = Math.min(64, e - C);
		C = e, b = x ? Math.min(1, b + n / vc) : Math.max(0, b - n / 380), T(), x && b >= 1 ? (S = 0, O()) : x || b > 0 ? S = requestAnimationFrame(E) : (S = 0, t.classList.remove("is-reading"));
	};
	i.addEventListener("pointerdown", (e) => {
		if (!(w || l() || e.pointerType === "mouse" && e.button !== 0)) {
			x = !0, clearTimeout(_), t.classList.add("is-reading"), y("reading"), S ||= (C = performance.now(), requestAnimationFrame(E));
			try {
				i.setPointerCapture(e.pointerId);
			} catch {}
		}
	});
	let D = () => {
		x && (x = !1, !w && (y("hint"), clearTimeout(_), _ = setTimeout(() => {
			!x && !w && y("rest");
		}, 1600)));
	};
	for (let e of [
		"pointerup",
		"pointercancel",
		"lostpointercapture"
	]) i.addEventListener(e, D);
	i.addEventListener("contextmenu", (e) => e.preventDefault()), i.addEventListener("click", (e) => {
		e.detail === 0 && !w && !l() && O();
	});
	function O() {
		w = !0, x = !1, b = 1, T(), cancelAnimationFrame(S), S = 0, t.classList.remove("is-reading"), t.classList.add("is-unlocked"), y("done"), navigator.vibrate?.(14), setTimeout(() => {
			w = !1, ae();
		}, r.reduced ? 0 : 320);
	}
	let ee = () => {
		clearTimeout(_), b = 0, T(), t.classList.remove("is-reading", "is-unlocked"), y("rest");
	}, k = [...c.children], te = [...k.filter((e) => e.matches("fieldset")), ...k.filter((e) => e.querySelector("select[name=\"area\"], select[name=\"contact[area]\"]"))], ne = [...te, ...k.filter((e) => !te.includes(e))], re = () => c.append(..._c.matches ? ne : k);
	_c.addEventListener("change", re), re();
	let j = (e) => {
		let t = s.getBoundingClientRect().top, n = t > 0 ? 20 : 92;
		if (t >= n && t <= innerHeight * .3) return;
		let i = scrollY + t - n, a = e && Math.abs(t) < innerHeight * 1.5;
		r.lenis ? (r.lenis.reset(), r.lenis.scrollTo(i, {
			immediate: !a,
			force: !0
		})) : window.scrollTo({
			top: i,
			behavior: a ? "smooth" : "auto"
		});
	}, M = 0, ie = 0;
	function ae({ animate: t = !0 } = {}) {
		l() ? j(!r.reduced) : (M = performance.now(), d() ? (e.classList.add("is-open"), u.open(), n.querySelector(".quote-panel__title")?.focus({ preventScroll: !0 }), clearTimeout(ie), ie = setTimeout(() => {
			l() && j(!0);
		}, t ? 350 : 0)) : (t || (e.classList.add("is-instant"), n.offsetWidth), e.classList.add("is-open"), n.querySelector(".quote-panel__title")?.focus({ preventScroll: !0 }), t ? (clearTimeout(ie), ie = setTimeout(() => {
			l() && j(!0);
		}, r.reduced ? 0 : yc * .45)) : (requestAnimationFrame(() => e.classList.remove("is-instant")), j(!r.reduced))));
	}
	let oe = () => {
		l() && (clearTimeout(ie), ee(), e.classList.remove("is-open"), d() && u.close(), n.contains(document.activeElement) && i.focus({ preventScroll: !0 }));
	};
	n.querySelector(".quote-panel__close")?.addEventListener("click", oe);
	let se = scrollY, ce = !1, N = () => n.contains(document.activeElement) && document.activeElement.matches("input:not([type=\"checkbox\"], [type=\"radio\"]), textarea");
	addEventListener("scroll", () => {
		let e = scrollY;
		if (e !== se && (ce = e > se), se = e, !l() || N() || performance.now() - M < f() + 900) return;
		let t = s.getBoundingClientRect();
		(ce ? t.bottom < t.height * bc : t.top >= innerHeight) && oe();
	}, { passive: !0 }), document.addEventListener("click", (e) => {
		let t = e.target.closest?.("a[href*=\"#quote\"]");
		if (!t) return;
		let n = new URL(t.href, location.href);
		if (n.hash !== "#quote" || n.pathname !== location.pathname && n.pathname !== new URL(window.AURA.route("contact.html"), location.href).pathname) return;
		e.preventDefault(), e.stopPropagation();
		let r = () => ae({ animate: !1 });
		document.getElementById("mnav")?.classList.contains("is-open") ? (history.state?.mnav ? addEventListener("popstate", () => setTimeout(r), { once: !0 }) : setTimeout(r), document.querySelector("[data-mnav-close]")?.click()) : r();
	}, !0), T(), location.hash === "#quote" && (ae({ animate: !1 }), addEventListener("load", () => requestAnimationFrame(() => {
		M = performance.now(), j(!1);
	}), { once: !0 }));
}
//#endregion
//#region src/motion/loops.js
window.A?.ready((e) => {
	document.querySelectorAll(".quote-print[data-quote-print]").forEach((t) => {
		let n = t.closest(".section"), r = n?.querySelector(".quote-slot > .quote-panel");
		r && Ec(n, t, r, e);
	});
}), window.A?.ready(() => {
	let e = new IntersectionObserver((e) => e.forEach((e) => e.target.classList.toggle("is-offscreen", !e.isIntersecting)), { rootMargin: "25% 0px" });
	document.querySelectorAll("main > :not(.aura-product-section, .aura-home-section, .section-hero, .section-scroll-film), .aura-product-section > *, main > :is(.aura-home-section, .section-hero, .section-scroll-film) > section, .site-footer").forEach((t) => e.observe(t));
});
//#endregion
//#region src/motion/snap.js
var Dc = 1 / 3, Oc = 1 / 4;
window.A?.ready((e) => {
	let t = e.lenis, n = [...document.querySelectorAll("[data-snap]")];
	if (!t || !n.length) return;
	let r = matchMedia("(min-width: 1000px)"), i = 0, a = 0, o = null, s = () => {
		if (r.matches && i) for (let e of n) {
			let n = e.getBoundingClientRect().top;
			if (Math.abs(n) < 2) {
				o = e;
				return;
			}
			let r = n * i;
			if (r > 0 ? r < innerHeight * Dc : -r < innerHeight * Oc && o !== e) {
				t.scrollTo(t.scroll + n, {
					duration: .7,
					easing: (e) => 1 - (1 - e) ** 3,
					userData: { initiator: "settle" },
					onComplete: () => {
						o = e;
					}
				});
				return;
			}
			o === e && Math.abs(n) > innerHeight * Dc && (o = null);
		}
	};
	t.on("scroll", (e) => {
		t.userData?.initiator !== "settle" && (e.direction && (i = e.direction), clearTimeout(a), a = setTimeout(s, 120));
	});
}), window.Lenis = _, window.AuraSearch = { products: Fn };
//#endregion
